import {
    fa0,
    fa1,
    fa2,
    fa3,
    fa4,
    fa5,
    fa6,
    fa7,
    fa8,
    fa9,
    faFillDrip,
    faArrowsToCircle,
    faCircleChevronRight,
    faChevronCircleRight,
    faWagonCovered,
    faLineHeight,
    faBagel,
    faTransporter7,
    faAt,
    faRectanglesMixed,
    faPhoneArrowUpRight,
    faPhoneArrowUp,
    faPhoneOutgoing,
    faTrashCan,
    faTrashAlt,
    faCircleL,
    faHeadSideGoggles,
    faHeadVr,
    faTextHeight,
    faUserXmark,
    faUserTimes,
    faFaceHandYawn,
    faGaugeSimpleMin,
    faTachometerSlowest,
    faStethoscope,
    faCoffin,
    faMessage,
    faCommentAlt,
    faSalad,
    faBowlSalad,
    faInfo,
    faRobotAstromech,
    faRingDiamond,
    faFonduePot,
    faTheta,
    faFaceHandPeeking,
    faSquareUser,
    faDownLeftAndUpRightToCenter,
    faCompressAlt,
    faExplosion,
    faFileLines,
    faFileAlt,
    faFileText,
    faWaveSquare,
    faRing,
    faBuildingUn,
    faDiceThree,
    faTirePressureWarning,
    faWifiFair,
    faWifi2,
    faCalendarDays,
    faCalendarAlt,
    faMp3Player,
    faAnchorCircleCheck,
    faTally4,
    faRectangleHistory,
    faBuildingCircleArrowRight,
    faVolleyball,
    faVolleyballBall,
    faSunHaze,
    faTextSize,
    faUfo,
    faFork,
    faUtensilFork,
    faArrowsUpToLine,
    faMobileSignal,
    faBarcodeScan,
    faSortDown,
    faSortDesc,
    faFolderArrowDown,
    faFolderDownload,
    faCircleMinus,
    faMinusCircle,
    faFaceIcicles,
    faShovel,
    faDoorOpen,
    faFilms,
    faRightFromBracket,
    faSignOutAlt,
    faFaceGlasses,
    faNfc,
    faAtom,
    faSoap,
    faIcons,
    faHeartMusicCameraBolt,
    faMicrophoneLinesSlash,
    faMicrophoneAltSlash,
    faClosedCaptioningSlash,
    faCalculatorSimple,
    faCalculatorAlt,
    faBridgeCircleCheck,
    faSlidersUp,
    faSlidersV,
    faLocationMinus,
    faMapMarkerMinus,
    faPumpMedical,
    faFingerprint,
    faSkiBoot,
    faStandardDefinition,
    faRectangleSd,
    faH1,
    faHandPointRight,
    faMagnifyingGlassLocation,
    faSearchLocation,
    faMessageBot,
    faForwardStep,
    faStepForward,
    faFaceSmileBeam,
    faSmileBeam,
    faLightCeiling,
    faMessageExclamation,
    faCommentAltExclamation,
    faBowlScoop,
    faBowlShavedIce,
    faSquareX,
    faUtilityPoleDouble,
    faFlagCheckered,
    faChevronsUp,
    faChevronDoubleUp,
    faFootball,
    faFootballBall,
    faUserVneck,
    faSchoolCircleExclamation,
    faCrop,
    faAnglesDown,
    faAngleDoubleDown,
    faUsersRectangle,
    faPeopleRoof,
    faSquareArrowRight,
    faArrowSquareRight,
    faLocationPlus,
    faMapMarkerPlus,
    faLightbulbExclamationOn,
    faPeopleLine,
    faBeerMugEmpty,
    faBeer,
    faCrateEmpty,
    faDiagramPredecessor,
    faTransporter,
    faCalendarCircleUser,
    faArrowUpLong,
    faLongArrowUp,
    faPersonCarryBox,
    faPersonCarry,
    faFireFlameSimple,
    faBurn,
    faPerson,
    faMale,
    faLaptop,
    faFileCsv,
    faMenorah,
    faUnion,
    faChevronsLeft,
    faChevronDoubleLeft,
    faCircleHeart,
    faHeartCircle,
    faTruckPlane,
    faRecordVinyl,
    faBringForward,
    faSquareP,
    faFaceGrinStars,
    faGrinStars,
    faSigma,
    faCameraMovie,
    faBong,
    faClarinet,
    faTruckFlatbed,
    faSpaghettiMonsterFlying,
    faPastafarianism,
    faArrowDownUpAcrossLine,
    faLeafHeart,
    faHouseBuilding,
    faCheeseSwiss,
    faSpoon,
    faUtensilSpoon,
    faJarWheat,
    faEnvelopesBulk,
    faMailBulk,
    faFileCircleExclamation,
    faBowArrow,
    faCartXmark,
    faHexagonXmark,
    faTimesHexagon,
    faXmarkHexagon,
    faCircleH,
    faHospitalSymbol,
    faMerge,
    faPager,
    faCartMinus,
    faAddressBook,
    faContactBook,
    faPanFrying,
    faGrid,
    faGrid3,
    faFootballHelmet,
    faHandLove,
    faTrees,
    faStrikethrough,
    faPage,
    faK,
    faDiagramPrevious,
    faGaugeMin,
    faTachometerAltSlowest,
    faFolderGrid,
    faEggplant,
    faRam,
    faLandmarkFlag,
    faLips,
    faPencil,
    faPencilAlt,
    faBackward,
    faCaretRight,
    faComments,
    faPaste,
    faFileClipboard,
    faDesktopArrowDown,
    faCodePullRequest,
    faPumpkin,
    faClipboardList,
    faPenField,
    faBlueberries,
    faTruckRampBox,
    faTruckLoading,
    faNote,
    faArrowDownToSquare,
    faUserCheck,
    faCloudXmark,
    faVialVirus,
    faBookBlank,
    faBookAlt,
    faGolfFlagHole,
    faMessageArrowDown,
    faCommentAltArrowDown,
    faFaceUnamused,
    faSheetPlastic,
    faCircle9,
    faBlog,
    faUserNinja,
    faPencilSlash,
    faBowlingPins,
    faPersonArrowUpFromLine,
    faDownRight,
    faScrollTorah,
    faTorah,
    faBlindsOpen,
    faFence,
    faUp,
    faArrowAltUp,
    faBroomBall,
    faQuidditch,
    faQuidditchBroomBall,
    faDrumstick,
    faSquareV,
    faFaceAwesome,
    faGaveDandy,
    faDialOff,
    faToggleOff,
    faFaceSmileHorns,
    faBoxArchive,
    faArchive,
    faGrapes,
    faPersonDrowning,
    faDialMax,
    faCircleM,
    faCalendarImage,
    faCircleCaretDown,
    faCaretCircleDown,
    faArrowDown91,
    faSortNumericDesc,
    faSortNumericDownAlt,
    faFaceGrinTongueSquint,
    faGrinTongueSquint,
    faShishKebab,
    faSprayCan,
    faAlarmSnooze,
    faScarecrow,
    faTruckMonster,
    faGiftCard,
    faW,
    faCodePullRequestDraft,
    faSquareB,
    faElephant,
    faEarthAfrica,
    faGlobeAfrica,
    faRainbow,
    faCircleNotch,
    faTabletScreenButton,
    faTabletAlt,
    faPaw,
    faMessageQuestion,
    faCloud,
    faTrowelBricks,
    faSquare3,
    faFaceFlushed,
    faFlushed,
    faHospitalUser,
    faMicrowave,
    faTentArrowLeftRight,
    faCartCircleArrowUp,
    faTrashClock,
    faGavel,
    faLegal,
    faSprinklerCeiling,
    faBrowsers,
    faTrillium,
    faMusicSlash,
    faTruckRamp,
    faBinoculars,
    faMicrophoneSlash,
    faBoxTissue,
    faCircleC,
    faStarChristmas,
    faChartBullet,
    faMotorcycle,
    faTreeChristmas,
    faTireFlat,
    faSunglasses,
    faBadge,
    faMessagePen,
    faCommentAltEdit,
    faMessageEdit,
    faBellConcierge,
    faConciergeBell,
    faPenRuler,
    faPencilRuler,
    faChessRookPiece,
    faChessRookAlt,
    faSquareRoot,
    faAlbumCollectionCirclePlus,
    faPeopleArrows,
    faPeopleArrowsLeftRight,
    faFaceAngryHorns,
    faMarsAndVenusBurst,
    faTombstone,
    faSquareCaretRight,
    faCaretSquareRight,
    faScissors,
    faCut,
    faListMusic,
    faSunPlantWilt,
    faToiletsPortable,
    faHockeyPuck,
    faMustache,
    faHyphen,
    faTable,
    faUserChef,
    faMessageImage,
    faCommentAltImage,
    faUsersMedical,
    faSensorTriangleExclamation,
    faSensorAlert,
    faMagnifyingGlassArrowRight,
    faTachographDigital,
    faDigitalTachograph,
    faFaceMask,
    faPickleball,
    faStarSharpHalf,
    faUsersSlash,
    faClover,
    faMeat,
    faReply,
    faMailReply,
    faStarAndCrescent,
    faEmptySet,
    faHouseFire,
    faSquareMinus,
    faMinusSquare,
    faHelicopter,
    faBird,
    faCompass,
    faSquareCaretDown,
    faCaretSquareDown,
    faHeartHalfStroke,
    faHeartHalfAlt,
    faFileCircleQuestion,
    faLaptopCode,
    faJoystick,
    faGrillFire,
    faRectangleVerticalHistory,
    faSwatchbook,
    faPrescriptionBottle,
    faBars,
    faNavicon,
    faKeyboardLeft,
    faPeopleGroup,
    faHourglassEnd,
    faHourglass3,
    faHeartCrack,
    faHeartBroken,
    faFaceBeamHandOverMouth,
    faDropletPercent,
    faHumidity,
    faSquareUpRight,
    faExternalLinkSquareAlt,
    faFaceKissBeam,
    faKissBeam,
    faCorn,
    faRollerCoaster,
    faPhotoFilmMusic,
    faRadar,
    faSickle,
    faFilm,
    faCoconut,
    faRulerHorizontal,
    faShieldCross,
    faCassetteTape,
    faSquareTerminal,
    faPeopleRobbery,
    faLightbulb,
    faCaretLeft,
    faCommentMiddle,
    faTrashCanList,
    faBlock,
    faCircleExclamation,
    faExclamationCircle,
    faSchoolCircleXmark,
    faArrowRightFromBracket,
    faSignOut,
    faFaceFrownSlight,
    faCircleChevronDown,
    faChevronCircleDown,
    faSidebarFlip,
    faUnlockKeyhole,
    faUnlockAlt,
    faTemperatureList,
    faCloudShowersHeavy,
    faHeadphonesSimple,
    faHeadphonesAlt,
    faSitemap,
    faPipeSection,
    faSpaceStationMoonConstruction,
    faSpaceStationMoonAlt,
    faCircleDollarToSlot,
    faDonate,
    faMemory,
    faFaceSleeping,
    faRoadSpikes,
    faFireBurner,
    faSquirrel,
    faArrowUpToLine,
    faArrowToTop,
    faFlag,
    faFaceCowboyHat,
    faHanukiah,
    faChartScatter3d,
    faSquareCode,
    faFeather,
    faVolumeLow,
    faVolumeDown,
    faXmarkToSlot,
    faTimesToSlot,
    faVoteNay,
    faBoxTaped,
    faBoxAlt,
    faCommentSlash,
    faSwords,
    faCloudSunRain,
    faAlbum,
    faCircleN,
    faCompress,
    faWheatAwn,
    faWheatAlt,
    faAnkh,
    faHandsHoldingChild,
    faAsterisk,
    faKeySkeletonLeftRight,
    faCommentLines,
    faLuchadorMask,
    faLuchador,
    faMaskLuchador,
    faSquareCheck,
    faCheckSquare,
    faShredder,
    faBookOpenCover,
    faBookOpenAlt,
    faSandwich,
    faPesetaSign,
    faSquareParkingSlash,
    faParkingSlash,
    faTrainTunnel,
    faHeading,
    faHeader,
    faGhost,
    faFaceAnguished,
    faHockeySticks,
    faAbacus,
    faFilmSimple,
    faFilmAlt,
    faList,
    faListSquares,
    faTreePalm,
    faSquarePhoneFlip,
    faPhoneSquareAlt,
    faCartPlus,
    faGamepad,
    faBorderCenterV,
    faCircleDot,
    faDotCircle,
    faClipboardMedical,
    faFaceDizzy,
    faDizzy,
    faEgg,
    faUpToLine,
    faArrowAltToTop,
    faHouseMedicalCircleXmark,
    faWatchFitness,
    faClockNineThirty,
    faCampground,
    faFolderPlus,
    faJug,
    faFutbol,
    faFutbolBall,
    faSoccerBall,
    faSnowBlowing,
    faPaintbrush,
    faPaintBrush,
    faLock,
    faArrowDownFromLine,
    faArrowFromTop,
    faGasPump,
    faSignalBarsSlash,
    faSignalAltSlash,
    faMonkey,
    faRectanglePro,
    faPro,
    faHouseNight,
    faHotTubPerson,
    faHotTub,
    faBlanket,
    faMapLocation,
    faMapMarked,
    faHouseFloodWater,
    faCommentsQuestionCheck,
    faTree,
    faArrowsCross,
    faBackpack,
    faSquareSmall,
    faFolderArrowUp,
    faFolderUpload,
    faBridgeLock,
    faCrosshairsSimple,
    faSackDollar,
    faPenToSquare,
    faEdit,
    faSquareSliders,
    faSlidersHSquare,
    faCarSide,
    faMessageMiddleTop,
    faCommentMiddleTopAlt,
    faLightbulbOn,
    faKnife,
    faUtensilKnife,
    faShareNodes,
    faShareAlt,
    faWaveSine,
    faHeartCircleMinus,
    faCircleW,
    faCircleCalendar,
    faCalendarCircle,
    faHourglassHalf,
    faHourglass2,
    faMicroscope,
    faSunset,
    faSink,
    faCalendarExclamation,
    faTruckContainerEmpty,
    faHandHeart,
    faBagShopping,
    faShoppingBag,
    faArrowDownZA,
    faSortAlphaDesc,
    faSortAlphaDownAlt,
    faMitten,
    faReplyClock,
    faReplyTime,
    faPersonRays,
    faRight,
    faArrowAltRight,
    faCircleF,
    faUsers,
    faFacePleading,
    faEyeSlash,
    faFlaskVial,
    faPoliceBox,
    faCucumber,
    faHeadSideBrain,
    faHand,
    faHandPaper,
    faPersonBikingMountain,
    faBikingMountain,
    faUtensilsSlash,
    faPrintMagnifyingGlass,
    faPrintSearch,
    faFolderBookmark,
    faOm,
    faPi,
    faFlaskRoundPotion,
    faFlaskPotion,
    faFaceShush,
    faWorm,
    faHouseCircleXmark,
    faPlug,
    faCalendarCircleExclamation,
    faSquareI,
    faChevronUp,
    faFaceSaluting,
    faGaugeSimpleLow,
    faTachometerSlow,
    faFacePersevering,
    faCircleCamera,
    faCameraCircle,
    faHandSpock,
    faSpiderWeb,
    faCircleMicrophone,
    faMicrophoneCircle,
    faBookArrowUp,
    faPopsicle,
    faCommand,
    faBlinds,
    faStopwatch,
    faSaxophone,
    faSquare2,
    faFieldHockeyStickBall,
    faFieldHockey,
    faArrowUpSquareTriangle,
    faSortShapesUpAlt,
    faFaceScream,
    faSquareM,
    faCameraWeb,
    faWebcam,
    faCommentArrowDown,
    faLightbulbCfl,
    faWindowFrameOpen,
    faFaceKiss,
    faKiss,
    faBridgeCircleXmark,
    faPeriod,
    faFaceGrinTongue,
    faGrinTongue,
    faUpToDottedLine,
    faThoughtBubble,
    faRaygun,
    faFlute,
    faAcorn,
    faVideoArrowUpRight,
    faGrateDroplet,
    faSealExclamation,
    faChessBishop,
    faMessageSms,
    faCoffeeBeans,
    faHatWitch,
    faFaceGrinWink,
    faGrinWink,
    faClockThreeThirty,
    faEarDeaf,
    faDeaf,
    faDeafness,
    faHardOfHearing,
    faAlarmClock,
    faEclipse,
    faFaceRelieved,
    faRoadCircleCheck,
    faDiceFive,
    faOctagonMinus,
    faMinusOctagon,
    faSquareRss,
    faRssSquare,
    faFaceZany,
    faTricycle,
    faLandMineOn,
    faSquareArrowUpLeft,
    faICursor,
    faSaltShaker,
    faStamp,
    faFilePlus,
    faDrawSquare,
    faToiletPaperUnderSlash,
    faToiletPaperReverseSlash,
    faStairs,
    faDroneFront,
    faDroneAlt,
    faGlassEmpty,
    faDialHigh,
    faUserHelmetSafety,
    faUserConstruction,
    faUserHardHat,
    faI,
    faHryvniaSign,
    faHryvnia,
    faArrowDownLeftAndArrowUpRightToCenter,
    faPills,
    faFaceGrinWide,
    faGrinAlt,
    faTooth,
    faBasketballHoop,
    faObjectsAlignBottom,
    faV,
    faSparkles,
    faSquid,
    faLeafyGreen,
    faCircleArrowUpRight,
    faCalendars,
    faBangladeshiTakaSign,
    faBicycle,
    faHammerWar,
    faCircleD,
    faSpiderBlackWidow,
    faStaffSnake,
    faRodAsclepius,
    faRodSnake,
    faStaffAesculapius,
    faPear,
    faHeadSideCoughSlash,
    faTriangle,
    faApartment,
    faTruckMedical,
    faAmbulance,
    faPepper,
    faPiano,
    faGunSquirt,
    faWheatAwnCircleExclamation,
    faSnowman,
    faUserAlien,
    faShieldCheck,
    faMortarPestle,
    faRoadBarrier,
    faChartCandlestick,
    faBriefcaseBlank,
    faSchool,
    faIgloo,
    faBracketRound,
    faParenthesis,
    faJoint,
    faHorseSaddle,
    faMugMarshmallows,
    faFilters,
    faBellOn,
    faAngleRight,
    faDialMed,
    faHorse,
    faQ,
    faMonitorWaveform,
    faMonitorHeartRate,
    faLinkSimple,
    faWhistle,
    faG,
    faWineGlassCrack,
    faFragile,
    faSlotMachine,
    faNotesMedical,
    faCarWash,
    faEscalator,
    faCommentImage,
    faTemperatureHalf,
    faTemperature2,
    faThermometer2,
    faThermometerHalf,
    faDongSign,
    faDonut,
    faDoughnut,
    faCapsules,
    faPooStorm,
    faPooBolt,
    faTally1,
    faFaceFrownOpen,
    faFrownOpen,
    faSquareDashed,
    faSquareJ,
    faHandPointUp,
    faMoneyBill,
    faArrowUpBigSmall,
    faSortSizeUp,
    faBarcodeRead,
    faBaguette,
    faBowlSoftServe,
    faFaceHoldingBackTears,
    faSquareUp,
    faArrowAltSquareUp,
    faTrainSubwayTunnel,
    faSubwayTunnel,
    faSquareExclamation,
    faExclamationSquare,
    faSemicolon,
    faBookmark,
    faFanTable,
    faAlignJustify,
    faBatteryLow,
    faBattery1,
    faCreditCardFront,
    faBrainArrowCurvedRight,
    faMindShare,
    faUmbrellaBeach,
    faHelmetUn,
    faLocationSmile,
    faMapMarkerSmile,
    faArrowLeftToLine,
    faArrowToLeft,
    faBullseye,
    faSushi,
    faNigiri,
    faMessageCaptions,
    faCommentAltCaptions,
    faTrashList,
    faBacon,
    faOption,
    faHandPointDown,
    faArrowUpFromBracket,
    faTrashPlus,
    faObjectsAlignTop,
    faFolder,
    faFolderBlank,
    faFaceAnxiousSweat,
    faCreditCardBlank,
    faFileWaveform,
    faFileMedicalAlt,
    faMicrochipAi,
    faMug,
    faPlaneUpSlash,
    faRadiation,
    faPenCircle,
    faChartSimple,
    faCrutches,
    faCircleParking,
    faParkingCircle,
    faMarsStroke,
    faLeafOak,
    faSquareBolt,
    faVial,
    faGauge,
    faDashboard,
    faGaugeMed,
    faTachometerAltAverage,
    faWandMagicSparkles,
    faMagicWandSparkles,
    faLambda,
    faE,
    faPizza,
    faBowlChopsticksNoodles,
    faH3,
    faPenClip,
    faPenAlt,
    faBridgeCircleExclamation,
    faBadgePercent,
    faUser,
    faSensor,
    faComma,
    faSchoolCircleCheck,
    faToiletPaperUnder,
    faToiletPaperReverse,
    faLightEmergency,
    faArrowDownToArc,
    faDumpster,
    faVanShuttle,
    faShuttleVan,
    faBuildingUser,
    faLightSwitch,
    faSquareCaretLeft,
    faCaretSquareLeft,
    faHighlighter,
    faWavePulse,
    faHeartRate,
    faKey,
    faHatSanta,
    faTamale,
    faBoxCheck,
    faBullhorn,
    faSteak,
    faLocationCrosshairsSlash,
    faLocationSlash,
    faPersonDolly,
    faGlobe,
    faSynagogue,
    faFileChartColumn,
    faFileChartLine,
    faPersonHalfDress,
    faFolderImage,
    faCalendarPen,
    faCalendarEdit,
    faRoadBridge,
    faFaceSmileTear,
    faMessagePlus,
    faCommentAltPlus,
    faLocationArrow,
    faC,
    faTabletButton,
    faRectangleHistoryCircleUser,
    faBuildingLock,
    faChartLineUp,
    faMailbox,
    faTruckBolt,
    faPizzaSlice,
    faMoneyBillWave,
    faChartArea,
    faAreaChart,
    faHouseFlag,
    faPersonCircleMinus,
    faScalpel,
    faBan,
    faCancel,
    faBellExclamation,
    faCircleBookmark,
    faBookmarkCircle,
    faEggFried,
    faFaceWeary,
    faUniformMartialArts,
    faCameraRotate,
    faSunDust,
    faCommentText,
    faSprayCanSparkles,
    faAirFreshener,
    faSignalBars,
    faSignalAlt,
    faSignalAlt4,
    faSignalBarsStrong,
    faDiamondExclamation,
    faStar,
    faDialMin,
    faRepeat,
    faCross,
    faPageCaretDown,
    faFileCaretDown,
    faBox,
    faVenusMars,
    faClockSevenThirty,
    faArrowPointer,
    faMousePointer,
    faClockFourThirty,
    faSignalBarsGood,
    faSignalAlt3,
    faCactus,
    faMaximize,
    faExpandArrowsAlt,
    faChargingStation,
    faShapes,
    faTriangleCircleSquare,
    faPlaneTail,
    faGaugeSimpleMax,
    faTachometerFastest,
    faCircleU,
    faShieldSlash,
    faSquarePhoneHangup,
    faPhoneSquareDown,
    faArrowUpLeft,
    faTransporter1,
    faPeanuts,
    faShuffle,
    faRandom,
    faPersonRunning,
    faRunning,
    faMobileRetro,
    faGripLinesVertical,
    faArrowUpFromSquare,
    faFileDashedLine,
    faPageBreak,
    faBracketCurlyRight,
    faSpider,
    faClockThree,
    faHandsBound,
    faScalpelLineDashed,
    faScalpelPath,
    faFileInvoiceDollar,
    faPipeSmoking,
    faFaceAstonished,
    faWindow,
    faPlaneCircleExclamation,
    faEar,
    faFileLock,
    faDiagramVenn,
    faXRay,
    faGoalNet,
    faCoffinCross,
    faSpellCheck,
    faLocationXmark,
    faMapMarkerTimes,
    faMapMarkerXmark,
    faLasso,
    faSlash,
    faPersonToPortal,
    faPortalEnter,
    faCalendarStar,
    faComputerMouse,
    faMouse,
    faArrowRightToBracket,
    faSignIn,
    faPegasus,
    faFilesMedical,
    faNfcLock,
    faPersonSkiLift,
    faSkiLift,
    faSquare6,
    faShopSlash,
    faStoreAltSlash,
    faWindTurbine,
    faSlidersSimple,
    faBadgeSheriff,
    faServer,
    faVirusCovidSlash,
    faIntersection,
    faShopLock,
    faFamily,
    faHourglassStart,
    faHourglass1,
    faUserHairBuns,
    faBlenderPhone,
    faHourglassClock,
    faPersonSeatReclined,
    faPaperPlaneTop,
    faPaperPlaneAlt,
    faSend,
    faMessageArrowUp,
    faCommentAltArrowUp,
    faLightbulbExclamation,
    faLayerMinus,
    faLayerGroupMinus,
    faCircleE,
    faBuildingWheat,
    faGaugeMax,
    faTachometerAltFastest,
    faPersonBreastfeeding,
    faApostrophe,
    faFireHydrant,
    faRightToBracket,
    faSignInAlt,
    faVideoPlus,
    faSquareRight,
    faArrowAltSquareRight,
    faCommentSmile,
    faVenus,
    faPassport,
    faInboxIn,
    faInboxArrowDown,
    faHeartPulse,
    faHeartbeat,
    faCircle8,
    faCloudsMoon,
    faClockTenThirty,
    faPeopleCarryBox,
    faPeopleCarry,
    faFolderUser,
    faTrashCanXmark,
    faTemperatureHigh,
    faMicrochip,
    faLeftLongToLine,
    faCrown,
    faWeightHanging,
    faXmarksLines,
    faFilePrescription,
    faCalendarRange,
    faFlowerDaffodil,
    faHandBackPointUp,
    faWeightScale,
    faWeight,
    faStarExclamation,
    faBooks,
    faUserGroup,
    faUserFriends,
    faArrowUpAZ,
    faSortAlphaUp,
    faLayerPlus,
    faLayerGroupPlus,
    faPlayPause,
    faBlockQuestion,
    faSnooze,
    faZzz,
    faScannerImage,
    faTvRetro,
    faSquareT,
    faFarm,
    faBarnSilo,
    faChessKnight,
    faBarsSort,
    faPalletBoxes,
    faPaletteBoxes,
    faPalletAlt,
    faFaceLaughSquint,
    faLaughSquint,
    faCodeSimple,
    faBoltSlash,
    faPanelFire,
    faBinaryCircleCheck,
    faCommentMinus,
    faBurrito,
    faViolin,
    faObjectsColumn,
    faSquareChevronDown,
    faChevronSquareDown,
    faCommentPlus,
    faTriangleInstrument,
    faTriangleMusic,
    faWheelchair,
    faUserPilotTie,
    faPianoKeyboard,
    faBedEmpty,
    faCircleArrowUp,
    faArrowCircleUp,
    faToggleOn,
    faRectangleVertical,
    faRectanglePortrait,
    faPersonWalking,
    faWalking,
    faL,
    faSignalStream,
    faDownToBracket,
    faCircleZ,
    faStars,
    faFire,
    faBedPulse,
    faProcedures,
    faHouseDay,
    faShuttleSpace,
    faSpaceShuttle,
    faShirtLongSleeve,
    faChartPieSimple,
    faChartPieAlt,
    faFaceLaugh,
    faLaugh,
    faFolderOpen,
    faAlbumCollectionCircleUser,
    faCandy,
    faBowlHot,
    faSoup,
    faFlatbread,
    faHeartCirclePlus,
    faCodeFork,
    faCity,
    faSignalBarsWeak,
    faSignalAlt1,
    faMicrophoneLines,
    faMicrophoneAlt,
    faClockTwelve,
    faPepperHot,
    faCitrusSlice,
    faSheep,
    faUnlock,
    faColonSign,
    faHeadset,
    faBadgerHoney,
    faH4,
    faStoreSlash,
    faRoadCircleXmark,
    faSignalSlash,
    faUserMinus,
    faMarsStrokeUp,
    faMarsStrokeV,
    faChampagneGlasses,
    faGlassCheers,
    faTaco,
    faHexagonPlus,
    faPlusHexagon,
    faClipboard,
    faHouseCircleExclamation,
    faFileArrowUp,
    faFileUpload,
    faWifi,
    faWifi3,
    faWifiStrong,
    faMessages,
    faCommentsAlt,
    faBath,
    faBathtub,
    faUmbrellaSimple,
    faUmbrellaAlt,
    faRectangleHistoryCirclePlus,
    faUnderline,
    faPrescriptionBottlePill,
    faUserPen,
    faUserEdit,
    faBinarySlash,
    faSquareO,
    faSignature,
    faStroopwafel,
    faBold,
    faAnchorLock,
    faBuildingNgo,
    faTransporter3,
    faEngineWarning,
    faEngineExclamation,
    faCircleDownRight,
    faSquareK,
    faManatSign,
    faMoneyCheckPen,
    faMoneyCheckEdit,
    faNotEqual,
    faBorderTopLeft,
    faBorderStyle,
    faMapLocationDot,
    faMapMarkedAlt,
    faTilde,
    faJedi,
    faSquarePollVertical,
    faPoll,
    faArrowDownSquareTriangle,
    faSortShapesDownAlt,
    faMugHot,
    faDogLeashed,
    faCarBattery,
    faBatteryCar,
    faFaceDowncastSweat,
    faMailboxFlagUp,
    faMemoCircleInfo,
    faGift,
    faDiceTwo,
    faVolume,
    faVolumeMedium,
    faTransporter5,
    faGaugeCircleBolt,
    faCoinFront,
    faFileSlash,
    faMessageArrowUpRight,
    faTreasureChest,
    faChessQueen,
    faPaintbrushFine,
    faPaintBrushAlt,
    faPaintBrushFine,
    faPaintbrushAlt,
    faGlasses,
    faHoodCloak,
    faSquareQuote,
    faUpLeft,
    faBringFront,
    faChessBoard,
    faBurgerCheese,
    faCheeseburger,
    faBuildingCircleCheck,
    faRepeat1,
    faArrowDownToLine,
    faArrowToBottom,
    faGrid5,
    faRightLongToLine,
    faPersonChalkboard,
    faMarsStrokeRight,
    faMarsStrokeH,
    faHandBackFist,
    faHandRock,
    faTally,
    faTally5,
    faSquareCaretUp,
    faCaretSquareUp,
    faCloudShowersWater,
    faChartBar,
    faBarChart,
    faHandsBubbles,
    faHandsWash,
    faLessThanEqual,
    faTrain,
    faUpFromDottedLine,
    faEyeLowVision,
    faLowVision,
    faTrafficLightGo,
    faFaceExhaling,
    faSensorFire,
    faUserUnlock,
    faHexagonDivide,
    fa00,
    faCrow,
    faCassetteBetamax,
    faBetamax,
    faSailboat,
    faWindowRestore,
    faNfcMagnifyingGlass,
    faFileBinary,
    faCircleV,
    faSquarePlus,
    faPlusSquare,
    faBowlScoops,
    faMistletoe,
    faCustard,
    faLacrosseStick,
    faHockeyMask,
    faSunrise,
    faPanelEws,
    faToriiGate,
    faCloudExclamation,
    faMessageLines,
    faCommentAltLines,
    faFrog,
    faBucket,
    faFloppyDiskPen,
    faImage,
    faWindowFrame,
    faMicrophone,
    faCow,
    faSquareRing,
    faDownFromLine,
    faArrowAltFromTop,
    faCaretUp,
    faShieldXmark,
    faShieldTimes,
    faScrewdriver,
    faCircleSortDown,
    faSortCircleDown,
    faFolderClosed,
    faHouseTsunami,
    faSquareNfi,
    faForklift,
    faArrowUpFromGroundWater,
    faBracketSquareRight,
    faMartiniGlass,
    faGlassMartiniAlt,
    faRotateLeft,
    faRotateBack,
    faRotateBackward,
    faUndoAlt,
    faTableColumns,
    faColumns,
    faSquareA,
    faTick,
    faLemon,
    faHeadSideMask,
    faHandshake,
    faGem,
    faDolly,
    faDollyBox,
    faSmoking,
    faMinimize,
    faCompressArrowsAlt,
    faRefrigerator,
    faMonument,
    faOctagonXmark,
    faTimesOctagon,
    faXmarkOctagon,
    faAlignSlash,
    faSnowplow,
    faAnglesRight,
    faAngleDoubleRight,
    faTruckRampCouch,
    faTruckCouch,
    faCannabis,
    faCirclePlay,
    faPlayCircle,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faTablets,
    fa360Degrees,
    faEthernet,
    faEuroSign,
    faEur,
    faEuro,
    faChair,
    faCircleCheck,
    faCheckCircle,
    faSquareDashedCirclePlus,
    faMoneySimpleFromBracket,
    faBat,
    faCircleStop,
    faStopCircle,
    faHeadSideHeadphones,
    faPhoneRotary,
    faCompassDrafting,
    faDraftingCompass,
    faPlateWheat,
    faCalendarCircleMinus,
    faChopsticks,
    faCarWrench,
    faCarMechanic,
    faIcicles,
    faPersonShelter,
    faNeuter,
    faIdBadge,
    faKazoo,
    faMarker,
    faFaceLaughBeam,
    faLaughBeam,
    faSquareArrowDownLeft,
    faBatteryBolt,
    faTreeLarge,
    faHelicopterSymbol,
    faAperture,
    faUniversalAccess,
    faFileMagnifyingGlass,
    faFileSearch,
    faUpRight,
    faCircleChevronUp,
    faChevronCircleUp,
    faUserPolice,
    faLariSign,
    faVolcano,
    faTeddyBear,
    faStocking,
    faPersonWalkingDashedLineArrowRight,
    faImageSlash,
    faMaskSnorkel,
    faSmoke,
    faSterlingSign,
    faGbp,
    faPoundSign,
    faBatteryExclamation,
    faViruses,
    faSquarePersonConfined,
    faUserTie,
    faArrowDownLong,
    faLongArrowDown,
    faTentArrowDownToLine,
    faCertificate,
    faCrystalBall,
    faReplyAll,
    faMailReplyAll,
    faSuitcase,
    faPersonSkating,
    faSkating,
    faStarShooting,
    faBinaryLock,
    faFilterCircleDollar,
    faFunnelDollar,
    faCameraRetro,
    faCircleArrowDown,
    faArrowCircleDown,
    faCommentPen,
    faCommentEdit,
    faFileImport,
    faArrowRightToFile,
    faBanjo,
    faSquareArrowUpRight,
    faExternalLinkSquare,
    faLightEmergencyOn,
    faKerning,
    faBoxOpen,
    faSquareF,
    faScroll,
    faSpa,
    faArrowLeftFromLine,
    faArrowFromRight,
    faStrawberry,
    faLocationPinLock,
    faPause,
    faClockEightThirty,
    faPlaneEngines,
    faPlaneAlt,
    faHillAvalanche,
    faTemperatureEmpty,
    faTemperature0,
    faThermometer0,
    faThermometerEmpty,
    faBomb,
    faGaugeLow,
    faTachometerAltSlow,
    faRegistered,
    faTrashCanPlus,
    faAddressCard,
    faContactCard,
    faVcard,
    faScaleUnbalancedFlip,
    faBalanceScaleRight,
    faGlobeSnow,
    faSubscript,
    faDiamondTurnRight,
    faDirections,
    faIntegral,
    faBurst,
    faHouseLaptop,
    faLaptopHouse,
    faFaceTired,
    faTired,
    faMoneyBills,
    faBlindsRaised,
    faSmog,
    faUfoBeam,
    faCircleCaretUp,
    faCaretCircleUp,
    faUserVneckHairLong,
    faSquareALock,
    faCrutch,
    faGasPumpSlash,
    faFontAwesome,
    faFontAwesomeFlag,
    faFontAwesomeLogoFull,
    faCloudArrowUp,
    faCloudUpload,
    faCloudUploadAlt,
    faPalette,
    faTransporter4,
    faObjectsAlignRight,
    faArrowsTurnRight,
    faVest,
    faPig,
    faInboxFull,
    faCircleEnvelope,
    faEnvelopeCircle,
    faTrianglePersonDigging,
    faConstruction,
    faFerry,
    faBullseyeArrow,
    faArrowsDownToPeople,
    faSeedling,
    faSprout,
    faClockSeven,
    faLeftRight,
    faArrowsAltH,
    faBoxesPacking,
    faCircleArrowLeft,
    faArrowCircleLeft,
    faFlashlight,
    faGroupArrowsRotate,
    faBowlFood,
    faSquare9,
    faCandyCane,
    faArrowDownWideShort,
    faSortAmountAsc,
    faSortAmountDown,
    faSquareDollar,
    faDollarSquare,
    faUsdSquare,
    faPhoneArrowRight,
    faHandHoldingSeedling,
    faMessageCheck,
    faCommentAltCheck,
    faCloudBolt,
    faThunderstorm,
    faTextSlash,
    faRemoveFormat,
    faWatch,
    faCircleDownLeft,
    faText,
    faProjector,
    faFaceSmileWink,
    faSmileWink,
    faTombstoneBlank,
    faTombstoneAlt,
    faChessKingPiece,
    faChessKingAlt,
    faCircle6,
    faLeft,
    faArrowAltLeft,
    faFileWord,
    faFilePowerpoint,
    faSquareDown,
    faArrowAltSquareDown,
    faObjectsAlignCenterVertical,
    faArrowsLeftRight,
    faArrowsH,
    faHouseLock,
    faCloudArrowDown,
    faCloudDownload,
    faCloudDownloadAlt,
    faWreath,
    faChildren,
    faMeterDroplet,
    faChalkboard,
    faBlackboard,
    faUserLargeSlash,
    faUserAltSlash,
    faSignalStrong,
    faSignal4,
    faLollipop,
    faLollypop,
    faListTree,
    faEnvelopeOpen,
    faDrawCircle,
    faCatSpace,
    faHandshakeSimpleSlash,
    faHandshakeAltSlash,
    faRabbitRunning,
    faRabbitFast,
    faMemoPad,
    faMattressPillow,
    faAlarmPlus,
    faAlicorn,
    faCommentQuestion,
    faGingerbreadMan,
    faGuaraniSign,
    faBurgerFries,
    faMugTea,
    faBorderTop,
    faArrowsRotate,
    faRefresh,
    faSync,
    faCircleBookOpen,
    faBookCircle,
    faArrowsToDottedLine,
    faFireExtinguisher,
    faGarageOpen,
    faShelvesEmpty,
    faCruzeiroSign,
    faWatchApple,
    faWatchCalculator,
    faListDropdown,
    faCabinetFiling,
    faBurgerSoda,
    faSquareArrowUp,
    faArrowSquareUp,
    faGreaterThanEqual,
    faPalletBox,
    faFaceConfounded,
    faShieldHalved,
    faShieldAlt,
    faTruckPlow,
    faBookAtlas,
    faAtlas,
    faVirus,
    faCommentMiddleTop,
    faEnvelopeCircleCheck,
    faLayerGroup,
    faRestroomSimple,
    faArrowsToDot,
    faBorderOuter,
    faHashtagLock,
    faClockTwoThirty,
    faArchway,
    faHeartCircleCheck,
    faHouseChimneyCrack,
    faHouseDamage,
    faFileZipper,
    faFileArchive,
    faHeartHalf,
    faCommentCheck,
    faSquare,
    faMemo,
    faMartiniGlassEmpty,
    faGlassMartini,
    faCouch,
    faCediSign,
    faItalic,
    faGlassCitrus,
    faCalendarLinesPen,
    faChurch,
    faPersonSnowmobiling,
    faSnowmobile,
    faFaceHushed,
    faCommentsDollar,
    faPickaxe,
    faLinkSimpleSlash,
    faDemocrat,
    faFaceConfused,
    faPinball,
    faZ,
    faPersonSkiing,
    faSkiing,
    faDeer,
    faInputPipe,
    faRoadLock,
    faA,
    faBookmarkSlash,
    faTemperatureArrowDown,
    faTemperatureDown,
    faMace,
    faFeatherPointed,
    faFeatherAlt,
    faSausage,
    faTrashCanClock,
    faP,
    faSnowflake,
    faStomach,
    faNewspaper,
    faRectangleAd,
    faAd,
    faGuitarElectric,
    faArrowTurnDownRight,
    faMoonCloud,
    faBreadSliceButter,
    faCircleArrowRight,
    faArrowCircleRight,
    faUserGroupCrown,
    faUsersCrown,
    faCircleI,
    faToiletPaperCheck,
    faFilterCircleXmark,
    faLocust,
    faSort,
    faUnsorted,
    faListOl,
    faList12,
    faListNumeric,
    faChartWaterfall,
    faFaceParty,
    faKidneys,
    faWifiExclamation,
    faChartNetwork,
    faPersonDressBurst,
    faDiceD4,
    faMoneyCheckDollar,
    faMoneyCheckAlt,
    faVectorSquare,
    faBreadSlice,
    faLanguage,
    faWheatAwnSlash,
    faFaceKissWinkHeart,
    faKissWinkHeart,
    faDagger,
    faPodium,
    faMemoCircleCheck,
    faRouteHighway,
    faDownToLine,
    faArrowAltToBottom,
    faFilter,
    faSquareG,
    faCirclePhone,
    faPhoneCircle,
    faClipboardPrescription,
    faUserNurseHair,
    faQuestion,
    faFileSignature,
    faToggleLargeOn,
    faUpDownLeftRight,
    faArrowsAlt,
    faDryerHeat,
    faDryerAlt,
    faHouseChimneyUser,
    faHandHoldingHeart,
    faArrowUpSmallBig,
    faSortSizeUpAlt,
    faTrainTrack,
    faPuzzlePiece,
    faMoneyCheck,
    faStarHalfStroke,
    faStarHalfAlt,
    faFileExclamation,
    faCode,
    faWhiskeyGlass,
    faGlassWhiskey,
    faMoonStars,
    faBuildingCircleExclamation,
    faClothesHanger,
    faMobileNotch,
    faMobileIphone,
    faMagnifyingGlassChart,
    faArrowUpRightFromSquare,
    faExternalLink,
    faCubesStacked,
    faImagesUser,
    faWonSign,
    faKrw,
    faWon,
    faImagePolaroidUser,
    faVirusCovid,
    faSquareEllipsis,
    faPie,
    faChessKnightPiece,
    faChessKnightAlt,
    faAustralSign,
    faCloudPlus,
    faF,
    faLeaf,
    faBedBunk,
    faRoad,
    faTaxi,
    faCab,
    faPersonCirclePlus,
    faChartPie,
    faPieChart,
    faBoltLightning,
    faClockEight,
    faSackXmark,
    faFileExcel,
    faFileContract,
    faFishFins,
    faCircleQ,
    faBuildingFlag,
    faFaceGrinBeam,
    faGrinBeam,
    faObjectUngroup,
    faFaceDisguise,
    faCircleArrowDownRight,
    faAlien8bit,
    faAlienMonster,
    faHandPointRibbon,
    faPoop,
    faObjectExclude,
    faTelescope,
    faLocationPin,
    faMapMarker,
    faSquareList,
    faKaaba,
    faToiletPaper,
    faHelmetSafety,
    faHardHat,
    faHatHard,
    faCommentCode,
    faSimCards,
    faStarship,
    faEject,
    faCircleRight,
    faArrowAltCircleRight,
    faPlaneCircleCheck,
    faSeal,
    faUserCowboy,
    faHexagonVerticalNft,
    faFaceRollingEyes,
    faMehRollingEyes,
    faBreadLoaf,
    faRingsWedding,
    faObjectGroup,
    faFrenchFries,
    faChartLine,
    faLineChart,
    faCalendarArrowDown,
    faCalendarDownload,
    faSendBack,
    faMaskVentilator,
    faSignatureLock,
    faArrowRight,
    faSignsPost,
    faMapSigns,
    faOctagonPlus,
    faPlusOctagon,
    faCashRegister,
    faPersonCircleQuestion,
    faMelonSlice,
    faSpaceStationMoon,
    faMessageSmile,
    faCommentAltSmile,
    faCupStraw,
    faLeftFromLine,
    faArrowAltFromRight,
    faH,
    faBasketShoppingSimple,
    faShoppingBasketAlt,
    faHandsHoldingHeart,
    faHandsHeart,
    faClockNine,
    faTarp,
    faFaceSleepy,
    faHandHorns,
    faScrewdriverWrench,
    faTools,
    faArrowsToEye,
    faCircleThreeQuarters,
    faTrophyStar,
    faTrophyAlt,
    faPlugCircleBolt,
    faFaceThermometer,
    faShirtRunning,
    faBookCircleArrowUp,
    faFaceNauseated,
    faHeart,
    faFileChartPie,
    faMarsAndVenus,
    faHouseUser,
    faHomeUser,
    faCircleArrowDownLeft,
    faDumpsterFire,
    faHexagonMinus,
    faMinusHexagon,
    faLeftToLine,
    faArrowAltToLeft,
    faHouseCrack,
    faPawSimple,
    faPawAlt,
    faArrowLeftLongToLine,
    faBracketsRound,
    faParentheses,
    faMartiniGlassCitrus,
    faCocktail,
    faUserShakespeare,
    faArrowRightToArc,
    faFaceSurprise,
    faSurprise,
    faBottleWater,
    faCirclePause,
    faPauseCircle,
    faGaugeCirclePlus,
    faFolders,
    faAngel,
    faValueAbsolute,
    faRabbit,
    faToiletPaperSlash,
    faAppleWhole,
    faAppleAlt,
    faKitchenSet,
    faDiamondHalf,
    faLockKeyhole,
    faLockAlt,
    faR,
    faTemperatureQuarter,
    faTemperature1,
    faThermometer1,
    faThermometerQuarter,
    faSquareInfo,
    faInfoSquare,
    faWifiSlash,
    faToiletPaperXmark,
    faHandsHoldingDollar,
    faHandsUsd,
    faCube,
    faArrowDownTriangleSquare,
    faSortShapesDown,
    faBitcoinSign,
    faShutters,
    faShieldDog,
    faSolarPanel,
    faLockOpen,
    faTableTree,
    faHouseChimneyHeart,
    faTally3,
    faElevator,
    faMoneyBillTransfer,
    faMoneyBillTrendUp,
    faHouseFloodWaterCircleArrowRight,
    faSquarePollHorizontal,
    faPollH,
    faCircle,
    faCartCircleExclamation,
    faSword,
    faBackwardFast,
    faFastBackward,
    faRecycle,
    faUserAstronaut,
    faInterrobang,
    faPlaneSlash,
    faCircleDashed,
    faTrademark,
    faBasketball,
    faBasketballBall,
    faForkKnife,
    faUtensilsAlt,
    faSatelliteDish,
    faBadgeCheck,
    faCircleUp,
    faArrowAltCircleUp,
    faSlider,
    faMobileScreenButton,
    faMobileAlt,
    faClockOneThirty,
    faInboxOut,
    faInboxArrowUp,
    faCloudSlash,
    faVolumeHigh,
    faVolumeUp,
    faUsersRays,
    faWallet,
    faOctagonCheck,
    faFlatbreadStuffed,
    faClipboardCheck,
    faCartCirclePlus,
    faTruckClock,
    faShippingTimed,
    faPool8Ball,
    faFileAudio,
    faTurnDownLeft,
    faLockHashtag,
    faChartRadar,
    faStaff,
    faBurger,
    faHamburger,
    faUtilityPole,
    faTransporter6,
    faWrench,
    faBugs,
    faVectorPolygon,
    faDiagramNested,
    faRupeeSign,
    faRupee,
    faFileImage,
    faCircleQuestion,
    faQuestionCircle,
    faImageUser,
    faBuoy,
    faPlaneDeparture,
    faHandshakeSlash,
    faBookBookmark,
    faBorderCenterH,
    faCanFood,
    faTypewriter,
    faArrowRightFromArc,
    faCircleK,
    faFaceHandOverMouth,
    faPopcorn,
    faHouseWater,
    faHouseFlood,
    faObjectSubtract,
    faCodeBranch,
    faWarehouseFull,
    faWarehouseAlt,
    faHatCowboy,
    faBridge,
    faPhoneFlip,
    faPhoneAlt,
    faArrowDownFromDottedLine,
    faSquareQuarters,
    faTruckFront,
    faCat,
    faTrashXmark,
    faCircleCaretLeft,
    faCaretCircleLeft,
    faFiles,
    faAnchorCircleExclamation,
    faFaceClouds,
    faUserCrown,
    faTruckField,
    faRoute,
    faCartCircleCheck,
    faClipboardQuestion,
    faPanorama,
    faCommentMedical,
    faTeethOpen,
    faUserTieHairLong,
    faFileCircleMinus,
    faHeadSideMedical,
    faTags,
    faWineGlass,
    faForwardFast,
    faFastForward,
    faFaceMehBlank,
    faMehBlank,
    faUserRobot,
    faSquareParking,
    faParking,
    faCardDiamond,
    faFaceZipper,
    faFaceRaisedEyebrow,
    faHouseSignal,
    faSquareChevronUp,
    faChevronSquareUp,
    faNfcSymbol,
    faBarsProgress,
    faTasksAlt,
    faFaucetDrip,
    faArrowsToLine,
    faDolphin,
    faArrowUpRight,
    faCircleR,
    faCartFlatbed,
    faDollyFlatbed,
    faBanSmoking,
    faSmokingBan,
    faCircleSortUp,
    faSortCircleUp,
    faTerminal,
    faMobileButton,
    faHouseMedicalFlag,
    faBasketShopping,
    faShoppingBasket,
    faTape,
    faChestnut,
    faBusSimple,
    faBusAlt,
    faEye,
    faFaceSadCry,
    faSadCry,
    faHeat,
    faTicketAirline,
    faBootHeeled,
    faArrowsMinimize,
    faCompressArrows,
    faAudioDescription,
    faPersonMilitaryToPerson,
    faFileShield,
    faHexagon,
    faManhole,
    faUserSlash,
    faPen,
    faTowerObservation,
    faFloppyDisks,
    faToiletPaperBlankUnder,
    faToiletPaperReverseAlt,
    faFileCode,
    faSignal,
    faSignal5,
    faSignalPerfect,
    faPump,
    faBus,
    faHeartCircleXmark,
    faArrowUpLeftFromCircle,
    faHouseChimney,
    faHomeLg,
    faWindowMaximize,
    faDryer,
    faFaceFrown,
    faFrown,
    faChessBishopPiece,
    faChessBishopAlt,
    faShirtTankTop,
    faDiploma,
    faScrollRibbon,
    faScreencast,
    faWalker,
    faPrescription,
    faShop,
    faStoreAlt,
    faFloppyDisk,
    faSave,
    faVihara,
    faFaceKissClosedEyes,
    faScaleUnbalanced,
    faBalanceScaleLeft,
    faFileUser,
    faUserPoliceTie,
    faFaceTongueMoney,
    faTennisBall,
    faSquareL,
    faSortUp,
    faSortAsc,
    faCalendarArrowUp,
    faCalendarUpload,
    faCommentDots,
    faCommenting,
    faPlantWilt,
    faScarf,
    faAlbumCirclePlus,
    faUserNurseHairLong,
    faDiamond,
    faSquareLeft,
    faArrowAltSquareLeft,
    faFaceGrinSquint,
    faGrinSquint,
    faCircleEllipsisVertical,
    faHandHoldingDollar,
    faHandHoldingUsd,
    faGridDividers,
    faBacterium,
    faHandPointer,
    faDrumSteelpan,
    faHandScissors,
    faHandsPraying,
    faPrayingHands,
    faFacePensive,
    faUserMusic,
    faArrowRotateRight,
    faArrowRightRotate,
    faArrowRotateForward,
    faRedo,
    faMessagesDollar,
    faCommentsAltDollar,
    faSensorOn,
    faBalloon,
    faBiohazard,
    faChessQueenPiece,
    faChessQueenAlt,
    faLocationCrosshairs,
    faLocation,
    faMarsDouble,
    faHousePersonLeave,
    faHouseLeave,
    faHousePersonDepart,
    faRulerTriangle,
    faCardClub,
    faChildDress,
    faUsersBetweenLines,
    faLungsVirus,
    faSpinnerThird,
    faFaceGrinTears,
    faGrinTears,
    faPhone,
    faComputerMouseScrollwheel,
    faMouseAlt,
    faCalendarXmark,
    faCalendarTimes,
    faChildReaching,
    faTableLayout,
    faNarwhal,
    faRampLoading,
    faCalendarCirclePlus,
    faToothbrush,
    faBorderInner,
    faPawClaws,
    faKiwiFruit,
    faTrafficLightSlow,
    faRectangleCode,
    faHeadSideVirus,
    faKeyboardBrightness,
    faBooksMedical,
    faLightbulbSlash,
    faHouseBlank,
    faHomeBlank,
    faSquare5,
    faSquareHeart,
    faHeartSquare,
    faPuzzle,
    faUserGear,
    faUserCog,
    faPipeCircleCheck,
    faArrowUp19,
    faSortNumericUp,
    faOctagonExclamation,
    faDialLow,
    faDoorClosed,
    faLaptopMobile,
    faPhoneLaptop,
    faConveyorBeltBoxes,
    faConveyorBeltAlt,
    faShieldVirus,
    faStarfighterTwinIonEngineAdvanced,
    faStarfighterAltAdvanced,
    faDiceSix,
    faStarfighterTwinIonEngine,
    faStarfighterAlt,
    faRocketLaunch,
    faMosquitoNet,
    faVentDamper,
    faBridgeWater,
    faBanBug,
    faDebug,
    faPersonBooth,
    faTextWidth,
    faGarageCar,
    faSquareKanban,
    faHatWizard,
    faPenFancy,
    faCoffeePot,
    faMouseField,
    faPersonDigging,
    faDigging,
    faShowerDown,
    faShowerAlt,
    faBoxCircleCheck,
    faBrightness,
    faCarSideBolt,
    faOrnament,
    faPhoneArrowDownLeft,
    faPhoneArrowDown,
    faPhoneIncoming,
    faCloudWord,
    faHandFingersCrossed,
    faTrash,
    faGaugeSimple,
    faGaugeSimpleMed,
    faTachometerAverage,
    faArrowDownSmallBig,
    faSortSizeDownAlt,
    faBookMedical,
    faFaceMelting,
    faPoo,
    faPenClipSlash,
    faPenAltSlash,
    faQuoteRight,
    faQuoteRightAlt,
    faScrollOld,
    faGuitars,
    faPhoneXmark,
    faHose,
    faClockSix,
    faShirt,
    faTShirt,
    faTshirt,
    faSquareR,
    faCubes,
    faEnvelopeOpenDollar,
    faDivide,
    faSunCloud,
    faLampFloor,
    faSquare7,
    faTengeSign,
    faTenge,
    faHeadphones,
    faHandsHolding,
    faCampfire,
    faCircleAmpersand,
    faSnowflakes,
    faHandsClapping,
    faRepublican,
    faLeafMaple,
    faArrowLeft,
    faPersonCircleXmark,
    faRuler,
    faCupStrawSwoosh,
    faTemperatureSun,
    faTemperatureHot,
    faAlignLeft,
    faDiceD6,
    faRestroom,
    faHighDefinition,
    faRectangleHd,
    faJ,
    faGalaxy,
    faUsersViewfinder,
    faFileVideo,
    faCherries,
    faUpRightFromSquare,
    faExternalLinkAlt,
    faCircleSort,
    faSortCircle,
    faTableCells,
    faTh,
    faFilePdf,
    faSiren,
    faArrowUpToDottedLine,
    faImageLandscape,
    faLandscape,
    faTankWater,
    faCurlingStone,
    faCurling,
    faGamepadModern,
    faGamepadAlt,
    faMessagesQuestion,
    faBookBible,
    faBible,
    faO,
    faSuitcaseMedical,
    faMedkit,
    faBriefcaseArrowRight,
    faExpandWide,
    faClockElevenThirty,
    faRv,
    faUserSecret,
    faOtter,
    faDreidel,
    faPersonDress,
    faFemale,
    faCommentDollar,
    faBusinessTime,
    faBriefcaseClock,
    faFlowerTulip,
    faPeoplePantsSimple,
    faCloudDrizzle,
    faTableCellsLarge,
    faThLarge,
    faBookTanakh,
    faTanakh,
    faSolarSystem,
    faSealQuestion,
    faPhoneVolume,
    faVolumeControlPhone,
    faDiscDrive,
    faHatCowboySide,
    faTableRows,
    faRows,
    faLocationExclamation,
    faMapMarkerExclamation,
    faFaceFearful,
    faClipboardUser,
    faBusSchool,
    faFilmSlash,
    faSquareArrowDownRight,
    faBookSparkles,
    faBookSpells,
    faWashingMachine,
    faWasher,
    faChild,
    faLiraSign,
    faUserVisor,
    faFilePlusMinus,
    faChessClockFlip,
    faChessClockAlt,
    faSatellite,
    faPlaneLock,
    faSteeringWheel,
    faTag,
    faStretcher,
    faBookSection,
    faBookLaw,
    faInboxes,
    faCoffeeBean,
    faBracketsCurly,
    faEllipsisStrokeVertical,
    faEllipsisVAlt,
    faComment,
    faSquare1,
    faCakeCandles,
    faBirthdayCake,
    faCake,
    faHeadSide,
    faEnvelope,
    faDollyEmpty,
    faFaceTissue,
    faAnglesUp,
    faAngleDoubleUp,
    faPaperclip,
    faChartLineDown,
    faArrowRightToCity,
    faLockA,
    faRibbon,
    faLungs,
    faPersonPinball,
    faArrowUp91,
    faSortNumericUpAlt,
    faAppleCore,
    faCircleY,
    faH6,
    faLitecoinSign,
    faCircleSmall,
    faBorderNone,
    faArrowTurnDownLeft,
    faCircleNodes,
    faParachuteBox,
    faMessageMedical,
    faCommentAltMedical,
    faRugbyBall,
    faCommentMusic,
    faIndent,
    faTreeDeciduous,
    faTreeAlt,
    faPuzzlePieceSimple,
    faPuzzlePieceAlt,
    faTruckFieldUn,
    faNfcTrash,
    faHourglass,
    faHourglassEmpty,
    faMountain,
    faFileXmark,
    faFileTimes,
    faHouseHeart,
    faHomeHeart,
    faHouseChimneyBlank,
    faMeterBolt,
    faUserDoctor,
    faUserMd,
    faSlashBack,
    faCircleInfo,
    faInfoCircle,
    faFishingRod,
    faHammerCrash,
    faMessageHeart,
    faCloudMeatball,
    faCameraPolaroid,
    faCamera,
    faCameraAlt,
    faSquareVirus,
    faCartArrowUp,
    faMeteor,
    faCarOn,
    faSleigh,
    faArrowDown19,
    faSortNumericAsc,
    faSortNumericDown,
    faBuoyMooring,
    faSquare4,
    faHandHoldingDroplet,
    faHandHoldingWater,
    faTricycleAdult,
    faWaveform,
    faWater,
    faStarSharpHalfStroke,
    faStarSharpHalfAlt,
    faNfcSignal,
    faPlaneProp,
    faCalendarCheck,
    faClockDesk,
    faCalendarClock,
    faCalendarTime,
    faBraille,
    faPrescriptionBottleMedical,
    faPrescriptionBottleAlt,
    faPlateUtensils,
    faFamilyPants,
    faHoseReel,
    faHouseWindow,
    faLandmark,
    faTruck,
    faCrosshairs,
    faCloudRainbow,
    faPersonCane,
    faAlien,
    faTent,
    faVestPatches,
    faPeopleDressSimple,
    faCheckDouble,
    faArrowDownAZ,
    faSortAlphaAsc,
    faSortAlphaDown,
    faBowlingBallPin,
    faBellSchoolSlash,
    faPlusLarge,
    faMoneyBillWheat,
    faCameraViewfinder,
    faScreenshot,
    faMessageMusic,
    faCommentAltMusic,
    faCarBuilding,
    faBorderBottomRight,
    faBorderStyleAlt,
    faOctagon,
    faCommentArrowUpRight,
    faOctagonDivide,
    faCookie,
    faArrowRotateLeft,
    faArrowLeftRotate,
    faArrowRotateBack,
    faArrowRotateBackward,
    faUndo,
    faTvMusic,
    faHardDrive,
    faHdd,
    faReel,
    faFaceGrinSquintTears,
    faGrinSquintTears,
    faDumbbell,
    faRectangleList,
    faListAlt,
    faTarpDroplet,
    faAlarmExclamation,
    faHouseMedicalCircleCheck,
    faTrafficCone,
    faGrate,
    faArrowDownRight,
    faPersonSkiingNordic,
    faSkiingNordic,
    faCalendarPlus,
    faPersonFromPortal,
    faPortalExit,
    faPlaneArrival,
    faCowbellCirclePlus,
    faCowbellMore,
    faCircleLeft,
    faArrowAltCircleLeft,
    faDistributeSpacingVertical,
    faSignalBarsFair,
    faSignalAlt2,
    faSportsball,
    faGameConsoleHandheldCrank,
    faTrainSubway,
    faSubway,
    faChartGantt,
    faFaceSmileUpsideDown,
    faBallPile,
    faBadgeDollar,
    faMoneyBillsSimple,
    faMoneyBillsAlt,
    faListTimeline,
    faIndianRupeeSign,
    faIndianRupee,
    faInr,
    faCropSimple,
    faCropAlt,
    faMoneyBill1,
    faMoneyBillAlt,
    faLeftLong,
    faLongArrowAltLeft,
    faKeyboardDown,
    faCircleUpRight,
    faCloudBoltMoon,
    faThunderstormMoon,
    faDna,
    faVirusSlash,
    faBracketRoundRight,
    faCircle5,
    faMinus,
    faSubtract,
    faFireFlame,
    faFlame,
    faRightToLine,
    faArrowAltToRight,
    faGif,
    faChess,
    faTrashSlash,
    faArrowLeftLong,
    faLongArrowLeft,
    faPlugCircleCheck,
    faFontCase,
    faStreetView,
    faArrowDownLeft,
    faFrancSign,
    faFlaskRoundPoison,
    faFlaskPoison,
    faVolumeOff,
    faBookCircleArrowRight,
    faChartUser,
    faUserChart,
    faHandsAslInterpreting,
    faAmericanSignLanguageInterpreting,
    faAslInterpreting,
    faHandsAmericanSignLanguageInterpreting,
    faPresentationScreen,
    faPresentation,
    faCircleBolt,
    faFaceSmileHalo,
    faCartCircleArrowDown,
    faHousePersonReturn,
    faHousePersonArrive,
    faHouseReturn,
    faMessageXmark,
    faCommentAltTimes,
    faMessageTimes,
    faFileCertificate,
    faFileAward,
    faUserDoctorHairLong,
    faCameraSecurity,
    faCameraHome,
    faGear,
    faCog,
    faDropletSlash,
    faTintSlash,
    faBookHeart,
    faMosque,
    faDuck,
    faMosquito,
    faStarOfDavid,
    faFlagSwallowtail,
    faFlagAlt,
    faPersonMilitaryRifle,
    faCarGarage,
    faCartShopping,
    faShoppingCart,
    faBookFont,
    faShieldPlus,
    faVials,
    faEyeDropperFull,
    faDistributeSpacingHorizontal,
    faTabletRugged,
    faTemperatureSnow,
    faTemperatureFrigid,
    faMoped,
    faFaceSmilePlus,
    faSmilePlus,
    faRadioTuner,
    faRadioAlt,
    faFaceSwear,
    faWaterArrowDown,
    faWaterLower,
    faScannerTouchscreen,
    faCircle7,
    faPlugCirclePlus,
    faPersonSkiJumping,
    faSkiJump,
    faPlaceOfWorship,
    faWaterArrowUp,
    faWaterRise,
    faWaveformLines,
    faWaveformPath,
    faSplit,
    faFilmCanister,
    faFilmCannister,
    faFolderXmark,
    faFolderTimes,
    faToiletPaperBlank,
    faToiletPaperAlt,
    faTabletScreen,
    faTabletAndroidAlt,
    faHexagonVerticalNftSlanted,
    faFolderMusic,
    faDisplayMedical,
    faDesktopMedical,
    faShareAll,
    faPeapod,
    faChessClock,
    faAxe,
    faSquareD,
    faGripVertical,
    faMobileSignalOut,
    faArrowTurnUp,
    faLevelUp,
    faU,
    faArrowUpFromDottedLine,
    faSquareRootVariable,
    faSquareRootAlt,
    faLightSwitchOn,
    faArrowDownArrowUp,
    faSortAlt,
    faRaindrops,
    faDash,
    faMinusLarge,
    faClock,
    faClockFour,
    faInputNumeric,
    faTruckTow,
    faBackwardStep,
    faStepBackward,
    faPallet,
    faCarBolt,
    faArrowsMaximize,
    faExpandArrows,
    faFaucet,
    faCloudSleet,
    faLampStreet,
    faListRadio,
    faPenNibSlash,
    faBaseballBatBall,
    faSquareUpLeft,
    faOverline,
    faS,
    faTimeline,
    faKeyboard,
    faArrowsFromDottedLine,
    faUsbDrive,
    faBallot,
    faCaretDown,
    faLocationDotSlash,
    faMapMarkerAltSlash,
    faCards,
    faHouseChimneyMedical,
    faClinicMedical,
    faBoxingGlove,
    faGloveBoxing,
    faTemperatureThreeQuarters,
    faTemperature3,
    faThermometer3,
    faThermometerThreeQuarters,
    faBellSchool,
    faMobileScreen,
    faMobileAndroidAlt,
    faPlaneUp,
    faFolderHeart,
    faCircleLocationArrow,
    faLocationCircle,
    faFaceHeadBandage,
    faSushiRoll,
    faMakiRoll,
    faMakizushi,
    faCarBump,
    faPiggyBank,
    faRacquet,
    faCarMirrors,
    faIndustryWindows,
    faIndustryAlt,
    faBoltAuto,
    faBatteryHalf,
    faBattery3,
    faFluxCapacitor,
    faMountainCity,
    faCoins,
    faHoneyPot,
    faOlive,
    faKhanda,
    faFilterList,
    faOutlet,
    faSliders,
    faSlidersH,
    faCauldron,
    faPeople,
    faFolderTree,
    faNetworkWired,
    faCroissant,
    faMapPin,
    faHamsa,
    faCentSign,
    faSwordsLaser,
    faFlask,
    faPersonPregnant,
    faSquareU,
    faWandSparkles,
    faRouter,
    faEllipsisVertical,
    faEllipsisV,
    faSwordLaserAlt,
    faTicket,
    faPowerOff,
    faCoin,
    faLaptopSlash,
    faRightLong,
    faLongArrowAltRight,
    faCircleB,
    faPersonDressSimple,
    faPipeCollar,
    faLightsHoliday,
    faCitrus,
    faFlagUsa,
    faLaptopFile,
    faTty,
    faTeletype,
    faChartTreeMap,
    faDiagramNext,
    faPersonRifle,
    faClockFiveThirty,
    faPipeValve,
    faArrowUpFromArc,
    faFaceSpiralEyes,
    faCompressWide,
    faCirclePhoneHangup,
    faPhoneCircleDown,
    faHouseMedicalCircleExclamation,
    faBadminton,
    faClosedCaptioning,
    faPersonHiking,
    faHiking,
    faRightFromLine,
    faArrowAltFromLeft,
    faVenusDouble,
    faImages,
    faCalculator,
    faShuttlecock,
    faUserHair,
    faEyeEvil,
    faPeoplePulling,
    faN,
    faGarage,
    faCableCar,
    faTram,
    faShovelSnow,
    faCloudRain,
    faFaceLying,
    faSprinkler,
    faBuildingCircleXmark,
    faPersonSledding,
    faSledding,
    faGameConsoleHandheld,
    faShip,
    faClockSixThirty,
    faBatterySlash,
    faTugrikSign,
    faArrowsDownToLine,
    faDownload,
    faShelves,
    faInventory,
    faCloudSnow,
    faFaceGrin,
    faGrin,
    faDeleteLeft,
    faBackspace,
    faOven,
    faEyeDropper,
    faEyeDropperEmpty,
    faEyedropper,
    faCommentCaptions,
    faCommentsQuestion,
    faScribble,
    faRotateExclamation,
    faFileCircleCheck,
    faGlass,
    faLoader,
    faForward,
    faUserPilot,
    faMobile,
    faMobileAndroid,
    faMobilePhone,
    faCodePullRequestClosed,
    faFaceMeh,
    faMeh,
    faAlignCenter,
    faBookSkull,
    faBookDead,
    faIdCard,
    faDriversLicense,
    faFaceDotted,
    faFaceWorried,
    faOutdent,
    faDedent,
    faHeartCircleExclamation,
    faHouse,
    faHome,
    faHomeAlt,
    faHomeLgAlt,
    faVectorCircle,
    faCarCircleBolt,
    faCalendarWeek,
    faFlyingDisc,
    faLaptopMedical,
    faSquareDownRight,
    faB,
    faSeatAirline,
    faMoonOverSun,
    faEclipseAlt,
    faPipe,
    faFileMedical,
    faPotato,
    faDiceOne,
    faCircleA,
    faHelmetBattle,
    faButter,
    faBlanketFire,
    faKiwiBird,
    faCastle,
    faGolfClub,
    faArrowRightArrowLeft,
    faExchange,
    faRotateRight,
    faRedoAlt,
    faRotateForward,
    faUtensils,
    faCutlery,
    faArrowUpWideShort,
    faSortAmountUp,
    faBalloons,
    faMillSign,
    faBowlRice,
    faTimelineArrow,
    faSkull,
    faGameBoardSimple,
    faGameBoardAlt,
    faCircleVideo,
    faVideoCircle,
    faChartScatterBubble,
    faHouseTurret,
    faBanana,
    faHandHoldingSkull,
    faPeopleDress,
    faLoveseat,
    faCouchSmall,
    faTowerBroadcast,
    faBroadcastTower,
    faTruckPickup,
    faBlockQuote,
    faUpLong,
    faLongArrowAltUp,
    faStop,
    faCodeMerge,
    faMoneyCheckDollarPen,
    faMoneyCheckEditAlt,
    faUpFromLine,
    faArrowAltFromBottom,
    faUpload,
    faHurricane,
    faPeoplePants,
    faMound,
    faWindsock,
    faCircleHalf,
    faBrakeWarning,
    faToiletPortable,
    faCompactDisc,
    faFileArrowDown,
    faFileDownload,
    faSaxophoneFire,
    faSaxHot,
    faCameraWebSlash,
    faWebcamSlash,
    faFolderMedical,
    faFolderGear,
    faFolderCog,
    faHandWave,
    faArrowUpArrowDown,
    faSortUpDown,
    faCaravan,
    faShieldCat,
    faMessageSlash,
    faCommentAltSlash,
    faBolt,
    faZap,
    faTrashCanCheck,
    faGlassWater,
    faOilWell,
    faPersonSimple,
    faVault,
    faMars,
    faToilet,
    faPlaneCircleXmark,
    faYenSign,
    faCny,
    faJpy,
    faRmb,
    faYen,
    faNotes,
    faRubleSign,
    faRouble,
    faRub,
    faRuble,
    faTrashUndo,
    faTrashArrowTurnLeft,
    faChampagneGlass,
    faGlassChampagne,
    faObjectsAlignCenterHorizontal,
    faSun,
    faTrashCanSlash,
    faTrashAltSlash,
    faScreenUsers,
    faUsersClass,
    faGuitar,
    faSquareArrowLeft,
    faArrowSquareLeft,
    faSquare8,
    faFaceSmileHearts,
    faBracketsSquare,
    faBrackets,
    faLaptopArrowDown,
    faHockeyStickPuck,
    faHouseTree,
    faSignalFair,
    faSignal2,
    faFaceLaughWink,
    faLaughWink,
    faCircleDollar,
    faDollarCircle,
    faUsdCircle,
    faHorseHead,
    faArrowsRepeat,
    faRepeatAlt,
    faBoreHole,
    faIndustry,
    faImagePolaroid,
    faWaveTriangle,
    faCircleDown,
    faArrowAltCircleDown,
    faGrill,
    faArrowsTurnToDots,
    faChartMixed,
    faAnalytics,
    faFlorinSign,
    faArrowDownShortWide,
    faSortAmountDesc,
    faSortAmountDownAlt,
    faLessThan,
    faDisplayCode,
    faDesktopCode,
    faFaceDrooling,
    faOilTemperature,
    faOilTemp,
    faSquareQuestion,
    faQuestionSquare,
    faAirConditioner,
    faAngleDown,
    faMountains,
    faOmega,
    faCarTunnel,
    faPersonDollyEmpty,
    faPanFood,
    faHeadSideCough,
    faGripLines,
    faThumbsDown,
    faUserLock,
    faArrowRightLong,
    faLongArrowRight,
    faTicketsAirline,
    faAnchorCircleXmark,
    faEllipsis,
    faEllipsisH,
    faNfcSlash,
    faChessPawn,
    faKitMedical,
    faFirstAid,
    faGrid2Plus,
    faBells,
    faPersonThroughWindow,
    faToolbox,
    faEnvelopeDot,
    faEnvelopeBadge,
    faHandsHoldingCircle,
    faBug,
    faBowlChopsticks,
    faCreditCard,
    faCreditCardAlt,
    faCircleS,
    faBoxBallot,
    faCar,
    faAutomobile,
    faHandHoldingHand,
    faUserTieHair,
    faPodiumStar,
    faUserHairMullet,
    faBusinessFront,
    faPartyBack,
    faTrianBalbot,
    faMicrophoneStand,
    faBookOpenReader,
    faBookReader,
    faFamilyDress,
    faCircleX,
    faCabin,
    faMountainSun,
    faChartSimpleHorizontal,
    faBluetooth,
    faArrowsLeftRightToLine,
    faHandBackPointLeft,
    faMessageDots,
    faCommentAltDots,
    faMessaging,
    faFileHeart,
    faBeerMug,
    faBeerFoam,
    faDiceD20,
    faDrone,
    faTruckDroplet,
    faFileCircleXmark,
    faTemperatureArrowUp,
    faTemperatureUp,
    faMedal,
    faBed,
    faBookCopy,
    faSquareH,
    faHSquare,
    faSquareC,
    faClockTwo,
    faSquareEllipsisVertical,
    faPodcast,
    faBee,
    faTemperatureFull,
    faTemperature4,
    faThermometer4,
    faThermometerFull,
    faBell,
    faCandyBar,
    faChocolateBar,
    faXmarkLarge,
    faPinata,
    faArrowsFromLine,
    faSuperscript,
    faBowlSpoon,
    faHexagonCheck,
    faPlugCircleXmark,
    faStarOfLife,
    faPhoneSlash,
    faTrafficLightStop,
    faPaintRoller,
    faAccentGrave,
    faHandshakeAngle,
    faHandsHelping,
    faCircle0,
    faDialMedLow,
    faLocationDot,
    faMapMarkerAlt,
    faCrab,
    faBoxOpenFull,
    faBoxFull,
    faFile,
    faGreaterThan,
    faQuotes,
    faPretzel,
    faPersonSwimming,
    faSwimmer,
    faArrowDown,
    faUserRobotXmarks,
    faMessageQuote,
    faCommentAltQuote,
    faCandyCorn,
    faFolderMagnifyingGlass,
    faFolderSearch,
    faNotebook,
    faDroplet,
    faTint,
    faBullseyePointer,
    faEraser,
    faHexagonImage,
    faEarthAmericas,
    faEarth,
    faEarthAmerica,
    faGlobeAmericas,
    faCrateApple,
    faAppleCrate,
    faPersonBurst,
    faGameBoard,
    faHatChef,
    faHandBackPointRight,
    faDove,
    faSnowflakeDroplets,
    faBatteryEmpty,
    faBattery0,
    faGrid4,
    faSocks,
    faFaceSunglasses,
    faInbox,
    faSquare0,
    faSection,
    faSquareThisWayUp,
    faBoxUp,
    faGaugeHigh,
    faTachometerAlt,
    faTachometerAltFast,
    faSquareAmpersand,
    faEnvelopeOpenText,
    faLampDesk,
    faHospital,
    faHospitalAlt,
    faHospitalWide,
    faPollPeople,
    faWhiskeyGlassIce,
    faGlassWhiskeyRocks,
    faWineBottle,
    faChessRook,
    faUserBountyHunter,
    faBarsStaggered,
    faReorder,
    faStream,
    faDiagramSankey,
    faCloudHailMixed,
    faCircleUpLeft,
    faDharmachakra,
    faObjectsAlignLeft,
    faOilCanDrip,
    faFaceSmilingHands,
    faBroccoli,
    faRouteInterstate,
    faEarMuffs,
    faHotdog,
    faTransporterEmpty,
    faPersonWalkingWithCane,
    faBlind,
    faAngle90,
    faRectangleTerminal,
    faKite,
    faDrum,
    faScrubber,
    faIceCream,
    faHeartCircleBolt,
    faFishBones,
    faDeerRudolph,
    faFax,
    faParagraph,
    faHeadSideHeart,
    faSquareE,
    faMeterFire,
    faCloudHail,
    faCheckToSlot,
    faVoteYea,
    faMoneyFromBracket,
    faStarHalf,
    faCarBus,
    faSpeaker,
    faTimer,
    faBoxesStacked,
    faBoxes,
    faBoxesAlt,
    faGrillHot,
    faBallotCheck,
    faLink,
    faChain,
    faEarListen,
    faAssistiveListeningSystems,
    faFileMinus,
    faTreeCity,
    faPlay,
    faFont,
    faCupTogo,
    faCoffeeTogo,
    faSquareDownLeft,
    faBurgerLettuce,
    faRupiahSign,
    faMagnifyingGlass,
    faSearch,
    faTableTennisPaddleBall,
    faPingPongPaddleBall,
    faTableTennis,
    faPersonDotsFromLine,
    faDiagnoses,
    faChevronsDown,
    faChevronDoubleDown,
    faTrashCanArrowUp,
    faTrashRestoreAlt,
    faSignalGood,
    faSignal3,
    faLocationQuestion,
    faMapMarkerQuestion,
    faFloppyDiskCircleXmark,
    faFloppyDiskTimes,
    faSaveCircleXmark,
    faSaveTimes,
    faNairaSign,
    faPeach,
    faTaxiBus,
    faBracketCurly,
    faBracketCurlyLeft,
    faLobster,
    faCartFlatbedEmpty,
    faDollyFlatbedEmpty,
    faColon,
    faCartArrowDown,
    faWand,
    faWalkieTalkie,
    faFilePen,
    faFileEdit,
    faReceipt,
    faTablePicnic,
    faSquarePen,
    faPenSquare,
    faPencilSquare,
    faCircleMicrophoneLines,
    faMicrophoneCircleAlt,
    faDisplaySlash,
    faDesktopSlash,
    faSuitcaseRolling,
    faPersonCircleExclamation,
    faTransporter2,
    faHandsHoldingDiamond,
    faHandReceiving,
    faMoneyBillSimpleWave,
    faChevronDown,
    faBatteryFull,
    faBattery,
    faBattery5,
    faBellPlus,
    faBookArrowRight,
    faHospitals,
    faClub,
    faSkullCrossbones,
    faDropletDegree,
    faDewpoint,
    faCodeCompare,
    faListUl,
    faListDots,
    faHandHoldingMagic,
    faWatermelonSlice,
    faCircleEllipsis,
    faSchoolLock,
    faTowerCell,
    faSdCards,
    faDownLong,
    faLongArrowAltDown,
    faEnvelopes,
    faPhoneOffice,
    faRankingStar,
    faChessKing,
    faNfcPen,
    faPersonHarassing,
    faHatWinter,
    faBrazilianRealSign,
    faLandmarkDome,
    faLandmarkAlt,
    faBoneBreak,
    faArrowUp,
    faDownFromDottedLine,
    faTv,
    faTelevision,
    faTvAlt,
    faBorderLeft,
    faCircleDivide,
    faShrimp,
    faListCheck,
    faTasks,
    faDiagramSubtask,
    faJugDetergent,
    faCircleUser,
    faUserCircle,
    faSquareY,
    faUserDoctorHair,
    faPlanetRinged,
    faMushroom,
    faUserShield,
    faMegaphone,
    faCircleExclamationCheck,
    faWind,
    faBoxDollar,
    faBoxUsd,
    faCarBurst,
    faCarCrash,
    faY,
    faUserHeadset,
    faArrowsRetweet,
    faRetweetAlt,
    faPersonSnowboarding,
    faSnowboarding,
    faSquareChevronRight,
    faChevronSquareRight,
    faLacrosseStickBall,
    faTruckFast,
    faShippingFast,
    faUserMagnifyingGlass,
    faStarSharp,
    faCommentHeart,
    faCircle1,
    faCircleStar,
    faStarCircle,
    faFish,
    faCloudFog,
    faFog,
    faWaffle,
    faMusicNote,
    faMusicAlt,
    faHexagonExclamation,
    faCartShoppingFast,
    faObjectUnion,
    faUserGraduate,
    faStarfighter,
    faCircleHalfStroke,
    faAdjust,
    faArrowRightLongToLine,
    faSquareArrowDown,
    faArrowSquareDown,
    faDiamondHalfStroke,
    faClapperboard,
    faSquareChevronLeft,
    faChevronSquareLeft,
    faPhoneIntercom,
    faLinkHorizontal,
    faChainHorizontal,
    faMango,
    faMusicNoteSlash,
    faMusicAltSlash,
    faCircleRadiation,
    faRadiationAlt,
    faFaceTongueSweat,
    faGlobeStand,
    faBaseball,
    faBaseballBall,
    faCircleP,
    faAwardSimple,
    faJetFighterUp,
    faDiagramProject,
    faProjectDiagram,
    faPedestal,
    faChartPyramid,
    faSidebar,
    faSnowmanHead,
    faFrostyHead,
    faCopy,
    faBurgerGlass,
    faVolumeXmark,
    faVolumeMute,
    faVolumeTimes,
    faHandSparkles,
    faBarsFilter,
    faPaintbrushPencil,
    faPartyBell,
    faUserVneckHair,
    faJackOLantern,
    faGrip,
    faGripHorizontal,
    faShareFromSquare,
    faShareSquare,
    faKeynote,
    faChildCombatant,
    faChildRifle,
    faGun,
    faSquarePhone,
    faPhoneSquare,
    faPlus,
    faAdd,
    faExpand,
    faComputer,
    faFort,
    faCloudCheck,
    faXmark,
    faClose,
    faMultiply,
    faRemove,
    faTimes,
    faFaceSmirking,
    faArrowsUpDownLeftRight,
    faArrows,
    faChalkboardUser,
    faChalkboardTeacher,
    faRhombus,
    faClawMarks,
    faPesoSign,
    faFaceSmileTongue,
    faCartCircleXmark,
    faBuildingShield,
    faCirclePhoneFlip,
    faPhoneCircleAlt,
    faBaby,
    faUsersLine,
    faQuoteLeft,
    faQuoteLeftAlt,
    faTractor,
    faKeySkeleton,
    faTrashArrowUp,
    faTrashRestore,
    faArrowDownUpLock,
    faArrowDownToBracket,
    faLinesLeaning,
    faSquareQ,
    faRulerCombined,
    faSymbols,
    faIconsAlt,
    faCopyright,
    faHighlighterLine,
    faBracketSquare,
    faBracket,
    faBracketLeft,
    faIslandTropical,
    faIslandTreePalm,
    faArrowRightFromLine,
    faArrowFromLeft,
    faH2,
    faEquals,
    faCakeSlice,
    faShortcake,
    faPeanut,
    faWrenchSimple,
    faBlender,
    faTeeth,
    faTally2,
    faShekelSign,
    faIls,
    faShekel,
    faSheqel,
    faSheqelSign,
    faCars,
    faAxeBattle,
    faUserHairLong,
    faMap,
    faFileCircleInfo,
    faFaceDisappointed,
    faLassoSparkles,
    faClockEleven,
    faRocket,
    faSirenOn,
    faClockTen,
    faCandleHolder,
    faVideoArrowDownLeft,
    faPhotoFilm,
    faPhotoVideo,
    faFloppyDiskCircleArrowRight,
    faSaveCircleArrowRight,
    faFolderMinus,
    faPlanetMoon,
    faFaceEyesXmarks,
    faChartScatter,
    faDisplayArrowDown,
    faStore,
    faArrowTrendUp,
    faPlugCircleMinus,
    faOliveBranch,
    faAngle,
    faVacuumRobot,
    faSignHanging,
    faSign,
    faSquareDivide,
    faSignalStreamSlash,
    faBezierCurve,
    faEyeDropperHalf,
    faStoreLock,
    faBellSlash,
    faCloudBoltSun,
    faThunderstormSun,
    faCameraSlash,
    faCommentQuote,
    faTablet,
    faTabletAndroid,
    faSchoolFlag,
    faMessageCode,
    faGlassHalf,
    faGlassHalfEmpty,
    faGlassHalfFull,
    faFill,
    faMessageMinus,
    faCommentAltMinus,
    faAngleUp,
    faDrumstickBite,
    faLinkHorizontalSlash,
    faChainHorizontalSlash,
    faHollyBerry,
    faNose,
    faChevronLeft,
    faBacteria,
    faClouds,
    faMoneyBillSimple,
    faHandLizard,
    faTablePivot,
    faFilterSlash,
    faTrashCanUndo,
    faTrashCanArrowTurnLeft,
    faTrashUndoAlt,
    faNotdef,
    faDisease,
    faPersonToDoor,
    faTurntable,
    faBriefcaseMedical,
    faGenderless,
    faChevronRight,
    faSignalWeak,
    faSignal1,
    faClockFive,
    faRetweet,
    faCarRear,
    faCarAlt,
    faPumpSoap,
    faComputerClassic,
    faFrame,
    faVideoSlash,
    faBatteryQuarter,
    faBattery2,
    faEllipsisStroke,
    faEllipsisHAlt,
    faRadio,
    faBabyCarriage,
    faCarriageBaby,
    faFaceExpressionless,
    faDownToDottedLine,
    faCloudMusic,
    faTrafficLight,
    faCloudMinus,
    faThermometer,
    faShieldMinus,
    faVrCardboard,
    faCarTilt,
    faGaugeCircleMinus,
    faBrightnessLow,
    faHandMiddleFinger,
    faPercent,
    faPercentage,
    faTruckMoving,
    faGlassWaterDroplet,
    faConveyorBelt,
    faLocationCheck,
    faMapMarkerCheck,
    faCoinVertical,
    faDisplay,
    faPersonSign,
    faFaceSmile,
    faSmile,
    faPhoneHangup,
    faSignatureSlash,
    faThumbtack,
    faThumbTack,
    faWheatSlash,
    faTrophy,
    faCloudsSun,
    faPersonPraying,
    faPray,
    faHammer,
    faFaceVomit,
    faSpeakers,
    faTtyAnswer,
    faTeletypeAnswer,
    faMugTeaSaucer,
    faDiagramLeanCanvas,
    faAlt,
    faDial,
    faDialMedHigh,
    faHandPeace,
    faCircleTrash,
    faTrashCircle,
    faRotate,
    faSyncAlt,
    faCircleQuarters,
    faSpinner,
    faTowerControl,
    faArrowUpTriangleSquare,
    faSortShapesUp,
    faWhale,
    faRobot,
    faPeace,
    faPartyHorn,
    faGears,
    faCogs,
    faSunBright,
    faSunAlt,
    faWarehouse,
    faLockKeyholeOpen,
    faLockOpenAlt,
    faSquareFragile,
    faBoxFragile,
    faSquareWineGlassCrack,
    faArrowUpRightDots,
    faSquareN,
    faSplotch,
    faFaceGrinHearts,
    faGrinHearts,
    faMeter,
    faMandolin,
    faDiceFour,
    faSimCard,
    faTransgender,
    faTransgenderAlt,
    faMercury,
    faUpFromBracket,
    faKnifeKitchen,
    faBorderRight,
    faArrowTurnDown,
    faLevelDown,
    faSpade,
    faCardSpade,
    faLineColumns,
    faArrowRightToLine,
    faArrowToRight,
    faPersonFallingBurst,
    faFlagPennant,
    faPennant,
    faConveyorBeltEmpty,
    faAward,
    faTicketSimple,
    faTicketAlt,
    faBuilding,
    faAnglesLeft,
    faAngleDoubleLeft,
    faCamcorder,
    faVideoHandheld,
    faPancakes,
    faAlbumCircleUser,
    faQrcode,
    faDiceD10,
    faFireplace,
    faBrowser,
    faPenPaintbrush,
    faPencilPaintbrush,
    faFishCooked,
    faChairOffice,
    faNestingDolls,
    faClockRotateLeft,
    faHistory,
    faTrumpet,
    faFaceGrinBeamSweat,
    faGrinBeamSweat,
    faFireSmoke,
    faPhoneMissed,
    faFileExport,
    faArrowRightFromFile,
    faShield,
    faShieldBlank,
    faArrowUpShortWide,
    faSortAmountUpAlt,
    faArrowsRepeat1,
    faRepeat1Alt,
    faGunSlash,
    faAvocado,
    faBinary,
    faGlassesRound,
    faGlassesAlt,
    faPhonePlus,
    faDitto,
    faPersonSeat,
    faHouseMedical,
    faGolfBallTee,
    faGolfBall,
    faCircleChevronLeft,
    faChevronCircleLeft,
    faHouseChimneyWindow,
    faScythe,
    faPenNib,
    faBanParking,
    faParkingCircleSlash,
    faTentArrowTurnLeft,
    faFaceDiagonalMouth,
    faDiagramCells,
    faCricketBatBall,
    faCricket,
    faTents,
    faWandMagic,
    faMagic,
    faDog,
    faPenLine,
    faAtomSimple,
    faAtomAlt,
    faAmpersand,
    faCarrot,
    faArrowUpFromLine,
    faArrowFromBottom,
    faMoon,
    faPenSlash,
    faWineGlassEmpty,
    faWineGlassAlt,
    faSquareStar,
    faCheese,
    faSendBackward,
    faYinYang,
    faMusic,
    faCompassSlash,
    faClockOne,
    faFileMusic,
    faCodeCommit,
    faTemperatureLow,
    faPersonBiking,
    faBiking,
    faSkeleton,
    faCircleG,
    faCircleArrowUpLeft,
    faCoinBlank,
    faBroom,
    faVacuum,
    faShieldHeart,
    faCardHeart,
    faLightbulbCflOn,
    faMelon,
    faGopuram,
    faEarthOceania,
    faGlobeOceania,
    faContainerStorage,
    faFacePouting,
    faSquareXmark,
    faTimesSquare,
    faXmarkSquare,
    faFaceExplode,
    faExplodingHead,
    faHashtag,
    faUpRightAndDownLeftFromCenter,
    faExpandAlt,
    faOilCan,
    faT,
    faTransformerBolt,
    faHippo,
    faChartColumn,
    faCassetteVhs,
    faVhs,
    faInfinity,
    faVialCircleCheck,
    faChimney,
    faObjectIntersect,
    faPersonArrowDownToLine,
    faVoicemail,
    faBlockBrick,
    faWallBrick,
    faFan,
    faBagsShopping,
    faParagraphLeft,
    faParagraphRtl,
    faPersonWalkingLuggage,
    faCaravanSimple,
    faCaravanAlt,
    faTurtle,
    faUpDown,
    faArrowsAltV,
    faCloudMoonRain,
    faBoothCurtain,
    faCalendar,
    faBoxHeart,
    faTrailer,
    faUserDoctorMessage,
    faUserMdChat,
    faBahai,
    faHaykal,
    faAmpGuitar,
    faSdCard,
    faVolumeSlash,
    faBorderBottom,
    faWifiWeak,
    faWifi1,
    faDragon,
    faShoePrints,
    faCirclePlus,
    faPlusCircle,
    faFaceGrinTongueWink,
    faGrinTongueWink,
    faHandHolding,
    faPlugCircleExclamation,
    faLinkSlash,
    faChainBroken,
    faChainSlash,
    faUnlink,
    faClone,
    faPersonWalkingArrowLoopLeft,
    faArrowUpZA,
    faSortAlphaUpAlt,
    faFireFlameCurved,
    faFireAlt,
    faTornado,
    faFileCirclePlus,
    faDeleteRight,
    faBookQuran,
    faQuran,
    faCircleQuarter,
    faAnchor,
    faBorderAll,
    faFunction,
    faFaceAngry,
    faAngry,
    faPeopleSimple,
    faCookieBite,
    faArrowTrendDown,
    faRss,
    faFeed,
    faFaceMonocle,
    faDrawPolygon,
    faScaleBalanced,
    faBalanceScale,
    faCalendarLines,
    faCalendarNote,
    faArrowDownBigSmall,
    faSortSizeDown,
    faGaugeSimpleHigh,
    faTachometer,
    faTachometerFast,
    faDoNotEnter,
    faShower,
    faDiceD8,
    faDesktop,
    faDesktopAlt,
    faM,
    faGripDotsVertical,
    faFaceViewfinder,
    faSoftServe,
    faCreemee,
    faH5,
    faHandBackPointDown,
    faTableList,
    faThList,
    faCommentSms,
    faSms,
    faRectangle,
    faRectangleLandscape,
    faClipboardListCheck,
    faTurkey,
    faBook,
    faUserPlus,
    faIceSkate,
    faCheck,
    faBatteryThreeQuarters,
    faBattery4,
    faTomato,
    faSwordLaser,
    faHouseCircleCheck,
    faBuildings,
    faAngleLeft,
    faCartFlatbedBoxes,
    faDollyFlatbedAlt,
    faDiagramSuccessor,
    faTruckArrowRight,
    faSquareW,
    faArrowsSplitUpAndLeft,
    faLamp,
    faAirplay,
    faHandFist,
    faFistRaised,
    faShieldQuartered,
    faSlashForward,
    faLocationPen,
    faMapMarkerEdit,
    faCloudMoon,
    faPotFood,
    faBriefcase,
    faPersonFalling,
    faImagePortrait,
    faPortrait,
    faUserTag,
    faRug,
    faPrintSlash,
    faEarthEurope,
    faGlobeEurope,
    faCartFlatbedSuitcase,
    faLuggageCart,
    faHandBackPointRibbon,
    faRectangleXmark,
    faRectangleTimes,
    faTimesRectangle,
    faWindowClose,
    faTireRugged,
    faLightbulbDollar,
    faCowbell,
    faBahtSign,
    faCorner,
    faChevronsRight,
    faChevronDoubleRight,
    faBookOpen,
    faBookJournalWhills,
    faJournalWhills,
    faInhaler,
    faHandcuffs,
    faSnake,
    faTriangleExclamation,
    faExclamationTriangle,
    faWarning,
    faNoteMedical,
    faDatabase,
    faDownLeft,
    faShare,
    faArrowTurnRight,
    faMailForward,
    faFaceThinking,
    faTurnDownRight,
    faBottleDroplet,
    faMaskFace,
    faHillRockslide,
    faScannerKeyboard,
    faCircleO,
    faGridHorizontal,
    faMessageDollar,
    faCommentAltDollar,
    faRightLeft,
    faExchangeAlt,
    faColumns3,
    faPaperPlane,
    faRoadCircleExclamation,
    faDungeon,
    faHandHoldingBox,
    faInputText,
    faWindowFlip,
    faWindowAlt,
    faAlignRight,
    faScannerGun,
    faScanner,
    faTire,
    faEngine,
    faMoneyBill1Wave,
    faMoneyBillWaveAlt,
    faLifeRing,
    faHands,
    faSignLanguage,
    faSigning,
    faCircleCaretRight,
    faCaretCircleRight,
    faWheat,
    faFileSpreadsheet,
    faAudioDescriptionSlash,
    faCalendarDay,
    faWaterLadder,
    faLadderWater,
    faSwimmingPool,
    faArrowsUpDown,
    faArrowsV,
    faChessPawnPiece,
    faChessPawnAlt,
    faFaceGrimace,
    faGrimace,
    faWheelchairMove,
    faWheelchairAlt,
    faTurnDown,
    faLevelDownAlt,
    faSquareS,
    faRectangleBarcode,
    faBarcodeAlt,
    faPersonWalkingArrowRight,
    faSquareEnvelope,
    faEnvelopeSquare,
    faDice,
    faUnicorn,
    faBowlingBall,
    faPompebled,
    faBrain,
    faWatchSmart,
    faBookUser,
    faSensorCloud,
    faSensorSmoke,
    faClapperboardPlay,
    faBandage,
    faBandAid,
    faCalendarMinus,
    faCircleXmark,
    faTimesCircle,
    faXmarkCircle,
    faCircle4,
    faGifts,
    faAlbumCollection,
    faHotel,
    faEarthAsia,
    faGlobeAsia,
    faIdCardClip,
    faIdCardAlt,
    faMagnifyingGlassPlus,
    faSearchPlus,
    faThumbsUp,
    faCloudShowers,
    faUserClock,
    faOnion,
    faClockTwelveThirty,
    faArrowDownToDottedLine,
    faHandDots,
    faAllergies,
    faFileInvoice,
    faWindowMinimize,
    faRectangleWide,
    faCommentArrowUp,
    faGarlic,
    faMugSaucer,
    faCoffee,
    faBrush,
    faTreeDecorated,
    faMask,
    faCalendarHeart,
    faMagnifyingGlassMinus,
    faSearchMinus,
    faFlower,
    faRulerVertical,
    faUserLarge,
    faUserAlt,
    faStarshipFreighter,
    faTrainTram,
    faBridgeSuspension,
    faTrashCheck,
    faUserNurse,
    faBoombox,
    faSyringe,
    faCloudSun,
    faShieldExclamation,
    faStopwatch20,
    faSquareFull,
    faGripDots,
    faCommentExclamation,
    faPenSwirl,
    faFalafel,
    faCircle2,
    faMagnet,
    faJar,
    faGramophone,
    faDiceD12,
    faNoteSticky,
    faStickyNote,
    faDown,
    faArrowAltDown,
    faHundredPoints,
    fa100,
    faPaperclipVertical,
    faWindWarning,
    faWindCircleExclamation,
    faLocationPinSlash,
    faMapMarkerSlash,
    faFaceSadSweat,
    faBugSlash,
    faCupcake,
    faLightSwitchOff,
    faToggleLargeOff,
    faPenFancySlash,
    faTruckContainer,
    faBoot,
    faArrowUpFromWaterPump,
    faFileCheck,
    faBone,
    faCardsBlank,
    faCircle3,
    faBenchTree,
    faKeyboardBrightnessLow,
    faSkiBootSki,
    faBrainCircuit,
    faUserInjured,
    faBlockBrickFire,
    faFirewall,
    faFaceSadTear,
    faSadTear,
    faPlane,
    faTentArrowsDown,
    faExclamation,
    faArrowsSpin,
    faFaceSmileRelaxed,
    faCommentXmark,
    faCommentTimes,
    faPrint,
    faTurkishLiraSign,
    faTry,
    faTurkishLira,
    faFaceNoseSteam,
    faCircleWaveformLines,
    faWaveformCircle,
    faDollarSign,
    faDollar,
    faUsd,
    faFerrisWheel,
    faComputerSpeaker,
    faSkullCow,
    faX,
    faMagnifyingGlassDollar,
    faSearchDollar,
    faUsersGear,
    faUsersCog,
    faPersonMilitaryPointing,
    faBuildingColumns,
    faBank,
    faInstitution,
    faMuseum,
    faUniversity,
    faCircleT,
    faSack,
    faGrid2,
    faCameraCctv,
    faCctv,
    faUmbrella,
    faTrowel,
    faHorizontalRule,
    faBedFront,
    faBedAlt,
    faD,
    faStapler,
    faMasksTheater,
    faTheaterMasks,
    faKipSign,
    faFaceWoozy,
    faCloudQuestion,
    faPineapple,
    faHandPointLeft,
    faGalleryThumbnails,
    faCircleJ,
    faEyes,
    faHandshakeSimple,
    faHandshakeAlt,
    faPageCaretUp,
    faFileCaretUp,
    faJetFighter,
    faFighterJet,
    faComet,
    faSquareShareNodes,
    faShareAltSquare,
    faShieldKeyhole,
    faBarcode,
    faPlusMinus,
    faSquareSlidersVertical,
    faSlidersVSquare,
    faVideo,
    faVideoCamera,
    faMessageMiddle,
    faCommentMiddleAlt,
    faGraduationCap,
    faMortarBoard,
    faHandHoldingMedical,
    faPersonCircleCheck,
    faSquareZ,
    faMessageText,
    faCommentAltText,
    faTurnUp,
    faLevelUpAlt,
    IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';

export enum EnumIcon {
    fa0 = 'fa0',
    fa1 = 'fa1',
    fa2 = 'fa2',
    fa3 = 'fa3',
    fa4 = 'fa4',
    fa5 = 'fa5',
    fa6 = 'fa6',
    fa7 = 'fa7',
    fa8 = 'fa8',
    fa9 = 'fa9',
    faFillDrip = 'faFillDrip',
    faArrowsToCircle = 'faArrowsToCircle',
    faCircleChevronRight = 'faCircleChevronRight',
    faChevronCircleRight = 'faChevronCircleRight',
    faWagonCovered = 'faWagonCovered',
    faLineHeight = 'faLineHeight',
    faBagel = 'faBagel',
    faTransporter7 = 'faTransporter7',
    faAt = 'faAt',
    faRectanglesMixed = 'faRectanglesMixed',
    faPhoneArrowUpRight = 'faPhoneArrowUpRight',
    faPhoneArrowUp = 'faPhoneArrowUp',
    faPhoneOutgoing = 'faPhoneOutgoing',
    faTrashCan = 'faTrashCan',
    faTrashAlt = 'faTrashAlt',
    faCircleL = 'faCircleL',
    faHeadSideGoggles = 'faHeadSideGoggles',
    faHeadVr = 'faHeadVr',
    faTextHeight = 'faTextHeight',
    faUserXmark = 'faUserXmark',
    faUserTimes = 'faUserTimes',
    faFaceHandYawn = 'faFaceHandYawn',
    faGaugeSimpleMin = 'faGaugeSimpleMin',
    faTachometerSlowest = 'faTachometerSlowest',
    faStethoscope = 'faStethoscope',
    faCoffin = 'faCoffin',
    faMessage = 'faMessage',
    faCommentAlt = 'faCommentAlt',
    faSalad = 'faSalad',
    faBowlSalad = 'faBowlSalad',
    faInfo = 'faInfo',
    faRobotAstromech = 'faRobotAstromech',
    faRingDiamond = 'faRingDiamond',
    faFonduePot = 'faFonduePot',
    faTheta = 'faTheta',
    faFaceHandPeeking = 'faFaceHandPeeking',
    faSquareUser = 'faSquareUser',
    faDownLeftAndUpRightToCenter = 'faDownLeftAndUpRightToCenter',
    faCompressAlt = 'faCompressAlt',
    faExplosion = 'faExplosion',
    faFileLines = 'faFileLines',
    faFileAlt = 'faFileAlt',
    faFileText = 'faFileText',
    faWaveSquare = 'faWaveSquare',
    faRing = 'faRing',
    faBuildingUn = 'faBuildingUn',
    faDiceThree = 'faDiceThree',
    faTirePressureWarning = 'faTirePressureWarning',
    faWifiFair = 'faWifiFair',
    faWifi2 = 'faWifi2',
    faCalendarDays = 'faCalendarDays',
    faCalendarAlt = 'faCalendarAlt',
    faMp3Player = 'faMp3Player',
    faAnchorCircleCheck = 'faAnchorCircleCheck',
    faTally4 = 'faTally4',
    faRectangleHistory = 'faRectangleHistory',
    faBuildingCircleArrowRight = 'faBuildingCircleArrowRight',
    faVolleyball = 'faVolleyball',
    faVolleyballBall = 'faVolleyballBall',
    faSunHaze = 'faSunHaze',
    faTextSize = 'faTextSize',
    faUfo = 'faUfo',
    faFork = 'faFork',
    faUtensilFork = 'faUtensilFork',
    faArrowsUpToLine = 'faArrowsUpToLine',
    faMobileSignal = 'faMobileSignal',
    faBarcodeScan = 'faBarcodeScan',
    faSortDown = 'faSortDown',
    faSortDesc = 'faSortDesc',
    faFolderArrowDown = 'faFolderArrowDown',
    faFolderDownload = 'faFolderDownload',
    faCircleMinus = 'faCircleMinus',
    faMinusCircle = 'faMinusCircle',
    faFaceIcicles = 'faFaceIcicles',
    faShovel = 'faShovel',
    faDoorOpen = 'faDoorOpen',
    faFilms = 'faFilms',
    faRightFromBracket = 'faRightFromBracket',
    faSignOutAlt = 'faSignOutAlt',
    faFaceGlasses = 'faFaceGlasses',
    faNfc = 'faNfc',
    faAtom = 'faAtom',
    faSoap = 'faSoap',
    faIcons = 'faIcons',
    faHeartMusicCameraBolt = 'faHeartMusicCameraBolt',
    faMicrophoneLinesSlash = 'faMicrophoneLinesSlash',
    faMicrophoneAltSlash = 'faMicrophoneAltSlash',
    faClosedCaptioningSlash = 'faClosedCaptioningSlash',
    faCalculatorSimple = 'faCalculatorSimple',
    faCalculatorAlt = 'faCalculatorAlt',
    faBridgeCircleCheck = 'faBridgeCircleCheck',
    faSlidersUp = 'faSlidersUp',
    faSlidersV = 'faSlidersV',
    faLocationMinus = 'faLocationMinus',
    faMapMarkerMinus = 'faMapMarkerMinus',
    faPumpMedical = 'faPumpMedical',
    faFingerprint = 'faFingerprint',
    faSkiBoot = 'faSkiBoot',
    faStandardDefinition = 'faStandardDefinition',
    faRectangleSd = 'faRectangleSd',
    faH1 = 'faH1',
    faHandPointRight = 'faHandPointRight',
    faMagnifyingGlassLocation = 'faMagnifyingGlassLocation',
    faSearchLocation = 'faSearchLocation',
    faMessageBot = 'faMessageBot',
    faForwardStep = 'faForwardStep',
    faStepForward = 'faStepForward',
    faFaceSmileBeam = 'faFaceSmileBeam',
    faSmileBeam = 'faSmileBeam',
    faLightCeiling = 'faLightCeiling',
    faMessageExclamation = 'faMessageExclamation',
    faCommentAltExclamation = 'faCommentAltExclamation',
    faBowlScoop = 'faBowlScoop',
    faBowlShavedIce = 'faBowlShavedIce',
    faSquareX = 'faSquareX',
    faUtilityPoleDouble = 'faUtilityPoleDouble',
    faFlagCheckered = 'faFlagCheckered',
    faChevronsUp = 'faChevronsUp',
    faChevronDoubleUp = 'faChevronDoubleUp',
    faFootball = 'faFootball',
    faFootballBall = 'faFootballBall',
    faUserVneck = 'faUserVneck',
    faSchoolCircleExclamation = 'faSchoolCircleExclamation',
    faCrop = 'faCrop',
    faAnglesDown = 'faAnglesDown',
    faAngleDoubleDown = 'faAngleDoubleDown',
    faUsersRectangle = 'faUsersRectangle',
    faPeopleRoof = 'faPeopleRoof',
    faSquareArrowRight = 'faSquareArrowRight',
    faArrowSquareRight = 'faArrowSquareRight',
    faLocationPlus = 'faLocationPlus',
    faMapMarkerPlus = 'faMapMarkerPlus',
    faLightbulbExclamationOn = 'faLightbulbExclamationOn',
    faPeopleLine = 'faPeopleLine',
    faBeerMugEmpty = 'faBeerMugEmpty',
    faBeer = 'faBeer',
    faCrateEmpty = 'faCrateEmpty',
    faDiagramPredecessor = 'faDiagramPredecessor',
    faTransporter = 'faTransporter',
    faCalendarCircleUser = 'faCalendarCircleUser',
    faArrowUpLong = 'faArrowUpLong',
    faLongArrowUp = 'faLongArrowUp',
    faPersonCarryBox = 'faPersonCarryBox',
    faPersonCarry = 'faPersonCarry',
    faFireFlameSimple = 'faFireFlameSimple',
    faBurn = 'faBurn',
    faPerson = 'faPerson',
    faMale = 'faMale',
    faLaptop = 'faLaptop',
    faFileCsv = 'faFileCsv',
    faMenorah = 'faMenorah',
    faUnion = 'faUnion',
    faChevronsLeft = 'faChevronsLeft',
    faChevronDoubleLeft = 'faChevronDoubleLeft',
    faCircleHeart = 'faCircleHeart',
    faHeartCircle = 'faHeartCircle',
    faTruckPlane = 'faTruckPlane',
    faRecordVinyl = 'faRecordVinyl',
    faBringForward = 'faBringForward',
    faSquareP = 'faSquareP',
    faFaceGrinStars = 'faFaceGrinStars',
    faGrinStars = 'faGrinStars',
    faSigma = 'faSigma',
    faCameraMovie = 'faCameraMovie',
    faBong = 'faBong',
    faClarinet = 'faClarinet',
    faTruckFlatbed = 'faTruckFlatbed',
    faSpaghettiMonsterFlying = 'faSpaghettiMonsterFlying',
    faPastafarianism = 'faPastafarianism',
    faArrowDownUpAcrossLine = 'faArrowDownUpAcrossLine',
    faLeafHeart = 'faLeafHeart',
    faHouseBuilding = 'faHouseBuilding',
    faCheeseSwiss = 'faCheeseSwiss',
    faSpoon = 'faSpoon',
    faUtensilSpoon = 'faUtensilSpoon',
    faJarWheat = 'faJarWheat',
    faEnvelopesBulk = 'faEnvelopesBulk',
    faMailBulk = 'faMailBulk',
    faFileCircleExclamation = 'faFileCircleExclamation',
    faBowArrow = 'faBowArrow',
    faCartXmark = 'faCartXmark',
    faHexagonXmark = 'faHexagonXmark',
    faTimesHexagon = 'faTimesHexagon',
    faXmarkHexagon = 'faXmarkHexagon',
    faCircleH = 'faCircleH',
    faHospitalSymbol = 'faHospitalSymbol',
    faMerge = 'faMerge',
    faPager = 'faPager',
    faCartMinus = 'faCartMinus',
    faAddressBook = 'faAddressBook',
    faContactBook = 'faContactBook',
    faPanFrying = 'faPanFrying',
    faGrid = 'faGrid',
    faGrid3 = 'faGrid3',
    faFootballHelmet = 'faFootballHelmet',
    faHandLove = 'faHandLove',
    faTrees = 'faTrees',
    faStrikethrough = 'faStrikethrough',
    faPage = 'faPage',
    faK = 'faK',
    faDiagramPrevious = 'faDiagramPrevious',
    faGaugeMin = 'faGaugeMin',
    faTachometerAltSlowest = 'faTachometerAltSlowest',
    faFolderGrid = 'faFolderGrid',
    faEggplant = 'faEggplant',
    faRam = 'faRam',
    faLandmarkFlag = 'faLandmarkFlag',
    faLips = 'faLips',
    faPencil = 'faPencil',
    faPencilAlt = 'faPencilAlt',
    faBackward = 'faBackward',
    faCaretRight = 'faCaretRight',
    faComments = 'faComments',
    faPaste = 'faPaste',
    faFileClipboard = 'faFileClipboard',
    faDesktopArrowDown = 'faDesktopArrowDown',
    faCodePullRequest = 'faCodePullRequest',
    faPumpkin = 'faPumpkin',
    faClipboardList = 'faClipboardList',
    faPenField = 'faPenField',
    faBlueberries = 'faBlueberries',
    faTruckRampBox = 'faTruckRampBox',
    faTruckLoading = 'faTruckLoading',
    faNote = 'faNote',
    faArrowDownToSquare = 'faArrowDownToSquare',
    faUserCheck = 'faUserCheck',
    faCloudXmark = 'faCloudXmark',
    faVialVirus = 'faVialVirus',
    faBookBlank = 'faBookBlank',
    faBookAlt = 'faBookAlt',
    faGolfFlagHole = 'faGolfFlagHole',
    faMessageArrowDown = 'faMessageArrowDown',
    faCommentAltArrowDown = 'faCommentAltArrowDown',
    faFaceUnamused = 'faFaceUnamused',
    faSheetPlastic = 'faSheetPlastic',
    faCircle9 = 'faCircle9',
    faBlog = 'faBlog',
    faUserNinja = 'faUserNinja',
    faPencilSlash = 'faPencilSlash',
    faBowlingPins = 'faBowlingPins',
    faPersonArrowUpFromLine = 'faPersonArrowUpFromLine',
    faDownRight = 'faDownRight',
    faScrollTorah = 'faScrollTorah',
    faTorah = 'faTorah',
    faBlindsOpen = 'faBlindsOpen',
    faFence = 'faFence',
    faUp = 'faUp',
    faArrowAltUp = 'faArrowAltUp',
    faBroomBall = 'faBroomBall',
    faQuidditch = 'faQuidditch',
    faQuidditchBroomBall = 'faQuidditchBroomBall',
    faDrumstick = 'faDrumstick',
    faSquareV = 'faSquareV',
    faFaceAwesome = 'faFaceAwesome',
    faGaveDandy = 'faGaveDandy',
    faDialOff = 'faDialOff',
    faToggleOff = 'faToggleOff',
    faFaceSmileHorns = 'faFaceSmileHorns',
    faBoxArchive = 'faBoxArchive',
    faArchive = 'faArchive',
    faGrapes = 'faGrapes',
    faPersonDrowning = 'faPersonDrowning',
    faDialMax = 'faDialMax',
    faCircleM = 'faCircleM',
    faCalendarImage = 'faCalendarImage',
    faCircleCaretDown = 'faCircleCaretDown',
    faCaretCircleDown = 'faCaretCircleDown',
    faArrowDown91 = 'faArrowDown91',
    faSortNumericDesc = 'faSortNumericDesc',
    faSortNumericDownAlt = 'faSortNumericDownAlt',
    faFaceGrinTongueSquint = 'faFaceGrinTongueSquint',
    faGrinTongueSquint = 'faGrinTongueSquint',
    faShishKebab = 'faShishKebab',
    faSprayCan = 'faSprayCan',
    faAlarmSnooze = 'faAlarmSnooze',
    faScarecrow = 'faScarecrow',
    faTruckMonster = 'faTruckMonster',
    faGiftCard = 'faGiftCard',
    faW = 'faW',
    faCodePullRequestDraft = 'faCodePullRequestDraft',
    faSquareB = 'faSquareB',
    faElephant = 'faElephant',
    faEarthAfrica = 'faEarthAfrica',
    faGlobeAfrica = 'faGlobeAfrica',
    faRainbow = 'faRainbow',
    faCircleNotch = 'faCircleNotch',
    faTabletScreenButton = 'faTabletScreenButton',
    faTabletAlt = 'faTabletAlt',
    faPaw = 'faPaw',
    faMessageQuestion = 'faMessageQuestion',
    faCloud = 'faCloud',
    faTrowelBricks = 'faTrowelBricks',
    faSquare3 = 'faSquare3',
    faFaceFlushed = 'faFaceFlushed',
    faFlushed = 'faFlushed',
    faHospitalUser = 'faHospitalUser',
    faMicrowave = 'faMicrowave',
    faTentArrowLeftRight = 'faTentArrowLeftRight',
    faCartCircleArrowUp = 'faCartCircleArrowUp',
    faTrashClock = 'faTrashClock',
    faGavel = 'faGavel',
    faLegal = 'faLegal',
    faSprinklerCeiling = 'faSprinklerCeiling',
    faBrowsers = 'faBrowsers',
    faTrillium = 'faTrillium',
    faMusicSlash = 'faMusicSlash',
    faTruckRamp = 'faTruckRamp',
    faBinoculars = 'faBinoculars',
    faMicrophoneSlash = 'faMicrophoneSlash',
    faBoxTissue = 'faBoxTissue',
    faCircleC = 'faCircleC',
    faStarChristmas = 'faStarChristmas',
    faChartBullet = 'faChartBullet',
    faMotorcycle = 'faMotorcycle',
    faTreeChristmas = 'faTreeChristmas',
    faTireFlat = 'faTireFlat',
    faSunglasses = 'faSunglasses',
    faBadge = 'faBadge',
    faMessagePen = 'faMessagePen',
    faCommentAltEdit = 'faCommentAltEdit',
    faMessageEdit = 'faMessageEdit',
    faBellConcierge = 'faBellConcierge',
    faConciergeBell = 'faConciergeBell',
    faPenRuler = 'faPenRuler',
    faPencilRuler = 'faPencilRuler',
    faChessRookPiece = 'faChessRookPiece',
    faChessRookAlt = 'faChessRookAlt',
    faSquareRoot = 'faSquareRoot',
    faAlbumCollectionCirclePlus = 'faAlbumCollectionCirclePlus',
    faPeopleArrows = 'faPeopleArrows',
    faPeopleArrowsLeftRight = 'faPeopleArrowsLeftRight',
    faFaceAngryHorns = 'faFaceAngryHorns',
    faMarsAndVenusBurst = 'faMarsAndVenusBurst',
    faTombstone = 'faTombstone',
    faSquareCaretRight = 'faSquareCaretRight',
    faCaretSquareRight = 'faCaretSquareRight',
    faScissors = 'faScissors',
    faCut = 'faCut',
    faListMusic = 'faListMusic',
    faSunPlantWilt = 'faSunPlantWilt',
    faToiletsPortable = 'faToiletsPortable',
    faHockeyPuck = 'faHockeyPuck',
    faMustache = 'faMustache',
    faHyphen = 'faHyphen',
    faTable = 'faTable',
    faUserChef = 'faUserChef',
    faMessageImage = 'faMessageImage',
    faCommentAltImage = 'faCommentAltImage',
    faUsersMedical = 'faUsersMedical',
    faSensorTriangleExclamation = 'faSensorTriangleExclamation',
    faSensorAlert = 'faSensorAlert',
    faMagnifyingGlassArrowRight = 'faMagnifyingGlassArrowRight',
    faTachographDigital = 'faTachographDigital',
    faDigitalTachograph = 'faDigitalTachograph',
    faFaceMask = 'faFaceMask',
    faPickleball = 'faPickleball',
    faStarSharpHalf = 'faStarSharpHalf',
    faUsersSlash = 'faUsersSlash',
    faClover = 'faClover',
    faMeat = 'faMeat',
    faReply = 'faReply',
    faMailReply = 'faMailReply',
    faStarAndCrescent = 'faStarAndCrescent',
    faEmptySet = 'faEmptySet',
    faHouseFire = 'faHouseFire',
    faSquareMinus = 'faSquareMinus',
    faMinusSquare = 'faMinusSquare',
    faHelicopter = 'faHelicopter',
    faBird = 'faBird',
    faCompass = 'faCompass',
    faSquareCaretDown = 'faSquareCaretDown',
    faCaretSquareDown = 'faCaretSquareDown',
    faHeartHalfStroke = 'faHeartHalfStroke',
    faHeartHalfAlt = 'faHeartHalfAlt',
    faFileCircleQuestion = 'faFileCircleQuestion',
    faLaptopCode = 'faLaptopCode',
    faJoystick = 'faJoystick',
    faGrillFire = 'faGrillFire',
    faRectangleVerticalHistory = 'faRectangleVerticalHistory',
    faSwatchbook = 'faSwatchbook',
    faPrescriptionBottle = 'faPrescriptionBottle',
    faBars = 'faBars',
    faNavicon = 'faNavicon',
    faKeyboardLeft = 'faKeyboardLeft',
    faPeopleGroup = 'faPeopleGroup',
    faHourglassEnd = 'faHourglassEnd',
    faHourglass3 = 'faHourglass3',
    faHeartCrack = 'faHeartCrack',
    faHeartBroken = 'faHeartBroken',
    faFaceBeamHandOverMouth = 'faFaceBeamHandOverMouth',
    faDropletPercent = 'faDropletPercent',
    faHumidity = 'faHumidity',
    faSquareUpRight = 'faSquareUpRight',
    faExternalLinkSquareAlt = 'faExternalLinkSquareAlt',
    faFaceKissBeam = 'faFaceKissBeam',
    faKissBeam = 'faKissBeam',
    faCorn = 'faCorn',
    faRollerCoaster = 'faRollerCoaster',
    faPhotoFilmMusic = 'faPhotoFilmMusic',
    faRadar = 'faRadar',
    faSickle = 'faSickle',
    faFilm = 'faFilm',
    faCoconut = 'faCoconut',
    faRulerHorizontal = 'faRulerHorizontal',
    faShieldCross = 'faShieldCross',
    faCassetteTape = 'faCassetteTape',
    faSquareTerminal = 'faSquareTerminal',
    faPeopleRobbery = 'faPeopleRobbery',
    faLightbulb = 'faLightbulb',
    faCaretLeft = 'faCaretLeft',
    faCommentMiddle = 'faCommentMiddle',
    faTrashCanList = 'faTrashCanList',
    faBlock = 'faBlock',
    faCircleExclamation = 'faCircleExclamation',
    faExclamationCircle = 'faExclamationCircle',
    faSchoolCircleXmark = 'faSchoolCircleXmark',
    faArrowRightFromBracket = 'faArrowRightFromBracket',
    faSignOut = 'faSignOut',
    faFaceFrownSlight = 'faFaceFrownSlight',
    faCircleChevronDown = 'faCircleChevronDown',
    faChevronCircleDown = 'faChevronCircleDown',
    faSidebarFlip = 'faSidebarFlip',
    faUnlockKeyhole = 'faUnlockKeyhole',
    faUnlockAlt = 'faUnlockAlt',
    faTemperatureList = 'faTemperatureList',
    faCloudShowersHeavy = 'faCloudShowersHeavy',
    faHeadphonesSimple = 'faHeadphonesSimple',
    faHeadphonesAlt = 'faHeadphonesAlt',
    faSitemap = 'faSitemap',
    faPipeSection = 'faPipeSection',
    faSpaceStationMoonConstruction = 'faSpaceStationMoonConstruction',
    faSpaceStationMoonAlt = 'faSpaceStationMoonAlt',
    faCircleDollarToSlot = 'faCircleDollarToSlot',
    faDonate = 'faDonate',
    faMemory = 'faMemory',
    faFaceSleeping = 'faFaceSleeping',
    faRoadSpikes = 'faRoadSpikes',
    faFireBurner = 'faFireBurner',
    faSquirrel = 'faSquirrel',
    faArrowUpToLine = 'faArrowUpToLine',
    faArrowToTop = 'faArrowToTop',
    faFlag = 'faFlag',
    faFaceCowboyHat = 'faFaceCowboyHat',
    faHanukiah = 'faHanukiah',
    faChartScatter3d = 'faChartScatter3d',
    faSquareCode = 'faSquareCode',
    faFeather = 'faFeather',
    faVolumeLow = 'faVolumeLow',
    faVolumeDown = 'faVolumeDown',
    faXmarkToSlot = 'faXmarkToSlot',
    faTimesToSlot = 'faTimesToSlot',
    faVoteNay = 'faVoteNay',
    faBoxTaped = 'faBoxTaped',
    faBoxAlt = 'faBoxAlt',
    faCommentSlash = 'faCommentSlash',
    faSwords = 'faSwords',
    faCloudSunRain = 'faCloudSunRain',
    faAlbum = 'faAlbum',
    faCircleN = 'faCircleN',
    faCompress = 'faCompress',
    faWheatAwn = 'faWheatAwn',
    faWheatAlt = 'faWheatAlt',
    faAnkh = 'faAnkh',
    faHandsHoldingChild = 'faHandsHoldingChild',
    faAsterisk = 'faAsterisk',
    faKeySkeletonLeftRight = 'faKeySkeletonLeftRight',
    faCommentLines = 'faCommentLines',
    faLuchadorMask = 'faLuchadorMask',
    faLuchador = 'faLuchador',
    faMaskLuchador = 'faMaskLuchador',
    faSquareCheck = 'faSquareCheck',
    faCheckSquare = 'faCheckSquare',
    faShredder = 'faShredder',
    faBookOpenCover = 'faBookOpenCover',
    faBookOpenAlt = 'faBookOpenAlt',
    faSandwich = 'faSandwich',
    faPesetaSign = 'faPesetaSign',
    faSquareParkingSlash = 'faSquareParkingSlash',
    faParkingSlash = 'faParkingSlash',
    faTrainTunnel = 'faTrainTunnel',
    faHeading = 'faHeading',
    faHeader = 'faHeader',
    faGhost = 'faGhost',
    faFaceAnguished = 'faFaceAnguished',
    faHockeySticks = 'faHockeySticks',
    faAbacus = 'faAbacus',
    faFilmSimple = 'faFilmSimple',
    faFilmAlt = 'faFilmAlt',
    faList = 'faList',
    faListSquares = 'faListSquares',
    faTreePalm = 'faTreePalm',
    faSquarePhoneFlip = 'faSquarePhoneFlip',
    faPhoneSquareAlt = 'faPhoneSquareAlt',
    faCartPlus = 'faCartPlus',
    faGamepad = 'faGamepad',
    faBorderCenterV = 'faBorderCenterV',
    faCircleDot = 'faCircleDot',
    faDotCircle = 'faDotCircle',
    faClipboardMedical = 'faClipboardMedical',
    faFaceDizzy = 'faFaceDizzy',
    faDizzy = 'faDizzy',
    faEgg = 'faEgg',
    faUpToLine = 'faUpToLine',
    faArrowAltToTop = 'faArrowAltToTop',
    faHouseMedicalCircleXmark = 'faHouseMedicalCircleXmark',
    faWatchFitness = 'faWatchFitness',
    faClockNineThirty = 'faClockNineThirty',
    faCampground = 'faCampground',
    faFolderPlus = 'faFolderPlus',
    faJug = 'faJug',
    faFutbol = 'faFutbol',
    faFutbolBall = 'faFutbolBall',
    faSoccerBall = 'faSoccerBall',
    faSnowBlowing = 'faSnowBlowing',
    faPaintbrush = 'faPaintbrush',
    faPaintBrush = 'faPaintBrush',
    faLock = 'faLock',
    faArrowDownFromLine = 'faArrowDownFromLine',
    faArrowFromTop = 'faArrowFromTop',
    faGasPump = 'faGasPump',
    faSignalBarsSlash = 'faSignalBarsSlash',
    faSignalAltSlash = 'faSignalAltSlash',
    faMonkey = 'faMonkey',
    faRectanglePro = 'faRectanglePro',
    faPro = 'faPro',
    faHouseNight = 'faHouseNight',
    faHotTubPerson = 'faHotTubPerson',
    faHotTub = 'faHotTub',
    faBlanket = 'faBlanket',
    faMapLocation = 'faMapLocation',
    faMapMarked = 'faMapMarked',
    faHouseFloodWater = 'faHouseFloodWater',
    faCommentsQuestionCheck = 'faCommentsQuestionCheck',
    faTree = 'faTree',
    faArrowsCross = 'faArrowsCross',
    faBackpack = 'faBackpack',
    faSquareSmall = 'faSquareSmall',
    faFolderArrowUp = 'faFolderArrowUp',
    faFolderUpload = 'faFolderUpload',
    faBridgeLock = 'faBridgeLock',
    faCrosshairsSimple = 'faCrosshairsSimple',
    faSackDollar = 'faSackDollar',
    faPenToSquare = 'faPenToSquare',
    faEdit = 'faEdit',
    faSquareSliders = 'faSquareSliders',
    faSlidersHSquare = 'faSlidersHSquare',
    faCarSide = 'faCarSide',
    faMessageMiddleTop = 'faMessageMiddleTop',
    faCommentMiddleTopAlt = 'faCommentMiddleTopAlt',
    faLightbulbOn = 'faLightbulbOn',
    faKnife = 'faKnife',
    faUtensilKnife = 'faUtensilKnife',
    faShareNodes = 'faShareNodes',
    faShareAlt = 'faShareAlt',
    faWaveSine = 'faWaveSine',
    faHeartCircleMinus = 'faHeartCircleMinus',
    faCircleW = 'faCircleW',
    faCircleCalendar = 'faCircleCalendar',
    faCalendarCircle = 'faCalendarCircle',
    faHourglassHalf = 'faHourglassHalf',
    faHourglass2 = 'faHourglass2',
    faMicroscope = 'faMicroscope',
    faSunset = 'faSunset',
    faSink = 'faSink',
    faCalendarExclamation = 'faCalendarExclamation',
    faTruckContainerEmpty = 'faTruckContainerEmpty',
    faHandHeart = 'faHandHeart',
    faBagShopping = 'faBagShopping',
    faShoppingBag = 'faShoppingBag',
    faArrowDownZA = 'faArrowDownZA',
    faSortAlphaDesc = 'faSortAlphaDesc',
    faSortAlphaDownAlt = 'faSortAlphaDownAlt',
    faMitten = 'faMitten',
    faReplyClock = 'faReplyClock',
    faReplyTime = 'faReplyTime',
    faPersonRays = 'faPersonRays',
    faRight = 'faRight',
    faArrowAltRight = 'faArrowAltRight',
    faCircleF = 'faCircleF',
    faUsers = 'faUsers',
    faFacePleading = 'faFacePleading',
    faEyeSlash = 'faEyeSlash',
    faFlaskVial = 'faFlaskVial',
    faPoliceBox = 'faPoliceBox',
    faCucumber = 'faCucumber',
    faHeadSideBrain = 'faHeadSideBrain',
    faHand = 'faHand',
    faHandPaper = 'faHandPaper',
    faPersonBikingMountain = 'faPersonBikingMountain',
    faBikingMountain = 'faBikingMountain',
    faUtensilsSlash = 'faUtensilsSlash',
    faPrintMagnifyingGlass = 'faPrintMagnifyingGlass',
    faPrintSearch = 'faPrintSearch',
    faFolderBookmark = 'faFolderBookmark',
    faOm = 'faOm',
    faPi = 'faPi',
    faFlaskRoundPotion = 'faFlaskRoundPotion',
    faFlaskPotion = 'faFlaskPotion',
    faFaceShush = 'faFaceShush',
    faWorm = 'faWorm',
    faHouseCircleXmark = 'faHouseCircleXmark',
    faPlug = 'faPlug',
    faCalendarCircleExclamation = 'faCalendarCircleExclamation',
    faSquareI = 'faSquareI',
    faChevronUp = 'faChevronUp',
    faFaceSaluting = 'faFaceSaluting',
    faGaugeSimpleLow = 'faGaugeSimpleLow',
    faTachometerSlow = 'faTachometerSlow',
    faFacePersevering = 'faFacePersevering',
    faCircleCamera = 'faCircleCamera',
    faCameraCircle = 'faCameraCircle',
    faHandSpock = 'faHandSpock',
    faSpiderWeb = 'faSpiderWeb',
    faCircleMicrophone = 'faCircleMicrophone',
    faMicrophoneCircle = 'faMicrophoneCircle',
    faBookArrowUp = 'faBookArrowUp',
    faPopsicle = 'faPopsicle',
    faCommand = 'faCommand',
    faBlinds = 'faBlinds',
    faStopwatch = 'faStopwatch',
    faSaxophone = 'faSaxophone',
    faSquare2 = 'faSquare2',
    faFieldHockeyStickBall = 'faFieldHockeyStickBall',
    faFieldHockey = 'faFieldHockey',
    faArrowUpSquareTriangle = 'faArrowUpSquareTriangle',
    faSortShapesUpAlt = 'faSortShapesUpAlt',
    faFaceScream = 'faFaceScream',
    faSquareM = 'faSquareM',
    faCameraWeb = 'faCameraWeb',
    faWebcam = 'faWebcam',
    faCommentArrowDown = 'faCommentArrowDown',
    faLightbulbCfl = 'faLightbulbCfl',
    faWindowFrameOpen = 'faWindowFrameOpen',
    faFaceKiss = 'faFaceKiss',
    faKiss = 'faKiss',
    faBridgeCircleXmark = 'faBridgeCircleXmark',
    faPeriod = 'faPeriod',
    faFaceGrinTongue = 'faFaceGrinTongue',
    faGrinTongue = 'faGrinTongue',
    faUpToDottedLine = 'faUpToDottedLine',
    faThoughtBubble = 'faThoughtBubble',
    faRaygun = 'faRaygun',
    faFlute = 'faFlute',
    faAcorn = 'faAcorn',
    faVideoArrowUpRight = 'faVideoArrowUpRight',
    faGrateDroplet = 'faGrateDroplet',
    faSealExclamation = 'faSealExclamation',
    faChessBishop = 'faChessBishop',
    faMessageSms = 'faMessageSms',
    faCoffeeBeans = 'faCoffeeBeans',
    faHatWitch = 'faHatWitch',
    faFaceGrinWink = 'faFaceGrinWink',
    faGrinWink = 'faGrinWink',
    faClockThreeThirty = 'faClockThreeThirty',
    faEarDeaf = 'faEarDeaf',
    faDeaf = 'faDeaf',
    faDeafness = 'faDeafness',
    faHardOfHearing = 'faHardOfHearing',
    faAlarmClock = 'faAlarmClock',
    faEclipse = 'faEclipse',
    faFaceRelieved = 'faFaceRelieved',
    faRoadCircleCheck = 'faRoadCircleCheck',
    faDiceFive = 'faDiceFive',
    faOctagonMinus = 'faOctagonMinus',
    faMinusOctagon = 'faMinusOctagon',
    faSquareRss = 'faSquareRss',
    faRssSquare = 'faRssSquare',
    faFaceZany = 'faFaceZany',
    faTricycle = 'faTricycle',
    faLandMineOn = 'faLandMineOn',
    faSquareArrowUpLeft = 'faSquareArrowUpLeft',
    faICursor = 'faICursor',
    faSaltShaker = 'faSaltShaker',
    faStamp = 'faStamp',
    faFilePlus = 'faFilePlus',
    faDrawSquare = 'faDrawSquare',
    faToiletPaperUnderSlash = 'faToiletPaperUnderSlash',
    faToiletPaperReverseSlash = 'faToiletPaperReverseSlash',
    faStairs = 'faStairs',
    faDroneFront = 'faDroneFront',
    faDroneAlt = 'faDroneAlt',
    faGlassEmpty = 'faGlassEmpty',
    faDialHigh = 'faDialHigh',
    faUserHelmetSafety = 'faUserHelmetSafety',
    faUserConstruction = 'faUserConstruction',
    faUserHardHat = 'faUserHardHat',
    faI = 'faI',
    faHryvniaSign = 'faHryvniaSign',
    faHryvnia = 'faHryvnia',
    faArrowDownLeftAndArrowUpRightToCenter = 'faArrowDownLeftAndArrowUpRightToCenter',
    faPills = 'faPills',
    faFaceGrinWide = 'faFaceGrinWide',
    faGrinAlt = 'faGrinAlt',
    faTooth = 'faTooth',
    faBasketballHoop = 'faBasketballHoop',
    faObjectsAlignBottom = 'faObjectsAlignBottom',
    faV = 'faV',
    faSparkles = 'faSparkles',
    faSquid = 'faSquid',
    faLeafyGreen = 'faLeafyGreen',
    faCircleArrowUpRight = 'faCircleArrowUpRight',
    faCalendars = 'faCalendars',
    faBangladeshiTakaSign = 'faBangladeshiTakaSign',
    faBicycle = 'faBicycle',
    faHammerWar = 'faHammerWar',
    faCircleD = 'faCircleD',
    faSpiderBlackWidow = 'faSpiderBlackWidow',
    faStaffSnake = 'faStaffSnake',
    faRodAsclepius = 'faRodAsclepius',
    faRodSnake = 'faRodSnake',
    faStaffAesculapius = 'faStaffAesculapius',
    faPear = 'faPear',
    faHeadSideCoughSlash = 'faHeadSideCoughSlash',
    faTriangle = 'faTriangle',
    faApartment = 'faApartment',
    faTruckMedical = 'faTruckMedical',
    faAmbulance = 'faAmbulance',
    faPepper = 'faPepper',
    faPiano = 'faPiano',
    faGunSquirt = 'faGunSquirt',
    faWheatAwnCircleExclamation = 'faWheatAwnCircleExclamation',
    faSnowman = 'faSnowman',
    faUserAlien = 'faUserAlien',
    faShieldCheck = 'faShieldCheck',
    faMortarPestle = 'faMortarPestle',
    faRoadBarrier = 'faRoadBarrier',
    faChartCandlestick = 'faChartCandlestick',
    faBriefcaseBlank = 'faBriefcaseBlank',
    faSchool = 'faSchool',
    faIgloo = 'faIgloo',
    faBracketRound = 'faBracketRound',
    faParenthesis = 'faParenthesis',
    faJoint = 'faJoint',
    faHorseSaddle = 'faHorseSaddle',
    faMugMarshmallows = 'faMugMarshmallows',
    faFilters = 'faFilters',
    faBellOn = 'faBellOn',
    faAngleRight = 'faAngleRight',
    faDialMed = 'faDialMed',
    faHorse = 'faHorse',
    faQ = 'faQ',
    faMonitorWaveform = 'faMonitorWaveform',
    faMonitorHeartRate = 'faMonitorHeartRate',
    faLinkSimple = 'faLinkSimple',
    faWhistle = 'faWhistle',
    faG = 'faG',
    faWineGlassCrack = 'faWineGlassCrack',
    faFragile = 'faFragile',
    faSlotMachine = 'faSlotMachine',
    faNotesMedical = 'faNotesMedical',
    faCarWash = 'faCarWash',
    faEscalator = 'faEscalator',
    faCommentImage = 'faCommentImage',
    faTemperatureHalf = 'faTemperatureHalf',
    faTemperature2 = 'faTemperature2',
    faThermometer2 = 'faThermometer2',
    faThermometerHalf = 'faThermometerHalf',
    faDongSign = 'faDongSign',
    faDonut = 'faDonut',
    faDoughnut = 'faDoughnut',
    faCapsules = 'faCapsules',
    faPooStorm = 'faPooStorm',
    faPooBolt = 'faPooBolt',
    faTally1 = 'faTally1',
    faFaceFrownOpen = 'faFaceFrownOpen',
    faFrownOpen = 'faFrownOpen',
    faSquareDashed = 'faSquareDashed',
    faSquareJ = 'faSquareJ',
    faHandPointUp = 'faHandPointUp',
    faMoneyBill = 'faMoneyBill',
    faArrowUpBigSmall = 'faArrowUpBigSmall',
    faSortSizeUp = 'faSortSizeUp',
    faBarcodeRead = 'faBarcodeRead',
    faBaguette = 'faBaguette',
    faBowlSoftServe = 'faBowlSoftServe',
    faFaceHoldingBackTears = 'faFaceHoldingBackTears',
    faSquareUp = 'faSquareUp',
    faArrowAltSquareUp = 'faArrowAltSquareUp',
    faTrainSubwayTunnel = 'faTrainSubwayTunnel',
    faSubwayTunnel = 'faSubwayTunnel',
    faSquareExclamation = 'faSquareExclamation',
    faExclamationSquare = 'faExclamationSquare',
    faSemicolon = 'faSemicolon',
    faBookmark = 'faBookmark',
    faFanTable = 'faFanTable',
    faAlignJustify = 'faAlignJustify',
    faBatteryLow = 'faBatteryLow',
    faBattery1 = 'faBattery1',
    faCreditCardFront = 'faCreditCardFront',
    faBrainArrowCurvedRight = 'faBrainArrowCurvedRight',
    faMindShare = 'faMindShare',
    faUmbrellaBeach = 'faUmbrellaBeach',
    faHelmetUn = 'faHelmetUn',
    faLocationSmile = 'faLocationSmile',
    faMapMarkerSmile = 'faMapMarkerSmile',
    faArrowLeftToLine = 'faArrowLeftToLine',
    faArrowToLeft = 'faArrowToLeft',
    faBullseye = 'faBullseye',
    faSushi = 'faSushi',
    faNigiri = 'faNigiri',
    faMessageCaptions = 'faMessageCaptions',
    faCommentAltCaptions = 'faCommentAltCaptions',
    faTrashList = 'faTrashList',
    faBacon = 'faBacon',
    faOption = 'faOption',
    faHandPointDown = 'faHandPointDown',
    faArrowUpFromBracket = 'faArrowUpFromBracket',
    faTrashPlus = 'faTrashPlus',
    faObjectsAlignTop = 'faObjectsAlignTop',
    faFolder = 'faFolder',
    faFolderBlank = 'faFolderBlank',
    faFaceAnxiousSweat = 'faFaceAnxiousSweat',
    faCreditCardBlank = 'faCreditCardBlank',
    faFileWaveform = 'faFileWaveform',
    faFileMedicalAlt = 'faFileMedicalAlt',
    faMicrochipAi = 'faMicrochipAi',
    faMug = 'faMug',
    faPlaneUpSlash = 'faPlaneUpSlash',
    faRadiation = 'faRadiation',
    faPenCircle = 'faPenCircle',
    faChartSimple = 'faChartSimple',
    faCrutches = 'faCrutches',
    faCircleParking = 'faCircleParking',
    faParkingCircle = 'faParkingCircle',
    faMarsStroke = 'faMarsStroke',
    faLeafOak = 'faLeafOak',
    faSquareBolt = 'faSquareBolt',
    faVial = 'faVial',
    faGauge = 'faGauge',
    faDashboard = 'faDashboard',
    faGaugeMed = 'faGaugeMed',
    faTachometerAltAverage = 'faTachometerAltAverage',
    faWandMagicSparkles = 'faWandMagicSparkles',
    faMagicWandSparkles = 'faMagicWandSparkles',
    faLambda = 'faLambda',
    faE = 'faE',
    faPizza = 'faPizza',
    faBowlChopsticksNoodles = 'faBowlChopsticksNoodles',
    faH3 = 'faH3',
    faPenClip = 'faPenClip',
    faPenAlt = 'faPenAlt',
    faBridgeCircleExclamation = 'faBridgeCircleExclamation',
    faBadgePercent = 'faBadgePercent',
    faUser = 'faUser',
    faSensor = 'faSensor',
    faComma = 'faComma',
    faSchoolCircleCheck = 'faSchoolCircleCheck',
    faToiletPaperUnder = 'faToiletPaperUnder',
    faToiletPaperReverse = 'faToiletPaperReverse',
    faLightEmergency = 'faLightEmergency',
    faArrowDownToArc = 'faArrowDownToArc',
    faDumpster = 'faDumpster',
    faVanShuttle = 'faVanShuttle',
    faShuttleVan = 'faShuttleVan',
    faBuildingUser = 'faBuildingUser',
    faLightSwitch = 'faLightSwitch',
    faSquareCaretLeft = 'faSquareCaretLeft',
    faCaretSquareLeft = 'faCaretSquareLeft',
    faHighlighter = 'faHighlighter',
    faWavePulse = 'faWavePulse',
    faHeartRate = 'faHeartRate',
    faKey = 'faKey',
    faHatSanta = 'faHatSanta',
    faTamale = 'faTamale',
    faBoxCheck = 'faBoxCheck',
    faBullhorn = 'faBullhorn',
    faSteak = 'faSteak',
    faLocationCrosshairsSlash = 'faLocationCrosshairsSlash',
    faLocationSlash = 'faLocationSlash',
    faPersonDolly = 'faPersonDolly',
    faGlobe = 'faGlobe',
    faSynagogue = 'faSynagogue',
    faFileChartColumn = 'faFileChartColumn',
    faFileChartLine = 'faFileChartLine',
    faPersonHalfDress = 'faPersonHalfDress',
    faFolderImage = 'faFolderImage',
    faCalendarPen = 'faCalendarPen',
    faCalendarEdit = 'faCalendarEdit',
    faRoadBridge = 'faRoadBridge',
    faFaceSmileTear = 'faFaceSmileTear',
    faMessagePlus = 'faMessagePlus',
    faCommentAltPlus = 'faCommentAltPlus',
    faLocationArrow = 'faLocationArrow',
    faC = 'faC',
    faTabletButton = 'faTabletButton',
    faRectangleHistoryCircleUser = 'faRectangleHistoryCircleUser',
    faBuildingLock = 'faBuildingLock',
    faChartLineUp = 'faChartLineUp',
    faMailbox = 'faMailbox',
    faTruckBolt = 'faTruckBolt',
    faPizzaSlice = 'faPizzaSlice',
    faMoneyBillWave = 'faMoneyBillWave',
    faChartArea = 'faChartArea',
    faAreaChart = 'faAreaChart',
    faHouseFlag = 'faHouseFlag',
    faPersonCircleMinus = 'faPersonCircleMinus',
    faScalpel = 'faScalpel',
    faBan = 'faBan',
    faCancel = 'faCancel',
    faBellExclamation = 'faBellExclamation',
    faCircleBookmark = 'faCircleBookmark',
    faBookmarkCircle = 'faBookmarkCircle',
    faEggFried = 'faEggFried',
    faFaceWeary = 'faFaceWeary',
    faUniformMartialArts = 'faUniformMartialArts',
    faCameraRotate = 'faCameraRotate',
    faSunDust = 'faSunDust',
    faCommentText = 'faCommentText',
    faSprayCanSparkles = 'faSprayCanSparkles',
    faAirFreshener = 'faAirFreshener',
    faSignalBars = 'faSignalBars',
    faSignalAlt = 'faSignalAlt',
    faSignalAlt4 = 'faSignalAlt4',
    faSignalBarsStrong = 'faSignalBarsStrong',
    faDiamondExclamation = 'faDiamondExclamation',
    faStar = 'faStar',
    faDialMin = 'faDialMin',
    faRepeat = 'faRepeat',
    faCross = 'faCross',
    faPageCaretDown = 'faPageCaretDown',
    faFileCaretDown = 'faFileCaretDown',
    faBox = 'faBox',
    faVenusMars = 'faVenusMars',
    faClockSevenThirty = 'faClockSevenThirty',
    faArrowPointer = 'faArrowPointer',
    faMousePointer = 'faMousePointer',
    faClockFourThirty = 'faClockFourThirty',
    faSignalBarsGood = 'faSignalBarsGood',
    faSignalAlt3 = 'faSignalAlt3',
    faCactus = 'faCactus',
    faMaximize = 'faMaximize',
    faExpandArrowsAlt = 'faExpandArrowsAlt',
    faChargingStation = 'faChargingStation',
    faShapes = 'faShapes',
    faTriangleCircleSquare = 'faTriangleCircleSquare',
    faPlaneTail = 'faPlaneTail',
    faGaugeSimpleMax = 'faGaugeSimpleMax',
    faTachometerFastest = 'faTachometerFastest',
    faCircleU = 'faCircleU',
    faShieldSlash = 'faShieldSlash',
    faSquarePhoneHangup = 'faSquarePhoneHangup',
    faPhoneSquareDown = 'faPhoneSquareDown',
    faArrowUpLeft = 'faArrowUpLeft',
    faTransporter1 = 'faTransporter1',
    faPeanuts = 'faPeanuts',
    faShuffle = 'faShuffle',
    faRandom = 'faRandom',
    faPersonRunning = 'faPersonRunning',
    faRunning = 'faRunning',
    faMobileRetro = 'faMobileRetro',
    faGripLinesVertical = 'faGripLinesVertical',
    faArrowUpFromSquare = 'faArrowUpFromSquare',
    faFileDashedLine = 'faFileDashedLine',
    faPageBreak = 'faPageBreak',
    faBracketCurlyRight = 'faBracketCurlyRight',
    faSpider = 'faSpider',
    faClockThree = 'faClockThree',
    faHandsBound = 'faHandsBound',
    faScalpelLineDashed = 'faScalpelLineDashed',
    faScalpelPath = 'faScalpelPath',
    faFileInvoiceDollar = 'faFileInvoiceDollar',
    faPipeSmoking = 'faPipeSmoking',
    faFaceAstonished = 'faFaceAstonished',
    faWindow = 'faWindow',
    faPlaneCircleExclamation = 'faPlaneCircleExclamation',
    faEar = 'faEar',
    faFileLock = 'faFileLock',
    faDiagramVenn = 'faDiagramVenn',
    faXRay = 'faXRay',
    faGoalNet = 'faGoalNet',
    faCoffinCross = 'faCoffinCross',
    faSpellCheck = 'faSpellCheck',
    faLocationXmark = 'faLocationXmark',
    faMapMarkerTimes = 'faMapMarkerTimes',
    faMapMarkerXmark = 'faMapMarkerXmark',
    faLasso = 'faLasso',
    faSlash = 'faSlash',
    faPersonToPortal = 'faPersonToPortal',
    faPortalEnter = 'faPortalEnter',
    faCalendarStar = 'faCalendarStar',
    faComputerMouse = 'faComputerMouse',
    faMouse = 'faMouse',
    faArrowRightToBracket = 'faArrowRightToBracket',
    faSignIn = 'faSignIn',
    faPegasus = 'faPegasus',
    faFilesMedical = 'faFilesMedical',
    faNfcLock = 'faNfcLock',
    faPersonSkiLift = 'faPersonSkiLift',
    faSkiLift = 'faSkiLift',
    faSquare6 = 'faSquare6',
    faShopSlash = 'faShopSlash',
    faStoreAltSlash = 'faStoreAltSlash',
    faWindTurbine = 'faWindTurbine',
    faSlidersSimple = 'faSlidersSimple',
    faBadgeSheriff = 'faBadgeSheriff',
    faServer = 'faServer',
    faVirusCovidSlash = 'faVirusCovidSlash',
    faIntersection = 'faIntersection',
    faShopLock = 'faShopLock',
    faFamily = 'faFamily',
    faHourglassStart = 'faHourglassStart',
    faHourglass1 = 'faHourglass1',
    faUserHairBuns = 'faUserHairBuns',
    faBlenderPhone = 'faBlenderPhone',
    faHourglassClock = 'faHourglassClock',
    faPersonSeatReclined = 'faPersonSeatReclined',
    faPaperPlaneTop = 'faPaperPlaneTop',
    faPaperPlaneAlt = 'faPaperPlaneAlt',
    faSend = 'faSend',
    faMessageArrowUp = 'faMessageArrowUp',
    faCommentAltArrowUp = 'faCommentAltArrowUp',
    faLightbulbExclamation = 'faLightbulbExclamation',
    faLayerMinus = 'faLayerMinus',
    faLayerGroupMinus = 'faLayerGroupMinus',
    faCircleE = 'faCircleE',
    faBuildingWheat = 'faBuildingWheat',
    faGaugeMax = 'faGaugeMax',
    faTachometerAltFastest = 'faTachometerAltFastest',
    faPersonBreastfeeding = 'faPersonBreastfeeding',
    faApostrophe = 'faApostrophe',
    faFireHydrant = 'faFireHydrant',
    faRightToBracket = 'faRightToBracket',
    faSignInAlt = 'faSignInAlt',
    faVideoPlus = 'faVideoPlus',
    faSquareRight = 'faSquareRight',
    faArrowAltSquareRight = 'faArrowAltSquareRight',
    faCommentSmile = 'faCommentSmile',
    faVenus = 'faVenus',
    faPassport = 'faPassport',
    faInboxIn = 'faInboxIn',
    faInboxArrowDown = 'faInboxArrowDown',
    faHeartPulse = 'faHeartPulse',
    faHeartbeat = 'faHeartbeat',
    faCircle8 = 'faCircle8',
    faCloudsMoon = 'faCloudsMoon',
    faClockTenThirty = 'faClockTenThirty',
    faPeopleCarryBox = 'faPeopleCarryBox',
    faPeopleCarry = 'faPeopleCarry',
    faFolderUser = 'faFolderUser',
    faTrashCanXmark = 'faTrashCanXmark',
    faTemperatureHigh = 'faTemperatureHigh',
    faMicrochip = 'faMicrochip',
    faLeftLongToLine = 'faLeftLongToLine',
    faCrown = 'faCrown',
    faWeightHanging = 'faWeightHanging',
    faXmarksLines = 'faXmarksLines',
    faFilePrescription = 'faFilePrescription',
    faCalendarRange = 'faCalendarRange',
    faFlowerDaffodil = 'faFlowerDaffodil',
    faHandBackPointUp = 'faHandBackPointUp',
    faWeightScale = 'faWeightScale',
    faWeight = 'faWeight',
    faStarExclamation = 'faStarExclamation',
    faBooks = 'faBooks',
    faUserGroup = 'faUserGroup',
    faUserFriends = 'faUserFriends',
    faArrowUpAZ = 'faArrowUpAZ',
    faSortAlphaUp = 'faSortAlphaUp',
    faLayerPlus = 'faLayerPlus',
    faLayerGroupPlus = 'faLayerGroupPlus',
    faPlayPause = 'faPlayPause',
    faBlockQuestion = 'faBlockQuestion',
    faSnooze = 'faSnooze',
    faZzz = 'faZzz',
    faScannerImage = 'faScannerImage',
    faTvRetro = 'faTvRetro',
    faSquareT = 'faSquareT',
    faFarm = 'faFarm',
    faBarnSilo = 'faBarnSilo',
    faChessKnight = 'faChessKnight',
    faBarsSort = 'faBarsSort',
    faPalletBoxes = 'faPalletBoxes',
    faPaletteBoxes = 'faPaletteBoxes',
    faPalletAlt = 'faPalletAlt',
    faFaceLaughSquint = 'faFaceLaughSquint',
    faLaughSquint = 'faLaughSquint',
    faCodeSimple = 'faCodeSimple',
    faBoltSlash = 'faBoltSlash',
    faPanelFire = 'faPanelFire',
    faBinaryCircleCheck = 'faBinaryCircleCheck',
    faCommentMinus = 'faCommentMinus',
    faBurrito = 'faBurrito',
    faViolin = 'faViolin',
    faObjectsColumn = 'faObjectsColumn',
    faSquareChevronDown = 'faSquareChevronDown',
    faChevronSquareDown = 'faChevronSquareDown',
    faCommentPlus = 'faCommentPlus',
    faTriangleInstrument = 'faTriangleInstrument',
    faTriangleMusic = 'faTriangleMusic',
    faWheelchair = 'faWheelchair',
    faUserPilotTie = 'faUserPilotTie',
    faPianoKeyboard = 'faPianoKeyboard',
    faBedEmpty = 'faBedEmpty',
    faCircleArrowUp = 'faCircleArrowUp',
    faArrowCircleUp = 'faArrowCircleUp',
    faToggleOn = 'faToggleOn',
    faRectangleVertical = 'faRectangleVertical',
    faRectanglePortrait = 'faRectanglePortrait',
    faPersonWalking = 'faPersonWalking',
    faWalking = 'faWalking',
    faL = 'faL',
    faSignalStream = 'faSignalStream',
    faDownToBracket = 'faDownToBracket',
    faCircleZ = 'faCircleZ',
    faStars = 'faStars',
    faFire = 'faFire',
    faBedPulse = 'faBedPulse',
    faProcedures = 'faProcedures',
    faHouseDay = 'faHouseDay',
    faShuttleSpace = 'faShuttleSpace',
    faSpaceShuttle = 'faSpaceShuttle',
    faShirtLongSleeve = 'faShirtLongSleeve',
    faChartPieSimple = 'faChartPieSimple',
    faChartPieAlt = 'faChartPieAlt',
    faFaceLaugh = 'faFaceLaugh',
    faLaugh = 'faLaugh',
    faFolderOpen = 'faFolderOpen',
    faAlbumCollectionCircleUser = 'faAlbumCollectionCircleUser',
    faCandy = 'faCandy',
    faBowlHot = 'faBowlHot',
    faSoup = 'faSoup',
    faFlatbread = 'faFlatbread',
    faHeartCirclePlus = 'faHeartCirclePlus',
    faCodeFork = 'faCodeFork',
    faCity = 'faCity',
    faSignalBarsWeak = 'faSignalBarsWeak',
    faSignalAlt1 = 'faSignalAlt1',
    faMicrophoneLines = 'faMicrophoneLines',
    faMicrophoneAlt = 'faMicrophoneAlt',
    faClockTwelve = 'faClockTwelve',
    faPepperHot = 'faPepperHot',
    faCitrusSlice = 'faCitrusSlice',
    faSheep = 'faSheep',
    faUnlock = 'faUnlock',
    faColonSign = 'faColonSign',
    faHeadset = 'faHeadset',
    faBadgerHoney = 'faBadgerHoney',
    faH4 = 'faH4',
    faStoreSlash = 'faStoreSlash',
    faRoadCircleXmark = 'faRoadCircleXmark',
    faSignalSlash = 'faSignalSlash',
    faUserMinus = 'faUserMinus',
    faMarsStrokeUp = 'faMarsStrokeUp',
    faMarsStrokeV = 'faMarsStrokeV',
    faChampagneGlasses = 'faChampagneGlasses',
    faGlassCheers = 'faGlassCheers',
    faTaco = 'faTaco',
    faHexagonPlus = 'faHexagonPlus',
    faPlusHexagon = 'faPlusHexagon',
    faClipboard = 'faClipboard',
    faHouseCircleExclamation = 'faHouseCircleExclamation',
    faFileArrowUp = 'faFileArrowUp',
    faFileUpload = 'faFileUpload',
    faWifi = 'faWifi',
    faWifi3 = 'faWifi3',
    faWifiStrong = 'faWifiStrong',
    faMessages = 'faMessages',
    faCommentsAlt = 'faCommentsAlt',
    faBath = 'faBath',
    faBathtub = 'faBathtub',
    faUmbrellaSimple = 'faUmbrellaSimple',
    faUmbrellaAlt = 'faUmbrellaAlt',
    faRectangleHistoryCirclePlus = 'faRectangleHistoryCirclePlus',
    faUnderline = 'faUnderline',
    faPrescriptionBottlePill = 'faPrescriptionBottlePill',
    faUserPen = 'faUserPen',
    faUserEdit = 'faUserEdit',
    faBinarySlash = 'faBinarySlash',
    faSquareO = 'faSquareO',
    faSignature = 'faSignature',
    faStroopwafel = 'faStroopwafel',
    faBold = 'faBold',
    faAnchorLock = 'faAnchorLock',
    faBuildingNgo = 'faBuildingNgo',
    faTransporter3 = 'faTransporter3',
    faEngineWarning = 'faEngineWarning',
    faEngineExclamation = 'faEngineExclamation',
    faCircleDownRight = 'faCircleDownRight',
    faSquareK = 'faSquareK',
    faManatSign = 'faManatSign',
    faMoneyCheckPen = 'faMoneyCheckPen',
    faMoneyCheckEdit = 'faMoneyCheckEdit',
    faNotEqual = 'faNotEqual',
    faBorderTopLeft = 'faBorderTopLeft',
    faBorderStyle = 'faBorderStyle',
    faMapLocationDot = 'faMapLocationDot',
    faMapMarkedAlt = 'faMapMarkedAlt',
    faTilde = 'faTilde',
    faJedi = 'faJedi',
    faSquarePollVertical = 'faSquarePollVertical',
    faPoll = 'faPoll',
    faArrowDownSquareTriangle = 'faArrowDownSquareTriangle',
    faSortShapesDownAlt = 'faSortShapesDownAlt',
    faMugHot = 'faMugHot',
    faDogLeashed = 'faDogLeashed',
    faCarBattery = 'faCarBattery',
    faBatteryCar = 'faBatteryCar',
    faFaceDowncastSweat = 'faFaceDowncastSweat',
    faMailboxFlagUp = 'faMailboxFlagUp',
    faMemoCircleInfo = 'faMemoCircleInfo',
    faGift = 'faGift',
    faDiceTwo = 'faDiceTwo',
    faVolume = 'faVolume',
    faVolumeMedium = 'faVolumeMedium',
    faTransporter5 = 'faTransporter5',
    faGaugeCircleBolt = 'faGaugeCircleBolt',
    faCoinFront = 'faCoinFront',
    faFileSlash = 'faFileSlash',
    faMessageArrowUpRight = 'faMessageArrowUpRight',
    faTreasureChest = 'faTreasureChest',
    faChessQueen = 'faChessQueen',
    faPaintbrushFine = 'faPaintbrushFine',
    faPaintBrushAlt = 'faPaintBrushAlt',
    faPaintBrushFine = 'faPaintBrushFine',
    faPaintbrushAlt = 'faPaintbrushAlt',
    faGlasses = 'faGlasses',
    faHoodCloak = 'faHoodCloak',
    faSquareQuote = 'faSquareQuote',
    faUpLeft = 'faUpLeft',
    faBringFront = 'faBringFront',
    faChessBoard = 'faChessBoard',
    faBurgerCheese = 'faBurgerCheese',
    faCheeseburger = 'faCheeseburger',
    faBuildingCircleCheck = 'faBuildingCircleCheck',
    faRepeat1 = 'faRepeat1',
    faArrowDownToLine = 'faArrowDownToLine',
    faArrowToBottom = 'faArrowToBottom',
    faGrid5 = 'faGrid5',
    faRightLongToLine = 'faRightLongToLine',
    faPersonChalkboard = 'faPersonChalkboard',
    faMarsStrokeRight = 'faMarsStrokeRight',
    faMarsStrokeH = 'faMarsStrokeH',
    faHandBackFist = 'faHandBackFist',
    faHandRock = 'faHandRock',
    faTally = 'faTally',
    faTally5 = 'faTally5',
    faSquareCaretUp = 'faSquareCaretUp',
    faCaretSquareUp = 'faCaretSquareUp',
    faCloudShowersWater = 'faCloudShowersWater',
    faChartBar = 'faChartBar',
    faBarChart = 'faBarChart',
    faHandsBubbles = 'faHandsBubbles',
    faHandsWash = 'faHandsWash',
    faLessThanEqual = 'faLessThanEqual',
    faTrain = 'faTrain',
    faUpFromDottedLine = 'faUpFromDottedLine',
    faEyeLowVision = 'faEyeLowVision',
    faLowVision = 'faLowVision',
    faTrafficLightGo = 'faTrafficLightGo',
    faFaceExhaling = 'faFaceExhaling',
    faSensorFire = 'faSensorFire',
    faUserUnlock = 'faUserUnlock',
    faHexagonDivide = 'faHexagonDivide',
    fa00 = 'fa00',
    faCrow = 'faCrow',
    faCassetteBetamax = 'faCassetteBetamax',
    faBetamax = 'faBetamax',
    faSailboat = 'faSailboat',
    faWindowRestore = 'faWindowRestore',
    faNfcMagnifyingGlass = 'faNfcMagnifyingGlass',
    faFileBinary = 'faFileBinary',
    faCircleV = 'faCircleV',
    faSquarePlus = 'faSquarePlus',
    faPlusSquare = 'faPlusSquare',
    faBowlScoops = 'faBowlScoops',
    faMistletoe = 'faMistletoe',
    faCustard = 'faCustard',
    faLacrosseStick = 'faLacrosseStick',
    faHockeyMask = 'faHockeyMask',
    faSunrise = 'faSunrise',
    faPanelEws = 'faPanelEws',
    faToriiGate = 'faToriiGate',
    faCloudExclamation = 'faCloudExclamation',
    faMessageLines = 'faMessageLines',
    faCommentAltLines = 'faCommentAltLines',
    faFrog = 'faFrog',
    faBucket = 'faBucket',
    faFloppyDiskPen = 'faFloppyDiskPen',
    faImage = 'faImage',
    faWindowFrame = 'faWindowFrame',
    faMicrophone = 'faMicrophone',
    faCow = 'faCow',
    faSquareRing = 'faSquareRing',
    faDownFromLine = 'faDownFromLine',
    faArrowAltFromTop = 'faArrowAltFromTop',
    faCaretUp = 'faCaretUp',
    faShieldXmark = 'faShieldXmark',
    faShieldTimes = 'faShieldTimes',
    faScrewdriver = 'faScrewdriver',
    faCircleSortDown = 'faCircleSortDown',
    faSortCircleDown = 'faSortCircleDown',
    faFolderClosed = 'faFolderClosed',
    faHouseTsunami = 'faHouseTsunami',
    faSquareNfi = 'faSquareNfi',
    faForklift = 'faForklift',
    faArrowUpFromGroundWater = 'faArrowUpFromGroundWater',
    faBracketSquareRight = 'faBracketSquareRight',
    faMartiniGlass = 'faMartiniGlass',
    faGlassMartiniAlt = 'faGlassMartiniAlt',
    faRotateLeft = 'faRotateLeft',
    faRotateBack = 'faRotateBack',
    faRotateBackward = 'faRotateBackward',
    faUndoAlt = 'faUndoAlt',
    faTableColumns = 'faTableColumns',
    faColumns = 'faColumns',
    faSquareA = 'faSquareA',
    faTick = 'faTick',
    faLemon = 'faLemon',
    faHeadSideMask = 'faHeadSideMask',
    faHandshake = 'faHandshake',
    faGem = 'faGem',
    faDolly = 'faDolly',
    faDollyBox = 'faDollyBox',
    faSmoking = 'faSmoking',
    faMinimize = 'faMinimize',
    faCompressArrowsAlt = 'faCompressArrowsAlt',
    faRefrigerator = 'faRefrigerator',
    faMonument = 'faMonument',
    faOctagonXmark = 'faOctagonXmark',
    faTimesOctagon = 'faTimesOctagon',
    faXmarkOctagon = 'faXmarkOctagon',
    faAlignSlash = 'faAlignSlash',
    faSnowplow = 'faSnowplow',
    faAnglesRight = 'faAnglesRight',
    faAngleDoubleRight = 'faAngleDoubleRight',
    faTruckRampCouch = 'faTruckRampCouch',
    faTruckCouch = 'faTruckCouch',
    faCannabis = 'faCannabis',
    faCirclePlay = 'faCirclePlay',
    faPlayCircle = 'faPlayCircle',
    faArrowUpRightAndArrowDownLeftFromCenter = 'faArrowUpRightAndArrowDownLeftFromCenter',
    faTablets = 'faTablets',
    fa360Degrees = 'fa360Degrees',
    faEthernet = 'faEthernet',
    faEuroSign = 'faEuroSign',
    faEur = 'faEur',
    faEuro = 'faEuro',
    faChair = 'faChair',
    faCircleCheck = 'faCircleCheck',
    faCheckCircle = 'faCheckCircle',
    faSquareDashedCirclePlus = 'faSquareDashedCirclePlus',
    faMoneySimpleFromBracket = 'faMoneySimpleFromBracket',
    faBat = 'faBat',
    faCircleStop = 'faCircleStop',
    faStopCircle = 'faStopCircle',
    faHeadSideHeadphones = 'faHeadSideHeadphones',
    faPhoneRotary = 'faPhoneRotary',
    faCompassDrafting = 'faCompassDrafting',
    faDraftingCompass = 'faDraftingCompass',
    faPlateWheat = 'faPlateWheat',
    faCalendarCircleMinus = 'faCalendarCircleMinus',
    faChopsticks = 'faChopsticks',
    faCarWrench = 'faCarWrench',
    faCarMechanic = 'faCarMechanic',
    faIcicles = 'faIcicles',
    faPersonShelter = 'faPersonShelter',
    faNeuter = 'faNeuter',
    faIdBadge = 'faIdBadge',
    faKazoo = 'faKazoo',
    faMarker = 'faMarker',
    faFaceLaughBeam = 'faFaceLaughBeam',
    faLaughBeam = 'faLaughBeam',
    faSquareArrowDownLeft = 'faSquareArrowDownLeft',
    faBatteryBolt = 'faBatteryBolt',
    faTreeLarge = 'faTreeLarge',
    faHelicopterSymbol = 'faHelicopterSymbol',
    faAperture = 'faAperture',
    faUniversalAccess = 'faUniversalAccess',
    faFileMagnifyingGlass = 'faFileMagnifyingGlass',
    faFileSearch = 'faFileSearch',
    faUpRight = 'faUpRight',
    faCircleChevronUp = 'faCircleChevronUp',
    faChevronCircleUp = 'faChevronCircleUp',
    faUserPolice = 'faUserPolice',
    faLariSign = 'faLariSign',
    faVolcano = 'faVolcano',
    faTeddyBear = 'faTeddyBear',
    faStocking = 'faStocking',
    faPersonWalkingDashedLineArrowRight = 'faPersonWalkingDashedLineArrowRight',
    faImageSlash = 'faImageSlash',
    faMaskSnorkel = 'faMaskSnorkel',
    faSmoke = 'faSmoke',
    faSterlingSign = 'faSterlingSign',
    faGbp = 'faGbp',
    faPoundSign = 'faPoundSign',
    faBatteryExclamation = 'faBatteryExclamation',
    faViruses = 'faViruses',
    faSquarePersonConfined = 'faSquarePersonConfined',
    faUserTie = 'faUserTie',
    faArrowDownLong = 'faArrowDownLong',
    faLongArrowDown = 'faLongArrowDown',
    faTentArrowDownToLine = 'faTentArrowDownToLine',
    faCertificate = 'faCertificate',
    faCrystalBall = 'faCrystalBall',
    faReplyAll = 'faReplyAll',
    faMailReplyAll = 'faMailReplyAll',
    faSuitcase = 'faSuitcase',
    faPersonSkating = 'faPersonSkating',
    faSkating = 'faSkating',
    faStarShooting = 'faStarShooting',
    faBinaryLock = 'faBinaryLock',
    faFilterCircleDollar = 'faFilterCircleDollar',
    faFunnelDollar = 'faFunnelDollar',
    faCameraRetro = 'faCameraRetro',
    faCircleArrowDown = 'faCircleArrowDown',
    faArrowCircleDown = 'faArrowCircleDown',
    faCommentPen = 'faCommentPen',
    faCommentEdit = 'faCommentEdit',
    faFileImport = 'faFileImport',
    faArrowRightToFile = 'faArrowRightToFile',
    faBanjo = 'faBanjo',
    faSquareArrowUpRight = 'faSquareArrowUpRight',
    faExternalLinkSquare = 'faExternalLinkSquare',
    faLightEmergencyOn = 'faLightEmergencyOn',
    faKerning = 'faKerning',
    faBoxOpen = 'faBoxOpen',
    faSquareF = 'faSquareF',
    faScroll = 'faScroll',
    faSpa = 'faSpa',
    faArrowLeftFromLine = 'faArrowLeftFromLine',
    faArrowFromRight = 'faArrowFromRight',
    faStrawberry = 'faStrawberry',
    faLocationPinLock = 'faLocationPinLock',
    faPause = 'faPause',
    faClockEightThirty = 'faClockEightThirty',
    faPlaneEngines = 'faPlaneEngines',
    faPlaneAlt = 'faPlaneAlt',
    faHillAvalanche = 'faHillAvalanche',
    faTemperatureEmpty = 'faTemperatureEmpty',
    faTemperature0 = 'faTemperature0',
    faThermometer0 = 'faThermometer0',
    faThermometerEmpty = 'faThermometerEmpty',
    faBomb = 'faBomb',
    faGaugeLow = 'faGaugeLow',
    faTachometerAltSlow = 'faTachometerAltSlow',
    faRegistered = 'faRegistered',
    faTrashCanPlus = 'faTrashCanPlus',
    faAddressCard = 'faAddressCard',
    faContactCard = 'faContactCard',
    faVcard = 'faVcard',
    faScaleUnbalancedFlip = 'faScaleUnbalancedFlip',
    faBalanceScaleRight = 'faBalanceScaleRight',
    faGlobeSnow = 'faGlobeSnow',
    faSubscript = 'faSubscript',
    faDiamondTurnRight = 'faDiamondTurnRight',
    faDirections = 'faDirections',
    faIntegral = 'faIntegral',
    faBurst = 'faBurst',
    faHouseLaptop = 'faHouseLaptop',
    faLaptopHouse = 'faLaptopHouse',
    faFaceTired = 'faFaceTired',
    faTired = 'faTired',
    faMoneyBills = 'faMoneyBills',
    faBlindsRaised = 'faBlindsRaised',
    faSmog = 'faSmog',
    faUfoBeam = 'faUfoBeam',
    faCircleCaretUp = 'faCircleCaretUp',
    faCaretCircleUp = 'faCaretCircleUp',
    faUserVneckHairLong = 'faUserVneckHairLong',
    faSquareALock = 'faSquareALock',
    faCrutch = 'faCrutch',
    faGasPumpSlash = 'faGasPumpSlash',
    faFontAwesome = 'faFontAwesome',
    faFontAwesomeFlag = 'faFontAwesomeFlag',
    faFontAwesomeLogoFull = 'faFontAwesomeLogoFull',
    faCloudArrowUp = 'faCloudArrowUp',
    faCloudUpload = 'faCloudUpload',
    faCloudUploadAlt = 'faCloudUploadAlt',
    faPalette = 'faPalette',
    faTransporter4 = 'faTransporter4',
    faObjectsAlignRight = 'faObjectsAlignRight',
    faArrowsTurnRight = 'faArrowsTurnRight',
    faVest = 'faVest',
    faPig = 'faPig',
    faInboxFull = 'faInboxFull',
    faCircleEnvelope = 'faCircleEnvelope',
    faEnvelopeCircle = 'faEnvelopeCircle',
    faTrianglePersonDigging = 'faTrianglePersonDigging',
    faConstruction = 'faConstruction',
    faFerry = 'faFerry',
    faBullseyeArrow = 'faBullseyeArrow',
    faArrowsDownToPeople = 'faArrowsDownToPeople',
    faSeedling = 'faSeedling',
    faSprout = 'faSprout',
    faClockSeven = 'faClockSeven',
    faLeftRight = 'faLeftRight',
    faArrowsAltH = 'faArrowsAltH',
    faBoxesPacking = 'faBoxesPacking',
    faCircleArrowLeft = 'faCircleArrowLeft',
    faArrowCircleLeft = 'faArrowCircleLeft',
    faFlashlight = 'faFlashlight',
    faGroupArrowsRotate = 'faGroupArrowsRotate',
    faBowlFood = 'faBowlFood',
    faSquare9 = 'faSquare9',
    faCandyCane = 'faCandyCane',
    faArrowDownWideShort = 'faArrowDownWideShort',
    faSortAmountAsc = 'faSortAmountAsc',
    faSortAmountDown = 'faSortAmountDown',
    faSquareDollar = 'faSquareDollar',
    faDollarSquare = 'faDollarSquare',
    faUsdSquare = 'faUsdSquare',
    faPhoneArrowRight = 'faPhoneArrowRight',
    faHandHoldingSeedling = 'faHandHoldingSeedling',
    faMessageCheck = 'faMessageCheck',
    faCommentAltCheck = 'faCommentAltCheck',
    faCloudBolt = 'faCloudBolt',
    faThunderstorm = 'faThunderstorm',
    faTextSlash = 'faTextSlash',
    faRemoveFormat = 'faRemoveFormat',
    faWatch = 'faWatch',
    faCircleDownLeft = 'faCircleDownLeft',
    faText = 'faText',
    faProjector = 'faProjector',
    faFaceSmileWink = 'faFaceSmileWink',
    faSmileWink = 'faSmileWink',
    faTombstoneBlank = 'faTombstoneBlank',
    faTombstoneAlt = 'faTombstoneAlt',
    faChessKingPiece = 'faChessKingPiece',
    faChessKingAlt = 'faChessKingAlt',
    faCircle6 = 'faCircle6',
    faLeft = 'faLeft',
    faArrowAltLeft = 'faArrowAltLeft',
    faFileWord = 'faFileWord',
    faFilePowerpoint = 'faFilePowerpoint',
    faSquareDown = 'faSquareDown',
    faArrowAltSquareDown = 'faArrowAltSquareDown',
    faObjectsAlignCenterVertical = 'faObjectsAlignCenterVertical',
    faArrowsLeftRight = 'faArrowsLeftRight',
    faArrowsH = 'faArrowsH',
    faHouseLock = 'faHouseLock',
    faCloudArrowDown = 'faCloudArrowDown',
    faCloudDownload = 'faCloudDownload',
    faCloudDownloadAlt = 'faCloudDownloadAlt',
    faWreath = 'faWreath',
    faChildren = 'faChildren',
    faMeterDroplet = 'faMeterDroplet',
    faChalkboard = 'faChalkboard',
    faBlackboard = 'faBlackboard',
    faUserLargeSlash = 'faUserLargeSlash',
    faUserAltSlash = 'faUserAltSlash',
    faSignalStrong = 'faSignalStrong',
    faSignal4 = 'faSignal4',
    faLollipop = 'faLollipop',
    faLollypop = 'faLollypop',
    faListTree = 'faListTree',
    faEnvelopeOpen = 'faEnvelopeOpen',
    faDrawCircle = 'faDrawCircle',
    faCatSpace = 'faCatSpace',
    faHandshakeSimpleSlash = 'faHandshakeSimpleSlash',
    faHandshakeAltSlash = 'faHandshakeAltSlash',
    faRabbitRunning = 'faRabbitRunning',
    faRabbitFast = 'faRabbitFast',
    faMemoPad = 'faMemoPad',
    faMattressPillow = 'faMattressPillow',
    faAlarmPlus = 'faAlarmPlus',
    faAlicorn = 'faAlicorn',
    faCommentQuestion = 'faCommentQuestion',
    faGingerbreadMan = 'faGingerbreadMan',
    faGuaraniSign = 'faGuaraniSign',
    faBurgerFries = 'faBurgerFries',
    faMugTea = 'faMugTea',
    faBorderTop = 'faBorderTop',
    faArrowsRotate = 'faArrowsRotate',
    faRefresh = 'faRefresh',
    faSync = 'faSync',
    faCircleBookOpen = 'faCircleBookOpen',
    faBookCircle = 'faBookCircle',
    faArrowsToDottedLine = 'faArrowsToDottedLine',
    faFireExtinguisher = 'faFireExtinguisher',
    faGarageOpen = 'faGarageOpen',
    faShelvesEmpty = 'faShelvesEmpty',
    faCruzeiroSign = 'faCruzeiroSign',
    faWatchApple = 'faWatchApple',
    faWatchCalculator = 'faWatchCalculator',
    faListDropdown = 'faListDropdown',
    faCabinetFiling = 'faCabinetFiling',
    faBurgerSoda = 'faBurgerSoda',
    faSquareArrowUp = 'faSquareArrowUp',
    faArrowSquareUp = 'faArrowSquareUp',
    faGreaterThanEqual = 'faGreaterThanEqual',
    faPalletBox = 'faPalletBox',
    faFaceConfounded = 'faFaceConfounded',
    faShieldHalved = 'faShieldHalved',
    faShieldAlt = 'faShieldAlt',
    faTruckPlow = 'faTruckPlow',
    faBookAtlas = 'faBookAtlas',
    faAtlas = 'faAtlas',
    faVirus = 'faVirus',
    faCommentMiddleTop = 'faCommentMiddleTop',
    faEnvelopeCircleCheck = 'faEnvelopeCircleCheck',
    faLayerGroup = 'faLayerGroup',
    faRestroomSimple = 'faRestroomSimple',
    faArrowsToDot = 'faArrowsToDot',
    faBorderOuter = 'faBorderOuter',
    faHashtagLock = 'faHashtagLock',
    faClockTwoThirty = 'faClockTwoThirty',
    faArchway = 'faArchway',
    faHeartCircleCheck = 'faHeartCircleCheck',
    faHouseChimneyCrack = 'faHouseChimneyCrack',
    faHouseDamage = 'faHouseDamage',
    faFileZipper = 'faFileZipper',
    faFileArchive = 'faFileArchive',
    faHeartHalf = 'faHeartHalf',
    faCommentCheck = 'faCommentCheck',
    faSquare = 'faSquare',
    faMemo = 'faMemo',
    faMartiniGlassEmpty = 'faMartiniGlassEmpty',
    faGlassMartini = 'faGlassMartini',
    faCouch = 'faCouch',
    faCediSign = 'faCediSign',
    faItalic = 'faItalic',
    faGlassCitrus = 'faGlassCitrus',
    faCalendarLinesPen = 'faCalendarLinesPen',
    faChurch = 'faChurch',
    faPersonSnowmobiling = 'faPersonSnowmobiling',
    faSnowmobile = 'faSnowmobile',
    faFaceHushed = 'faFaceHushed',
    faCommentsDollar = 'faCommentsDollar',
    faPickaxe = 'faPickaxe',
    faLinkSimpleSlash = 'faLinkSimpleSlash',
    faDemocrat = 'faDemocrat',
    faFaceConfused = 'faFaceConfused',
    faPinball = 'faPinball',
    faZ = 'faZ',
    faPersonSkiing = 'faPersonSkiing',
    faSkiing = 'faSkiing',
    faDeer = 'faDeer',
    faInputPipe = 'faInputPipe',
    faRoadLock = 'faRoadLock',
    faA = 'faA',
    faBookmarkSlash = 'faBookmarkSlash',
    faTemperatureArrowDown = 'faTemperatureArrowDown',
    faTemperatureDown = 'faTemperatureDown',
    faMace = 'faMace',
    faFeatherPointed = 'faFeatherPointed',
    faFeatherAlt = 'faFeatherAlt',
    faSausage = 'faSausage',
    faTrashCanClock = 'faTrashCanClock',
    faP = 'faP',
    faSnowflake = 'faSnowflake',
    faStomach = 'faStomach',
    faNewspaper = 'faNewspaper',
    faRectangleAd = 'faRectangleAd',
    faAd = 'faAd',
    faGuitarElectric = 'faGuitarElectric',
    faArrowTurnDownRight = 'faArrowTurnDownRight',
    faMoonCloud = 'faMoonCloud',
    faBreadSliceButter = 'faBreadSliceButter',
    faCircleArrowRight = 'faCircleArrowRight',
    faArrowCircleRight = 'faArrowCircleRight',
    faUserGroupCrown = 'faUserGroupCrown',
    faUsersCrown = 'faUsersCrown',
    faCircleI = 'faCircleI',
    faToiletPaperCheck = 'faToiletPaperCheck',
    faFilterCircleXmark = 'faFilterCircleXmark',
    faLocust = 'faLocust',
    faSort = 'faSort',
    faUnsorted = 'faUnsorted',
    faListOl = 'faListOl',
    faList12 = 'faList12',
    faListNumeric = 'faListNumeric',
    faChartWaterfall = 'faChartWaterfall',
    faFaceParty = 'faFaceParty',
    faKidneys = 'faKidneys',
    faWifiExclamation = 'faWifiExclamation',
    faChartNetwork = 'faChartNetwork',
    faPersonDressBurst = 'faPersonDressBurst',
    faDiceD4 = 'faDiceD4',
    faMoneyCheckDollar = 'faMoneyCheckDollar',
    faMoneyCheckAlt = 'faMoneyCheckAlt',
    faVectorSquare = 'faVectorSquare',
    faBreadSlice = 'faBreadSlice',
    faLanguage = 'faLanguage',
    faWheatAwnSlash = 'faWheatAwnSlash',
    faFaceKissWinkHeart = 'faFaceKissWinkHeart',
    faKissWinkHeart = 'faKissWinkHeart',
    faDagger = 'faDagger',
    faPodium = 'faPodium',
    faMemoCircleCheck = 'faMemoCircleCheck',
    faRouteHighway = 'faRouteHighway',
    faDownToLine = 'faDownToLine',
    faArrowAltToBottom = 'faArrowAltToBottom',
    faFilter = 'faFilter',
    faSquareG = 'faSquareG',
    faCirclePhone = 'faCirclePhone',
    faPhoneCircle = 'faPhoneCircle',
    faClipboardPrescription = 'faClipboardPrescription',
    faUserNurseHair = 'faUserNurseHair',
    faQuestion = 'faQuestion',
    faFileSignature = 'faFileSignature',
    faToggleLargeOn = 'faToggleLargeOn',
    faUpDownLeftRight = 'faUpDownLeftRight',
    faArrowsAlt = 'faArrowsAlt',
    faDryerHeat = 'faDryerHeat',
    faDryerAlt = 'faDryerAlt',
    faHouseChimneyUser = 'faHouseChimneyUser',
    faHandHoldingHeart = 'faHandHoldingHeart',
    faArrowUpSmallBig = 'faArrowUpSmallBig',
    faSortSizeUpAlt = 'faSortSizeUpAlt',
    faTrainTrack = 'faTrainTrack',
    faPuzzlePiece = 'faPuzzlePiece',
    faMoneyCheck = 'faMoneyCheck',
    faStarHalfStroke = 'faStarHalfStroke',
    faStarHalfAlt = 'faStarHalfAlt',
    faFileExclamation = 'faFileExclamation',
    faCode = 'faCode',
    faWhiskeyGlass = 'faWhiskeyGlass',
    faGlassWhiskey = 'faGlassWhiskey',
    faMoonStars = 'faMoonStars',
    faBuildingCircleExclamation = 'faBuildingCircleExclamation',
    faClothesHanger = 'faClothesHanger',
    faMobileNotch = 'faMobileNotch',
    faMobileIphone = 'faMobileIphone',
    faMagnifyingGlassChart = 'faMagnifyingGlassChart',
    faArrowUpRightFromSquare = 'faArrowUpRightFromSquare',
    faExternalLink = 'faExternalLink',
    faCubesStacked = 'faCubesStacked',
    faImagesUser = 'faImagesUser',
    faWonSign = 'faWonSign',
    faKrw = 'faKrw',
    faWon = 'faWon',
    faImagePolaroidUser = 'faImagePolaroidUser',
    faVirusCovid = 'faVirusCovid',
    faSquareEllipsis = 'faSquareEllipsis',
    faPie = 'faPie',
    faChessKnightPiece = 'faChessKnightPiece',
    faChessKnightAlt = 'faChessKnightAlt',
    faAustralSign = 'faAustralSign',
    faCloudPlus = 'faCloudPlus',
    faF = 'faF',
    faLeaf = 'faLeaf',
    faBedBunk = 'faBedBunk',
    faRoad = 'faRoad',
    faTaxi = 'faTaxi',
    faCab = 'faCab',
    faPersonCirclePlus = 'faPersonCirclePlus',
    faChartPie = 'faChartPie',
    faPieChart = 'faPieChart',
    faBoltLightning = 'faBoltLightning',
    faClockEight = 'faClockEight',
    faSackXmark = 'faSackXmark',
    faFileExcel = 'faFileExcel',
    faFileContract = 'faFileContract',
    faFishFins = 'faFishFins',
    faCircleQ = 'faCircleQ',
    faBuildingFlag = 'faBuildingFlag',
    faFaceGrinBeam = 'faFaceGrinBeam',
    faGrinBeam = 'faGrinBeam',
    faObjectUngroup = 'faObjectUngroup',
    faFaceDisguise = 'faFaceDisguise',
    faCircleArrowDownRight = 'faCircleArrowDownRight',
    faAlien8bit = 'faAlien8bit',
    faAlienMonster = 'faAlienMonster',
    faHandPointRibbon = 'faHandPointRibbon',
    faPoop = 'faPoop',
    faObjectExclude = 'faObjectExclude',
    faTelescope = 'faTelescope',
    faLocationPin = 'faLocationPin',
    faMapMarker = 'faMapMarker',
    faSquareList = 'faSquareList',
    faKaaba = 'faKaaba',
    faToiletPaper = 'faToiletPaper',
    faHelmetSafety = 'faHelmetSafety',
    faHardHat = 'faHardHat',
    faHatHard = 'faHatHard',
    faCommentCode = 'faCommentCode',
    faSimCards = 'faSimCards',
    faStarship = 'faStarship',
    faEject = 'faEject',
    faCircleRight = 'faCircleRight',
    faArrowAltCircleRight = 'faArrowAltCircleRight',
    faPlaneCircleCheck = 'faPlaneCircleCheck',
    faSeal = 'faSeal',
    faUserCowboy = 'faUserCowboy',
    faHexagonVerticalNft = 'faHexagonVerticalNft',
    faFaceRollingEyes = 'faFaceRollingEyes',
    faMehRollingEyes = 'faMehRollingEyes',
    faBreadLoaf = 'faBreadLoaf',
    faRingsWedding = 'faRingsWedding',
    faObjectGroup = 'faObjectGroup',
    faFrenchFries = 'faFrenchFries',
    faChartLine = 'faChartLine',
    faLineChart = 'faLineChart',
    faCalendarArrowDown = 'faCalendarArrowDown',
    faCalendarDownload = 'faCalendarDownload',
    faSendBack = 'faSendBack',
    faMaskVentilator = 'faMaskVentilator',
    faSignatureLock = 'faSignatureLock',
    faArrowRight = 'faArrowRight',
    faSignsPost = 'faSignsPost',
    faMapSigns = 'faMapSigns',
    faOctagonPlus = 'faOctagonPlus',
    faPlusOctagon = 'faPlusOctagon',
    faCashRegister = 'faCashRegister',
    faPersonCircleQuestion = 'faPersonCircleQuestion',
    faMelonSlice = 'faMelonSlice',
    faSpaceStationMoon = 'faSpaceStationMoon',
    faMessageSmile = 'faMessageSmile',
    faCommentAltSmile = 'faCommentAltSmile',
    faCupStraw = 'faCupStraw',
    faLeftFromLine = 'faLeftFromLine',
    faArrowAltFromRight = 'faArrowAltFromRight',
    faH = 'faH',
    faBasketShoppingSimple = 'faBasketShoppingSimple',
    faShoppingBasketAlt = 'faShoppingBasketAlt',
    faHandsHoldingHeart = 'faHandsHoldingHeart',
    faHandsHeart = 'faHandsHeart',
    faClockNine = 'faClockNine',
    faTarp = 'faTarp',
    faFaceSleepy = 'faFaceSleepy',
    faHandHorns = 'faHandHorns',
    faScrewdriverWrench = 'faScrewdriverWrench',
    faTools = 'faTools',
    faArrowsToEye = 'faArrowsToEye',
    faCircleThreeQuarters = 'faCircleThreeQuarters',
    faTrophyStar = 'faTrophyStar',
    faTrophyAlt = 'faTrophyAlt',
    faPlugCircleBolt = 'faPlugCircleBolt',
    faFaceThermometer = 'faFaceThermometer',
    faShirtRunning = 'faShirtRunning',
    faBookCircleArrowUp = 'faBookCircleArrowUp',
    faFaceNauseated = 'faFaceNauseated',
    faHeart = 'faHeart',
    faFileChartPie = 'faFileChartPie',
    faMarsAndVenus = 'faMarsAndVenus',
    faHouseUser = 'faHouseUser',
    faHomeUser = 'faHomeUser',
    faCircleArrowDownLeft = 'faCircleArrowDownLeft',
    faDumpsterFire = 'faDumpsterFire',
    faHexagonMinus = 'faHexagonMinus',
    faMinusHexagon = 'faMinusHexagon',
    faLeftToLine = 'faLeftToLine',
    faArrowAltToLeft = 'faArrowAltToLeft',
    faHouseCrack = 'faHouseCrack',
    faPawSimple = 'faPawSimple',
    faPawAlt = 'faPawAlt',
    faArrowLeftLongToLine = 'faArrowLeftLongToLine',
    faBracketsRound = 'faBracketsRound',
    faParentheses = 'faParentheses',
    faMartiniGlassCitrus = 'faMartiniGlassCitrus',
    faCocktail = 'faCocktail',
    faUserShakespeare = 'faUserShakespeare',
    faArrowRightToArc = 'faArrowRightToArc',
    faFaceSurprise = 'faFaceSurprise',
    faSurprise = 'faSurprise',
    faBottleWater = 'faBottleWater',
    faCirclePause = 'faCirclePause',
    faPauseCircle = 'faPauseCircle',
    faGaugeCirclePlus = 'faGaugeCirclePlus',
    faFolders = 'faFolders',
    faAngel = 'faAngel',
    faValueAbsolute = 'faValueAbsolute',
    faRabbit = 'faRabbit',
    faToiletPaperSlash = 'faToiletPaperSlash',
    faAppleWhole = 'faAppleWhole',
    faAppleAlt = 'faAppleAlt',
    faKitchenSet = 'faKitchenSet',
    faDiamondHalf = 'faDiamondHalf',
    faLockKeyhole = 'faLockKeyhole',
    faLockAlt = 'faLockAlt',
    faR = 'faR',
    faTemperatureQuarter = 'faTemperatureQuarter',
    faTemperature1 = 'faTemperature1',
    faThermometer1 = 'faThermometer1',
    faThermometerQuarter = 'faThermometerQuarter',
    faSquareInfo = 'faSquareInfo',
    faInfoSquare = 'faInfoSquare',
    faWifiSlash = 'faWifiSlash',
    faToiletPaperXmark = 'faToiletPaperXmark',
    faHandsHoldingDollar = 'faHandsHoldingDollar',
    faHandsUsd = 'faHandsUsd',
    faCube = 'faCube',
    faArrowDownTriangleSquare = 'faArrowDownTriangleSquare',
    faSortShapesDown = 'faSortShapesDown',
    faBitcoinSign = 'faBitcoinSign',
    faShutters = 'faShutters',
    faShieldDog = 'faShieldDog',
    faSolarPanel = 'faSolarPanel',
    faLockOpen = 'faLockOpen',
    faTableTree = 'faTableTree',
    faHouseChimneyHeart = 'faHouseChimneyHeart',
    faTally3 = 'faTally3',
    faElevator = 'faElevator',
    faMoneyBillTransfer = 'faMoneyBillTransfer',
    faMoneyBillTrendUp = 'faMoneyBillTrendUp',
    faHouseFloodWaterCircleArrowRight = 'faHouseFloodWaterCircleArrowRight',
    faSquarePollHorizontal = 'faSquarePollHorizontal',
    faPollH = 'faPollH',
    faCircle = 'faCircle',
    faCartCircleExclamation = 'faCartCircleExclamation',
    faSword = 'faSword',
    faBackwardFast = 'faBackwardFast',
    faFastBackward = 'faFastBackward',
    faRecycle = 'faRecycle',
    faUserAstronaut = 'faUserAstronaut',
    faInterrobang = 'faInterrobang',
    faPlaneSlash = 'faPlaneSlash',
    faCircleDashed = 'faCircleDashed',
    faTrademark = 'faTrademark',
    faBasketball = 'faBasketball',
    faBasketballBall = 'faBasketballBall',
    faForkKnife = 'faForkKnife',
    faUtensilsAlt = 'faUtensilsAlt',
    faSatelliteDish = 'faSatelliteDish',
    faBadgeCheck = 'faBadgeCheck',
    faCircleUp = 'faCircleUp',
    faArrowAltCircleUp = 'faArrowAltCircleUp',
    faSlider = 'faSlider',
    faMobileScreenButton = 'faMobileScreenButton',
    faMobileAlt = 'faMobileAlt',
    faClockOneThirty = 'faClockOneThirty',
    faInboxOut = 'faInboxOut',
    faInboxArrowUp = 'faInboxArrowUp',
    faCloudSlash = 'faCloudSlash',
    faVolumeHigh = 'faVolumeHigh',
    faVolumeUp = 'faVolumeUp',
    faUsersRays = 'faUsersRays',
    faWallet = 'faWallet',
    faOctagonCheck = 'faOctagonCheck',
    faFlatbreadStuffed = 'faFlatbreadStuffed',
    faClipboardCheck = 'faClipboardCheck',
    faCartCirclePlus = 'faCartCirclePlus',
    faTruckClock = 'faTruckClock',
    faShippingTimed = 'faShippingTimed',
    faPool8Ball = 'faPool8Ball',
    faFileAudio = 'faFileAudio',
    faTurnDownLeft = 'faTurnDownLeft',
    faLockHashtag = 'faLockHashtag',
    faChartRadar = 'faChartRadar',
    faStaff = 'faStaff',
    faBurger = 'faBurger',
    faHamburger = 'faHamburger',
    faUtilityPole = 'faUtilityPole',
    faTransporter6 = 'faTransporter6',
    faWrench = 'faWrench',
    faBugs = 'faBugs',
    faVectorPolygon = 'faVectorPolygon',
    faDiagramNested = 'faDiagramNested',
    faRupeeSign = 'faRupeeSign',
    faRupee = 'faRupee',
    faFileImage = 'faFileImage',
    faCircleQuestion = 'faCircleQuestion',
    faQuestionCircle = 'faQuestionCircle',
    faImageUser = 'faImageUser',
    faBuoy = 'faBuoy',
    faPlaneDeparture = 'faPlaneDeparture',
    faHandshakeSlash = 'faHandshakeSlash',
    faBookBookmark = 'faBookBookmark',
    faBorderCenterH = 'faBorderCenterH',
    faCanFood = 'faCanFood',
    faTypewriter = 'faTypewriter',
    faArrowRightFromArc = 'faArrowRightFromArc',
    faCircleK = 'faCircleK',
    faFaceHandOverMouth = 'faFaceHandOverMouth',
    faPopcorn = 'faPopcorn',
    faHouseWater = 'faHouseWater',
    faHouseFlood = 'faHouseFlood',
    faObjectSubtract = 'faObjectSubtract',
    faCodeBranch = 'faCodeBranch',
    faWarehouseFull = 'faWarehouseFull',
    faWarehouseAlt = 'faWarehouseAlt',
    faHatCowboy = 'faHatCowboy',
    faBridge = 'faBridge',
    faPhoneFlip = 'faPhoneFlip',
    faPhoneAlt = 'faPhoneAlt',
    faArrowDownFromDottedLine = 'faArrowDownFromDottedLine',
    faSquareQuarters = 'faSquareQuarters',
    faTruckFront = 'faTruckFront',
    faCat = 'faCat',
    faTrashXmark = 'faTrashXmark',
    faCircleCaretLeft = 'faCircleCaretLeft',
    faCaretCircleLeft = 'faCaretCircleLeft',
    faFiles = 'faFiles',
    faAnchorCircleExclamation = 'faAnchorCircleExclamation',
    faFaceClouds = 'faFaceClouds',
    faUserCrown = 'faUserCrown',
    faTruckField = 'faTruckField',
    faRoute = 'faRoute',
    faCartCircleCheck = 'faCartCircleCheck',
    faClipboardQuestion = 'faClipboardQuestion',
    faPanorama = 'faPanorama',
    faCommentMedical = 'faCommentMedical',
    faTeethOpen = 'faTeethOpen',
    faUserTieHairLong = 'faUserTieHairLong',
    faFileCircleMinus = 'faFileCircleMinus',
    faHeadSideMedical = 'faHeadSideMedical',
    faTags = 'faTags',
    faWineGlass = 'faWineGlass',
    faForwardFast = 'faForwardFast',
    faFastForward = 'faFastForward',
    faFaceMehBlank = 'faFaceMehBlank',
    faMehBlank = 'faMehBlank',
    faUserRobot = 'faUserRobot',
    faSquareParking = 'faSquareParking',
    faParking = 'faParking',
    faCardDiamond = 'faCardDiamond',
    faFaceZipper = 'faFaceZipper',
    faFaceRaisedEyebrow = 'faFaceRaisedEyebrow',
    faHouseSignal = 'faHouseSignal',
    faSquareChevronUp = 'faSquareChevronUp',
    faChevronSquareUp = 'faChevronSquareUp',
    faNfcSymbol = 'faNfcSymbol',
    faBarsProgress = 'faBarsProgress',
    faTasksAlt = 'faTasksAlt',
    faFaucetDrip = 'faFaucetDrip',
    faArrowsToLine = 'faArrowsToLine',
    faDolphin = 'faDolphin',
    faArrowUpRight = 'faArrowUpRight',
    faCircleR = 'faCircleR',
    faCartFlatbed = 'faCartFlatbed',
    faDollyFlatbed = 'faDollyFlatbed',
    faBanSmoking = 'faBanSmoking',
    faSmokingBan = 'faSmokingBan',
    faCircleSortUp = 'faCircleSortUp',
    faSortCircleUp = 'faSortCircleUp',
    faTerminal = 'faTerminal',
    faMobileButton = 'faMobileButton',
    faHouseMedicalFlag = 'faHouseMedicalFlag',
    faBasketShopping = 'faBasketShopping',
    faShoppingBasket = 'faShoppingBasket',
    faTape = 'faTape',
    faChestnut = 'faChestnut',
    faBusSimple = 'faBusSimple',
    faBusAlt = 'faBusAlt',
    faEye = 'faEye',
    faFaceSadCry = 'faFaceSadCry',
    faSadCry = 'faSadCry',
    faHeat = 'faHeat',
    faTicketAirline = 'faTicketAirline',
    faBootHeeled = 'faBootHeeled',
    faArrowsMinimize = 'faArrowsMinimize',
    faCompressArrows = 'faCompressArrows',
    faAudioDescription = 'faAudioDescription',
    faPersonMilitaryToPerson = 'faPersonMilitaryToPerson',
    faFileShield = 'faFileShield',
    faHexagon = 'faHexagon',
    faManhole = 'faManhole',
    faUserSlash = 'faUserSlash',
    faPen = 'faPen',
    faTowerObservation = 'faTowerObservation',
    faFloppyDisks = 'faFloppyDisks',
    faToiletPaperBlankUnder = 'faToiletPaperBlankUnder',
    faToiletPaperReverseAlt = 'faToiletPaperReverseAlt',
    faFileCode = 'faFileCode',
    faSignal = 'faSignal',
    faSignal5 = 'faSignal5',
    faSignalPerfect = 'faSignalPerfect',
    faPump = 'faPump',
    faBus = 'faBus',
    faHeartCircleXmark = 'faHeartCircleXmark',
    faArrowUpLeftFromCircle = 'faArrowUpLeftFromCircle',
    faHouseChimney = 'faHouseChimney',
    faHomeLg = 'faHomeLg',
    faWindowMaximize = 'faWindowMaximize',
    faDryer = 'faDryer',
    faFaceFrown = 'faFaceFrown',
    faFrown = 'faFrown',
    faChessBishopPiece = 'faChessBishopPiece',
    faChessBishopAlt = 'faChessBishopAlt',
    faShirtTankTop = 'faShirtTankTop',
    faDiploma = 'faDiploma',
    faScrollRibbon = 'faScrollRibbon',
    faScreencast = 'faScreencast',
    faWalker = 'faWalker',
    faPrescription = 'faPrescription',
    faShop = 'faShop',
    faStoreAlt = 'faStoreAlt',
    faFloppyDisk = 'faFloppyDisk',
    faSave = 'faSave',
    faVihara = 'faVihara',
    faFaceKissClosedEyes = 'faFaceKissClosedEyes',
    faScaleUnbalanced = 'faScaleUnbalanced',
    faBalanceScaleLeft = 'faBalanceScaleLeft',
    faFileUser = 'faFileUser',
    faUserPoliceTie = 'faUserPoliceTie',
    faFaceTongueMoney = 'faFaceTongueMoney',
    faTennisBall = 'faTennisBall',
    faSquareL = 'faSquareL',
    faSortUp = 'faSortUp',
    faSortAsc = 'faSortAsc',
    faCalendarArrowUp = 'faCalendarArrowUp',
    faCalendarUpload = 'faCalendarUpload',
    faCommentDots = 'faCommentDots',
    faCommenting = 'faCommenting',
    faPlantWilt = 'faPlantWilt',
    faScarf = 'faScarf',
    faAlbumCirclePlus = 'faAlbumCirclePlus',
    faUserNurseHairLong = 'faUserNurseHairLong',
    faDiamond = 'faDiamond',
    faSquareLeft = 'faSquareLeft',
    faArrowAltSquareLeft = 'faArrowAltSquareLeft',
    faFaceGrinSquint = 'faFaceGrinSquint',
    faGrinSquint = 'faGrinSquint',
    faCircleEllipsisVertical = 'faCircleEllipsisVertical',
    faHandHoldingDollar = 'faHandHoldingDollar',
    faHandHoldingUsd = 'faHandHoldingUsd',
    faGridDividers = 'faGridDividers',
    faBacterium = 'faBacterium',
    faHandPointer = 'faHandPointer',
    faDrumSteelpan = 'faDrumSteelpan',
    faHandScissors = 'faHandScissors',
    faHandsPraying = 'faHandsPraying',
    faPrayingHands = 'faPrayingHands',
    faFacePensive = 'faFacePensive',
    faUserMusic = 'faUserMusic',
    faArrowRotateRight = 'faArrowRotateRight',
    faArrowRightRotate = 'faArrowRightRotate',
    faArrowRotateForward = 'faArrowRotateForward',
    faRedo = 'faRedo',
    faMessagesDollar = 'faMessagesDollar',
    faCommentsAltDollar = 'faCommentsAltDollar',
    faSensorOn = 'faSensorOn',
    faBalloon = 'faBalloon',
    faBiohazard = 'faBiohazard',
    faChessQueenPiece = 'faChessQueenPiece',
    faChessQueenAlt = 'faChessQueenAlt',
    faLocationCrosshairs = 'faLocationCrosshairs',
    faLocation = 'faLocation',
    faMarsDouble = 'faMarsDouble',
    faHousePersonLeave = 'faHousePersonLeave',
    faHouseLeave = 'faHouseLeave',
    faHousePersonDepart = 'faHousePersonDepart',
    faRulerTriangle = 'faRulerTriangle',
    faCardClub = 'faCardClub',
    faChildDress = 'faChildDress',
    faUsersBetweenLines = 'faUsersBetweenLines',
    faLungsVirus = 'faLungsVirus',
    faSpinnerThird = 'faSpinnerThird',
    faFaceGrinTears = 'faFaceGrinTears',
    faGrinTears = 'faGrinTears',
    faPhone = 'faPhone',
    faComputerMouseScrollwheel = 'faComputerMouseScrollwheel',
    faMouseAlt = 'faMouseAlt',
    faCalendarXmark = 'faCalendarXmark',
    faCalendarTimes = 'faCalendarTimes',
    faChildReaching = 'faChildReaching',
    faTableLayout = 'faTableLayout',
    faNarwhal = 'faNarwhal',
    faRampLoading = 'faRampLoading',
    faCalendarCirclePlus = 'faCalendarCirclePlus',
    faToothbrush = 'faToothbrush',
    faBorderInner = 'faBorderInner',
    faPawClaws = 'faPawClaws',
    faKiwiFruit = 'faKiwiFruit',
    faTrafficLightSlow = 'faTrafficLightSlow',
    faRectangleCode = 'faRectangleCode',
    faHeadSideVirus = 'faHeadSideVirus',
    faKeyboardBrightness = 'faKeyboardBrightness',
    faBooksMedical = 'faBooksMedical',
    faLightbulbSlash = 'faLightbulbSlash',
    faHouseBlank = 'faHouseBlank',
    faHomeBlank = 'faHomeBlank',
    faSquare5 = 'faSquare5',
    faSquareHeart = 'faSquareHeart',
    faHeartSquare = 'faHeartSquare',
    faPuzzle = 'faPuzzle',
    faUserGear = 'faUserGear',
    faUserCog = 'faUserCog',
    faPipeCircleCheck = 'faPipeCircleCheck',
    faArrowUp19 = 'faArrowUp19',
    faSortNumericUp = 'faSortNumericUp',
    faOctagonExclamation = 'faOctagonExclamation',
    faDialLow = 'faDialLow',
    faDoorClosed = 'faDoorClosed',
    faLaptopMobile = 'faLaptopMobile',
    faPhoneLaptop = 'faPhoneLaptop',
    faConveyorBeltBoxes = 'faConveyorBeltBoxes',
    faConveyorBeltAlt = 'faConveyorBeltAlt',
    faShieldVirus = 'faShieldVirus',
    faStarfighterTwinIonEngineAdvanced = 'faStarfighterTwinIonEngineAdvanced',
    faStarfighterAltAdvanced = 'faStarfighterAltAdvanced',
    faDiceSix = 'faDiceSix',
    faStarfighterTwinIonEngine = 'faStarfighterTwinIonEngine',
    faStarfighterAlt = 'faStarfighterAlt',
    faRocketLaunch = 'faRocketLaunch',
    faMosquitoNet = 'faMosquitoNet',
    faVentDamper = 'faVentDamper',
    faBridgeWater = 'faBridgeWater',
    faBanBug = 'faBanBug',
    faDebug = 'faDebug',
    faPersonBooth = 'faPersonBooth',
    faTextWidth = 'faTextWidth',
    faGarageCar = 'faGarageCar',
    faSquareKanban = 'faSquareKanban',
    faHatWizard = 'faHatWizard',
    faPenFancy = 'faPenFancy',
    faCoffeePot = 'faCoffeePot',
    faMouseField = 'faMouseField',
    faPersonDigging = 'faPersonDigging',
    faDigging = 'faDigging',
    faShowerDown = 'faShowerDown',
    faShowerAlt = 'faShowerAlt',
    faBoxCircleCheck = 'faBoxCircleCheck',
    faBrightness = 'faBrightness',
    faCarSideBolt = 'faCarSideBolt',
    faOrnament = 'faOrnament',
    faPhoneArrowDownLeft = 'faPhoneArrowDownLeft',
    faPhoneArrowDown = 'faPhoneArrowDown',
    faPhoneIncoming = 'faPhoneIncoming',
    faCloudWord = 'faCloudWord',
    faHandFingersCrossed = 'faHandFingersCrossed',
    faTrash = 'faTrash',
    faGaugeSimple = 'faGaugeSimple',
    faGaugeSimpleMed = 'faGaugeSimpleMed',
    faTachometerAverage = 'faTachometerAverage',
    faArrowDownSmallBig = 'faArrowDownSmallBig',
    faSortSizeDownAlt = 'faSortSizeDownAlt',
    faBookMedical = 'faBookMedical',
    faFaceMelting = 'faFaceMelting',
    faPoo = 'faPoo',
    faPenClipSlash = 'faPenClipSlash',
    faPenAltSlash = 'faPenAltSlash',
    faQuoteRight = 'faQuoteRight',
    faQuoteRightAlt = 'faQuoteRightAlt',
    faScrollOld = 'faScrollOld',
    faGuitars = 'faGuitars',
    faPhoneXmark = 'faPhoneXmark',
    faHose = 'faHose',
    faClockSix = 'faClockSix',
    faShirt = 'faShirt',
    faTShirt = 'faTShirt',
    faTshirt = 'faTshirt',
    faSquareR = 'faSquareR',
    faCubes = 'faCubes',
    faEnvelopeOpenDollar = 'faEnvelopeOpenDollar',
    faDivide = 'faDivide',
    faSunCloud = 'faSunCloud',
    faLampFloor = 'faLampFloor',
    faSquare7 = 'faSquare7',
    faTengeSign = 'faTengeSign',
    faTenge = 'faTenge',
    faHeadphones = 'faHeadphones',
    faHandsHolding = 'faHandsHolding',
    faCampfire = 'faCampfire',
    faCircleAmpersand = 'faCircleAmpersand',
    faSnowflakes = 'faSnowflakes',
    faHandsClapping = 'faHandsClapping',
    faRepublican = 'faRepublican',
    faLeafMaple = 'faLeafMaple',
    faArrowLeft = 'faArrowLeft',
    faPersonCircleXmark = 'faPersonCircleXmark',
    faRuler = 'faRuler',
    faCupStrawSwoosh = 'faCupStrawSwoosh',
    faTemperatureSun = 'faTemperatureSun',
    faTemperatureHot = 'faTemperatureHot',
    faAlignLeft = 'faAlignLeft',
    faDiceD6 = 'faDiceD6',
    faRestroom = 'faRestroom',
    faHighDefinition = 'faHighDefinition',
    faRectangleHd = 'faRectangleHd',
    faJ = 'faJ',
    faGalaxy = 'faGalaxy',
    faUsersViewfinder = 'faUsersViewfinder',
    faFileVideo = 'faFileVideo',
    faCherries = 'faCherries',
    faUpRightFromSquare = 'faUpRightFromSquare',
    faExternalLinkAlt = 'faExternalLinkAlt',
    faCircleSort = 'faCircleSort',
    faSortCircle = 'faSortCircle',
    faTableCells = 'faTableCells',
    faTh = 'faTh',
    faFilePdf = 'faFilePdf',
    faSiren = 'faSiren',
    faArrowUpToDottedLine = 'faArrowUpToDottedLine',
    faImageLandscape = 'faImageLandscape',
    faLandscape = 'faLandscape',
    faTankWater = 'faTankWater',
    faCurlingStone = 'faCurlingStone',
    faCurling = 'faCurling',
    faGamepadModern = 'faGamepadModern',
    faGamepadAlt = 'faGamepadAlt',
    faMessagesQuestion = 'faMessagesQuestion',
    faBookBible = 'faBookBible',
    faBible = 'faBible',
    faO = 'faO',
    faSuitcaseMedical = 'faSuitcaseMedical',
    faMedkit = 'faMedkit',
    faBriefcaseArrowRight = 'faBriefcaseArrowRight',
    faExpandWide = 'faExpandWide',
    faClockElevenThirty = 'faClockElevenThirty',
    faRv = 'faRv',
    faUserSecret = 'faUserSecret',
    faOtter = 'faOtter',
    faDreidel = 'faDreidel',
    faPersonDress = 'faPersonDress',
    faFemale = 'faFemale',
    faCommentDollar = 'faCommentDollar',
    faBusinessTime = 'faBusinessTime',
    faBriefcaseClock = 'faBriefcaseClock',
    faFlowerTulip = 'faFlowerTulip',
    faPeoplePantsSimple = 'faPeoplePantsSimple',
    faCloudDrizzle = 'faCloudDrizzle',
    faTableCellsLarge = 'faTableCellsLarge',
    faThLarge = 'faThLarge',
    faBookTanakh = 'faBookTanakh',
    faTanakh = 'faTanakh',
    faSolarSystem = 'faSolarSystem',
    faSealQuestion = 'faSealQuestion',
    faPhoneVolume = 'faPhoneVolume',
    faVolumeControlPhone = 'faVolumeControlPhone',
    faDiscDrive = 'faDiscDrive',
    faHatCowboySide = 'faHatCowboySide',
    faTableRows = 'faTableRows',
    faRows = 'faRows',
    faLocationExclamation = 'faLocationExclamation',
    faMapMarkerExclamation = 'faMapMarkerExclamation',
    faFaceFearful = 'faFaceFearful',
    faClipboardUser = 'faClipboardUser',
    faBusSchool = 'faBusSchool',
    faFilmSlash = 'faFilmSlash',
    faSquareArrowDownRight = 'faSquareArrowDownRight',
    faBookSparkles = 'faBookSparkles',
    faBookSpells = 'faBookSpells',
    faWashingMachine = 'faWashingMachine',
    faWasher = 'faWasher',
    faChild = 'faChild',
    faLiraSign = 'faLiraSign',
    faUserVisor = 'faUserVisor',
    faFilePlusMinus = 'faFilePlusMinus',
    faChessClockFlip = 'faChessClockFlip',
    faChessClockAlt = 'faChessClockAlt',
    faSatellite = 'faSatellite',
    faPlaneLock = 'faPlaneLock',
    faSteeringWheel = 'faSteeringWheel',
    faTag = 'faTag',
    faStretcher = 'faStretcher',
    faBookSection = 'faBookSection',
    faBookLaw = 'faBookLaw',
    faInboxes = 'faInboxes',
    faCoffeeBean = 'faCoffeeBean',
    faBracketsCurly = 'faBracketsCurly',
    faEllipsisStrokeVertical = 'faEllipsisStrokeVertical',
    faEllipsisVAlt = 'faEllipsisVAlt',
    faComment = 'faComment',
    faSquare1 = 'faSquare1',
    faCakeCandles = 'faCakeCandles',
    faBirthdayCake = 'faBirthdayCake',
    faCake = 'faCake',
    faHeadSide = 'faHeadSide',
    faEnvelope = 'faEnvelope',
    faDollyEmpty = 'faDollyEmpty',
    faFaceTissue = 'faFaceTissue',
    faAnglesUp = 'faAnglesUp',
    faAngleDoubleUp = 'faAngleDoubleUp',
    faPaperclip = 'faPaperclip',
    faChartLineDown = 'faChartLineDown',
    faArrowRightToCity = 'faArrowRightToCity',
    faLockA = 'faLockA',
    faRibbon = 'faRibbon',
    faLungs = 'faLungs',
    faPersonPinball = 'faPersonPinball',
    faArrowUp91 = 'faArrowUp91',
    faSortNumericUpAlt = 'faSortNumericUpAlt',
    faAppleCore = 'faAppleCore',
    faCircleY = 'faCircleY',
    faH6 = 'faH6',
    faLitecoinSign = 'faLitecoinSign',
    faCircleSmall = 'faCircleSmall',
    faBorderNone = 'faBorderNone',
    faArrowTurnDownLeft = 'faArrowTurnDownLeft',
    faCircleNodes = 'faCircleNodes',
    faParachuteBox = 'faParachuteBox',
    faMessageMedical = 'faMessageMedical',
    faCommentAltMedical = 'faCommentAltMedical',
    faRugbyBall = 'faRugbyBall',
    faCommentMusic = 'faCommentMusic',
    faIndent = 'faIndent',
    faTreeDeciduous = 'faTreeDeciduous',
    faTreeAlt = 'faTreeAlt',
    faPuzzlePieceSimple = 'faPuzzlePieceSimple',
    faPuzzlePieceAlt = 'faPuzzlePieceAlt',
    faTruckFieldUn = 'faTruckFieldUn',
    faNfcTrash = 'faNfcTrash',
    faHourglass = 'faHourglass',
    faHourglassEmpty = 'faHourglassEmpty',
    faMountain = 'faMountain',
    faFileXmark = 'faFileXmark',
    faFileTimes = 'faFileTimes',
    faHouseHeart = 'faHouseHeart',
    faHomeHeart = 'faHomeHeart',
    faHouseChimneyBlank = 'faHouseChimneyBlank',
    faMeterBolt = 'faMeterBolt',
    faUserDoctor = 'faUserDoctor',
    faUserMd = 'faUserMd',
    faSlashBack = 'faSlashBack',
    faCircleInfo = 'faCircleInfo',
    faInfoCircle = 'faInfoCircle',
    faFishingRod = 'faFishingRod',
    faHammerCrash = 'faHammerCrash',
    faMessageHeart = 'faMessageHeart',
    faCloudMeatball = 'faCloudMeatball',
    faCameraPolaroid = 'faCameraPolaroid',
    faCamera = 'faCamera',
    faCameraAlt = 'faCameraAlt',
    faSquareVirus = 'faSquareVirus',
    faCartArrowUp = 'faCartArrowUp',
    faMeteor = 'faMeteor',
    faCarOn = 'faCarOn',
    faSleigh = 'faSleigh',
    faArrowDown19 = 'faArrowDown19',
    faSortNumericAsc = 'faSortNumericAsc',
    faSortNumericDown = 'faSortNumericDown',
    faBuoyMooring = 'faBuoyMooring',
    faSquare4 = 'faSquare4',
    faHandHoldingDroplet = 'faHandHoldingDroplet',
    faHandHoldingWater = 'faHandHoldingWater',
    faTricycleAdult = 'faTricycleAdult',
    faWaveform = 'faWaveform',
    faWater = 'faWater',
    faStarSharpHalfStroke = 'faStarSharpHalfStroke',
    faStarSharpHalfAlt = 'faStarSharpHalfAlt',
    faNfcSignal = 'faNfcSignal',
    faPlaneProp = 'faPlaneProp',
    faCalendarCheck = 'faCalendarCheck',
    faClockDesk = 'faClockDesk',
    faCalendarClock = 'faCalendarClock',
    faCalendarTime = 'faCalendarTime',
    faBraille = 'faBraille',
    faPrescriptionBottleMedical = 'faPrescriptionBottleMedical',
    faPrescriptionBottleAlt = 'faPrescriptionBottleAlt',
    faPlateUtensils = 'faPlateUtensils',
    faFamilyPants = 'faFamilyPants',
    faHoseReel = 'faHoseReel',
    faHouseWindow = 'faHouseWindow',
    faLandmark = 'faLandmark',
    faTruck = 'faTruck',
    faCrosshairs = 'faCrosshairs',
    faCloudRainbow = 'faCloudRainbow',
    faPersonCane = 'faPersonCane',
    faAlien = 'faAlien',
    faTent = 'faTent',
    faVestPatches = 'faVestPatches',
    faPeopleDressSimple = 'faPeopleDressSimple',
    faCheckDouble = 'faCheckDouble',
    faArrowDownAZ = 'faArrowDownAZ',
    faSortAlphaAsc = 'faSortAlphaAsc',
    faSortAlphaDown = 'faSortAlphaDown',
    faBowlingBallPin = 'faBowlingBallPin',
    faBellSchoolSlash = 'faBellSchoolSlash',
    faPlusLarge = 'faPlusLarge',
    faMoneyBillWheat = 'faMoneyBillWheat',
    faCameraViewfinder = 'faCameraViewfinder',
    faScreenshot = 'faScreenshot',
    faMessageMusic = 'faMessageMusic',
    faCommentAltMusic = 'faCommentAltMusic',
    faCarBuilding = 'faCarBuilding',
    faBorderBottomRight = 'faBorderBottomRight',
    faBorderStyleAlt = 'faBorderStyleAlt',
    faOctagon = 'faOctagon',
    faCommentArrowUpRight = 'faCommentArrowUpRight',
    faOctagonDivide = 'faOctagonDivide',
    faCookie = 'faCookie',
    faArrowRotateLeft = 'faArrowRotateLeft',
    faArrowLeftRotate = 'faArrowLeftRotate',
    faArrowRotateBack = 'faArrowRotateBack',
    faArrowRotateBackward = 'faArrowRotateBackward',
    faUndo = 'faUndo',
    faTvMusic = 'faTvMusic',
    faHardDrive = 'faHardDrive',
    faHdd = 'faHdd',
    faReel = 'faReel',
    faFaceGrinSquintTears = 'faFaceGrinSquintTears',
    faGrinSquintTears = 'faGrinSquintTears',
    faDumbbell = 'faDumbbell',
    faRectangleList = 'faRectangleList',
    faListAlt = 'faListAlt',
    faTarpDroplet = 'faTarpDroplet',
    faAlarmExclamation = 'faAlarmExclamation',
    faHouseMedicalCircleCheck = 'faHouseMedicalCircleCheck',
    faTrafficCone = 'faTrafficCone',
    faGrate = 'faGrate',
    faArrowDownRight = 'faArrowDownRight',
    faPersonSkiingNordic = 'faPersonSkiingNordic',
    faSkiingNordic = 'faSkiingNordic',
    faCalendarPlus = 'faCalendarPlus',
    faPersonFromPortal = 'faPersonFromPortal',
    faPortalExit = 'faPortalExit',
    faPlaneArrival = 'faPlaneArrival',
    faCowbellCirclePlus = 'faCowbellCirclePlus',
    faCowbellMore = 'faCowbellMore',
    faCircleLeft = 'faCircleLeft',
    faArrowAltCircleLeft = 'faArrowAltCircleLeft',
    faDistributeSpacingVertical = 'faDistributeSpacingVertical',
    faSignalBarsFair = 'faSignalBarsFair',
    faSignalAlt2 = 'faSignalAlt2',
    faSportsball = 'faSportsball',
    faGameConsoleHandheldCrank = 'faGameConsoleHandheldCrank',
    faTrainSubway = 'faTrainSubway',
    faSubway = 'faSubway',
    faChartGantt = 'faChartGantt',
    faFaceSmileUpsideDown = 'faFaceSmileUpsideDown',
    faBallPile = 'faBallPile',
    faBadgeDollar = 'faBadgeDollar',
    faMoneyBillsSimple = 'faMoneyBillsSimple',
    faMoneyBillsAlt = 'faMoneyBillsAlt',
    faListTimeline = 'faListTimeline',
    faIndianRupeeSign = 'faIndianRupeeSign',
    faIndianRupee = 'faIndianRupee',
    faInr = 'faInr',
    faCropSimple = 'faCropSimple',
    faCropAlt = 'faCropAlt',
    faMoneyBill1 = 'faMoneyBill1',
    faMoneyBillAlt = 'faMoneyBillAlt',
    faLeftLong = 'faLeftLong',
    faLongArrowAltLeft = 'faLongArrowAltLeft',
    faKeyboardDown = 'faKeyboardDown',
    faCircleUpRight = 'faCircleUpRight',
    faCloudBoltMoon = 'faCloudBoltMoon',
    faThunderstormMoon = 'faThunderstormMoon',
    faDna = 'faDna',
    faVirusSlash = 'faVirusSlash',
    faBracketRoundRight = 'faBracketRoundRight',
    faCircle5 = 'faCircle5',
    faMinus = 'faMinus',
    faSubtract = 'faSubtract',
    faFireFlame = 'faFireFlame',
    faFlame = 'faFlame',
    faRightToLine = 'faRightToLine',
    faArrowAltToRight = 'faArrowAltToRight',
    faGif = 'faGif',
    faChess = 'faChess',
    faTrashSlash = 'faTrashSlash',
    faArrowLeftLong = 'faArrowLeftLong',
    faLongArrowLeft = 'faLongArrowLeft',
    faPlugCircleCheck = 'faPlugCircleCheck',
    faFontCase = 'faFontCase',
    faStreetView = 'faStreetView',
    faArrowDownLeft = 'faArrowDownLeft',
    faFrancSign = 'faFrancSign',
    faFlaskRoundPoison = 'faFlaskRoundPoison',
    faFlaskPoison = 'faFlaskPoison',
    faVolumeOff = 'faVolumeOff',
    faBookCircleArrowRight = 'faBookCircleArrowRight',
    faChartUser = 'faChartUser',
    faUserChart = 'faUserChart',
    faHandsAslInterpreting = 'faHandsAslInterpreting',
    faAmericanSignLanguageInterpreting = 'faAmericanSignLanguageInterpreting',
    faAslInterpreting = 'faAslInterpreting',
    faHandsAmericanSignLanguageInterpreting = 'faHandsAmericanSignLanguageInterpreting',
    faPresentationScreen = 'faPresentationScreen',
    faPresentation = 'faPresentation',
    faCircleBolt = 'faCircleBolt',
    faFaceSmileHalo = 'faFaceSmileHalo',
    faCartCircleArrowDown = 'faCartCircleArrowDown',
    faHousePersonReturn = 'faHousePersonReturn',
    faHousePersonArrive = 'faHousePersonArrive',
    faHouseReturn = 'faHouseReturn',
    faMessageXmark = 'faMessageXmark',
    faCommentAltTimes = 'faCommentAltTimes',
    faMessageTimes = 'faMessageTimes',
    faFileCertificate = 'faFileCertificate',
    faFileAward = 'faFileAward',
    faUserDoctorHairLong = 'faUserDoctorHairLong',
    faCameraSecurity = 'faCameraSecurity',
    faCameraHome = 'faCameraHome',
    faGear = 'faGear',
    faCog = 'faCog',
    faDropletSlash = 'faDropletSlash',
    faTintSlash = 'faTintSlash',
    faBookHeart = 'faBookHeart',
    faMosque = 'faMosque',
    faDuck = 'faDuck',
    faMosquito = 'faMosquito',
    faStarOfDavid = 'faStarOfDavid',
    faFlagSwallowtail = 'faFlagSwallowtail',
    faFlagAlt = 'faFlagAlt',
    faPersonMilitaryRifle = 'faPersonMilitaryRifle',
    faCarGarage = 'faCarGarage',
    faCartShopping = 'faCartShopping',
    faShoppingCart = 'faShoppingCart',
    faBookFont = 'faBookFont',
    faShieldPlus = 'faShieldPlus',
    faVials = 'faVials',
    faEyeDropperFull = 'faEyeDropperFull',
    faDistributeSpacingHorizontal = 'faDistributeSpacingHorizontal',
    faTabletRugged = 'faTabletRugged',
    faTemperatureSnow = 'faTemperatureSnow',
    faTemperatureFrigid = 'faTemperatureFrigid',
    faMoped = 'faMoped',
    faFaceSmilePlus = 'faFaceSmilePlus',
    faSmilePlus = 'faSmilePlus',
    faRadioTuner = 'faRadioTuner',
    faRadioAlt = 'faRadioAlt',
    faFaceSwear = 'faFaceSwear',
    faWaterArrowDown = 'faWaterArrowDown',
    faWaterLower = 'faWaterLower',
    faScannerTouchscreen = 'faScannerTouchscreen',
    faCircle7 = 'faCircle7',
    faPlugCirclePlus = 'faPlugCirclePlus',
    faPersonSkiJumping = 'faPersonSkiJumping',
    faSkiJump = 'faSkiJump',
    faPlaceOfWorship = 'faPlaceOfWorship',
    faWaterArrowUp = 'faWaterArrowUp',
    faWaterRise = 'faWaterRise',
    faWaveformLines = 'faWaveformLines',
    faWaveformPath = 'faWaveformPath',
    faSplit = 'faSplit',
    faFilmCanister = 'faFilmCanister',
    faFilmCannister = 'faFilmCannister',
    faFolderXmark = 'faFolderXmark',
    faFolderTimes = 'faFolderTimes',
    faToiletPaperBlank = 'faToiletPaperBlank',
    faToiletPaperAlt = 'faToiletPaperAlt',
    faTabletScreen = 'faTabletScreen',
    faTabletAndroidAlt = 'faTabletAndroidAlt',
    faHexagonVerticalNftSlanted = 'faHexagonVerticalNftSlanted',
    faFolderMusic = 'faFolderMusic',
    faDisplayMedical = 'faDisplayMedical',
    faDesktopMedical = 'faDesktopMedical',
    faShareAll = 'faShareAll',
    faPeapod = 'faPeapod',
    faChessClock = 'faChessClock',
    faAxe = 'faAxe',
    faSquareD = 'faSquareD',
    faGripVertical = 'faGripVertical',
    faMobileSignalOut = 'faMobileSignalOut',
    faArrowTurnUp = 'faArrowTurnUp',
    faLevelUp = 'faLevelUp',
    faU = 'faU',
    faArrowUpFromDottedLine = 'faArrowUpFromDottedLine',
    faSquareRootVariable = 'faSquareRootVariable',
    faSquareRootAlt = 'faSquareRootAlt',
    faLightSwitchOn = 'faLightSwitchOn',
    faArrowDownArrowUp = 'faArrowDownArrowUp',
    faSortAlt = 'faSortAlt',
    faRaindrops = 'faRaindrops',
    faDash = 'faDash',
    faMinusLarge = 'faMinusLarge',
    faClock = 'faClock',
    faClockFour = 'faClockFour',
    faInputNumeric = 'faInputNumeric',
    faTruckTow = 'faTruckTow',
    faBackwardStep = 'faBackwardStep',
    faStepBackward = 'faStepBackward',
    faPallet = 'faPallet',
    faCarBolt = 'faCarBolt',
    faArrowsMaximize = 'faArrowsMaximize',
    faExpandArrows = 'faExpandArrows',
    faFaucet = 'faFaucet',
    faCloudSleet = 'faCloudSleet',
    faLampStreet = 'faLampStreet',
    faListRadio = 'faListRadio',
    faPenNibSlash = 'faPenNibSlash',
    faBaseballBatBall = 'faBaseballBatBall',
    faSquareUpLeft = 'faSquareUpLeft',
    faOverline = 'faOverline',
    faS = 'faS',
    faTimeline = 'faTimeline',
    faKeyboard = 'faKeyboard',
    faArrowsFromDottedLine = 'faArrowsFromDottedLine',
    faUsbDrive = 'faUsbDrive',
    faBallot = 'faBallot',
    faCaretDown = 'faCaretDown',
    faLocationDotSlash = 'faLocationDotSlash',
    faMapMarkerAltSlash = 'faMapMarkerAltSlash',
    faCards = 'faCards',
    faHouseChimneyMedical = 'faHouseChimneyMedical',
    faClinicMedical = 'faClinicMedical',
    faBoxingGlove = 'faBoxingGlove',
    faGloveBoxing = 'faGloveBoxing',
    faTemperatureThreeQuarters = 'faTemperatureThreeQuarters',
    faTemperature3 = 'faTemperature3',
    faThermometer3 = 'faThermometer3',
    faThermometerThreeQuarters = 'faThermometerThreeQuarters',
    faBellSchool = 'faBellSchool',
    faMobileScreen = 'faMobileScreen',
    faMobileAndroidAlt = 'faMobileAndroidAlt',
    faPlaneUp = 'faPlaneUp',
    faFolderHeart = 'faFolderHeart',
    faCircleLocationArrow = 'faCircleLocationArrow',
    faLocationCircle = 'faLocationCircle',
    faFaceHeadBandage = 'faFaceHeadBandage',
    faSushiRoll = 'faSushiRoll',
    faMakiRoll = 'faMakiRoll',
    faMakizushi = 'faMakizushi',
    faCarBump = 'faCarBump',
    faPiggyBank = 'faPiggyBank',
    faRacquet = 'faRacquet',
    faCarMirrors = 'faCarMirrors',
    faIndustryWindows = 'faIndustryWindows',
    faIndustryAlt = 'faIndustryAlt',
    faBoltAuto = 'faBoltAuto',
    faBatteryHalf = 'faBatteryHalf',
    faBattery3 = 'faBattery3',
    faFluxCapacitor = 'faFluxCapacitor',
    faMountainCity = 'faMountainCity',
    faCoins = 'faCoins',
    faHoneyPot = 'faHoneyPot',
    faOlive = 'faOlive',
    faKhanda = 'faKhanda',
    faFilterList = 'faFilterList',
    faOutlet = 'faOutlet',
    faSliders = 'faSliders',
    faSlidersH = 'faSlidersH',
    faCauldron = 'faCauldron',
    faPeople = 'faPeople',
    faFolderTree = 'faFolderTree',
    faNetworkWired = 'faNetworkWired',
    faCroissant = 'faCroissant',
    faMapPin = 'faMapPin',
    faHamsa = 'faHamsa',
    faCentSign = 'faCentSign',
    faSwordsLaser = 'faSwordsLaser',
    faFlask = 'faFlask',
    faPersonPregnant = 'faPersonPregnant',
    faSquareU = 'faSquareU',
    faWandSparkles = 'faWandSparkles',
    faRouter = 'faRouter',
    faEllipsisVertical = 'faEllipsisVertical',
    faEllipsisV = 'faEllipsisV',
    faSwordLaserAlt = 'faSwordLaserAlt',
    faTicket = 'faTicket',
    faPowerOff = 'faPowerOff',
    faCoin = 'faCoin',
    faLaptopSlash = 'faLaptopSlash',
    faRightLong = 'faRightLong',
    faLongArrowAltRight = 'faLongArrowAltRight',
    faCircleB = 'faCircleB',
    faPersonDressSimple = 'faPersonDressSimple',
    faPipeCollar = 'faPipeCollar',
    faLightsHoliday = 'faLightsHoliday',
    faCitrus = 'faCitrus',
    faFlagUsa = 'faFlagUsa',
    faLaptopFile = 'faLaptopFile',
    faTty = 'faTty',
    faTeletype = 'faTeletype',
    faChartTreeMap = 'faChartTreeMap',
    faDiagramNext = 'faDiagramNext',
    faPersonRifle = 'faPersonRifle',
    faClockFiveThirty = 'faClockFiveThirty',
    faPipeValve = 'faPipeValve',
    faArrowUpFromArc = 'faArrowUpFromArc',
    faFaceSpiralEyes = 'faFaceSpiralEyes',
    faCompressWide = 'faCompressWide',
    faCirclePhoneHangup = 'faCirclePhoneHangup',
    faPhoneCircleDown = 'faPhoneCircleDown',
    faHouseMedicalCircleExclamation = 'faHouseMedicalCircleExclamation',
    faBadminton = 'faBadminton',
    faClosedCaptioning = 'faClosedCaptioning',
    faPersonHiking = 'faPersonHiking',
    faHiking = 'faHiking',
    faRightFromLine = 'faRightFromLine',
    faArrowAltFromLeft = 'faArrowAltFromLeft',
    faVenusDouble = 'faVenusDouble',
    faImages = 'faImages',
    faCalculator = 'faCalculator',
    faShuttlecock = 'faShuttlecock',
    faUserHair = 'faUserHair',
    faEyeEvil = 'faEyeEvil',
    faPeoplePulling = 'faPeoplePulling',
    faN = 'faN',
    faGarage = 'faGarage',
    faCableCar = 'faCableCar',
    faTram = 'faTram',
    faShovelSnow = 'faShovelSnow',
    faCloudRain = 'faCloudRain',
    faFaceLying = 'faFaceLying',
    faSprinkler = 'faSprinkler',
    faBuildingCircleXmark = 'faBuildingCircleXmark',
    faPersonSledding = 'faPersonSledding',
    faSledding = 'faSledding',
    faGameConsoleHandheld = 'faGameConsoleHandheld',
    faShip = 'faShip',
    faClockSixThirty = 'faClockSixThirty',
    faBatterySlash = 'faBatterySlash',
    faTugrikSign = 'faTugrikSign',
    faArrowsDownToLine = 'faArrowsDownToLine',
    faDownload = 'faDownload',
    faShelves = 'faShelves',
    faInventory = 'faInventory',
    faCloudSnow = 'faCloudSnow',
    faFaceGrin = 'faFaceGrin',
    faGrin = 'faGrin',
    faDeleteLeft = 'faDeleteLeft',
    faBackspace = 'faBackspace',
    faOven = 'faOven',
    faEyeDropper = 'faEyeDropper',
    faEyeDropperEmpty = 'faEyeDropperEmpty',
    faEyedropper = 'faEyedropper',
    faCommentCaptions = 'faCommentCaptions',
    faCommentsQuestion = 'faCommentsQuestion',
    faScribble = 'faScribble',
    faRotateExclamation = 'faRotateExclamation',
    faFileCircleCheck = 'faFileCircleCheck',
    faGlass = 'faGlass',
    faLoader = 'faLoader',
    faForward = 'faForward',
    faUserPilot = 'faUserPilot',
    faMobile = 'faMobile',
    faMobileAndroid = 'faMobileAndroid',
    faMobilePhone = 'faMobilePhone',
    faCodePullRequestClosed = 'faCodePullRequestClosed',
    faFaceMeh = 'faFaceMeh',
    faMeh = 'faMeh',
    faAlignCenter = 'faAlignCenter',
    faBookSkull = 'faBookSkull',
    faBookDead = 'faBookDead',
    faIdCard = 'faIdCard',
    faDriversLicense = 'faDriversLicense',
    faFaceDotted = 'faFaceDotted',
    faFaceWorried = 'faFaceWorried',
    faOutdent = 'faOutdent',
    faDedent = 'faDedent',
    faHeartCircleExclamation = 'faHeartCircleExclamation',
    faHouse = 'faHouse',
    faHome = 'faHome',
    faHomeAlt = 'faHomeAlt',
    faHomeLgAlt = 'faHomeLgAlt',
    faVectorCircle = 'faVectorCircle',
    faCarCircleBolt = 'faCarCircleBolt',
    faCalendarWeek = 'faCalendarWeek',
    faFlyingDisc = 'faFlyingDisc',
    faLaptopMedical = 'faLaptopMedical',
    faSquareDownRight = 'faSquareDownRight',
    faB = 'faB',
    faSeatAirline = 'faSeatAirline',
    faMoonOverSun = 'faMoonOverSun',
    faEclipseAlt = 'faEclipseAlt',
    faPipe = 'faPipe',
    faFileMedical = 'faFileMedical',
    faPotato = 'faPotato',
    faDiceOne = 'faDiceOne',
    faCircleA = 'faCircleA',
    faHelmetBattle = 'faHelmetBattle',
    faButter = 'faButter',
    faBlanketFire = 'faBlanketFire',
    faKiwiBird = 'faKiwiBird',
    faCastle = 'faCastle',
    faGolfClub = 'faGolfClub',
    faArrowRightArrowLeft = 'faArrowRightArrowLeft',
    faExchange = 'faExchange',
    faRotateRight = 'faRotateRight',
    faRedoAlt = 'faRedoAlt',
    faRotateForward = 'faRotateForward',
    faUtensils = 'faUtensils',
    faCutlery = 'faCutlery',
    faArrowUpWideShort = 'faArrowUpWideShort',
    faSortAmountUp = 'faSortAmountUp',
    faBalloons = 'faBalloons',
    faMillSign = 'faMillSign',
    faBowlRice = 'faBowlRice',
    faTimelineArrow = 'faTimelineArrow',
    faSkull = 'faSkull',
    faGameBoardSimple = 'faGameBoardSimple',
    faGameBoardAlt = 'faGameBoardAlt',
    faCircleVideo = 'faCircleVideo',
    faVideoCircle = 'faVideoCircle',
    faChartScatterBubble = 'faChartScatterBubble',
    faHouseTurret = 'faHouseTurret',
    faBanana = 'faBanana',
    faHandHoldingSkull = 'faHandHoldingSkull',
    faPeopleDress = 'faPeopleDress',
    faLoveseat = 'faLoveseat',
    faCouchSmall = 'faCouchSmall',
    faTowerBroadcast = 'faTowerBroadcast',
    faBroadcastTower = 'faBroadcastTower',
    faTruckPickup = 'faTruckPickup',
    faBlockQuote = 'faBlockQuote',
    faUpLong = 'faUpLong',
    faLongArrowAltUp = 'faLongArrowAltUp',
    faStop = 'faStop',
    faCodeMerge = 'faCodeMerge',
    faMoneyCheckDollarPen = 'faMoneyCheckDollarPen',
    faMoneyCheckEditAlt = 'faMoneyCheckEditAlt',
    faUpFromLine = 'faUpFromLine',
    faArrowAltFromBottom = 'faArrowAltFromBottom',
    faUpload = 'faUpload',
    faHurricane = 'faHurricane',
    faPeoplePants = 'faPeoplePants',
    faMound = 'faMound',
    faWindsock = 'faWindsock',
    faCircleHalf = 'faCircleHalf',
    faBrakeWarning = 'faBrakeWarning',
    faToiletPortable = 'faToiletPortable',
    faCompactDisc = 'faCompactDisc',
    faFileArrowDown = 'faFileArrowDown',
    faFileDownload = 'faFileDownload',
    faSaxophoneFire = 'faSaxophoneFire',
    faSaxHot = 'faSaxHot',
    faCameraWebSlash = 'faCameraWebSlash',
    faWebcamSlash = 'faWebcamSlash',
    faFolderMedical = 'faFolderMedical',
    faFolderGear = 'faFolderGear',
    faFolderCog = 'faFolderCog',
    faHandWave = 'faHandWave',
    faArrowUpArrowDown = 'faArrowUpArrowDown',
    faSortUpDown = 'faSortUpDown',
    faCaravan = 'faCaravan',
    faShieldCat = 'faShieldCat',
    faMessageSlash = 'faMessageSlash',
    faCommentAltSlash = 'faCommentAltSlash',
    faBolt = 'faBolt',
    faZap = 'faZap',
    faTrashCanCheck = 'faTrashCanCheck',
    faGlassWater = 'faGlassWater',
    faOilWell = 'faOilWell',
    faPersonSimple = 'faPersonSimple',
    faVault = 'faVault',
    faMars = 'faMars',
    faToilet = 'faToilet',
    faPlaneCircleXmark = 'faPlaneCircleXmark',
    faYenSign = 'faYenSign',
    faCny = 'faCny',
    faJpy = 'faJpy',
    faRmb = 'faRmb',
    faYen = 'faYen',
    faNotes = 'faNotes',
    faRubleSign = 'faRubleSign',
    faRouble = 'faRouble',
    faRub = 'faRub',
    faRuble = 'faRuble',
    faTrashUndo = 'faTrashUndo',
    faTrashArrowTurnLeft = 'faTrashArrowTurnLeft',
    faChampagneGlass = 'faChampagneGlass',
    faGlassChampagne = 'faGlassChampagne',
    faObjectsAlignCenterHorizontal = 'faObjectsAlignCenterHorizontal',
    faSun = 'faSun',
    faTrashCanSlash = 'faTrashCanSlash',
    faTrashAltSlash = 'faTrashAltSlash',
    faScreenUsers = 'faScreenUsers',
    faUsersClass = 'faUsersClass',
    faGuitar = 'faGuitar',
    faSquareArrowLeft = 'faSquareArrowLeft',
    faArrowSquareLeft = 'faArrowSquareLeft',
    faSquare8 = 'faSquare8',
    faFaceSmileHearts = 'faFaceSmileHearts',
    faBracketsSquare = 'faBracketsSquare',
    faBrackets = 'faBrackets',
    faLaptopArrowDown = 'faLaptopArrowDown',
    faHockeyStickPuck = 'faHockeyStickPuck',
    faHouseTree = 'faHouseTree',
    faSignalFair = 'faSignalFair',
    faSignal2 = 'faSignal2',
    faFaceLaughWink = 'faFaceLaughWink',
    faLaughWink = 'faLaughWink',
    faCircleDollar = 'faCircleDollar',
    faDollarCircle = 'faDollarCircle',
    faUsdCircle = 'faUsdCircle',
    faHorseHead = 'faHorseHead',
    faArrowsRepeat = 'faArrowsRepeat',
    faRepeatAlt = 'faRepeatAlt',
    faBoreHole = 'faBoreHole',
    faIndustry = 'faIndustry',
    faImagePolaroid = 'faImagePolaroid',
    faWaveTriangle = 'faWaveTriangle',
    faCircleDown = 'faCircleDown',
    faArrowAltCircleDown = 'faArrowAltCircleDown',
    faGrill = 'faGrill',
    faArrowsTurnToDots = 'faArrowsTurnToDots',
    faChartMixed = 'faChartMixed',
    faAnalytics = 'faAnalytics',
    faFlorinSign = 'faFlorinSign',
    faArrowDownShortWide = 'faArrowDownShortWide',
    faSortAmountDesc = 'faSortAmountDesc',
    faSortAmountDownAlt = 'faSortAmountDownAlt',
    faLessThan = 'faLessThan',
    faDisplayCode = 'faDisplayCode',
    faDesktopCode = 'faDesktopCode',
    faFaceDrooling = 'faFaceDrooling',
    faOilTemperature = 'faOilTemperature',
    faOilTemp = 'faOilTemp',
    faSquareQuestion = 'faSquareQuestion',
    faQuestionSquare = 'faQuestionSquare',
    faAirConditioner = 'faAirConditioner',
    faAngleDown = 'faAngleDown',
    faMountains = 'faMountains',
    faOmega = 'faOmega',
    faCarTunnel = 'faCarTunnel',
    faPersonDollyEmpty = 'faPersonDollyEmpty',
    faPanFood = 'faPanFood',
    faHeadSideCough = 'faHeadSideCough',
    faGripLines = 'faGripLines',
    faThumbsDown = 'faThumbsDown',
    faUserLock = 'faUserLock',
    faArrowRightLong = 'faArrowRightLong',
    faLongArrowRight = 'faLongArrowRight',
    faTicketsAirline = 'faTicketsAirline',
    faAnchorCircleXmark = 'faAnchorCircleXmark',
    faEllipsis = 'faEllipsis',
    faEllipsisH = 'faEllipsisH',
    faNfcSlash = 'faNfcSlash',
    faChessPawn = 'faChessPawn',
    faKitMedical = 'faKitMedical',
    faFirstAid = 'faFirstAid',
    faGrid2Plus = 'faGrid2Plus',
    faBells = 'faBells',
    faPersonThroughWindow = 'faPersonThroughWindow',
    faToolbox = 'faToolbox',
    faEnvelopeDot = 'faEnvelopeDot',
    faEnvelopeBadge = 'faEnvelopeBadge',
    faHandsHoldingCircle = 'faHandsHoldingCircle',
    faBug = 'faBug',
    faBowlChopsticks = 'faBowlChopsticks',
    faCreditCard = 'faCreditCard',
    faCreditCardAlt = 'faCreditCardAlt',
    faCircleS = 'faCircleS',
    faBoxBallot = 'faBoxBallot',
    faCar = 'faCar',
    faAutomobile = 'faAutomobile',
    faHandHoldingHand = 'faHandHoldingHand',
    faUserTieHair = 'faUserTieHair',
    faPodiumStar = 'faPodiumStar',
    faUserHairMullet = 'faUserHairMullet',
    faBusinessFront = 'faBusinessFront',
    faPartyBack = 'faPartyBack',
    faTrianBalbot = 'faTrianBalbot',
    faMicrophoneStand = 'faMicrophoneStand',
    faBookOpenReader = 'faBookOpenReader',
    faBookReader = 'faBookReader',
    faFamilyDress = 'faFamilyDress',
    faCircleX = 'faCircleX',
    faCabin = 'faCabin',
    faMountainSun = 'faMountainSun',
    faChartSimpleHorizontal = 'faChartSimpleHorizontal',
    faBluetooth = 'faBluetooth',
    faArrowsLeftRightToLine = 'faArrowsLeftRightToLine',
    faHandBackPointLeft = 'faHandBackPointLeft',
    faMessageDots = 'faMessageDots',
    faCommentAltDots = 'faCommentAltDots',
    faMessaging = 'faMessaging',
    faFileHeart = 'faFileHeart',
    faBeerMug = 'faBeerMug',
    faBeerFoam = 'faBeerFoam',
    faDiceD20 = 'faDiceD20',
    faDrone = 'faDrone',
    faTruckDroplet = 'faTruckDroplet',
    faFileCircleXmark = 'faFileCircleXmark',
    faTemperatureArrowUp = 'faTemperatureArrowUp',
    faTemperatureUp = 'faTemperatureUp',
    faMedal = 'faMedal',
    faBed = 'faBed',
    faBookCopy = 'faBookCopy',
    faSquareH = 'faSquareH',
    faHSquare = 'faHSquare',
    faSquareC = 'faSquareC',
    faClockTwo = 'faClockTwo',
    faSquareEllipsisVertical = 'faSquareEllipsisVertical',
    faPodcast = 'faPodcast',
    faBee = 'faBee',
    faTemperatureFull = 'faTemperatureFull',
    faTemperature4 = 'faTemperature4',
    faThermometer4 = 'faThermometer4',
    faThermometerFull = 'faThermometerFull',
    faBell = 'faBell',
    faCandyBar = 'faCandyBar',
    faChocolateBar = 'faChocolateBar',
    faXmarkLarge = 'faXmarkLarge',
    faPinata = 'faPinata',
    faArrowsFromLine = 'faArrowsFromLine',
    faSuperscript = 'faSuperscript',
    faBowlSpoon = 'faBowlSpoon',
    faHexagonCheck = 'faHexagonCheck',
    faPlugCircleXmark = 'faPlugCircleXmark',
    faStarOfLife = 'faStarOfLife',
    faPhoneSlash = 'faPhoneSlash',
    faTrafficLightStop = 'faTrafficLightStop',
    faPaintRoller = 'faPaintRoller',
    faAccentGrave = 'faAccentGrave',
    faHandshakeAngle = 'faHandshakeAngle',
    faHandsHelping = 'faHandsHelping',
    faCircle0 = 'faCircle0',
    faDialMedLow = 'faDialMedLow',
    faLocationDot = 'faLocationDot',
    faMapMarkerAlt = 'faMapMarkerAlt',
    faCrab = 'faCrab',
    faBoxOpenFull = 'faBoxOpenFull',
    faBoxFull = 'faBoxFull',
    faFile = 'faFile',
    faGreaterThan = 'faGreaterThan',
    faQuotes = 'faQuotes',
    faPretzel = 'faPretzel',
    faPersonSwimming = 'faPersonSwimming',
    faSwimmer = 'faSwimmer',
    faArrowDown = 'faArrowDown',
    faUserRobotXmarks = 'faUserRobotXmarks',
    faMessageQuote = 'faMessageQuote',
    faCommentAltQuote = 'faCommentAltQuote',
    faCandyCorn = 'faCandyCorn',
    faFolderMagnifyingGlass = 'faFolderMagnifyingGlass',
    faFolderSearch = 'faFolderSearch',
    faNotebook = 'faNotebook',
    faDroplet = 'faDroplet',
    faTint = 'faTint',
    faBullseyePointer = 'faBullseyePointer',
    faEraser = 'faEraser',
    faHexagonImage = 'faHexagonImage',
    faEarthAmericas = 'faEarthAmericas',
    faEarth = 'faEarth',
    faEarthAmerica = 'faEarthAmerica',
    faGlobeAmericas = 'faGlobeAmericas',
    faCrateApple = 'faCrateApple',
    faAppleCrate = 'faAppleCrate',
    faPersonBurst = 'faPersonBurst',
    faGameBoard = 'faGameBoard',
    faHatChef = 'faHatChef',
    faHandBackPointRight = 'faHandBackPointRight',
    faDove = 'faDove',
    faSnowflakeDroplets = 'faSnowflakeDroplets',
    faBatteryEmpty = 'faBatteryEmpty',
    faBattery0 = 'faBattery0',
    faGrid4 = 'faGrid4',
    faSocks = 'faSocks',
    faFaceSunglasses = 'faFaceSunglasses',
    faInbox = 'faInbox',
    faSquare0 = 'faSquare0',
    faSection = 'faSection',
    faSquareThisWayUp = 'faSquareThisWayUp',
    faBoxUp = 'faBoxUp',
    faGaugeHigh = 'faGaugeHigh',
    faTachometerAlt = 'faTachometerAlt',
    faTachometerAltFast = 'faTachometerAltFast',
    faSquareAmpersand = 'faSquareAmpersand',
    faEnvelopeOpenText = 'faEnvelopeOpenText',
    faLampDesk = 'faLampDesk',
    faHospital = 'faHospital',
    faHospitalAlt = 'faHospitalAlt',
    faHospitalWide = 'faHospitalWide',
    faPollPeople = 'faPollPeople',
    faWhiskeyGlassIce = 'faWhiskeyGlassIce',
    faGlassWhiskeyRocks = 'faGlassWhiskeyRocks',
    faWineBottle = 'faWineBottle',
    faChessRook = 'faChessRook',
    faUserBountyHunter = 'faUserBountyHunter',
    faBarsStaggered = 'faBarsStaggered',
    faReorder = 'faReorder',
    faStream = 'faStream',
    faDiagramSankey = 'faDiagramSankey',
    faCloudHailMixed = 'faCloudHailMixed',
    faCircleUpLeft = 'faCircleUpLeft',
    faDharmachakra = 'faDharmachakra',
    faObjectsAlignLeft = 'faObjectsAlignLeft',
    faOilCanDrip = 'faOilCanDrip',
    faFaceSmilingHands = 'faFaceSmilingHands',
    faBroccoli = 'faBroccoli',
    faRouteInterstate = 'faRouteInterstate',
    faEarMuffs = 'faEarMuffs',
    faHotdog = 'faHotdog',
    faTransporterEmpty = 'faTransporterEmpty',
    faPersonWalkingWithCane = 'faPersonWalkingWithCane',
    faBlind = 'faBlind',
    faAngle90 = 'faAngle90',
    faRectangleTerminal = 'faRectangleTerminal',
    faKite = 'faKite',
    faDrum = 'faDrum',
    faScrubber = 'faScrubber',
    faIceCream = 'faIceCream',
    faHeartCircleBolt = 'faHeartCircleBolt',
    faFishBones = 'faFishBones',
    faDeerRudolph = 'faDeerRudolph',
    faFax = 'faFax',
    faParagraph = 'faParagraph',
    faHeadSideHeart = 'faHeadSideHeart',
    faSquareE = 'faSquareE',
    faMeterFire = 'faMeterFire',
    faCloudHail = 'faCloudHail',
    faCheckToSlot = 'faCheckToSlot',
    faVoteYea = 'faVoteYea',
    faMoneyFromBracket = 'faMoneyFromBracket',
    faStarHalf = 'faStarHalf',
    faCarBus = 'faCarBus',
    faSpeaker = 'faSpeaker',
    faTimer = 'faTimer',
    faBoxesStacked = 'faBoxesStacked',
    faBoxes = 'faBoxes',
    faBoxesAlt = 'faBoxesAlt',
    faGrillHot = 'faGrillHot',
    faBallotCheck = 'faBallotCheck',
    faLink = 'faLink',
    faChain = 'faChain',
    faEarListen = 'faEarListen',
    faAssistiveListeningSystems = 'faAssistiveListeningSystems',
    faFileMinus = 'faFileMinus',
    faTreeCity = 'faTreeCity',
    faPlay = 'faPlay',
    faFont = 'faFont',
    faCupTogo = 'faCupTogo',
    faCoffeeTogo = 'faCoffeeTogo',
    faSquareDownLeft = 'faSquareDownLeft',
    faBurgerLettuce = 'faBurgerLettuce',
    faRupiahSign = 'faRupiahSign',
    faMagnifyingGlass = 'faMagnifyingGlass',
    faSearch = 'faSearch',
    faTableTennisPaddleBall = 'faTableTennisPaddleBall',
    faPingPongPaddleBall = 'faPingPongPaddleBall',
    faTableTennis = 'faTableTennis',
    faPersonDotsFromLine = 'faPersonDotsFromLine',
    faDiagnoses = 'faDiagnoses',
    faChevronsDown = 'faChevronsDown',
    faChevronDoubleDown = 'faChevronDoubleDown',
    faTrashCanArrowUp = 'faTrashCanArrowUp',
    faTrashRestoreAlt = 'faTrashRestoreAlt',
    faSignalGood = 'faSignalGood',
    faSignal3 = 'faSignal3',
    faLocationQuestion = 'faLocationQuestion',
    faMapMarkerQuestion = 'faMapMarkerQuestion',
    faFloppyDiskCircleXmark = 'faFloppyDiskCircleXmark',
    faFloppyDiskTimes = 'faFloppyDiskTimes',
    faSaveCircleXmark = 'faSaveCircleXmark',
    faSaveTimes = 'faSaveTimes',
    faNairaSign = 'faNairaSign',
    faPeach = 'faPeach',
    faTaxiBus = 'faTaxiBus',
    faBracketCurly = 'faBracketCurly',
    faBracketCurlyLeft = 'faBracketCurlyLeft',
    faLobster = 'faLobster',
    faCartFlatbedEmpty = 'faCartFlatbedEmpty',
    faDollyFlatbedEmpty = 'faDollyFlatbedEmpty',
    faColon = 'faColon',
    faCartArrowDown = 'faCartArrowDown',
    faWand = 'faWand',
    faWalkieTalkie = 'faWalkieTalkie',
    faFilePen = 'faFilePen',
    faFileEdit = 'faFileEdit',
    faReceipt = 'faReceipt',
    faTablePicnic = 'faTablePicnic',
    faSquarePen = 'faSquarePen',
    faPenSquare = 'faPenSquare',
    faPencilSquare = 'faPencilSquare',
    faCircleMicrophoneLines = 'faCircleMicrophoneLines',
    faMicrophoneCircleAlt = 'faMicrophoneCircleAlt',
    faDisplaySlash = 'faDisplaySlash',
    faDesktopSlash = 'faDesktopSlash',
    faSuitcaseRolling = 'faSuitcaseRolling',
    faPersonCircleExclamation = 'faPersonCircleExclamation',
    faTransporter2 = 'faTransporter2',
    faHandsHoldingDiamond = 'faHandsHoldingDiamond',
    faHandReceiving = 'faHandReceiving',
    faMoneyBillSimpleWave = 'faMoneyBillSimpleWave',
    faChevronDown = 'faChevronDown',
    faBatteryFull = 'faBatteryFull',
    faBattery = 'faBattery',
    faBattery5 = 'faBattery5',
    faBellPlus = 'faBellPlus',
    faBookArrowRight = 'faBookArrowRight',
    faHospitals = 'faHospitals',
    faClub = 'faClub',
    faSkullCrossbones = 'faSkullCrossbones',
    faDropletDegree = 'faDropletDegree',
    faDewpoint = 'faDewpoint',
    faCodeCompare = 'faCodeCompare',
    faListUl = 'faListUl',
    faListDots = 'faListDots',
    faHandHoldingMagic = 'faHandHoldingMagic',
    faWatermelonSlice = 'faWatermelonSlice',
    faCircleEllipsis = 'faCircleEllipsis',
    faSchoolLock = 'faSchoolLock',
    faTowerCell = 'faTowerCell',
    faSdCards = 'faSdCards',
    faDownLong = 'faDownLong',
    faLongArrowAltDown = 'faLongArrowAltDown',
    faEnvelopes = 'faEnvelopes',
    faPhoneOffice = 'faPhoneOffice',
    faRankingStar = 'faRankingStar',
    faChessKing = 'faChessKing',
    faNfcPen = 'faNfcPen',
    faPersonHarassing = 'faPersonHarassing',
    faHatWinter = 'faHatWinter',
    faBrazilianRealSign = 'faBrazilianRealSign',
    faLandmarkDome = 'faLandmarkDome',
    faLandmarkAlt = 'faLandmarkAlt',
    faBoneBreak = 'faBoneBreak',
    faArrowUp = 'faArrowUp',
    faDownFromDottedLine = 'faDownFromDottedLine',
    faTv = 'faTv',
    faTelevision = 'faTelevision',
    faTvAlt = 'faTvAlt',
    faBorderLeft = 'faBorderLeft',
    faCircleDivide = 'faCircleDivide',
    faShrimp = 'faShrimp',
    faListCheck = 'faListCheck',
    faTasks = 'faTasks',
    faDiagramSubtask = 'faDiagramSubtask',
    faJugDetergent = 'faJugDetergent',
    faCircleUser = 'faCircleUser',
    faUserCircle = 'faUserCircle',
    faSquareY = 'faSquareY',
    faUserDoctorHair = 'faUserDoctorHair',
    faPlanetRinged = 'faPlanetRinged',
    faMushroom = 'faMushroom',
    faUserShield = 'faUserShield',
    faMegaphone = 'faMegaphone',
    faCircleExclamationCheck = 'faCircleExclamationCheck',
    faWind = 'faWind',
    faBoxDollar = 'faBoxDollar',
    faBoxUsd = 'faBoxUsd',
    faCarBurst = 'faCarBurst',
    faCarCrash = 'faCarCrash',
    faY = 'faY',
    faUserHeadset = 'faUserHeadset',
    faArrowsRetweet = 'faArrowsRetweet',
    faRetweetAlt = 'faRetweetAlt',
    faPersonSnowboarding = 'faPersonSnowboarding',
    faSnowboarding = 'faSnowboarding',
    faSquareChevronRight = 'faSquareChevronRight',
    faChevronSquareRight = 'faChevronSquareRight',
    faLacrosseStickBall = 'faLacrosseStickBall',
    faTruckFast = 'faTruckFast',
    faShippingFast = 'faShippingFast',
    faUserMagnifyingGlass = 'faUserMagnifyingGlass',
    faStarSharp = 'faStarSharp',
    faCommentHeart = 'faCommentHeart',
    faCircle1 = 'faCircle1',
    faCircleStar = 'faCircleStar',
    faStarCircle = 'faStarCircle',
    faFish = 'faFish',
    faCloudFog = 'faCloudFog',
    faFog = 'faFog',
    faWaffle = 'faWaffle',
    faMusicNote = 'faMusicNote',
    faMusicAlt = 'faMusicAlt',
    faHexagonExclamation = 'faHexagonExclamation',
    faCartShoppingFast = 'faCartShoppingFast',
    faObjectUnion = 'faObjectUnion',
    faUserGraduate = 'faUserGraduate',
    faStarfighter = 'faStarfighter',
    faCircleHalfStroke = 'faCircleHalfStroke',
    faAdjust = 'faAdjust',
    faArrowRightLongToLine = 'faArrowRightLongToLine',
    faSquareArrowDown = 'faSquareArrowDown',
    faArrowSquareDown = 'faArrowSquareDown',
    faDiamondHalfStroke = 'faDiamondHalfStroke',
    faClapperboard = 'faClapperboard',
    faSquareChevronLeft = 'faSquareChevronLeft',
    faChevronSquareLeft = 'faChevronSquareLeft',
    faPhoneIntercom = 'faPhoneIntercom',
    faLinkHorizontal = 'faLinkHorizontal',
    faChainHorizontal = 'faChainHorizontal',
    faMango = 'faMango',
    faMusicNoteSlash = 'faMusicNoteSlash',
    faMusicAltSlash = 'faMusicAltSlash',
    faCircleRadiation = 'faCircleRadiation',
    faRadiationAlt = 'faRadiationAlt',
    faFaceTongueSweat = 'faFaceTongueSweat',
    faGlobeStand = 'faGlobeStand',
    faBaseball = 'faBaseball',
    faBaseballBall = 'faBaseballBall',
    faCircleP = 'faCircleP',
    faAwardSimple = 'faAwardSimple',
    faJetFighterUp = 'faJetFighterUp',
    faDiagramProject = 'faDiagramProject',
    faProjectDiagram = 'faProjectDiagram',
    faPedestal = 'faPedestal',
    faChartPyramid = 'faChartPyramid',
    faSidebar = 'faSidebar',
    faSnowmanHead = 'faSnowmanHead',
    faFrostyHead = 'faFrostyHead',
    faCopy = 'faCopy',
    faBurgerGlass = 'faBurgerGlass',
    faVolumeXmark = 'faVolumeXmark',
    faVolumeMute = 'faVolumeMute',
    faVolumeTimes = 'faVolumeTimes',
    faHandSparkles = 'faHandSparkles',
    faBarsFilter = 'faBarsFilter',
    faPaintbrushPencil = 'faPaintbrushPencil',
    faPartyBell = 'faPartyBell',
    faUserVneckHair = 'faUserVneckHair',
    faJackOLantern = 'faJackOLantern',
    faGrip = 'faGrip',
    faGripHorizontal = 'faGripHorizontal',
    faShareFromSquare = 'faShareFromSquare',
    faShareSquare = 'faShareSquare',
    faKeynote = 'faKeynote',
    faChildCombatant = 'faChildCombatant',
    faChildRifle = 'faChildRifle',
    faGun = 'faGun',
    faSquarePhone = 'faSquarePhone',
    faPhoneSquare = 'faPhoneSquare',
    faPlus = 'faPlus',
    faAdd = 'faAdd',
    faExpand = 'faExpand',
    faComputer = 'faComputer',
    faFort = 'faFort',
    faCloudCheck = 'faCloudCheck',
    faXmark = 'faXmark',
    faClose = 'faClose',
    faMultiply = 'faMultiply',
    faRemove = 'faRemove',
    faTimes = 'faTimes',
    faFaceSmirking = 'faFaceSmirking',
    faArrowsUpDownLeftRight = 'faArrowsUpDownLeftRight',
    faArrows = 'faArrows',
    faChalkboardUser = 'faChalkboardUser',
    faChalkboardTeacher = 'faChalkboardTeacher',
    faRhombus = 'faRhombus',
    faClawMarks = 'faClawMarks',
    faPesoSign = 'faPesoSign',
    faFaceSmileTongue = 'faFaceSmileTongue',
    faCartCircleXmark = 'faCartCircleXmark',
    faBuildingShield = 'faBuildingShield',
    faCirclePhoneFlip = 'faCirclePhoneFlip',
    faPhoneCircleAlt = 'faPhoneCircleAlt',
    faBaby = 'faBaby',
    faUsersLine = 'faUsersLine',
    faQuoteLeft = 'faQuoteLeft',
    faQuoteLeftAlt = 'faQuoteLeftAlt',
    faTractor = 'faTractor',
    faKeySkeleton = 'faKeySkeleton',
    faTrashArrowUp = 'faTrashArrowUp',
    faTrashRestore = 'faTrashRestore',
    faArrowDownUpLock = 'faArrowDownUpLock',
    faArrowDownToBracket = 'faArrowDownToBracket',
    faLinesLeaning = 'faLinesLeaning',
    faSquareQ = 'faSquareQ',
    faRulerCombined = 'faRulerCombined',
    faSymbols = 'faSymbols',
    faIconsAlt = 'faIconsAlt',
    faCopyright = 'faCopyright',
    faHighlighterLine = 'faHighlighterLine',
    faBracketSquare = 'faBracketSquare',
    faBracket = 'faBracket',
    faBracketLeft = 'faBracketLeft',
    faIslandTropical = 'faIslandTropical',
    faIslandTreePalm = 'faIslandTreePalm',
    faArrowRightFromLine = 'faArrowRightFromLine',
    faArrowFromLeft = 'faArrowFromLeft',
    faH2 = 'faH2',
    faEquals = 'faEquals',
    faCakeSlice = 'faCakeSlice',
    faShortcake = 'faShortcake',
    faPeanut = 'faPeanut',
    faWrenchSimple = 'faWrenchSimple',
    faBlender = 'faBlender',
    faTeeth = 'faTeeth',
    faTally2 = 'faTally2',
    faShekelSign = 'faShekelSign',
    faIls = 'faIls',
    faShekel = 'faShekel',
    faSheqel = 'faSheqel',
    faSheqelSign = 'faSheqelSign',
    faCars = 'faCars',
    faAxeBattle = 'faAxeBattle',
    faUserHairLong = 'faUserHairLong',
    faMap = 'faMap',
    faFileCircleInfo = 'faFileCircleInfo',
    faFaceDisappointed = 'faFaceDisappointed',
    faLassoSparkles = 'faLassoSparkles',
    faClockEleven = 'faClockEleven',
    faRocket = 'faRocket',
    faSirenOn = 'faSirenOn',
    faClockTen = 'faClockTen',
    faCandleHolder = 'faCandleHolder',
    faVideoArrowDownLeft = 'faVideoArrowDownLeft',
    faPhotoFilm = 'faPhotoFilm',
    faPhotoVideo = 'faPhotoVideo',
    faFloppyDiskCircleArrowRight = 'faFloppyDiskCircleArrowRight',
    faSaveCircleArrowRight = 'faSaveCircleArrowRight',
    faFolderMinus = 'faFolderMinus',
    faPlanetMoon = 'faPlanetMoon',
    faFaceEyesXmarks = 'faFaceEyesXmarks',
    faChartScatter = 'faChartScatter',
    faDisplayArrowDown = 'faDisplayArrowDown',
    faStore = 'faStore',
    faArrowTrendUp = 'faArrowTrendUp',
    faPlugCircleMinus = 'faPlugCircleMinus',
    faOliveBranch = 'faOliveBranch',
    faAngle = 'faAngle',
    faVacuumRobot = 'faVacuumRobot',
    faSignHanging = 'faSignHanging',
    faSign = 'faSign',
    faSquareDivide = 'faSquareDivide',
    faSignalStreamSlash = 'faSignalStreamSlash',
    faBezierCurve = 'faBezierCurve',
    faEyeDropperHalf = 'faEyeDropperHalf',
    faStoreLock = 'faStoreLock',
    faBellSlash = 'faBellSlash',
    faCloudBoltSun = 'faCloudBoltSun',
    faThunderstormSun = 'faThunderstormSun',
    faCameraSlash = 'faCameraSlash',
    faCommentQuote = 'faCommentQuote',
    faTablet = 'faTablet',
    faTabletAndroid = 'faTabletAndroid',
    faSchoolFlag = 'faSchoolFlag',
    faMessageCode = 'faMessageCode',
    faGlassHalf = 'faGlassHalf',
    faGlassHalfEmpty = 'faGlassHalfEmpty',
    faGlassHalfFull = 'faGlassHalfFull',
    faFill = 'faFill',
    faMessageMinus = 'faMessageMinus',
    faCommentAltMinus = 'faCommentAltMinus',
    faAngleUp = 'faAngleUp',
    faDrumstickBite = 'faDrumstickBite',
    faLinkHorizontalSlash = 'faLinkHorizontalSlash',
    faChainHorizontalSlash = 'faChainHorizontalSlash',
    faHollyBerry = 'faHollyBerry',
    faNose = 'faNose',
    faChevronLeft = 'faChevronLeft',
    faBacteria = 'faBacteria',
    faClouds = 'faClouds',
    faMoneyBillSimple = 'faMoneyBillSimple',
    faHandLizard = 'faHandLizard',
    faTablePivot = 'faTablePivot',
    faFilterSlash = 'faFilterSlash',
    faTrashCanUndo = 'faTrashCanUndo',
    faTrashCanArrowTurnLeft = 'faTrashCanArrowTurnLeft',
    faTrashUndoAlt = 'faTrashUndoAlt',
    faNotdef = 'faNotdef',
    faDisease = 'faDisease',
    faPersonToDoor = 'faPersonToDoor',
    faTurntable = 'faTurntable',
    faBriefcaseMedical = 'faBriefcaseMedical',
    faGenderless = 'faGenderless',
    faChevronRight = 'faChevronRight',
    faSignalWeak = 'faSignalWeak',
    faSignal1 = 'faSignal1',
    faClockFive = 'faClockFive',
    faRetweet = 'faRetweet',
    faCarRear = 'faCarRear',
    faCarAlt = 'faCarAlt',
    faPumpSoap = 'faPumpSoap',
    faComputerClassic = 'faComputerClassic',
    faFrame = 'faFrame',
    faVideoSlash = 'faVideoSlash',
    faBatteryQuarter = 'faBatteryQuarter',
    faBattery2 = 'faBattery2',
    faEllipsisStroke = 'faEllipsisStroke',
    faEllipsisHAlt = 'faEllipsisHAlt',
    faRadio = 'faRadio',
    faBabyCarriage = 'faBabyCarriage',
    faCarriageBaby = 'faCarriageBaby',
    faFaceExpressionless = 'faFaceExpressionless',
    faDownToDottedLine = 'faDownToDottedLine',
    faCloudMusic = 'faCloudMusic',
    faTrafficLight = 'faTrafficLight',
    faCloudMinus = 'faCloudMinus',
    faThermometer = 'faThermometer',
    faShieldMinus = 'faShieldMinus',
    faVrCardboard = 'faVrCardboard',
    faCarTilt = 'faCarTilt',
    faGaugeCircleMinus = 'faGaugeCircleMinus',
    faBrightnessLow = 'faBrightnessLow',
    faHandMiddleFinger = 'faHandMiddleFinger',
    faPercent = 'faPercent',
    faPercentage = 'faPercentage',
    faTruckMoving = 'faTruckMoving',
    faGlassWaterDroplet = 'faGlassWaterDroplet',
    faConveyorBelt = 'faConveyorBelt',
    faLocationCheck = 'faLocationCheck',
    faMapMarkerCheck = 'faMapMarkerCheck',
    faCoinVertical = 'faCoinVertical',
    faDisplay = 'faDisplay',
    faPersonSign = 'faPersonSign',
    faFaceSmile = 'faFaceSmile',
    faSmile = 'faSmile',
    faPhoneHangup = 'faPhoneHangup',
    faSignatureSlash = 'faSignatureSlash',
    faThumbtack = 'faThumbtack',
    faThumbTack = 'faThumbTack',
    faWheatSlash = 'faWheatSlash',
    faTrophy = 'faTrophy',
    faCloudsSun = 'faCloudsSun',
    faPersonPraying = 'faPersonPraying',
    faPray = 'faPray',
    faHammer = 'faHammer',
    faFaceVomit = 'faFaceVomit',
    faSpeakers = 'faSpeakers',
    faTtyAnswer = 'faTtyAnswer',
    faTeletypeAnswer = 'faTeletypeAnswer',
    faMugTeaSaucer = 'faMugTeaSaucer',
    faDiagramLeanCanvas = 'faDiagramLeanCanvas',
    faAlt = 'faAlt',
    faDial = 'faDial',
    faDialMedHigh = 'faDialMedHigh',
    faHandPeace = 'faHandPeace',
    faCircleTrash = 'faCircleTrash',
    faTrashCircle = 'faTrashCircle',
    faRotate = 'faRotate',
    faSyncAlt = 'faSyncAlt',
    faCircleQuarters = 'faCircleQuarters',
    faSpinner = 'faSpinner',
    faTowerControl = 'faTowerControl',
    faArrowUpTriangleSquare = 'faArrowUpTriangleSquare',
    faSortShapesUp = 'faSortShapesUp',
    faWhale = 'faWhale',
    faRobot = 'faRobot',
    faPeace = 'faPeace',
    faPartyHorn = 'faPartyHorn',
    faGears = 'faGears',
    faCogs = 'faCogs',
    faSunBright = 'faSunBright',
    faSunAlt = 'faSunAlt',
    faWarehouse = 'faWarehouse',
    faLockKeyholeOpen = 'faLockKeyholeOpen',
    faLockOpenAlt = 'faLockOpenAlt',
    faSquareFragile = 'faSquareFragile',
    faBoxFragile = 'faBoxFragile',
    faSquareWineGlassCrack = 'faSquareWineGlassCrack',
    faArrowUpRightDots = 'faArrowUpRightDots',
    faSquareN = 'faSquareN',
    faSplotch = 'faSplotch',
    faFaceGrinHearts = 'faFaceGrinHearts',
    faGrinHearts = 'faGrinHearts',
    faMeter = 'faMeter',
    faMandolin = 'faMandolin',
    faDiceFour = 'faDiceFour',
    faSimCard = 'faSimCard',
    faTransgender = 'faTransgender',
    faTransgenderAlt = 'faTransgenderAlt',
    faMercury = 'faMercury',
    faUpFromBracket = 'faUpFromBracket',
    faKnifeKitchen = 'faKnifeKitchen',
    faBorderRight = 'faBorderRight',
    faArrowTurnDown = 'faArrowTurnDown',
    faLevelDown = 'faLevelDown',
    faSpade = 'faSpade',
    faCardSpade = 'faCardSpade',
    faLineColumns = 'faLineColumns',
    faArrowRightToLine = 'faArrowRightToLine',
    faArrowToRight = 'faArrowToRight',
    faPersonFallingBurst = 'faPersonFallingBurst',
    faFlagPennant = 'faFlagPennant',
    faPennant = 'faPennant',
    faConveyorBeltEmpty = 'faConveyorBeltEmpty',
    faAward = 'faAward',
    faTicketSimple = 'faTicketSimple',
    faTicketAlt = 'faTicketAlt',
    faBuilding = 'faBuilding',
    faAnglesLeft = 'faAnglesLeft',
    faAngleDoubleLeft = 'faAngleDoubleLeft',
    faCamcorder = 'faCamcorder',
    faVideoHandheld = 'faVideoHandheld',
    faPancakes = 'faPancakes',
    faAlbumCircleUser = 'faAlbumCircleUser',
    faQrcode = 'faQrcode',
    faDiceD10 = 'faDiceD10',
    faFireplace = 'faFireplace',
    faBrowser = 'faBrowser',
    faPenPaintbrush = 'faPenPaintbrush',
    faPencilPaintbrush = 'faPencilPaintbrush',
    faFishCooked = 'faFishCooked',
    faChairOffice = 'faChairOffice',
    faNestingDolls = 'faNestingDolls',
    faClockRotateLeft = 'faClockRotateLeft',
    faHistory = 'faHistory',
    faTrumpet = 'faTrumpet',
    faFaceGrinBeamSweat = 'faFaceGrinBeamSweat',
    faGrinBeamSweat = 'faGrinBeamSweat',
    faFireSmoke = 'faFireSmoke',
    faPhoneMissed = 'faPhoneMissed',
    faFileExport = 'faFileExport',
    faArrowRightFromFile = 'faArrowRightFromFile',
    faShield = 'faShield',
    faShieldBlank = 'faShieldBlank',
    faArrowUpShortWide = 'faArrowUpShortWide',
    faSortAmountUpAlt = 'faSortAmountUpAlt',
    faArrowsRepeat1 = 'faArrowsRepeat1',
    faRepeat1Alt = 'faRepeat1Alt',
    faGunSlash = 'faGunSlash',
    faAvocado = 'faAvocado',
    faBinary = 'faBinary',
    faGlassesRound = 'faGlassesRound',
    faGlassesAlt = 'faGlassesAlt',
    faPhonePlus = 'faPhonePlus',
    faDitto = 'faDitto',
    faPersonSeat = 'faPersonSeat',
    faHouseMedical = 'faHouseMedical',
    faGolfBallTee = 'faGolfBallTee',
    faGolfBall = 'faGolfBall',
    faCircleChevronLeft = 'faCircleChevronLeft',
    faChevronCircleLeft = 'faChevronCircleLeft',
    faHouseChimneyWindow = 'faHouseChimneyWindow',
    faScythe = 'faScythe',
    faPenNib = 'faPenNib',
    faBanParking = 'faBanParking',
    faParkingCircleSlash = 'faParkingCircleSlash',
    faTentArrowTurnLeft = 'faTentArrowTurnLeft',
    faFaceDiagonalMouth = 'faFaceDiagonalMouth',
    faDiagramCells = 'faDiagramCells',
    faCricketBatBall = 'faCricketBatBall',
    faCricket = 'faCricket',
    faTents = 'faTents',
    faWandMagic = 'faWandMagic',
    faMagic = 'faMagic',
    faDog = 'faDog',
    faPenLine = 'faPenLine',
    faAtomSimple = 'faAtomSimple',
    faAtomAlt = 'faAtomAlt',
    faAmpersand = 'faAmpersand',
    faCarrot = 'faCarrot',
    faArrowUpFromLine = 'faArrowUpFromLine',
    faArrowFromBottom = 'faArrowFromBottom',
    faMoon = 'faMoon',
    faPenSlash = 'faPenSlash',
    faWineGlassEmpty = 'faWineGlassEmpty',
    faWineGlassAlt = 'faWineGlassAlt',
    faSquareStar = 'faSquareStar',
    faCheese = 'faCheese',
    faSendBackward = 'faSendBackward',
    faYinYang = 'faYinYang',
    faMusic = 'faMusic',
    faCompassSlash = 'faCompassSlash',
    faClockOne = 'faClockOne',
    faFileMusic = 'faFileMusic',
    faCodeCommit = 'faCodeCommit',
    faTemperatureLow = 'faTemperatureLow',
    faPersonBiking = 'faPersonBiking',
    faBiking = 'faBiking',
    faSkeleton = 'faSkeleton',
    faCircleG = 'faCircleG',
    faCircleArrowUpLeft = 'faCircleArrowUpLeft',
    faCoinBlank = 'faCoinBlank',
    faBroom = 'faBroom',
    faVacuum = 'faVacuum',
    faShieldHeart = 'faShieldHeart',
    faCardHeart = 'faCardHeart',
    faLightbulbCflOn = 'faLightbulbCflOn',
    faMelon = 'faMelon',
    faGopuram = 'faGopuram',
    faEarthOceania = 'faEarthOceania',
    faGlobeOceania = 'faGlobeOceania',
    faContainerStorage = 'faContainerStorage',
    faFacePouting = 'faFacePouting',
    faSquareXmark = 'faSquareXmark',
    faTimesSquare = 'faTimesSquare',
    faXmarkSquare = 'faXmarkSquare',
    faFaceExplode = 'faFaceExplode',
    faExplodingHead = 'faExplodingHead',
    faHashtag = 'faHashtag',
    faUpRightAndDownLeftFromCenter = 'faUpRightAndDownLeftFromCenter',
    faExpandAlt = 'faExpandAlt',
    faOilCan = 'faOilCan',
    faT = 'faT',
    faTransformerBolt = 'faTransformerBolt',
    faHippo = 'faHippo',
    faChartColumn = 'faChartColumn',
    faCassetteVhs = 'faCassetteVhs',
    faVhs = 'faVhs',
    faInfinity = 'faInfinity',
    faVialCircleCheck = 'faVialCircleCheck',
    faChimney = 'faChimney',
    faObjectIntersect = 'faObjectIntersect',
    faPersonArrowDownToLine = 'faPersonArrowDownToLine',
    faVoicemail = 'faVoicemail',
    faBlockBrick = 'faBlockBrick',
    faWallBrick = 'faWallBrick',
    faFan = 'faFan',
    faBagsShopping = 'faBagsShopping',
    faParagraphLeft = 'faParagraphLeft',
    faParagraphRtl = 'faParagraphRtl',
    faPersonWalkingLuggage = 'faPersonWalkingLuggage',
    faCaravanSimple = 'faCaravanSimple',
    faCaravanAlt = 'faCaravanAlt',
    faTurtle = 'faTurtle',
    faUpDown = 'faUpDown',
    faArrowsAltV = 'faArrowsAltV',
    faCloudMoonRain = 'faCloudMoonRain',
    faBoothCurtain = 'faBoothCurtain',
    faCalendar = 'faCalendar',
    faBoxHeart = 'faBoxHeart',
    faTrailer = 'faTrailer',
    faUserDoctorMessage = 'faUserDoctorMessage',
    faUserMdChat = 'faUserMdChat',
    faBahai = 'faBahai',
    faHaykal = 'faHaykal',
    faAmpGuitar = 'faAmpGuitar',
    faSdCard = 'faSdCard',
    faVolumeSlash = 'faVolumeSlash',
    faBorderBottom = 'faBorderBottom',
    faWifiWeak = 'faWifiWeak',
    faWifi1 = 'faWifi1',
    faDragon = 'faDragon',
    faShoePrints = 'faShoePrints',
    faCirclePlus = 'faCirclePlus',
    faPlusCircle = 'faPlusCircle',
    faFaceGrinTongueWink = 'faFaceGrinTongueWink',
    faGrinTongueWink = 'faGrinTongueWink',
    faHandHolding = 'faHandHolding',
    faPlugCircleExclamation = 'faPlugCircleExclamation',
    faLinkSlash = 'faLinkSlash',
    faChainBroken = 'faChainBroken',
    faChainSlash = 'faChainSlash',
    faUnlink = 'faUnlink',
    faClone = 'faClone',
    faPersonWalkingArrowLoopLeft = 'faPersonWalkingArrowLoopLeft',
    faArrowUpZA = 'faArrowUpZA',
    faSortAlphaUpAlt = 'faSortAlphaUpAlt',
    faFireFlameCurved = 'faFireFlameCurved',
    faFireAlt = 'faFireAlt',
    faTornado = 'faTornado',
    faFileCirclePlus = 'faFileCirclePlus',
    faDeleteRight = 'faDeleteRight',
    faBookQuran = 'faBookQuran',
    faQuran = 'faQuran',
    faCircleQuarter = 'faCircleQuarter',
    faAnchor = 'faAnchor',
    faBorderAll = 'faBorderAll',
    faFunction = 'faFunction',
    faFaceAngry = 'faFaceAngry',
    faAngry = 'faAngry',
    faPeopleSimple = 'faPeopleSimple',
    faCookieBite = 'faCookieBite',
    faArrowTrendDown = 'faArrowTrendDown',
    faRss = 'faRss',
    faFeed = 'faFeed',
    faFaceMonocle = 'faFaceMonocle',
    faDrawPolygon = 'faDrawPolygon',
    faScaleBalanced = 'faScaleBalanced',
    faBalanceScale = 'faBalanceScale',
    faCalendarLines = 'faCalendarLines',
    faCalendarNote = 'faCalendarNote',
    faArrowDownBigSmall = 'faArrowDownBigSmall',
    faSortSizeDown = 'faSortSizeDown',
    faGaugeSimpleHigh = 'faGaugeSimpleHigh',
    faTachometer = 'faTachometer',
    faTachometerFast = 'faTachometerFast',
    faDoNotEnter = 'faDoNotEnter',
    faShower = 'faShower',
    faDiceD8 = 'faDiceD8',
    faDesktop = 'faDesktop',
    faDesktopAlt = 'faDesktopAlt',
    faM = 'faM',
    faGripDotsVertical = 'faGripDotsVertical',
    faFaceViewfinder = 'faFaceViewfinder',
    faSoftServe = 'faSoftServe',
    faCreemee = 'faCreemee',
    faH5 = 'faH5',
    faHandBackPointDown = 'faHandBackPointDown',
    faTableList = 'faTableList',
    faThList = 'faThList',
    faCommentSms = 'faCommentSms',
    faSms = 'faSms',
    faRectangle = 'faRectangle',
    faRectangleLandscape = 'faRectangleLandscape',
    faClipboardListCheck = 'faClipboardListCheck',
    faTurkey = 'faTurkey',
    faBook = 'faBook',
    faUserPlus = 'faUserPlus',
    faIceSkate = 'faIceSkate',
    faCheck = 'faCheck',
    faBatteryThreeQuarters = 'faBatteryThreeQuarters',
    faBattery4 = 'faBattery4',
    faTomato = 'faTomato',
    faSwordLaser = 'faSwordLaser',
    faHouseCircleCheck = 'faHouseCircleCheck',
    faBuildings = 'faBuildings',
    faAngleLeft = 'faAngleLeft',
    faCartFlatbedBoxes = 'faCartFlatbedBoxes',
    faDollyFlatbedAlt = 'faDollyFlatbedAlt',
    faDiagramSuccessor = 'faDiagramSuccessor',
    faTruckArrowRight = 'faTruckArrowRight',
    faSquareW = 'faSquareW',
    faArrowsSplitUpAndLeft = 'faArrowsSplitUpAndLeft',
    faLamp = 'faLamp',
    faAirplay = 'faAirplay',
    faHandFist = 'faHandFist',
    faFistRaised = 'faFistRaised',
    faShieldQuartered = 'faShieldQuartered',
    faSlashForward = 'faSlashForward',
    faLocationPen = 'faLocationPen',
    faMapMarkerEdit = 'faMapMarkerEdit',
    faCloudMoon = 'faCloudMoon',
    faPotFood = 'faPotFood',
    faBriefcase = 'faBriefcase',
    faPersonFalling = 'faPersonFalling',
    faImagePortrait = 'faImagePortrait',
    faPortrait = 'faPortrait',
    faUserTag = 'faUserTag',
    faRug = 'faRug',
    faPrintSlash = 'faPrintSlash',
    faEarthEurope = 'faEarthEurope',
    faGlobeEurope = 'faGlobeEurope',
    faCartFlatbedSuitcase = 'faCartFlatbedSuitcase',
    faLuggageCart = 'faLuggageCart',
    faHandBackPointRibbon = 'faHandBackPointRibbon',
    faRectangleXmark = 'faRectangleXmark',
    faRectangleTimes = 'faRectangleTimes',
    faTimesRectangle = 'faTimesRectangle',
    faWindowClose = 'faWindowClose',
    faTireRugged = 'faTireRugged',
    faLightbulbDollar = 'faLightbulbDollar',
    faCowbell = 'faCowbell',
    faBahtSign = 'faBahtSign',
    faCorner = 'faCorner',
    faChevronsRight = 'faChevronsRight',
    faChevronDoubleRight = 'faChevronDoubleRight',
    faBookOpen = 'faBookOpen',
    faBookJournalWhills = 'faBookJournalWhills',
    faJournalWhills = 'faJournalWhills',
    faInhaler = 'faInhaler',
    faHandcuffs = 'faHandcuffs',
    faSnake = 'faSnake',
    faTriangleExclamation = 'faTriangleExclamation',
    faExclamationTriangle = 'faExclamationTriangle',
    faWarning = 'faWarning',
    faNoteMedical = 'faNoteMedical',
    faDatabase = 'faDatabase',
    faDownLeft = 'faDownLeft',
    faShare = 'faShare',
    faArrowTurnRight = 'faArrowTurnRight',
    faMailForward = 'faMailForward',
    faFaceThinking = 'faFaceThinking',
    faTurnDownRight = 'faTurnDownRight',
    faBottleDroplet = 'faBottleDroplet',
    faMaskFace = 'faMaskFace',
    faHillRockslide = 'faHillRockslide',
    faScannerKeyboard = 'faScannerKeyboard',
    faCircleO = 'faCircleO',
    faGridHorizontal = 'faGridHorizontal',
    faMessageDollar = 'faMessageDollar',
    faCommentAltDollar = 'faCommentAltDollar',
    faRightLeft = 'faRightLeft',
    faExchangeAlt = 'faExchangeAlt',
    faColumns3 = 'faColumns3',
    faPaperPlane = 'faPaperPlane',
    faRoadCircleExclamation = 'faRoadCircleExclamation',
    faDungeon = 'faDungeon',
    faHandHoldingBox = 'faHandHoldingBox',
    faInputText = 'faInputText',
    faWindowFlip = 'faWindowFlip',
    faWindowAlt = 'faWindowAlt',
    faAlignRight = 'faAlignRight',
    faScannerGun = 'faScannerGun',
    faScanner = 'faScanner',
    faTire = 'faTire',
    faEngine = 'faEngine',
    faMoneyBill1Wave = 'faMoneyBill1Wave',
    faMoneyBillWaveAlt = 'faMoneyBillWaveAlt',
    faLifeRing = 'faLifeRing',
    faHands = 'faHands',
    faSignLanguage = 'faSignLanguage',
    faSigning = 'faSigning',
    faCircleCaretRight = 'faCircleCaretRight',
    faCaretCircleRight = 'faCaretCircleRight',
    faWheat = 'faWheat',
    faFileSpreadsheet = 'faFileSpreadsheet',
    faAudioDescriptionSlash = 'faAudioDescriptionSlash',
    faCalendarDay = 'faCalendarDay',
    faWaterLadder = 'faWaterLadder',
    faLadderWater = 'faLadderWater',
    faSwimmingPool = 'faSwimmingPool',
    faArrowsUpDown = 'faArrowsUpDown',
    faArrowsV = 'faArrowsV',
    faChessPawnPiece = 'faChessPawnPiece',
    faChessPawnAlt = 'faChessPawnAlt',
    faFaceGrimace = 'faFaceGrimace',
    faGrimace = 'faGrimace',
    faWheelchairMove = 'faWheelchairMove',
    faWheelchairAlt = 'faWheelchairAlt',
    faTurnDown = 'faTurnDown',
    faLevelDownAlt = 'faLevelDownAlt',
    faSquareS = 'faSquareS',
    faRectangleBarcode = 'faRectangleBarcode',
    faBarcodeAlt = 'faBarcodeAlt',
    faPersonWalkingArrowRight = 'faPersonWalkingArrowRight',
    faSquareEnvelope = 'faSquareEnvelope',
    faEnvelopeSquare = 'faEnvelopeSquare',
    faDice = 'faDice',
    faUnicorn = 'faUnicorn',
    faBowlingBall = 'faBowlingBall',
    faPompebled = 'faPompebled',
    faBrain = 'faBrain',
    faWatchSmart = 'faWatchSmart',
    faBookUser = 'faBookUser',
    faSensorCloud = 'faSensorCloud',
    faSensorSmoke = 'faSensorSmoke',
    faClapperboardPlay = 'faClapperboardPlay',
    faBandage = 'faBandage',
    faBandAid = 'faBandAid',
    faCalendarMinus = 'faCalendarMinus',
    faCircleXmark = 'faCircleXmark',
    faTimesCircle = 'faTimesCircle',
    faXmarkCircle = 'faXmarkCircle',
    faCircle4 = 'faCircle4',
    faGifts = 'faGifts',
    faAlbumCollection = 'faAlbumCollection',
    faHotel = 'faHotel',
    faEarthAsia = 'faEarthAsia',
    faGlobeAsia = 'faGlobeAsia',
    faIdCardClip = 'faIdCardClip',
    faIdCardAlt = 'faIdCardAlt',
    faMagnifyingGlassPlus = 'faMagnifyingGlassPlus',
    faSearchPlus = 'faSearchPlus',
    faThumbsUp = 'faThumbsUp',
    faCloudShowers = 'faCloudShowers',
    faUserClock = 'faUserClock',
    faOnion = 'faOnion',
    faClockTwelveThirty = 'faClockTwelveThirty',
    faArrowDownToDottedLine = 'faArrowDownToDottedLine',
    faHandDots = 'faHandDots',
    faAllergies = 'faAllergies',
    faFileInvoice = 'faFileInvoice',
    faWindowMinimize = 'faWindowMinimize',
    faRectangleWide = 'faRectangleWide',
    faCommentArrowUp = 'faCommentArrowUp',
    faGarlic = 'faGarlic',
    faMugSaucer = 'faMugSaucer',
    faCoffee = 'faCoffee',
    faBrush = 'faBrush',
    faTreeDecorated = 'faTreeDecorated',
    faMask = 'faMask',
    faCalendarHeart = 'faCalendarHeart',
    faMagnifyingGlassMinus = 'faMagnifyingGlassMinus',
    faSearchMinus = 'faSearchMinus',
    faFlower = 'faFlower',
    faRulerVertical = 'faRulerVertical',
    faUserLarge = 'faUserLarge',
    faUserAlt = 'faUserAlt',
    faStarshipFreighter = 'faStarshipFreighter',
    faTrainTram = 'faTrainTram',
    faBridgeSuspension = 'faBridgeSuspension',
    faTrashCheck = 'faTrashCheck',
    faUserNurse = 'faUserNurse',
    faBoombox = 'faBoombox',
    faSyringe = 'faSyringe',
    faCloudSun = 'faCloudSun',
    faShieldExclamation = 'faShieldExclamation',
    faStopwatch20 = 'faStopwatch20',
    faSquareFull = 'faSquareFull',
    faGripDots = 'faGripDots',
    faCommentExclamation = 'faCommentExclamation',
    faPenSwirl = 'faPenSwirl',
    faFalafel = 'faFalafel',
    faCircle2 = 'faCircle2',
    faMagnet = 'faMagnet',
    faJar = 'faJar',
    faGramophone = 'faGramophone',
    faDiceD12 = 'faDiceD12',
    faNoteSticky = 'faNoteSticky',
    faStickyNote = 'faStickyNote',
    faDown = 'faDown',
    faArrowAltDown = 'faArrowAltDown',
    faHundredPoints = 'faHundredPoints',
    fa100 = 'fa100',
    faPaperclipVertical = 'faPaperclipVertical',
    faWindWarning = 'faWindWarning',
    faWindCircleExclamation = 'faWindCircleExclamation',
    faLocationPinSlash = 'faLocationPinSlash',
    faMapMarkerSlash = 'faMapMarkerSlash',
    faFaceSadSweat = 'faFaceSadSweat',
    faBugSlash = 'faBugSlash',
    faCupcake = 'faCupcake',
    faLightSwitchOff = 'faLightSwitchOff',
    faToggleLargeOff = 'faToggleLargeOff',
    faPenFancySlash = 'faPenFancySlash',
    faTruckContainer = 'faTruckContainer',
    faBoot = 'faBoot',
    faArrowUpFromWaterPump = 'faArrowUpFromWaterPump',
    faFileCheck = 'faFileCheck',
    faBone = 'faBone',
    faCardsBlank = 'faCardsBlank',
    faCircle3 = 'faCircle3',
    faBenchTree = 'faBenchTree',
    faKeyboardBrightnessLow = 'faKeyboardBrightnessLow',
    faSkiBootSki = 'faSkiBootSki',
    faBrainCircuit = 'faBrainCircuit',
    faUserInjured = 'faUserInjured',
    faBlockBrickFire = 'faBlockBrickFire',
    faFirewall = 'faFirewall',
    faFaceSadTear = 'faFaceSadTear',
    faSadTear = 'faSadTear',
    faPlane = 'faPlane',
    faTentArrowsDown = 'faTentArrowsDown',
    faExclamation = 'faExclamation',
    faArrowsSpin = 'faArrowsSpin',
    faFaceSmileRelaxed = 'faFaceSmileRelaxed',
    faCommentXmark = 'faCommentXmark',
    faCommentTimes = 'faCommentTimes',
    faPrint = 'faPrint',
    faTurkishLiraSign = 'faTurkishLiraSign',
    faTry = 'faTry',
    faTurkishLira = 'faTurkishLira',
    faFaceNoseSteam = 'faFaceNoseSteam',
    faCircleWaveformLines = 'faCircleWaveformLines',
    faWaveformCircle = 'faWaveformCircle',
    faDollarSign = 'faDollarSign',
    faDollar = 'faDollar',
    faUsd = 'faUsd',
    faFerrisWheel = 'faFerrisWheel',
    faComputerSpeaker = 'faComputerSpeaker',
    faSkullCow = 'faSkullCow',
    faX = 'faX',
    faMagnifyingGlassDollar = 'faMagnifyingGlassDollar',
    faSearchDollar = 'faSearchDollar',
    faUsersGear = 'faUsersGear',
    faUsersCog = 'faUsersCog',
    faPersonMilitaryPointing = 'faPersonMilitaryPointing',
    faBuildingColumns = 'faBuildingColumns',
    faBank = 'faBank',
    faInstitution = 'faInstitution',
    faMuseum = 'faMuseum',
    faUniversity = 'faUniversity',
    faCircleT = 'faCircleT',
    faSack = 'faSack',
    faGrid2 = 'faGrid2',
    faCameraCctv = 'faCameraCctv',
    faCctv = 'faCctv',
    faUmbrella = 'faUmbrella',
    faTrowel = 'faTrowel',
    faHorizontalRule = 'faHorizontalRule',
    faBedFront = 'faBedFront',
    faBedAlt = 'faBedAlt',
    faD = 'faD',
    faStapler = 'faStapler',
    faMasksTheater = 'faMasksTheater',
    faTheaterMasks = 'faTheaterMasks',
    faKipSign = 'faKipSign',
    faFaceWoozy = 'faFaceWoozy',
    faCloudQuestion = 'faCloudQuestion',
    faPineapple = 'faPineapple',
    faHandPointLeft = 'faHandPointLeft',
    faGalleryThumbnails = 'faGalleryThumbnails',
    faCircleJ = 'faCircleJ',
    faEyes = 'faEyes',
    faHandshakeSimple = 'faHandshakeSimple',
    faHandshakeAlt = 'faHandshakeAlt',
    faPageCaretUp = 'faPageCaretUp',
    faFileCaretUp = 'faFileCaretUp',
    faJetFighter = 'faJetFighter',
    faFighterJet = 'faFighterJet',
    faComet = 'faComet',
    faSquareShareNodes = 'faSquareShareNodes',
    faShareAltSquare = 'faShareAltSquare',
    faShieldKeyhole = 'faShieldKeyhole',
    faBarcode = 'faBarcode',
    faPlusMinus = 'faPlusMinus',
    faSquareSlidersVertical = 'faSquareSlidersVertical',
    faSlidersVSquare = 'faSlidersVSquare',
    faVideo = 'faVideo',
    faVideoCamera = 'faVideoCamera',
    faMessageMiddle = 'faMessageMiddle',
    faCommentMiddleAlt = 'faCommentMiddleAlt',
    faGraduationCap = 'faGraduationCap',
    faMortarBoard = 'faMortarBoard',
    faHandHoldingMedical = 'faHandHoldingMedical',
    faPersonCircleCheck = 'faPersonCircleCheck',
    faSquareZ = 'faSquareZ',
    faMessageText = 'faMessageText',
    faCommentAltText = 'faCommentAltText',
    faTurnUp = 'faTurnUp',
    faLevelUpAlt = 'faLevelUpAlt',
}

export type EnumIconValue = `${EnumIcon}`;

export const EnumIconMap: {
    [key in EnumIcon]: IconDefinition;
} = {
    [EnumIcon.fa0]: fa0,
    [EnumIcon.fa1]: fa1,
    [EnumIcon.fa2]: fa2,
    [EnumIcon.fa3]: fa3,
    [EnumIcon.fa4]: fa4,
    [EnumIcon.fa5]: fa5,
    [EnumIcon.fa6]: fa6,
    [EnumIcon.fa7]: fa7,
    [EnumIcon.fa8]: fa8,
    [EnumIcon.fa9]: fa9,
    [EnumIcon.faFillDrip]: faFillDrip,
    [EnumIcon.faArrowsToCircle]: faArrowsToCircle,
    [EnumIcon.faCircleChevronRight]: faCircleChevronRight,
    [EnumIcon.faChevronCircleRight]: faChevronCircleRight,
    [EnumIcon.faWagonCovered]: faWagonCovered,
    [EnumIcon.faLineHeight]: faLineHeight,
    [EnumIcon.faBagel]: faBagel,
    [EnumIcon.faTransporter7]: faTransporter7,
    [EnumIcon.faAt]: faAt,
    [EnumIcon.faRectanglesMixed]: faRectanglesMixed,
    [EnumIcon.faPhoneArrowUpRight]: faPhoneArrowUpRight,
    [EnumIcon.faPhoneArrowUp]: faPhoneArrowUp,
    [EnumIcon.faPhoneOutgoing]: faPhoneOutgoing,
    [EnumIcon.faTrashCan]: faTrashCan,
    [EnumIcon.faTrashAlt]: faTrashAlt,
    [EnumIcon.faCircleL]: faCircleL,
    [EnumIcon.faHeadSideGoggles]: faHeadSideGoggles,
    [EnumIcon.faHeadVr]: faHeadVr,
    [EnumIcon.faTextHeight]: faTextHeight,
    [EnumIcon.faUserXmark]: faUserXmark,
    [EnumIcon.faUserTimes]: faUserTimes,
    [EnumIcon.faFaceHandYawn]: faFaceHandYawn,
    [EnumIcon.faGaugeSimpleMin]: faGaugeSimpleMin,
    [EnumIcon.faTachometerSlowest]: faTachometerSlowest,
    [EnumIcon.faStethoscope]: faStethoscope,
    [EnumIcon.faCoffin]: faCoffin,
    [EnumIcon.faMessage]: faMessage,
    [EnumIcon.faCommentAlt]: faCommentAlt,
    [EnumIcon.faSalad]: faSalad,
    [EnumIcon.faBowlSalad]: faBowlSalad,
    [EnumIcon.faInfo]: faInfo,
    [EnumIcon.faRobotAstromech]: faRobotAstromech,
    [EnumIcon.faRingDiamond]: faRingDiamond,
    [EnumIcon.faFonduePot]: faFonduePot,
    [EnumIcon.faTheta]: faTheta,
    [EnumIcon.faFaceHandPeeking]: faFaceHandPeeking,
    [EnumIcon.faSquareUser]: faSquareUser,
    [EnumIcon.faDownLeftAndUpRightToCenter]: faDownLeftAndUpRightToCenter,
    [EnumIcon.faCompressAlt]: faCompressAlt,
    [EnumIcon.faExplosion]: faExplosion,
    [EnumIcon.faFileLines]: faFileLines,
    [EnumIcon.faFileAlt]: faFileAlt,
    [EnumIcon.faFileText]: faFileText,
    [EnumIcon.faWaveSquare]: faWaveSquare,
    [EnumIcon.faRing]: faRing,
    [EnumIcon.faBuildingUn]: faBuildingUn,
    [EnumIcon.faDiceThree]: faDiceThree,
    [EnumIcon.faTirePressureWarning]: faTirePressureWarning,
    [EnumIcon.faWifiFair]: faWifiFair,
    [EnumIcon.faWifi2]: faWifi2,
    [EnumIcon.faCalendarDays]: faCalendarDays,
    [EnumIcon.faCalendarAlt]: faCalendarAlt,
    [EnumIcon.faMp3Player]: faMp3Player,
    [EnumIcon.faAnchorCircleCheck]: faAnchorCircleCheck,
    [EnumIcon.faTally4]: faTally4,
    [EnumIcon.faRectangleHistory]: faRectangleHistory,
    [EnumIcon.faBuildingCircleArrowRight]: faBuildingCircleArrowRight,
    [EnumIcon.faVolleyball]: faVolleyball,
    [EnumIcon.faVolleyballBall]: faVolleyballBall,
    [EnumIcon.faSunHaze]: faSunHaze,
    [EnumIcon.faTextSize]: faTextSize,
    [EnumIcon.faUfo]: faUfo,
    [EnumIcon.faFork]: faFork,
    [EnumIcon.faUtensilFork]: faUtensilFork,
    [EnumIcon.faArrowsUpToLine]: faArrowsUpToLine,
    [EnumIcon.faMobileSignal]: faMobileSignal,
    [EnumIcon.faBarcodeScan]: faBarcodeScan,
    [EnumIcon.faSortDown]: faSortDown,
    [EnumIcon.faSortDesc]: faSortDesc,
    [EnumIcon.faFolderArrowDown]: faFolderArrowDown,
    [EnumIcon.faFolderDownload]: faFolderDownload,
    [EnumIcon.faCircleMinus]: faCircleMinus,
    [EnumIcon.faMinusCircle]: faMinusCircle,
    [EnumIcon.faFaceIcicles]: faFaceIcicles,
    [EnumIcon.faShovel]: faShovel,
    [EnumIcon.faDoorOpen]: faDoorOpen,
    [EnumIcon.faFilms]: faFilms,
    [EnumIcon.faRightFromBracket]: faRightFromBracket,
    [EnumIcon.faSignOutAlt]: faSignOutAlt,
    [EnumIcon.faFaceGlasses]: faFaceGlasses,
    [EnumIcon.faNfc]: faNfc,
    [EnumIcon.faAtom]: faAtom,
    [EnumIcon.faSoap]: faSoap,
    [EnumIcon.faIcons]: faIcons,
    [EnumIcon.faHeartMusicCameraBolt]: faHeartMusicCameraBolt,
    [EnumIcon.faMicrophoneLinesSlash]: faMicrophoneLinesSlash,
    [EnumIcon.faMicrophoneAltSlash]: faMicrophoneAltSlash,
    [EnumIcon.faClosedCaptioningSlash]: faClosedCaptioningSlash,
    [EnumIcon.faCalculatorSimple]: faCalculatorSimple,
    [EnumIcon.faCalculatorAlt]: faCalculatorAlt,
    [EnumIcon.faBridgeCircleCheck]: faBridgeCircleCheck,
    [EnumIcon.faSlidersUp]: faSlidersUp,
    [EnumIcon.faSlidersV]: faSlidersV,
    [EnumIcon.faLocationMinus]: faLocationMinus,
    [EnumIcon.faMapMarkerMinus]: faMapMarkerMinus,
    [EnumIcon.faPumpMedical]: faPumpMedical,
    [EnumIcon.faFingerprint]: faFingerprint,
    [EnumIcon.faSkiBoot]: faSkiBoot,
    [EnumIcon.faStandardDefinition]: faStandardDefinition,
    [EnumIcon.faRectangleSd]: faRectangleSd,
    [EnumIcon.faH1]: faH1,
    [EnumIcon.faHandPointRight]: faHandPointRight,
    [EnumIcon.faMagnifyingGlassLocation]: faMagnifyingGlassLocation,
    [EnumIcon.faSearchLocation]: faSearchLocation,
    [EnumIcon.faMessageBot]: faMessageBot,
    [EnumIcon.faForwardStep]: faForwardStep,
    [EnumIcon.faStepForward]: faStepForward,
    [EnumIcon.faFaceSmileBeam]: faFaceSmileBeam,
    [EnumIcon.faSmileBeam]: faSmileBeam,
    [EnumIcon.faLightCeiling]: faLightCeiling,
    [EnumIcon.faMessageExclamation]: faMessageExclamation,
    [EnumIcon.faCommentAltExclamation]: faCommentAltExclamation,
    [EnumIcon.faBowlScoop]: faBowlScoop,
    [EnumIcon.faBowlShavedIce]: faBowlShavedIce,
    [EnumIcon.faSquareX]: faSquareX,
    [EnumIcon.faUtilityPoleDouble]: faUtilityPoleDouble,
    [EnumIcon.faFlagCheckered]: faFlagCheckered,
    [EnumIcon.faChevronsUp]: faChevronsUp,
    [EnumIcon.faChevronDoubleUp]: faChevronDoubleUp,
    [EnumIcon.faFootball]: faFootball,
    [EnumIcon.faFootballBall]: faFootballBall,
    [EnumIcon.faUserVneck]: faUserVneck,
    [EnumIcon.faSchoolCircleExclamation]: faSchoolCircleExclamation,
    [EnumIcon.faCrop]: faCrop,
    [EnumIcon.faAnglesDown]: faAnglesDown,
    [EnumIcon.faAngleDoubleDown]: faAngleDoubleDown,
    [EnumIcon.faUsersRectangle]: faUsersRectangle,
    [EnumIcon.faPeopleRoof]: faPeopleRoof,
    [EnumIcon.faSquareArrowRight]: faSquareArrowRight,
    [EnumIcon.faArrowSquareRight]: faArrowSquareRight,
    [EnumIcon.faLocationPlus]: faLocationPlus,
    [EnumIcon.faMapMarkerPlus]: faMapMarkerPlus,
    [EnumIcon.faLightbulbExclamationOn]: faLightbulbExclamationOn,
    [EnumIcon.faPeopleLine]: faPeopleLine,
    [EnumIcon.faBeerMugEmpty]: faBeerMugEmpty,
    [EnumIcon.faBeer]: faBeer,
    [EnumIcon.faCrateEmpty]: faCrateEmpty,
    [EnumIcon.faDiagramPredecessor]: faDiagramPredecessor,
    [EnumIcon.faTransporter]: faTransporter,
    [EnumIcon.faCalendarCircleUser]: faCalendarCircleUser,
    [EnumIcon.faArrowUpLong]: faArrowUpLong,
    [EnumIcon.faLongArrowUp]: faLongArrowUp,
    [EnumIcon.faPersonCarryBox]: faPersonCarryBox,
    [EnumIcon.faPersonCarry]: faPersonCarry,
    [EnumIcon.faFireFlameSimple]: faFireFlameSimple,
    [EnumIcon.faBurn]: faBurn,
    [EnumIcon.faPerson]: faPerson,
    [EnumIcon.faMale]: faMale,
    [EnumIcon.faLaptop]: faLaptop,
    [EnumIcon.faFileCsv]: faFileCsv,
    [EnumIcon.faMenorah]: faMenorah,
    [EnumIcon.faUnion]: faUnion,
    [EnumIcon.faChevronsLeft]: faChevronsLeft,
    [EnumIcon.faChevronDoubleLeft]: faChevronDoubleLeft,
    [EnumIcon.faCircleHeart]: faCircleHeart,
    [EnumIcon.faHeartCircle]: faHeartCircle,
    [EnumIcon.faTruckPlane]: faTruckPlane,
    [EnumIcon.faRecordVinyl]: faRecordVinyl,
    [EnumIcon.faBringForward]: faBringForward,
    [EnumIcon.faSquareP]: faSquareP,
    [EnumIcon.faFaceGrinStars]: faFaceGrinStars,
    [EnumIcon.faGrinStars]: faGrinStars,
    [EnumIcon.faSigma]: faSigma,
    [EnumIcon.faCameraMovie]: faCameraMovie,
    [EnumIcon.faBong]: faBong,
    [EnumIcon.faClarinet]: faClarinet,
    [EnumIcon.faTruckFlatbed]: faTruckFlatbed,
    [EnumIcon.faSpaghettiMonsterFlying]: faSpaghettiMonsterFlying,
    [EnumIcon.faPastafarianism]: faPastafarianism,
    [EnumIcon.faArrowDownUpAcrossLine]: faArrowDownUpAcrossLine,
    [EnumIcon.faLeafHeart]: faLeafHeart,
    [EnumIcon.faHouseBuilding]: faHouseBuilding,
    [EnumIcon.faCheeseSwiss]: faCheeseSwiss,
    [EnumIcon.faSpoon]: faSpoon,
    [EnumIcon.faUtensilSpoon]: faUtensilSpoon,
    [EnumIcon.faJarWheat]: faJarWheat,
    [EnumIcon.faEnvelopesBulk]: faEnvelopesBulk,
    [EnumIcon.faMailBulk]: faMailBulk,
    [EnumIcon.faFileCircleExclamation]: faFileCircleExclamation,
    [EnumIcon.faBowArrow]: faBowArrow,
    [EnumIcon.faCartXmark]: faCartXmark,
    [EnumIcon.faHexagonXmark]: faHexagonXmark,
    [EnumIcon.faTimesHexagon]: faTimesHexagon,
    [EnumIcon.faXmarkHexagon]: faXmarkHexagon,
    [EnumIcon.faCircleH]: faCircleH,
    [EnumIcon.faHospitalSymbol]: faHospitalSymbol,
    [EnumIcon.faMerge]: faMerge,
    [EnumIcon.faPager]: faPager,
    [EnumIcon.faCartMinus]: faCartMinus,
    [EnumIcon.faAddressBook]: faAddressBook,
    [EnumIcon.faContactBook]: faContactBook,
    [EnumIcon.faPanFrying]: faPanFrying,
    [EnumIcon.faGrid]: faGrid,
    [EnumIcon.faGrid3]: faGrid3,
    [EnumIcon.faFootballHelmet]: faFootballHelmet,
    [EnumIcon.faHandLove]: faHandLove,
    [EnumIcon.faTrees]: faTrees,
    [EnumIcon.faStrikethrough]: faStrikethrough,
    [EnumIcon.faPage]: faPage,
    [EnumIcon.faK]: faK,
    [EnumIcon.faDiagramPrevious]: faDiagramPrevious,
    [EnumIcon.faGaugeMin]: faGaugeMin,
    [EnumIcon.faTachometerAltSlowest]: faTachometerAltSlowest,
    [EnumIcon.faFolderGrid]: faFolderGrid,
    [EnumIcon.faEggplant]: faEggplant,
    [EnumIcon.faRam]: faRam,
    [EnumIcon.faLandmarkFlag]: faLandmarkFlag,
    [EnumIcon.faLips]: faLips,
    [EnumIcon.faPencil]: faPencil,
    [EnumIcon.faPencilAlt]: faPencilAlt,
    [EnumIcon.faBackward]: faBackward,
    [EnumIcon.faCaretRight]: faCaretRight,
    [EnumIcon.faComments]: faComments,
    [EnumIcon.faPaste]: faPaste,
    [EnumIcon.faFileClipboard]: faFileClipboard,
    [EnumIcon.faDesktopArrowDown]: faDesktopArrowDown,
    [EnumIcon.faCodePullRequest]: faCodePullRequest,
    [EnumIcon.faPumpkin]: faPumpkin,
    [EnumIcon.faClipboardList]: faClipboardList,
    [EnumIcon.faPenField]: faPenField,
    [EnumIcon.faBlueberries]: faBlueberries,
    [EnumIcon.faTruckRampBox]: faTruckRampBox,
    [EnumIcon.faTruckLoading]: faTruckLoading,
    [EnumIcon.faNote]: faNote,
    [EnumIcon.faArrowDownToSquare]: faArrowDownToSquare,
    [EnumIcon.faUserCheck]: faUserCheck,
    [EnumIcon.faCloudXmark]: faCloudXmark,
    [EnumIcon.faVialVirus]: faVialVirus,
    [EnumIcon.faBookBlank]: faBookBlank,
    [EnumIcon.faBookAlt]: faBookAlt,
    [EnumIcon.faGolfFlagHole]: faGolfFlagHole,
    [EnumIcon.faMessageArrowDown]: faMessageArrowDown,
    [EnumIcon.faCommentAltArrowDown]: faCommentAltArrowDown,
    [EnumIcon.faFaceUnamused]: faFaceUnamused,
    [EnumIcon.faSheetPlastic]: faSheetPlastic,
    [EnumIcon.faCircle9]: faCircle9,
    [EnumIcon.faBlog]: faBlog,
    [EnumIcon.faUserNinja]: faUserNinja,
    [EnumIcon.faPencilSlash]: faPencilSlash,
    [EnumIcon.faBowlingPins]: faBowlingPins,
    [EnumIcon.faPersonArrowUpFromLine]: faPersonArrowUpFromLine,
    [EnumIcon.faDownRight]: faDownRight,
    [EnumIcon.faScrollTorah]: faScrollTorah,
    [EnumIcon.faTorah]: faTorah,
    [EnumIcon.faBlindsOpen]: faBlindsOpen,
    [EnumIcon.faFence]: faFence,
    [EnumIcon.faUp]: faUp,
    [EnumIcon.faArrowAltUp]: faArrowAltUp,
    [EnumIcon.faBroomBall]: faBroomBall,
    [EnumIcon.faQuidditch]: faQuidditch,
    [EnumIcon.faQuidditchBroomBall]: faQuidditchBroomBall,
    [EnumIcon.faDrumstick]: faDrumstick,
    [EnumIcon.faSquareV]: faSquareV,
    [EnumIcon.faFaceAwesome]: faFaceAwesome,
    [EnumIcon.faGaveDandy]: faGaveDandy,
    [EnumIcon.faDialOff]: faDialOff,
    [EnumIcon.faToggleOff]: faToggleOff,
    [EnumIcon.faFaceSmileHorns]: faFaceSmileHorns,
    [EnumIcon.faBoxArchive]: faBoxArchive,
    [EnumIcon.faArchive]: faArchive,
    [EnumIcon.faGrapes]: faGrapes,
    [EnumIcon.faPersonDrowning]: faPersonDrowning,
    [EnumIcon.faDialMax]: faDialMax,
    [EnumIcon.faCircleM]: faCircleM,
    [EnumIcon.faCalendarImage]: faCalendarImage,
    [EnumIcon.faCircleCaretDown]: faCircleCaretDown,
    [EnumIcon.faCaretCircleDown]: faCaretCircleDown,
    [EnumIcon.faArrowDown91]: faArrowDown91,
    [EnumIcon.faSortNumericDesc]: faSortNumericDesc,
    [EnumIcon.faSortNumericDownAlt]: faSortNumericDownAlt,
    [EnumIcon.faFaceGrinTongueSquint]: faFaceGrinTongueSquint,
    [EnumIcon.faGrinTongueSquint]: faGrinTongueSquint,
    [EnumIcon.faShishKebab]: faShishKebab,
    [EnumIcon.faSprayCan]: faSprayCan,
    [EnumIcon.faAlarmSnooze]: faAlarmSnooze,
    [EnumIcon.faScarecrow]: faScarecrow,
    [EnumIcon.faTruckMonster]: faTruckMonster,
    [EnumIcon.faGiftCard]: faGiftCard,
    [EnumIcon.faW]: faW,
    [EnumIcon.faCodePullRequestDraft]: faCodePullRequestDraft,
    [EnumIcon.faSquareB]: faSquareB,
    [EnumIcon.faElephant]: faElephant,
    [EnumIcon.faEarthAfrica]: faEarthAfrica,
    [EnumIcon.faGlobeAfrica]: faGlobeAfrica,
    [EnumIcon.faRainbow]: faRainbow,
    [EnumIcon.faCircleNotch]: faCircleNotch,
    [EnumIcon.faTabletScreenButton]: faTabletScreenButton,
    [EnumIcon.faTabletAlt]: faTabletAlt,
    [EnumIcon.faPaw]: faPaw,
    [EnumIcon.faMessageQuestion]: faMessageQuestion,
    [EnumIcon.faCloud]: faCloud,
    [EnumIcon.faTrowelBricks]: faTrowelBricks,
    [EnumIcon.faSquare3]: faSquare3,
    [EnumIcon.faFaceFlushed]: faFaceFlushed,
    [EnumIcon.faFlushed]: faFlushed,
    [EnumIcon.faHospitalUser]: faHospitalUser,
    [EnumIcon.faMicrowave]: faMicrowave,
    [EnumIcon.faTentArrowLeftRight]: faTentArrowLeftRight,
    [EnumIcon.faCartCircleArrowUp]: faCartCircleArrowUp,
    [EnumIcon.faTrashClock]: faTrashClock,
    [EnumIcon.faGavel]: faGavel,
    [EnumIcon.faLegal]: faLegal,
    [EnumIcon.faSprinklerCeiling]: faSprinklerCeiling,
    [EnumIcon.faBrowsers]: faBrowsers,
    [EnumIcon.faTrillium]: faTrillium,
    [EnumIcon.faMusicSlash]: faMusicSlash,
    [EnumIcon.faTruckRamp]: faTruckRamp,
    [EnumIcon.faBinoculars]: faBinoculars,
    [EnumIcon.faMicrophoneSlash]: faMicrophoneSlash,
    [EnumIcon.faBoxTissue]: faBoxTissue,
    [EnumIcon.faCircleC]: faCircleC,
    [EnumIcon.faStarChristmas]: faStarChristmas,
    [EnumIcon.faChartBullet]: faChartBullet,
    [EnumIcon.faMotorcycle]: faMotorcycle,
    [EnumIcon.faTreeChristmas]: faTreeChristmas,
    [EnumIcon.faTireFlat]: faTireFlat,
    [EnumIcon.faSunglasses]: faSunglasses,
    [EnumIcon.faBadge]: faBadge,
    [EnumIcon.faMessagePen]: faMessagePen,
    [EnumIcon.faCommentAltEdit]: faCommentAltEdit,
    [EnumIcon.faMessageEdit]: faMessageEdit,
    [EnumIcon.faBellConcierge]: faBellConcierge,
    [EnumIcon.faConciergeBell]: faConciergeBell,
    [EnumIcon.faPenRuler]: faPenRuler,
    [EnumIcon.faPencilRuler]: faPencilRuler,
    [EnumIcon.faChessRookPiece]: faChessRookPiece,
    [EnumIcon.faChessRookAlt]: faChessRookAlt,
    [EnumIcon.faSquareRoot]: faSquareRoot,
    [EnumIcon.faAlbumCollectionCirclePlus]: faAlbumCollectionCirclePlus,
    [EnumIcon.faPeopleArrows]: faPeopleArrows,
    [EnumIcon.faPeopleArrowsLeftRight]: faPeopleArrowsLeftRight,
    [EnumIcon.faFaceAngryHorns]: faFaceAngryHorns,
    [EnumIcon.faMarsAndVenusBurst]: faMarsAndVenusBurst,
    [EnumIcon.faTombstone]: faTombstone,
    [EnumIcon.faSquareCaretRight]: faSquareCaretRight,
    [EnumIcon.faCaretSquareRight]: faCaretSquareRight,
    [EnumIcon.faScissors]: faScissors,
    [EnumIcon.faCut]: faCut,
    [EnumIcon.faListMusic]: faListMusic,
    [EnumIcon.faSunPlantWilt]: faSunPlantWilt,
    [EnumIcon.faToiletsPortable]: faToiletsPortable,
    [EnumIcon.faHockeyPuck]: faHockeyPuck,
    [EnumIcon.faMustache]: faMustache,
    [EnumIcon.faHyphen]: faHyphen,
    [EnumIcon.faTable]: faTable,
    [EnumIcon.faUserChef]: faUserChef,
    [EnumIcon.faMessageImage]: faMessageImage,
    [EnumIcon.faCommentAltImage]: faCommentAltImage,
    [EnumIcon.faUsersMedical]: faUsersMedical,
    [EnumIcon.faSensorTriangleExclamation]: faSensorTriangleExclamation,
    [EnumIcon.faSensorAlert]: faSensorAlert,
    [EnumIcon.faMagnifyingGlassArrowRight]: faMagnifyingGlassArrowRight,
    [EnumIcon.faTachographDigital]: faTachographDigital,
    [EnumIcon.faDigitalTachograph]: faDigitalTachograph,
    [EnumIcon.faFaceMask]: faFaceMask,
    [EnumIcon.faPickleball]: faPickleball,
    [EnumIcon.faStarSharpHalf]: faStarSharpHalf,
    [EnumIcon.faUsersSlash]: faUsersSlash,
    [EnumIcon.faClover]: faClover,
    [EnumIcon.faMeat]: faMeat,
    [EnumIcon.faReply]: faReply,
    [EnumIcon.faMailReply]: faMailReply,
    [EnumIcon.faStarAndCrescent]: faStarAndCrescent,
    [EnumIcon.faEmptySet]: faEmptySet,
    [EnumIcon.faHouseFire]: faHouseFire,
    [EnumIcon.faSquareMinus]: faSquareMinus,
    [EnumIcon.faMinusSquare]: faMinusSquare,
    [EnumIcon.faHelicopter]: faHelicopter,
    [EnumIcon.faBird]: faBird,
    [EnumIcon.faCompass]: faCompass,
    [EnumIcon.faSquareCaretDown]: faSquareCaretDown,
    [EnumIcon.faCaretSquareDown]: faCaretSquareDown,
    [EnumIcon.faHeartHalfStroke]: faHeartHalfStroke,
    [EnumIcon.faHeartHalfAlt]: faHeartHalfAlt,
    [EnumIcon.faFileCircleQuestion]: faFileCircleQuestion,
    [EnumIcon.faLaptopCode]: faLaptopCode,
    [EnumIcon.faJoystick]: faJoystick,
    [EnumIcon.faGrillFire]: faGrillFire,
    [EnumIcon.faRectangleVerticalHistory]: faRectangleVerticalHistory,
    [EnumIcon.faSwatchbook]: faSwatchbook,
    [EnumIcon.faPrescriptionBottle]: faPrescriptionBottle,
    [EnumIcon.faBars]: faBars,
    [EnumIcon.faNavicon]: faNavicon,
    [EnumIcon.faKeyboardLeft]: faKeyboardLeft,
    [EnumIcon.faPeopleGroup]: faPeopleGroup,
    [EnumIcon.faHourglassEnd]: faHourglassEnd,
    [EnumIcon.faHourglass3]: faHourglass3,
    [EnumIcon.faHeartCrack]: faHeartCrack,
    [EnumIcon.faHeartBroken]: faHeartBroken,
    [EnumIcon.faFaceBeamHandOverMouth]: faFaceBeamHandOverMouth,
    [EnumIcon.faDropletPercent]: faDropletPercent,
    [EnumIcon.faHumidity]: faHumidity,
    [EnumIcon.faSquareUpRight]: faSquareUpRight,
    [EnumIcon.faExternalLinkSquareAlt]: faExternalLinkSquareAlt,
    [EnumIcon.faFaceKissBeam]: faFaceKissBeam,
    [EnumIcon.faKissBeam]: faKissBeam,
    [EnumIcon.faCorn]: faCorn,
    [EnumIcon.faRollerCoaster]: faRollerCoaster,
    [EnumIcon.faPhotoFilmMusic]: faPhotoFilmMusic,
    [EnumIcon.faRadar]: faRadar,
    [EnumIcon.faSickle]: faSickle,
    [EnumIcon.faFilm]: faFilm,
    [EnumIcon.faCoconut]: faCoconut,
    [EnumIcon.faRulerHorizontal]: faRulerHorizontal,
    [EnumIcon.faShieldCross]: faShieldCross,
    [EnumIcon.faCassetteTape]: faCassetteTape,
    [EnumIcon.faSquareTerminal]: faSquareTerminal,
    [EnumIcon.faPeopleRobbery]: faPeopleRobbery,
    [EnumIcon.faLightbulb]: faLightbulb,
    [EnumIcon.faCaretLeft]: faCaretLeft,
    [EnumIcon.faCommentMiddle]: faCommentMiddle,
    [EnumIcon.faTrashCanList]: faTrashCanList,
    [EnumIcon.faBlock]: faBlock,
    [EnumIcon.faCircleExclamation]: faCircleExclamation,
    [EnumIcon.faExclamationCircle]: faExclamationCircle,
    [EnumIcon.faSchoolCircleXmark]: faSchoolCircleXmark,
    [EnumIcon.faArrowRightFromBracket]: faArrowRightFromBracket,
    [EnumIcon.faSignOut]: faSignOut,
    [EnumIcon.faFaceFrownSlight]: faFaceFrownSlight,
    [EnumIcon.faCircleChevronDown]: faCircleChevronDown,
    [EnumIcon.faChevronCircleDown]: faChevronCircleDown,
    [EnumIcon.faSidebarFlip]: faSidebarFlip,
    [EnumIcon.faUnlockKeyhole]: faUnlockKeyhole,
    [EnumIcon.faUnlockAlt]: faUnlockAlt,
    [EnumIcon.faTemperatureList]: faTemperatureList,
    [EnumIcon.faCloudShowersHeavy]: faCloudShowersHeavy,
    [EnumIcon.faHeadphonesSimple]: faHeadphonesSimple,
    [EnumIcon.faHeadphonesAlt]: faHeadphonesAlt,
    [EnumIcon.faSitemap]: faSitemap,
    [EnumIcon.faPipeSection]: faPipeSection,
    [EnumIcon.faSpaceStationMoonConstruction]: faSpaceStationMoonConstruction,
    [EnumIcon.faSpaceStationMoonAlt]: faSpaceStationMoonAlt,
    [EnumIcon.faCircleDollarToSlot]: faCircleDollarToSlot,
    [EnumIcon.faDonate]: faDonate,
    [EnumIcon.faMemory]: faMemory,
    [EnumIcon.faFaceSleeping]: faFaceSleeping,
    [EnumIcon.faRoadSpikes]: faRoadSpikes,
    [EnumIcon.faFireBurner]: faFireBurner,
    [EnumIcon.faSquirrel]: faSquirrel,
    [EnumIcon.faArrowUpToLine]: faArrowUpToLine,
    [EnumIcon.faArrowToTop]: faArrowToTop,
    [EnumIcon.faFlag]: faFlag,
    [EnumIcon.faFaceCowboyHat]: faFaceCowboyHat,
    [EnumIcon.faHanukiah]: faHanukiah,
    [EnumIcon.faChartScatter3d]: faChartScatter3d,
    [EnumIcon.faSquareCode]: faSquareCode,
    [EnumIcon.faFeather]: faFeather,
    [EnumIcon.faVolumeLow]: faVolumeLow,
    [EnumIcon.faVolumeDown]: faVolumeDown,
    [EnumIcon.faXmarkToSlot]: faXmarkToSlot,
    [EnumIcon.faTimesToSlot]: faTimesToSlot,
    [EnumIcon.faVoteNay]: faVoteNay,
    [EnumIcon.faBoxTaped]: faBoxTaped,
    [EnumIcon.faBoxAlt]: faBoxAlt,
    [EnumIcon.faCommentSlash]: faCommentSlash,
    [EnumIcon.faSwords]: faSwords,
    [EnumIcon.faCloudSunRain]: faCloudSunRain,
    [EnumIcon.faAlbum]: faAlbum,
    [EnumIcon.faCircleN]: faCircleN,
    [EnumIcon.faCompress]: faCompress,
    [EnumIcon.faWheatAwn]: faWheatAwn,
    [EnumIcon.faWheatAlt]: faWheatAlt,
    [EnumIcon.faAnkh]: faAnkh,
    [EnumIcon.faHandsHoldingChild]: faHandsHoldingChild,
    [EnumIcon.faAsterisk]: faAsterisk,
    [EnumIcon.faKeySkeletonLeftRight]: faKeySkeletonLeftRight,
    [EnumIcon.faCommentLines]: faCommentLines,
    [EnumIcon.faLuchadorMask]: faLuchadorMask,
    [EnumIcon.faLuchador]: faLuchador,
    [EnumIcon.faMaskLuchador]: faMaskLuchador,
    [EnumIcon.faSquareCheck]: faSquareCheck,
    [EnumIcon.faCheckSquare]: faCheckSquare,
    [EnumIcon.faShredder]: faShredder,
    [EnumIcon.faBookOpenCover]: faBookOpenCover,
    [EnumIcon.faBookOpenAlt]: faBookOpenAlt,
    [EnumIcon.faSandwich]: faSandwich,
    [EnumIcon.faPesetaSign]: faPesetaSign,
    [EnumIcon.faSquareParkingSlash]: faSquareParkingSlash,
    [EnumIcon.faParkingSlash]: faParkingSlash,
    [EnumIcon.faTrainTunnel]: faTrainTunnel,
    [EnumIcon.faHeading]: faHeading,
    [EnumIcon.faHeader]: faHeader,
    [EnumIcon.faGhost]: faGhost,
    [EnumIcon.faFaceAnguished]: faFaceAnguished,
    [EnumIcon.faHockeySticks]: faHockeySticks,
    [EnumIcon.faAbacus]: faAbacus,
    [EnumIcon.faFilmSimple]: faFilmSimple,
    [EnumIcon.faFilmAlt]: faFilmAlt,
    [EnumIcon.faList]: faList,
    [EnumIcon.faListSquares]: faListSquares,
    [EnumIcon.faTreePalm]: faTreePalm,
    [EnumIcon.faSquarePhoneFlip]: faSquarePhoneFlip,
    [EnumIcon.faPhoneSquareAlt]: faPhoneSquareAlt,
    [EnumIcon.faCartPlus]: faCartPlus,
    [EnumIcon.faGamepad]: faGamepad,
    [EnumIcon.faBorderCenterV]: faBorderCenterV,
    [EnumIcon.faCircleDot]: faCircleDot,
    [EnumIcon.faDotCircle]: faDotCircle,
    [EnumIcon.faClipboardMedical]: faClipboardMedical,
    [EnumIcon.faFaceDizzy]: faFaceDizzy,
    [EnumIcon.faDizzy]: faDizzy,
    [EnumIcon.faEgg]: faEgg,
    [EnumIcon.faUpToLine]: faUpToLine,
    [EnumIcon.faArrowAltToTop]: faArrowAltToTop,
    [EnumIcon.faHouseMedicalCircleXmark]: faHouseMedicalCircleXmark,
    [EnumIcon.faWatchFitness]: faWatchFitness,
    [EnumIcon.faClockNineThirty]: faClockNineThirty,
    [EnumIcon.faCampground]: faCampground,
    [EnumIcon.faFolderPlus]: faFolderPlus,
    [EnumIcon.faJug]: faJug,
    [EnumIcon.faFutbol]: faFutbol,
    [EnumIcon.faFutbolBall]: faFutbolBall,
    [EnumIcon.faSoccerBall]: faSoccerBall,
    [EnumIcon.faSnowBlowing]: faSnowBlowing,
    [EnumIcon.faPaintbrush]: faPaintbrush,
    [EnumIcon.faPaintBrush]: faPaintBrush,
    [EnumIcon.faLock]: faLock,
    [EnumIcon.faArrowDownFromLine]: faArrowDownFromLine,
    [EnumIcon.faArrowFromTop]: faArrowFromTop,
    [EnumIcon.faGasPump]: faGasPump,
    [EnumIcon.faSignalBarsSlash]: faSignalBarsSlash,
    [EnumIcon.faSignalAltSlash]: faSignalAltSlash,
    [EnumIcon.faMonkey]: faMonkey,
    [EnumIcon.faRectanglePro]: faRectanglePro,
    [EnumIcon.faPro]: faPro,
    [EnumIcon.faHouseNight]: faHouseNight,
    [EnumIcon.faHotTubPerson]: faHotTubPerson,
    [EnumIcon.faHotTub]: faHotTub,
    [EnumIcon.faBlanket]: faBlanket,
    [EnumIcon.faMapLocation]: faMapLocation,
    [EnumIcon.faMapMarked]: faMapMarked,
    [EnumIcon.faHouseFloodWater]: faHouseFloodWater,
    [EnumIcon.faCommentsQuestionCheck]: faCommentsQuestionCheck,
    [EnumIcon.faTree]: faTree,
    [EnumIcon.faArrowsCross]: faArrowsCross,
    [EnumIcon.faBackpack]: faBackpack,
    [EnumIcon.faSquareSmall]: faSquareSmall,
    [EnumIcon.faFolderArrowUp]: faFolderArrowUp,
    [EnumIcon.faFolderUpload]: faFolderUpload,
    [EnumIcon.faBridgeLock]: faBridgeLock,
    [EnumIcon.faCrosshairsSimple]: faCrosshairsSimple,
    [EnumIcon.faSackDollar]: faSackDollar,
    [EnumIcon.faPenToSquare]: faPenToSquare,
    [EnumIcon.faEdit]: faEdit,
    [EnumIcon.faSquareSliders]: faSquareSliders,
    [EnumIcon.faSlidersHSquare]: faSlidersHSquare,
    [EnumIcon.faCarSide]: faCarSide,
    [EnumIcon.faMessageMiddleTop]: faMessageMiddleTop,
    [EnumIcon.faCommentMiddleTopAlt]: faCommentMiddleTopAlt,
    [EnumIcon.faLightbulbOn]: faLightbulbOn,
    [EnumIcon.faKnife]: faKnife,
    [EnumIcon.faUtensilKnife]: faUtensilKnife,
    [EnumIcon.faShareNodes]: faShareNodes,
    [EnumIcon.faShareAlt]: faShareAlt,
    [EnumIcon.faWaveSine]: faWaveSine,
    [EnumIcon.faHeartCircleMinus]: faHeartCircleMinus,
    [EnumIcon.faCircleW]: faCircleW,
    [EnumIcon.faCircleCalendar]: faCircleCalendar,
    [EnumIcon.faCalendarCircle]: faCalendarCircle,
    [EnumIcon.faHourglassHalf]: faHourglassHalf,
    [EnumIcon.faHourglass2]: faHourglass2,
    [EnumIcon.faMicroscope]: faMicroscope,
    [EnumIcon.faSunset]: faSunset,
    [EnumIcon.faSink]: faSink,
    [EnumIcon.faCalendarExclamation]: faCalendarExclamation,
    [EnumIcon.faTruckContainerEmpty]: faTruckContainerEmpty,
    [EnumIcon.faHandHeart]: faHandHeart,
    [EnumIcon.faBagShopping]: faBagShopping,
    [EnumIcon.faShoppingBag]: faShoppingBag,
    [EnumIcon.faArrowDownZA]: faArrowDownZA,
    [EnumIcon.faSortAlphaDesc]: faSortAlphaDesc,
    [EnumIcon.faSortAlphaDownAlt]: faSortAlphaDownAlt,
    [EnumIcon.faMitten]: faMitten,
    [EnumIcon.faReplyClock]: faReplyClock,
    [EnumIcon.faReplyTime]: faReplyTime,
    [EnumIcon.faPersonRays]: faPersonRays,
    [EnumIcon.faRight]: faRight,
    [EnumIcon.faArrowAltRight]: faArrowAltRight,
    [EnumIcon.faCircleF]: faCircleF,
    [EnumIcon.faUsers]: faUsers,
    [EnumIcon.faFacePleading]: faFacePleading,
    [EnumIcon.faEyeSlash]: faEyeSlash,
    [EnumIcon.faFlaskVial]: faFlaskVial,
    [EnumIcon.faPoliceBox]: faPoliceBox,
    [EnumIcon.faCucumber]: faCucumber,
    [EnumIcon.faHeadSideBrain]: faHeadSideBrain,
    [EnumIcon.faHand]: faHand,
    [EnumIcon.faHandPaper]: faHandPaper,
    [EnumIcon.faPersonBikingMountain]: faPersonBikingMountain,
    [EnumIcon.faBikingMountain]: faBikingMountain,
    [EnumIcon.faUtensilsSlash]: faUtensilsSlash,
    [EnumIcon.faPrintMagnifyingGlass]: faPrintMagnifyingGlass,
    [EnumIcon.faPrintSearch]: faPrintSearch,
    [EnumIcon.faFolderBookmark]: faFolderBookmark,
    [EnumIcon.faOm]: faOm,
    [EnumIcon.faPi]: faPi,
    [EnumIcon.faFlaskRoundPotion]: faFlaskRoundPotion,
    [EnumIcon.faFlaskPotion]: faFlaskPotion,
    [EnumIcon.faFaceShush]: faFaceShush,
    [EnumIcon.faWorm]: faWorm,
    [EnumIcon.faHouseCircleXmark]: faHouseCircleXmark,
    [EnumIcon.faPlug]: faPlug,
    [EnumIcon.faCalendarCircleExclamation]: faCalendarCircleExclamation,
    [EnumIcon.faSquareI]: faSquareI,
    [EnumIcon.faChevronUp]: faChevronUp,
    [EnumIcon.faFaceSaluting]: faFaceSaluting,
    [EnumIcon.faGaugeSimpleLow]: faGaugeSimpleLow,
    [EnumIcon.faTachometerSlow]: faTachometerSlow,
    [EnumIcon.faFacePersevering]: faFacePersevering,
    [EnumIcon.faCircleCamera]: faCircleCamera,
    [EnumIcon.faCameraCircle]: faCameraCircle,
    [EnumIcon.faHandSpock]: faHandSpock,
    [EnumIcon.faSpiderWeb]: faSpiderWeb,
    [EnumIcon.faCircleMicrophone]: faCircleMicrophone,
    [EnumIcon.faMicrophoneCircle]: faMicrophoneCircle,
    [EnumIcon.faBookArrowUp]: faBookArrowUp,
    [EnumIcon.faPopsicle]: faPopsicle,
    [EnumIcon.faCommand]: faCommand,
    [EnumIcon.faBlinds]: faBlinds,
    [EnumIcon.faStopwatch]: faStopwatch,
    [EnumIcon.faSaxophone]: faSaxophone,
    [EnumIcon.faSquare2]: faSquare2,
    [EnumIcon.faFieldHockeyStickBall]: faFieldHockeyStickBall,
    [EnumIcon.faFieldHockey]: faFieldHockey,
    [EnumIcon.faArrowUpSquareTriangle]: faArrowUpSquareTriangle,
    [EnumIcon.faSortShapesUpAlt]: faSortShapesUpAlt,
    [EnumIcon.faFaceScream]: faFaceScream,
    [EnumIcon.faSquareM]: faSquareM,
    [EnumIcon.faCameraWeb]: faCameraWeb,
    [EnumIcon.faWebcam]: faWebcam,
    [EnumIcon.faCommentArrowDown]: faCommentArrowDown,
    [EnumIcon.faLightbulbCfl]: faLightbulbCfl,
    [EnumIcon.faWindowFrameOpen]: faWindowFrameOpen,
    [EnumIcon.faFaceKiss]: faFaceKiss,
    [EnumIcon.faKiss]: faKiss,
    [EnumIcon.faBridgeCircleXmark]: faBridgeCircleXmark,
    [EnumIcon.faPeriod]: faPeriod,
    [EnumIcon.faFaceGrinTongue]: faFaceGrinTongue,
    [EnumIcon.faGrinTongue]: faGrinTongue,
    [EnumIcon.faUpToDottedLine]: faUpToDottedLine,
    [EnumIcon.faThoughtBubble]: faThoughtBubble,
    [EnumIcon.faRaygun]: faRaygun,
    [EnumIcon.faFlute]: faFlute,
    [EnumIcon.faAcorn]: faAcorn,
    [EnumIcon.faVideoArrowUpRight]: faVideoArrowUpRight,
    [EnumIcon.faGrateDroplet]: faGrateDroplet,
    [EnumIcon.faSealExclamation]: faSealExclamation,
    [EnumIcon.faChessBishop]: faChessBishop,
    [EnumIcon.faMessageSms]: faMessageSms,
    [EnumIcon.faCoffeeBeans]: faCoffeeBeans,
    [EnumIcon.faHatWitch]: faHatWitch,
    [EnumIcon.faFaceGrinWink]: faFaceGrinWink,
    [EnumIcon.faGrinWink]: faGrinWink,
    [EnumIcon.faClockThreeThirty]: faClockThreeThirty,
    [EnumIcon.faEarDeaf]: faEarDeaf,
    [EnumIcon.faDeaf]: faDeaf,
    [EnumIcon.faDeafness]: faDeafness,
    [EnumIcon.faHardOfHearing]: faHardOfHearing,
    [EnumIcon.faAlarmClock]: faAlarmClock,
    [EnumIcon.faEclipse]: faEclipse,
    [EnumIcon.faFaceRelieved]: faFaceRelieved,
    [EnumIcon.faRoadCircleCheck]: faRoadCircleCheck,
    [EnumIcon.faDiceFive]: faDiceFive,
    [EnumIcon.faOctagonMinus]: faOctagonMinus,
    [EnumIcon.faMinusOctagon]: faMinusOctagon,
    [EnumIcon.faSquareRss]: faSquareRss,
    [EnumIcon.faRssSquare]: faRssSquare,
    [EnumIcon.faFaceZany]: faFaceZany,
    [EnumIcon.faTricycle]: faTricycle,
    [EnumIcon.faLandMineOn]: faLandMineOn,
    [EnumIcon.faSquareArrowUpLeft]: faSquareArrowUpLeft,
    [EnumIcon.faICursor]: faICursor,
    [EnumIcon.faSaltShaker]: faSaltShaker,
    [EnumIcon.faStamp]: faStamp,
    [EnumIcon.faFilePlus]: faFilePlus,
    [EnumIcon.faDrawSquare]: faDrawSquare,
    [EnumIcon.faToiletPaperUnderSlash]: faToiletPaperUnderSlash,
    [EnumIcon.faToiletPaperReverseSlash]: faToiletPaperReverseSlash,
    [EnumIcon.faStairs]: faStairs,
    [EnumIcon.faDroneFront]: faDroneFront,
    [EnumIcon.faDroneAlt]: faDroneAlt,
    [EnumIcon.faGlassEmpty]: faGlassEmpty,
    [EnumIcon.faDialHigh]: faDialHigh,
    [EnumIcon.faUserHelmetSafety]: faUserHelmetSafety,
    [EnumIcon.faUserConstruction]: faUserConstruction,
    [EnumIcon.faUserHardHat]: faUserHardHat,
    [EnumIcon.faI]: faI,
    [EnumIcon.faHryvniaSign]: faHryvniaSign,
    [EnumIcon.faHryvnia]: faHryvnia,
    [EnumIcon.faArrowDownLeftAndArrowUpRightToCenter]: faArrowDownLeftAndArrowUpRightToCenter,
    [EnumIcon.faPills]: faPills,
    [EnumIcon.faFaceGrinWide]: faFaceGrinWide,
    [EnumIcon.faGrinAlt]: faGrinAlt,
    [EnumIcon.faTooth]: faTooth,
    [EnumIcon.faBasketballHoop]: faBasketballHoop,
    [EnumIcon.faObjectsAlignBottom]: faObjectsAlignBottom,
    [EnumIcon.faV]: faV,
    [EnumIcon.faSparkles]: faSparkles,
    [EnumIcon.faSquid]: faSquid,
    [EnumIcon.faLeafyGreen]: faLeafyGreen,
    [EnumIcon.faCircleArrowUpRight]: faCircleArrowUpRight,
    [EnumIcon.faCalendars]: faCalendars,
    [EnumIcon.faBangladeshiTakaSign]: faBangladeshiTakaSign,
    [EnumIcon.faBicycle]: faBicycle,
    [EnumIcon.faHammerWar]: faHammerWar,
    [EnumIcon.faCircleD]: faCircleD,
    [EnumIcon.faSpiderBlackWidow]: faSpiderBlackWidow,
    [EnumIcon.faStaffSnake]: faStaffSnake,
    [EnumIcon.faRodAsclepius]: faRodAsclepius,
    [EnumIcon.faRodSnake]: faRodSnake,
    [EnumIcon.faStaffAesculapius]: faStaffAesculapius,
    [EnumIcon.faPear]: faPear,
    [EnumIcon.faHeadSideCoughSlash]: faHeadSideCoughSlash,
    [EnumIcon.faTriangle]: faTriangle,
    [EnumIcon.faApartment]: faApartment,
    [EnumIcon.faTruckMedical]: faTruckMedical,
    [EnumIcon.faAmbulance]: faAmbulance,
    [EnumIcon.faPepper]: faPepper,
    [EnumIcon.faPiano]: faPiano,
    [EnumIcon.faGunSquirt]: faGunSquirt,
    [EnumIcon.faWheatAwnCircleExclamation]: faWheatAwnCircleExclamation,
    [EnumIcon.faSnowman]: faSnowman,
    [EnumIcon.faUserAlien]: faUserAlien,
    [EnumIcon.faShieldCheck]: faShieldCheck,
    [EnumIcon.faMortarPestle]: faMortarPestle,
    [EnumIcon.faRoadBarrier]: faRoadBarrier,
    [EnumIcon.faChartCandlestick]: faChartCandlestick,
    [EnumIcon.faBriefcaseBlank]: faBriefcaseBlank,
    [EnumIcon.faSchool]: faSchool,
    [EnumIcon.faIgloo]: faIgloo,
    [EnumIcon.faBracketRound]: faBracketRound,
    [EnumIcon.faParenthesis]: faParenthesis,
    [EnumIcon.faJoint]: faJoint,
    [EnumIcon.faHorseSaddle]: faHorseSaddle,
    [EnumIcon.faMugMarshmallows]: faMugMarshmallows,
    [EnumIcon.faFilters]: faFilters,
    [EnumIcon.faBellOn]: faBellOn,
    [EnumIcon.faAngleRight]: faAngleRight,
    [EnumIcon.faDialMed]: faDialMed,
    [EnumIcon.faHorse]: faHorse,
    [EnumIcon.faQ]: faQ,
    [EnumIcon.faMonitorWaveform]: faMonitorWaveform,
    [EnumIcon.faMonitorHeartRate]: faMonitorHeartRate,
    [EnumIcon.faLinkSimple]: faLinkSimple,
    [EnumIcon.faWhistle]: faWhistle,
    [EnumIcon.faG]: faG,
    [EnumIcon.faWineGlassCrack]: faWineGlassCrack,
    [EnumIcon.faFragile]: faFragile,
    [EnumIcon.faSlotMachine]: faSlotMachine,
    [EnumIcon.faNotesMedical]: faNotesMedical,
    [EnumIcon.faCarWash]: faCarWash,
    [EnumIcon.faEscalator]: faEscalator,
    [EnumIcon.faCommentImage]: faCommentImage,
    [EnumIcon.faTemperatureHalf]: faTemperatureHalf,
    [EnumIcon.faTemperature2]: faTemperature2,
    [EnumIcon.faThermometer2]: faThermometer2,
    [EnumIcon.faThermometerHalf]: faThermometerHalf,
    [EnumIcon.faDongSign]: faDongSign,
    [EnumIcon.faDonut]: faDonut,
    [EnumIcon.faDoughnut]: faDoughnut,
    [EnumIcon.faCapsules]: faCapsules,
    [EnumIcon.faPooStorm]: faPooStorm,
    [EnumIcon.faPooBolt]: faPooBolt,
    [EnumIcon.faTally1]: faTally1,
    [EnumIcon.faFaceFrownOpen]: faFaceFrownOpen,
    [EnumIcon.faFrownOpen]: faFrownOpen,
    [EnumIcon.faSquareDashed]: faSquareDashed,
    [EnumIcon.faSquareJ]: faSquareJ,
    [EnumIcon.faHandPointUp]: faHandPointUp,
    [EnumIcon.faMoneyBill]: faMoneyBill,
    [EnumIcon.faArrowUpBigSmall]: faArrowUpBigSmall,
    [EnumIcon.faSortSizeUp]: faSortSizeUp,
    [EnumIcon.faBarcodeRead]: faBarcodeRead,
    [EnumIcon.faBaguette]: faBaguette,
    [EnumIcon.faBowlSoftServe]: faBowlSoftServe,
    [EnumIcon.faFaceHoldingBackTears]: faFaceHoldingBackTears,
    [EnumIcon.faSquareUp]: faSquareUp,
    [EnumIcon.faArrowAltSquareUp]: faArrowAltSquareUp,
    [EnumIcon.faTrainSubwayTunnel]: faTrainSubwayTunnel,
    [EnumIcon.faSubwayTunnel]: faSubwayTunnel,
    [EnumIcon.faSquareExclamation]: faSquareExclamation,
    [EnumIcon.faExclamationSquare]: faExclamationSquare,
    [EnumIcon.faSemicolon]: faSemicolon,
    [EnumIcon.faBookmark]: faBookmark,
    [EnumIcon.faFanTable]: faFanTable,
    [EnumIcon.faAlignJustify]: faAlignJustify,
    [EnumIcon.faBatteryLow]: faBatteryLow,
    [EnumIcon.faBattery1]: faBattery1,
    [EnumIcon.faCreditCardFront]: faCreditCardFront,
    [EnumIcon.faBrainArrowCurvedRight]: faBrainArrowCurvedRight,
    [EnumIcon.faMindShare]: faMindShare,
    [EnumIcon.faUmbrellaBeach]: faUmbrellaBeach,
    [EnumIcon.faHelmetUn]: faHelmetUn,
    [EnumIcon.faLocationSmile]: faLocationSmile,
    [EnumIcon.faMapMarkerSmile]: faMapMarkerSmile,
    [EnumIcon.faArrowLeftToLine]: faArrowLeftToLine,
    [EnumIcon.faArrowToLeft]: faArrowToLeft,
    [EnumIcon.faBullseye]: faBullseye,
    [EnumIcon.faSushi]: faSushi,
    [EnumIcon.faNigiri]: faNigiri,
    [EnumIcon.faMessageCaptions]: faMessageCaptions,
    [EnumIcon.faCommentAltCaptions]: faCommentAltCaptions,
    [EnumIcon.faTrashList]: faTrashList,
    [EnumIcon.faBacon]: faBacon,
    [EnumIcon.faOption]: faOption,
    [EnumIcon.faHandPointDown]: faHandPointDown,
    [EnumIcon.faArrowUpFromBracket]: faArrowUpFromBracket,
    [EnumIcon.faTrashPlus]: faTrashPlus,
    [EnumIcon.faObjectsAlignTop]: faObjectsAlignTop,
    [EnumIcon.faFolder]: faFolder,
    [EnumIcon.faFolderBlank]: faFolderBlank,
    [EnumIcon.faFaceAnxiousSweat]: faFaceAnxiousSweat,
    [EnumIcon.faCreditCardBlank]: faCreditCardBlank,
    [EnumIcon.faFileWaveform]: faFileWaveform,
    [EnumIcon.faFileMedicalAlt]: faFileMedicalAlt,
    [EnumIcon.faMicrochipAi]: faMicrochipAi,
    [EnumIcon.faMug]: faMug,
    [EnumIcon.faPlaneUpSlash]: faPlaneUpSlash,
    [EnumIcon.faRadiation]: faRadiation,
    [EnumIcon.faPenCircle]: faPenCircle,
    [EnumIcon.faChartSimple]: faChartSimple,
    [EnumIcon.faCrutches]: faCrutches,
    [EnumIcon.faCircleParking]: faCircleParking,
    [EnumIcon.faParkingCircle]: faParkingCircle,
    [EnumIcon.faMarsStroke]: faMarsStroke,
    [EnumIcon.faLeafOak]: faLeafOak,
    [EnumIcon.faSquareBolt]: faSquareBolt,
    [EnumIcon.faVial]: faVial,
    [EnumIcon.faGauge]: faGauge,
    [EnumIcon.faDashboard]: faDashboard,
    [EnumIcon.faGaugeMed]: faGaugeMed,
    [EnumIcon.faTachometerAltAverage]: faTachometerAltAverage,
    [EnumIcon.faWandMagicSparkles]: faWandMagicSparkles,
    [EnumIcon.faMagicWandSparkles]: faMagicWandSparkles,
    [EnumIcon.faLambda]: faLambda,
    [EnumIcon.faE]: faE,
    [EnumIcon.faPizza]: faPizza,
    [EnumIcon.faBowlChopsticksNoodles]: faBowlChopsticksNoodles,
    [EnumIcon.faH3]: faH3,
    [EnumIcon.faPenClip]: faPenClip,
    [EnumIcon.faPenAlt]: faPenAlt,
    [EnumIcon.faBridgeCircleExclamation]: faBridgeCircleExclamation,
    [EnumIcon.faBadgePercent]: faBadgePercent,
    [EnumIcon.faUser]: faUser,
    [EnumIcon.faSensor]: faSensor,
    [EnumIcon.faComma]: faComma,
    [EnumIcon.faSchoolCircleCheck]: faSchoolCircleCheck,
    [EnumIcon.faToiletPaperUnder]: faToiletPaperUnder,
    [EnumIcon.faToiletPaperReverse]: faToiletPaperReverse,
    [EnumIcon.faLightEmergency]: faLightEmergency,
    [EnumIcon.faArrowDownToArc]: faArrowDownToArc,
    [EnumIcon.faDumpster]: faDumpster,
    [EnumIcon.faVanShuttle]: faVanShuttle,
    [EnumIcon.faShuttleVan]: faShuttleVan,
    [EnumIcon.faBuildingUser]: faBuildingUser,
    [EnumIcon.faLightSwitch]: faLightSwitch,
    [EnumIcon.faSquareCaretLeft]: faSquareCaretLeft,
    [EnumIcon.faCaretSquareLeft]: faCaretSquareLeft,
    [EnumIcon.faHighlighter]: faHighlighter,
    [EnumIcon.faWavePulse]: faWavePulse,
    [EnumIcon.faHeartRate]: faHeartRate,
    [EnumIcon.faKey]: faKey,
    [EnumIcon.faHatSanta]: faHatSanta,
    [EnumIcon.faTamale]: faTamale,
    [EnumIcon.faBoxCheck]: faBoxCheck,
    [EnumIcon.faBullhorn]: faBullhorn,
    [EnumIcon.faSteak]: faSteak,
    [EnumIcon.faLocationCrosshairsSlash]: faLocationCrosshairsSlash,
    [EnumIcon.faLocationSlash]: faLocationSlash,
    [EnumIcon.faPersonDolly]: faPersonDolly,
    [EnumIcon.faGlobe]: faGlobe,
    [EnumIcon.faSynagogue]: faSynagogue,
    [EnumIcon.faFileChartColumn]: faFileChartColumn,
    [EnumIcon.faFileChartLine]: faFileChartLine,
    [EnumIcon.faPersonHalfDress]: faPersonHalfDress,
    [EnumIcon.faFolderImage]: faFolderImage,
    [EnumIcon.faCalendarPen]: faCalendarPen,
    [EnumIcon.faCalendarEdit]: faCalendarEdit,
    [EnumIcon.faRoadBridge]: faRoadBridge,
    [EnumIcon.faFaceSmileTear]: faFaceSmileTear,
    [EnumIcon.faMessagePlus]: faMessagePlus,
    [EnumIcon.faCommentAltPlus]: faCommentAltPlus,
    [EnumIcon.faLocationArrow]: faLocationArrow,
    [EnumIcon.faC]: faC,
    [EnumIcon.faTabletButton]: faTabletButton,
    [EnumIcon.faRectangleHistoryCircleUser]: faRectangleHistoryCircleUser,
    [EnumIcon.faBuildingLock]: faBuildingLock,
    [EnumIcon.faChartLineUp]: faChartLineUp,
    [EnumIcon.faMailbox]: faMailbox,
    [EnumIcon.faTruckBolt]: faTruckBolt,
    [EnumIcon.faPizzaSlice]: faPizzaSlice,
    [EnumIcon.faMoneyBillWave]: faMoneyBillWave,
    [EnumIcon.faChartArea]: faChartArea,
    [EnumIcon.faAreaChart]: faAreaChart,
    [EnumIcon.faHouseFlag]: faHouseFlag,
    [EnumIcon.faPersonCircleMinus]: faPersonCircleMinus,
    [EnumIcon.faScalpel]: faScalpel,
    [EnumIcon.faBan]: faBan,
    [EnumIcon.faCancel]: faCancel,
    [EnumIcon.faBellExclamation]: faBellExclamation,
    [EnumIcon.faCircleBookmark]: faCircleBookmark,
    [EnumIcon.faBookmarkCircle]: faBookmarkCircle,
    [EnumIcon.faEggFried]: faEggFried,
    [EnumIcon.faFaceWeary]: faFaceWeary,
    [EnumIcon.faUniformMartialArts]: faUniformMartialArts,
    [EnumIcon.faCameraRotate]: faCameraRotate,
    [EnumIcon.faSunDust]: faSunDust,
    [EnumIcon.faCommentText]: faCommentText,
    [EnumIcon.faSprayCanSparkles]: faSprayCanSparkles,
    [EnumIcon.faAirFreshener]: faAirFreshener,
    [EnumIcon.faSignalBars]: faSignalBars,
    [EnumIcon.faSignalAlt]: faSignalAlt,
    [EnumIcon.faSignalAlt4]: faSignalAlt4,
    [EnumIcon.faSignalBarsStrong]: faSignalBarsStrong,
    [EnumIcon.faDiamondExclamation]: faDiamondExclamation,
    [EnumIcon.faStar]: faStar,
    [EnumIcon.faDialMin]: faDialMin,
    [EnumIcon.faRepeat]: faRepeat,
    [EnumIcon.faCross]: faCross,
    [EnumIcon.faPageCaretDown]: faPageCaretDown,
    [EnumIcon.faFileCaretDown]: faFileCaretDown,
    [EnumIcon.faBox]: faBox,
    [EnumIcon.faVenusMars]: faVenusMars,
    [EnumIcon.faClockSevenThirty]: faClockSevenThirty,
    [EnumIcon.faArrowPointer]: faArrowPointer,
    [EnumIcon.faMousePointer]: faMousePointer,
    [EnumIcon.faClockFourThirty]: faClockFourThirty,
    [EnumIcon.faSignalBarsGood]: faSignalBarsGood,
    [EnumIcon.faSignalAlt3]: faSignalAlt3,
    [EnumIcon.faCactus]: faCactus,
    [EnumIcon.faMaximize]: faMaximize,
    [EnumIcon.faExpandArrowsAlt]: faExpandArrowsAlt,
    [EnumIcon.faChargingStation]: faChargingStation,
    [EnumIcon.faShapes]: faShapes,
    [EnumIcon.faTriangleCircleSquare]: faTriangleCircleSquare,
    [EnumIcon.faPlaneTail]: faPlaneTail,
    [EnumIcon.faGaugeSimpleMax]: faGaugeSimpleMax,
    [EnumIcon.faTachometerFastest]: faTachometerFastest,
    [EnumIcon.faCircleU]: faCircleU,
    [EnumIcon.faShieldSlash]: faShieldSlash,
    [EnumIcon.faSquarePhoneHangup]: faSquarePhoneHangup,
    [EnumIcon.faPhoneSquareDown]: faPhoneSquareDown,
    [EnumIcon.faArrowUpLeft]: faArrowUpLeft,
    [EnumIcon.faTransporter1]: faTransporter1,
    [EnumIcon.faPeanuts]: faPeanuts,
    [EnumIcon.faShuffle]: faShuffle,
    [EnumIcon.faRandom]: faRandom,
    [EnumIcon.faPersonRunning]: faPersonRunning,
    [EnumIcon.faRunning]: faRunning,
    [EnumIcon.faMobileRetro]: faMobileRetro,
    [EnumIcon.faGripLinesVertical]: faGripLinesVertical,
    [EnumIcon.faArrowUpFromSquare]: faArrowUpFromSquare,
    [EnumIcon.faFileDashedLine]: faFileDashedLine,
    [EnumIcon.faPageBreak]: faPageBreak,
    [EnumIcon.faBracketCurlyRight]: faBracketCurlyRight,
    [EnumIcon.faSpider]: faSpider,
    [EnumIcon.faClockThree]: faClockThree,
    [EnumIcon.faHandsBound]: faHandsBound,
    [EnumIcon.faScalpelLineDashed]: faScalpelLineDashed,
    [EnumIcon.faScalpelPath]: faScalpelPath,
    [EnumIcon.faFileInvoiceDollar]: faFileInvoiceDollar,
    [EnumIcon.faPipeSmoking]: faPipeSmoking,
    [EnumIcon.faFaceAstonished]: faFaceAstonished,
    [EnumIcon.faWindow]: faWindow,
    [EnumIcon.faPlaneCircleExclamation]: faPlaneCircleExclamation,
    [EnumIcon.faEar]: faEar,
    [EnumIcon.faFileLock]: faFileLock,
    [EnumIcon.faDiagramVenn]: faDiagramVenn,
    [EnumIcon.faXRay]: faXRay,
    [EnumIcon.faGoalNet]: faGoalNet,
    [EnumIcon.faCoffinCross]: faCoffinCross,
    [EnumIcon.faSpellCheck]: faSpellCheck,
    [EnumIcon.faLocationXmark]: faLocationXmark,
    [EnumIcon.faMapMarkerTimes]: faMapMarkerTimes,
    [EnumIcon.faMapMarkerXmark]: faMapMarkerXmark,
    [EnumIcon.faLasso]: faLasso,
    [EnumIcon.faSlash]: faSlash,
    [EnumIcon.faPersonToPortal]: faPersonToPortal,
    [EnumIcon.faPortalEnter]: faPortalEnter,
    [EnumIcon.faCalendarStar]: faCalendarStar,
    [EnumIcon.faComputerMouse]: faComputerMouse,
    [EnumIcon.faMouse]: faMouse,
    [EnumIcon.faArrowRightToBracket]: faArrowRightToBracket,
    [EnumIcon.faSignIn]: faSignIn,
    [EnumIcon.faPegasus]: faPegasus,
    [EnumIcon.faFilesMedical]: faFilesMedical,
    [EnumIcon.faNfcLock]: faNfcLock,
    [EnumIcon.faPersonSkiLift]: faPersonSkiLift,
    [EnumIcon.faSkiLift]: faSkiLift,
    [EnumIcon.faSquare6]: faSquare6,
    [EnumIcon.faShopSlash]: faShopSlash,
    [EnumIcon.faStoreAltSlash]: faStoreAltSlash,
    [EnumIcon.faWindTurbine]: faWindTurbine,
    [EnumIcon.faSlidersSimple]: faSlidersSimple,
    [EnumIcon.faBadgeSheriff]: faBadgeSheriff,
    [EnumIcon.faServer]: faServer,
    [EnumIcon.faVirusCovidSlash]: faVirusCovidSlash,
    [EnumIcon.faIntersection]: faIntersection,
    [EnumIcon.faShopLock]: faShopLock,
    [EnumIcon.faFamily]: faFamily,
    [EnumIcon.faHourglassStart]: faHourglassStart,
    [EnumIcon.faHourglass1]: faHourglass1,
    [EnumIcon.faUserHairBuns]: faUserHairBuns,
    [EnumIcon.faBlenderPhone]: faBlenderPhone,
    [EnumIcon.faHourglassClock]: faHourglassClock,
    [EnumIcon.faPersonSeatReclined]: faPersonSeatReclined,
    [EnumIcon.faPaperPlaneTop]: faPaperPlaneTop,
    [EnumIcon.faPaperPlaneAlt]: faPaperPlaneAlt,
    [EnumIcon.faSend]: faSend,
    [EnumIcon.faMessageArrowUp]: faMessageArrowUp,
    [EnumIcon.faCommentAltArrowUp]: faCommentAltArrowUp,
    [EnumIcon.faLightbulbExclamation]: faLightbulbExclamation,
    [EnumIcon.faLayerMinus]: faLayerMinus,
    [EnumIcon.faLayerGroupMinus]: faLayerGroupMinus,
    [EnumIcon.faCircleE]: faCircleE,
    [EnumIcon.faBuildingWheat]: faBuildingWheat,
    [EnumIcon.faGaugeMax]: faGaugeMax,
    [EnumIcon.faTachometerAltFastest]: faTachometerAltFastest,
    [EnumIcon.faPersonBreastfeeding]: faPersonBreastfeeding,
    [EnumIcon.faApostrophe]: faApostrophe,
    [EnumIcon.faFireHydrant]: faFireHydrant,
    [EnumIcon.faRightToBracket]: faRightToBracket,
    [EnumIcon.faSignInAlt]: faSignInAlt,
    [EnumIcon.faVideoPlus]: faVideoPlus,
    [EnumIcon.faSquareRight]: faSquareRight,
    [EnumIcon.faArrowAltSquareRight]: faArrowAltSquareRight,
    [EnumIcon.faCommentSmile]: faCommentSmile,
    [EnumIcon.faVenus]: faVenus,
    [EnumIcon.faPassport]: faPassport,
    [EnumIcon.faInboxIn]: faInboxIn,
    [EnumIcon.faInboxArrowDown]: faInboxArrowDown,
    [EnumIcon.faHeartPulse]: faHeartPulse,
    [EnumIcon.faHeartbeat]: faHeartbeat,
    [EnumIcon.faCircle8]: faCircle8,
    [EnumIcon.faCloudsMoon]: faCloudsMoon,
    [EnumIcon.faClockTenThirty]: faClockTenThirty,
    [EnumIcon.faPeopleCarryBox]: faPeopleCarryBox,
    [EnumIcon.faPeopleCarry]: faPeopleCarry,
    [EnumIcon.faFolderUser]: faFolderUser,
    [EnumIcon.faTrashCanXmark]: faTrashCanXmark,
    [EnumIcon.faTemperatureHigh]: faTemperatureHigh,
    [EnumIcon.faMicrochip]: faMicrochip,
    [EnumIcon.faLeftLongToLine]: faLeftLongToLine,
    [EnumIcon.faCrown]: faCrown,
    [EnumIcon.faWeightHanging]: faWeightHanging,
    [EnumIcon.faXmarksLines]: faXmarksLines,
    [EnumIcon.faFilePrescription]: faFilePrescription,
    [EnumIcon.faCalendarRange]: faCalendarRange,
    [EnumIcon.faFlowerDaffodil]: faFlowerDaffodil,
    [EnumIcon.faHandBackPointUp]: faHandBackPointUp,
    [EnumIcon.faWeightScale]: faWeightScale,
    [EnumIcon.faWeight]: faWeight,
    [EnumIcon.faStarExclamation]: faStarExclamation,
    [EnumIcon.faBooks]: faBooks,
    [EnumIcon.faUserGroup]: faUserGroup,
    [EnumIcon.faUserFriends]: faUserFriends,
    [EnumIcon.faArrowUpAZ]: faArrowUpAZ,
    [EnumIcon.faSortAlphaUp]: faSortAlphaUp,
    [EnumIcon.faLayerPlus]: faLayerPlus,
    [EnumIcon.faLayerGroupPlus]: faLayerGroupPlus,
    [EnumIcon.faPlayPause]: faPlayPause,
    [EnumIcon.faBlockQuestion]: faBlockQuestion,
    [EnumIcon.faSnooze]: faSnooze,
    [EnumIcon.faZzz]: faZzz,
    [EnumIcon.faScannerImage]: faScannerImage,
    [EnumIcon.faTvRetro]: faTvRetro,
    [EnumIcon.faSquareT]: faSquareT,
    [EnumIcon.faFarm]: faFarm,
    [EnumIcon.faBarnSilo]: faBarnSilo,
    [EnumIcon.faChessKnight]: faChessKnight,
    [EnumIcon.faBarsSort]: faBarsSort,
    [EnumIcon.faPalletBoxes]: faPalletBoxes,
    [EnumIcon.faPaletteBoxes]: faPaletteBoxes,
    [EnumIcon.faPalletAlt]: faPalletAlt,
    [EnumIcon.faFaceLaughSquint]: faFaceLaughSquint,
    [EnumIcon.faLaughSquint]: faLaughSquint,
    [EnumIcon.faCodeSimple]: faCodeSimple,
    [EnumIcon.faBoltSlash]: faBoltSlash,
    [EnumIcon.faPanelFire]: faPanelFire,
    [EnumIcon.faBinaryCircleCheck]: faBinaryCircleCheck,
    [EnumIcon.faCommentMinus]: faCommentMinus,
    [EnumIcon.faBurrito]: faBurrito,
    [EnumIcon.faViolin]: faViolin,
    [EnumIcon.faObjectsColumn]: faObjectsColumn,
    [EnumIcon.faSquareChevronDown]: faSquareChevronDown,
    [EnumIcon.faChevronSquareDown]: faChevronSquareDown,
    [EnumIcon.faCommentPlus]: faCommentPlus,
    [EnumIcon.faTriangleInstrument]: faTriangleInstrument,
    [EnumIcon.faTriangleMusic]: faTriangleMusic,
    [EnumIcon.faWheelchair]: faWheelchair,
    [EnumIcon.faUserPilotTie]: faUserPilotTie,
    [EnumIcon.faPianoKeyboard]: faPianoKeyboard,
    [EnumIcon.faBedEmpty]: faBedEmpty,
    [EnumIcon.faCircleArrowUp]: faCircleArrowUp,
    [EnumIcon.faArrowCircleUp]: faArrowCircleUp,
    [EnumIcon.faToggleOn]: faToggleOn,
    [EnumIcon.faRectangleVertical]: faRectangleVertical,
    [EnumIcon.faRectanglePortrait]: faRectanglePortrait,
    [EnumIcon.faPersonWalking]: faPersonWalking,
    [EnumIcon.faWalking]: faWalking,
    [EnumIcon.faL]: faL,
    [EnumIcon.faSignalStream]: faSignalStream,
    [EnumIcon.faDownToBracket]: faDownToBracket,
    [EnumIcon.faCircleZ]: faCircleZ,
    [EnumIcon.faStars]: faStars,
    [EnumIcon.faFire]: faFire,
    [EnumIcon.faBedPulse]: faBedPulse,
    [EnumIcon.faProcedures]: faProcedures,
    [EnumIcon.faHouseDay]: faHouseDay,
    [EnumIcon.faShuttleSpace]: faShuttleSpace,
    [EnumIcon.faSpaceShuttle]: faSpaceShuttle,
    [EnumIcon.faShirtLongSleeve]: faShirtLongSleeve,
    [EnumIcon.faChartPieSimple]: faChartPieSimple,
    [EnumIcon.faChartPieAlt]: faChartPieAlt,
    [EnumIcon.faFaceLaugh]: faFaceLaugh,
    [EnumIcon.faLaugh]: faLaugh,
    [EnumIcon.faFolderOpen]: faFolderOpen,
    [EnumIcon.faAlbumCollectionCircleUser]: faAlbumCollectionCircleUser,
    [EnumIcon.faCandy]: faCandy,
    [EnumIcon.faBowlHot]: faBowlHot,
    [EnumIcon.faSoup]: faSoup,
    [EnumIcon.faFlatbread]: faFlatbread,
    [EnumIcon.faHeartCirclePlus]: faHeartCirclePlus,
    [EnumIcon.faCodeFork]: faCodeFork,
    [EnumIcon.faCity]: faCity,
    [EnumIcon.faSignalBarsWeak]: faSignalBarsWeak,
    [EnumIcon.faSignalAlt1]: faSignalAlt1,
    [EnumIcon.faMicrophoneLines]: faMicrophoneLines,
    [EnumIcon.faMicrophoneAlt]: faMicrophoneAlt,
    [EnumIcon.faClockTwelve]: faClockTwelve,
    [EnumIcon.faPepperHot]: faPepperHot,
    [EnumIcon.faCitrusSlice]: faCitrusSlice,
    [EnumIcon.faSheep]: faSheep,
    [EnumIcon.faUnlock]: faUnlock,
    [EnumIcon.faColonSign]: faColonSign,
    [EnumIcon.faHeadset]: faHeadset,
    [EnumIcon.faBadgerHoney]: faBadgerHoney,
    [EnumIcon.faH4]: faH4,
    [EnumIcon.faStoreSlash]: faStoreSlash,
    [EnumIcon.faRoadCircleXmark]: faRoadCircleXmark,
    [EnumIcon.faSignalSlash]: faSignalSlash,
    [EnumIcon.faUserMinus]: faUserMinus,
    [EnumIcon.faMarsStrokeUp]: faMarsStrokeUp,
    [EnumIcon.faMarsStrokeV]: faMarsStrokeV,
    [EnumIcon.faChampagneGlasses]: faChampagneGlasses,
    [EnumIcon.faGlassCheers]: faGlassCheers,
    [EnumIcon.faTaco]: faTaco,
    [EnumIcon.faHexagonPlus]: faHexagonPlus,
    [EnumIcon.faPlusHexagon]: faPlusHexagon,
    [EnumIcon.faClipboard]: faClipboard,
    [EnumIcon.faHouseCircleExclamation]: faHouseCircleExclamation,
    [EnumIcon.faFileArrowUp]: faFileArrowUp,
    [EnumIcon.faFileUpload]: faFileUpload,
    [EnumIcon.faWifi]: faWifi,
    [EnumIcon.faWifi3]: faWifi3,
    [EnumIcon.faWifiStrong]: faWifiStrong,
    [EnumIcon.faMessages]: faMessages,
    [EnumIcon.faCommentsAlt]: faCommentsAlt,
    [EnumIcon.faBath]: faBath,
    [EnumIcon.faBathtub]: faBathtub,
    [EnumIcon.faUmbrellaSimple]: faUmbrellaSimple,
    [EnumIcon.faUmbrellaAlt]: faUmbrellaAlt,
    [EnumIcon.faRectangleHistoryCirclePlus]: faRectangleHistoryCirclePlus,
    [EnumIcon.faUnderline]: faUnderline,
    [EnumIcon.faPrescriptionBottlePill]: faPrescriptionBottlePill,
    [EnumIcon.faUserPen]: faUserPen,
    [EnumIcon.faUserEdit]: faUserEdit,
    [EnumIcon.faBinarySlash]: faBinarySlash,
    [EnumIcon.faSquareO]: faSquareO,
    [EnumIcon.faSignature]: faSignature,
    [EnumIcon.faStroopwafel]: faStroopwafel,
    [EnumIcon.faBold]: faBold,
    [EnumIcon.faAnchorLock]: faAnchorLock,
    [EnumIcon.faBuildingNgo]: faBuildingNgo,
    [EnumIcon.faTransporter3]: faTransporter3,
    [EnumIcon.faEngineWarning]: faEngineWarning,
    [EnumIcon.faEngineExclamation]: faEngineExclamation,
    [EnumIcon.faCircleDownRight]: faCircleDownRight,
    [EnumIcon.faSquareK]: faSquareK,
    [EnumIcon.faManatSign]: faManatSign,
    [EnumIcon.faMoneyCheckPen]: faMoneyCheckPen,
    [EnumIcon.faMoneyCheckEdit]: faMoneyCheckEdit,
    [EnumIcon.faNotEqual]: faNotEqual,
    [EnumIcon.faBorderTopLeft]: faBorderTopLeft,
    [EnumIcon.faBorderStyle]: faBorderStyle,
    [EnumIcon.faMapLocationDot]: faMapLocationDot,
    [EnumIcon.faMapMarkedAlt]: faMapMarkedAlt,
    [EnumIcon.faTilde]: faTilde,
    [EnumIcon.faJedi]: faJedi,
    [EnumIcon.faSquarePollVertical]: faSquarePollVertical,
    [EnumIcon.faPoll]: faPoll,
    [EnumIcon.faArrowDownSquareTriangle]: faArrowDownSquareTriangle,
    [EnumIcon.faSortShapesDownAlt]: faSortShapesDownAlt,
    [EnumIcon.faMugHot]: faMugHot,
    [EnumIcon.faDogLeashed]: faDogLeashed,
    [EnumIcon.faCarBattery]: faCarBattery,
    [EnumIcon.faBatteryCar]: faBatteryCar,
    [EnumIcon.faFaceDowncastSweat]: faFaceDowncastSweat,
    [EnumIcon.faMailboxFlagUp]: faMailboxFlagUp,
    [EnumIcon.faMemoCircleInfo]: faMemoCircleInfo,
    [EnumIcon.faGift]: faGift,
    [EnumIcon.faDiceTwo]: faDiceTwo,
    [EnumIcon.faVolume]: faVolume,
    [EnumIcon.faVolumeMedium]: faVolumeMedium,
    [EnumIcon.faTransporter5]: faTransporter5,
    [EnumIcon.faGaugeCircleBolt]: faGaugeCircleBolt,
    [EnumIcon.faCoinFront]: faCoinFront,
    [EnumIcon.faFileSlash]: faFileSlash,
    [EnumIcon.faMessageArrowUpRight]: faMessageArrowUpRight,
    [EnumIcon.faTreasureChest]: faTreasureChest,
    [EnumIcon.faChessQueen]: faChessQueen,
    [EnumIcon.faPaintbrushFine]: faPaintbrushFine,
    [EnumIcon.faPaintBrushAlt]: faPaintBrushAlt,
    [EnumIcon.faPaintBrushFine]: faPaintBrushFine,
    [EnumIcon.faPaintbrushAlt]: faPaintbrushAlt,
    [EnumIcon.faGlasses]: faGlasses,
    [EnumIcon.faHoodCloak]: faHoodCloak,
    [EnumIcon.faSquareQuote]: faSquareQuote,
    [EnumIcon.faUpLeft]: faUpLeft,
    [EnumIcon.faBringFront]: faBringFront,
    [EnumIcon.faChessBoard]: faChessBoard,
    [EnumIcon.faBurgerCheese]: faBurgerCheese,
    [EnumIcon.faCheeseburger]: faCheeseburger,
    [EnumIcon.faBuildingCircleCheck]: faBuildingCircleCheck,
    [EnumIcon.faRepeat1]: faRepeat1,
    [EnumIcon.faArrowDownToLine]: faArrowDownToLine,
    [EnumIcon.faArrowToBottom]: faArrowToBottom,
    [EnumIcon.faGrid5]: faGrid5,
    [EnumIcon.faRightLongToLine]: faRightLongToLine,
    [EnumIcon.faPersonChalkboard]: faPersonChalkboard,
    [EnumIcon.faMarsStrokeRight]: faMarsStrokeRight,
    [EnumIcon.faMarsStrokeH]: faMarsStrokeH,
    [EnumIcon.faHandBackFist]: faHandBackFist,
    [EnumIcon.faHandRock]: faHandRock,
    [EnumIcon.faTally]: faTally,
    [EnumIcon.faTally5]: faTally5,
    [EnumIcon.faSquareCaretUp]: faSquareCaretUp,
    [EnumIcon.faCaretSquareUp]: faCaretSquareUp,
    [EnumIcon.faCloudShowersWater]: faCloudShowersWater,
    [EnumIcon.faChartBar]: faChartBar,
    [EnumIcon.faBarChart]: faBarChart,
    [EnumIcon.faHandsBubbles]: faHandsBubbles,
    [EnumIcon.faHandsWash]: faHandsWash,
    [EnumIcon.faLessThanEqual]: faLessThanEqual,
    [EnumIcon.faTrain]: faTrain,
    [EnumIcon.faUpFromDottedLine]: faUpFromDottedLine,
    [EnumIcon.faEyeLowVision]: faEyeLowVision,
    [EnumIcon.faLowVision]: faLowVision,
    [EnumIcon.faTrafficLightGo]: faTrafficLightGo,
    [EnumIcon.faFaceExhaling]: faFaceExhaling,
    [EnumIcon.faSensorFire]: faSensorFire,
    [EnumIcon.faUserUnlock]: faUserUnlock,
    [EnumIcon.faHexagonDivide]: faHexagonDivide,
    [EnumIcon.fa00]: fa00,
    [EnumIcon.faCrow]: faCrow,
    [EnumIcon.faCassetteBetamax]: faCassetteBetamax,
    [EnumIcon.faBetamax]: faBetamax,
    [EnumIcon.faSailboat]: faSailboat,
    [EnumIcon.faWindowRestore]: faWindowRestore,
    [EnumIcon.faNfcMagnifyingGlass]: faNfcMagnifyingGlass,
    [EnumIcon.faFileBinary]: faFileBinary,
    [EnumIcon.faCircleV]: faCircleV,
    [EnumIcon.faSquarePlus]: faSquarePlus,
    [EnumIcon.faPlusSquare]: faPlusSquare,
    [EnumIcon.faBowlScoops]: faBowlScoops,
    [EnumIcon.faMistletoe]: faMistletoe,
    [EnumIcon.faCustard]: faCustard,
    [EnumIcon.faLacrosseStick]: faLacrosseStick,
    [EnumIcon.faHockeyMask]: faHockeyMask,
    [EnumIcon.faSunrise]: faSunrise,
    [EnumIcon.faPanelEws]: faPanelEws,
    [EnumIcon.faToriiGate]: faToriiGate,
    [EnumIcon.faCloudExclamation]: faCloudExclamation,
    [EnumIcon.faMessageLines]: faMessageLines,
    [EnumIcon.faCommentAltLines]: faCommentAltLines,
    [EnumIcon.faFrog]: faFrog,
    [EnumIcon.faBucket]: faBucket,
    [EnumIcon.faFloppyDiskPen]: faFloppyDiskPen,
    [EnumIcon.faImage]: faImage,
    [EnumIcon.faWindowFrame]: faWindowFrame,
    [EnumIcon.faMicrophone]: faMicrophone,
    [EnumIcon.faCow]: faCow,
    [EnumIcon.faSquareRing]: faSquareRing,
    [EnumIcon.faDownFromLine]: faDownFromLine,
    [EnumIcon.faArrowAltFromTop]: faArrowAltFromTop,
    [EnumIcon.faCaretUp]: faCaretUp,
    [EnumIcon.faShieldXmark]: faShieldXmark,
    [EnumIcon.faShieldTimes]: faShieldTimes,
    [EnumIcon.faScrewdriver]: faScrewdriver,
    [EnumIcon.faCircleSortDown]: faCircleSortDown,
    [EnumIcon.faSortCircleDown]: faSortCircleDown,
    [EnumIcon.faFolderClosed]: faFolderClosed,
    [EnumIcon.faHouseTsunami]: faHouseTsunami,
    [EnumIcon.faSquareNfi]: faSquareNfi,
    [EnumIcon.faForklift]: faForklift,
    [EnumIcon.faArrowUpFromGroundWater]: faArrowUpFromGroundWater,
    [EnumIcon.faBracketSquareRight]: faBracketSquareRight,
    [EnumIcon.faMartiniGlass]: faMartiniGlass,
    [EnumIcon.faGlassMartiniAlt]: faGlassMartiniAlt,
    [EnumIcon.faRotateLeft]: faRotateLeft,
    [EnumIcon.faRotateBack]: faRotateBack,
    [EnumIcon.faRotateBackward]: faRotateBackward,
    [EnumIcon.faUndoAlt]: faUndoAlt,
    [EnumIcon.faTableColumns]: faTableColumns,
    [EnumIcon.faColumns]: faColumns,
    [EnumIcon.faSquareA]: faSquareA,
    [EnumIcon.faTick]: faTick,
    [EnumIcon.faLemon]: faLemon,
    [EnumIcon.faHeadSideMask]: faHeadSideMask,
    [EnumIcon.faHandshake]: faHandshake,
    [EnumIcon.faGem]: faGem,
    [EnumIcon.faDolly]: faDolly,
    [EnumIcon.faDollyBox]: faDollyBox,
    [EnumIcon.faSmoking]: faSmoking,
    [EnumIcon.faMinimize]: faMinimize,
    [EnumIcon.faCompressArrowsAlt]: faCompressArrowsAlt,
    [EnumIcon.faRefrigerator]: faRefrigerator,
    [EnumIcon.faMonument]: faMonument,
    [EnumIcon.faOctagonXmark]: faOctagonXmark,
    [EnumIcon.faTimesOctagon]: faTimesOctagon,
    [EnumIcon.faXmarkOctagon]: faXmarkOctagon,
    [EnumIcon.faAlignSlash]: faAlignSlash,
    [EnumIcon.faSnowplow]: faSnowplow,
    [EnumIcon.faAnglesRight]: faAnglesRight,
    [EnumIcon.faAngleDoubleRight]: faAngleDoubleRight,
    [EnumIcon.faTruckRampCouch]: faTruckRampCouch,
    [EnumIcon.faTruckCouch]: faTruckCouch,
    [EnumIcon.faCannabis]: faCannabis,
    [EnumIcon.faCirclePlay]: faCirclePlay,
    [EnumIcon.faPlayCircle]: faPlayCircle,
    [EnumIcon.faArrowUpRightAndArrowDownLeftFromCenter]: faArrowUpRightAndArrowDownLeftFromCenter,
    [EnumIcon.faTablets]: faTablets,
    [EnumIcon.fa360Degrees]: fa360Degrees,
    [EnumIcon.faEthernet]: faEthernet,
    [EnumIcon.faEuroSign]: faEuroSign,
    [EnumIcon.faEur]: faEur,
    [EnumIcon.faEuro]: faEuro,
    [EnumIcon.faChair]: faChair,
    [EnumIcon.faCircleCheck]: faCircleCheck,
    [EnumIcon.faCheckCircle]: faCheckCircle,
    [EnumIcon.faSquareDashedCirclePlus]: faSquareDashedCirclePlus,
    [EnumIcon.faMoneySimpleFromBracket]: faMoneySimpleFromBracket,
    [EnumIcon.faBat]: faBat,
    [EnumIcon.faCircleStop]: faCircleStop,
    [EnumIcon.faStopCircle]: faStopCircle,
    [EnumIcon.faHeadSideHeadphones]: faHeadSideHeadphones,
    [EnumIcon.faPhoneRotary]: faPhoneRotary,
    [EnumIcon.faCompassDrafting]: faCompassDrafting,
    [EnumIcon.faDraftingCompass]: faDraftingCompass,
    [EnumIcon.faPlateWheat]: faPlateWheat,
    [EnumIcon.faCalendarCircleMinus]: faCalendarCircleMinus,
    [EnumIcon.faChopsticks]: faChopsticks,
    [EnumIcon.faCarWrench]: faCarWrench,
    [EnumIcon.faCarMechanic]: faCarMechanic,
    [EnumIcon.faIcicles]: faIcicles,
    [EnumIcon.faPersonShelter]: faPersonShelter,
    [EnumIcon.faNeuter]: faNeuter,
    [EnumIcon.faIdBadge]: faIdBadge,
    [EnumIcon.faKazoo]: faKazoo,
    [EnumIcon.faMarker]: faMarker,
    [EnumIcon.faFaceLaughBeam]: faFaceLaughBeam,
    [EnumIcon.faLaughBeam]: faLaughBeam,
    [EnumIcon.faSquareArrowDownLeft]: faSquareArrowDownLeft,
    [EnumIcon.faBatteryBolt]: faBatteryBolt,
    [EnumIcon.faTreeLarge]: faTreeLarge,
    [EnumIcon.faHelicopterSymbol]: faHelicopterSymbol,
    [EnumIcon.faAperture]: faAperture,
    [EnumIcon.faUniversalAccess]: faUniversalAccess,
    [EnumIcon.faFileMagnifyingGlass]: faFileMagnifyingGlass,
    [EnumIcon.faFileSearch]: faFileSearch,
    [EnumIcon.faUpRight]: faUpRight,
    [EnumIcon.faCircleChevronUp]: faCircleChevronUp,
    [EnumIcon.faChevronCircleUp]: faChevronCircleUp,
    [EnumIcon.faUserPolice]: faUserPolice,
    [EnumIcon.faLariSign]: faLariSign,
    [EnumIcon.faVolcano]: faVolcano,
    [EnumIcon.faTeddyBear]: faTeddyBear,
    [EnumIcon.faStocking]: faStocking,
    [EnumIcon.faPersonWalkingDashedLineArrowRight]: faPersonWalkingDashedLineArrowRight,
    [EnumIcon.faImageSlash]: faImageSlash,
    [EnumIcon.faMaskSnorkel]: faMaskSnorkel,
    [EnumIcon.faSmoke]: faSmoke,
    [EnumIcon.faSterlingSign]: faSterlingSign,
    [EnumIcon.faGbp]: faGbp,
    [EnumIcon.faPoundSign]: faPoundSign,
    [EnumIcon.faBatteryExclamation]: faBatteryExclamation,
    [EnumIcon.faViruses]: faViruses,
    [EnumIcon.faSquarePersonConfined]: faSquarePersonConfined,
    [EnumIcon.faUserTie]: faUserTie,
    [EnumIcon.faArrowDownLong]: faArrowDownLong,
    [EnumIcon.faLongArrowDown]: faLongArrowDown,
    [EnumIcon.faTentArrowDownToLine]: faTentArrowDownToLine,
    [EnumIcon.faCertificate]: faCertificate,
    [EnumIcon.faCrystalBall]: faCrystalBall,
    [EnumIcon.faReplyAll]: faReplyAll,
    [EnumIcon.faMailReplyAll]: faMailReplyAll,
    [EnumIcon.faSuitcase]: faSuitcase,
    [EnumIcon.faPersonSkating]: faPersonSkating,
    [EnumIcon.faSkating]: faSkating,
    [EnumIcon.faStarShooting]: faStarShooting,
    [EnumIcon.faBinaryLock]: faBinaryLock,
    [EnumIcon.faFilterCircleDollar]: faFilterCircleDollar,
    [EnumIcon.faFunnelDollar]: faFunnelDollar,
    [EnumIcon.faCameraRetro]: faCameraRetro,
    [EnumIcon.faCircleArrowDown]: faCircleArrowDown,
    [EnumIcon.faArrowCircleDown]: faArrowCircleDown,
    [EnumIcon.faCommentPen]: faCommentPen,
    [EnumIcon.faCommentEdit]: faCommentEdit,
    [EnumIcon.faFileImport]: faFileImport,
    [EnumIcon.faArrowRightToFile]: faArrowRightToFile,
    [EnumIcon.faBanjo]: faBanjo,
    [EnumIcon.faSquareArrowUpRight]: faSquareArrowUpRight,
    [EnumIcon.faExternalLinkSquare]: faExternalLinkSquare,
    [EnumIcon.faLightEmergencyOn]: faLightEmergencyOn,
    [EnumIcon.faKerning]: faKerning,
    [EnumIcon.faBoxOpen]: faBoxOpen,
    [EnumIcon.faSquareF]: faSquareF,
    [EnumIcon.faScroll]: faScroll,
    [EnumIcon.faSpa]: faSpa,
    [EnumIcon.faArrowLeftFromLine]: faArrowLeftFromLine,
    [EnumIcon.faArrowFromRight]: faArrowFromRight,
    [EnumIcon.faStrawberry]: faStrawberry,
    [EnumIcon.faLocationPinLock]: faLocationPinLock,
    [EnumIcon.faPause]: faPause,
    [EnumIcon.faClockEightThirty]: faClockEightThirty,
    [EnumIcon.faPlaneEngines]: faPlaneEngines,
    [EnumIcon.faPlaneAlt]: faPlaneAlt,
    [EnumIcon.faHillAvalanche]: faHillAvalanche,
    [EnumIcon.faTemperatureEmpty]: faTemperatureEmpty,
    [EnumIcon.faTemperature0]: faTemperature0,
    [EnumIcon.faThermometer0]: faThermometer0,
    [EnumIcon.faThermometerEmpty]: faThermometerEmpty,
    [EnumIcon.faBomb]: faBomb,
    [EnumIcon.faGaugeLow]: faGaugeLow,
    [EnumIcon.faTachometerAltSlow]: faTachometerAltSlow,
    [EnumIcon.faRegistered]: faRegistered,
    [EnumIcon.faTrashCanPlus]: faTrashCanPlus,
    [EnumIcon.faAddressCard]: faAddressCard,
    [EnumIcon.faContactCard]: faContactCard,
    [EnumIcon.faVcard]: faVcard,
    [EnumIcon.faScaleUnbalancedFlip]: faScaleUnbalancedFlip,
    [EnumIcon.faBalanceScaleRight]: faBalanceScaleRight,
    [EnumIcon.faGlobeSnow]: faGlobeSnow,
    [EnumIcon.faSubscript]: faSubscript,
    [EnumIcon.faDiamondTurnRight]: faDiamondTurnRight,
    [EnumIcon.faDirections]: faDirections,
    [EnumIcon.faIntegral]: faIntegral,
    [EnumIcon.faBurst]: faBurst,
    [EnumIcon.faHouseLaptop]: faHouseLaptop,
    [EnumIcon.faLaptopHouse]: faLaptopHouse,
    [EnumIcon.faFaceTired]: faFaceTired,
    [EnumIcon.faTired]: faTired,
    [EnumIcon.faMoneyBills]: faMoneyBills,
    [EnumIcon.faBlindsRaised]: faBlindsRaised,
    [EnumIcon.faSmog]: faSmog,
    [EnumIcon.faUfoBeam]: faUfoBeam,
    [EnumIcon.faCircleCaretUp]: faCircleCaretUp,
    [EnumIcon.faCaretCircleUp]: faCaretCircleUp,
    [EnumIcon.faUserVneckHairLong]: faUserVneckHairLong,
    [EnumIcon.faSquareALock]: faSquareALock,
    [EnumIcon.faCrutch]: faCrutch,
    [EnumIcon.faGasPumpSlash]: faGasPumpSlash,
    [EnumIcon.faFontAwesome]: faFontAwesome,
    [EnumIcon.faFontAwesomeFlag]: faFontAwesomeFlag,
    [EnumIcon.faFontAwesomeLogoFull]: faFontAwesomeLogoFull,
    [EnumIcon.faCloudArrowUp]: faCloudArrowUp,
    [EnumIcon.faCloudUpload]: faCloudUpload,
    [EnumIcon.faCloudUploadAlt]: faCloudUploadAlt,
    [EnumIcon.faPalette]: faPalette,
    [EnumIcon.faTransporter4]: faTransporter4,
    [EnumIcon.faObjectsAlignRight]: faObjectsAlignRight,
    [EnumIcon.faArrowsTurnRight]: faArrowsTurnRight,
    [EnumIcon.faVest]: faVest,
    [EnumIcon.faPig]: faPig,
    [EnumIcon.faInboxFull]: faInboxFull,
    [EnumIcon.faCircleEnvelope]: faCircleEnvelope,
    [EnumIcon.faEnvelopeCircle]: faEnvelopeCircle,
    [EnumIcon.faTrianglePersonDigging]: faTrianglePersonDigging,
    [EnumIcon.faConstruction]: faConstruction,
    [EnumIcon.faFerry]: faFerry,
    [EnumIcon.faBullseyeArrow]: faBullseyeArrow,
    [EnumIcon.faArrowsDownToPeople]: faArrowsDownToPeople,
    [EnumIcon.faSeedling]: faSeedling,
    [EnumIcon.faSprout]: faSprout,
    [EnumIcon.faClockSeven]: faClockSeven,
    [EnumIcon.faLeftRight]: faLeftRight,
    [EnumIcon.faArrowsAltH]: faArrowsAltH,
    [EnumIcon.faBoxesPacking]: faBoxesPacking,
    [EnumIcon.faCircleArrowLeft]: faCircleArrowLeft,
    [EnumIcon.faArrowCircleLeft]: faArrowCircleLeft,
    [EnumIcon.faFlashlight]: faFlashlight,
    [EnumIcon.faGroupArrowsRotate]: faGroupArrowsRotate,
    [EnumIcon.faBowlFood]: faBowlFood,
    [EnumIcon.faSquare9]: faSquare9,
    [EnumIcon.faCandyCane]: faCandyCane,
    [EnumIcon.faArrowDownWideShort]: faArrowDownWideShort,
    [EnumIcon.faSortAmountAsc]: faSortAmountAsc,
    [EnumIcon.faSortAmountDown]: faSortAmountDown,
    [EnumIcon.faSquareDollar]: faSquareDollar,
    [EnumIcon.faDollarSquare]: faDollarSquare,
    [EnumIcon.faUsdSquare]: faUsdSquare,
    [EnumIcon.faPhoneArrowRight]: faPhoneArrowRight,
    [EnumIcon.faHandHoldingSeedling]: faHandHoldingSeedling,
    [EnumIcon.faMessageCheck]: faMessageCheck,
    [EnumIcon.faCommentAltCheck]: faCommentAltCheck,
    [EnumIcon.faCloudBolt]: faCloudBolt,
    [EnumIcon.faThunderstorm]: faThunderstorm,
    [EnumIcon.faTextSlash]: faTextSlash,
    [EnumIcon.faRemoveFormat]: faRemoveFormat,
    [EnumIcon.faWatch]: faWatch,
    [EnumIcon.faCircleDownLeft]: faCircleDownLeft,
    [EnumIcon.faText]: faText,
    [EnumIcon.faProjector]: faProjector,
    [EnumIcon.faFaceSmileWink]: faFaceSmileWink,
    [EnumIcon.faSmileWink]: faSmileWink,
    [EnumIcon.faTombstoneBlank]: faTombstoneBlank,
    [EnumIcon.faTombstoneAlt]: faTombstoneAlt,
    [EnumIcon.faChessKingPiece]: faChessKingPiece,
    [EnumIcon.faChessKingAlt]: faChessKingAlt,
    [EnumIcon.faCircle6]: faCircle6,
    [EnumIcon.faLeft]: faLeft,
    [EnumIcon.faArrowAltLeft]: faArrowAltLeft,
    [EnumIcon.faFileWord]: faFileWord,
    [EnumIcon.faFilePowerpoint]: faFilePowerpoint,
    [EnumIcon.faSquareDown]: faSquareDown,
    [EnumIcon.faArrowAltSquareDown]: faArrowAltSquareDown,
    [EnumIcon.faObjectsAlignCenterVertical]: faObjectsAlignCenterVertical,
    [EnumIcon.faArrowsLeftRight]: faArrowsLeftRight,
    [EnumIcon.faArrowsH]: faArrowsH,
    [EnumIcon.faHouseLock]: faHouseLock,
    [EnumIcon.faCloudArrowDown]: faCloudArrowDown,
    [EnumIcon.faCloudDownload]: faCloudDownload,
    [EnumIcon.faCloudDownloadAlt]: faCloudDownloadAlt,
    [EnumIcon.faWreath]: faWreath,
    [EnumIcon.faChildren]: faChildren,
    [EnumIcon.faMeterDroplet]: faMeterDroplet,
    [EnumIcon.faChalkboard]: faChalkboard,
    [EnumIcon.faBlackboard]: faBlackboard,
    [EnumIcon.faUserLargeSlash]: faUserLargeSlash,
    [EnumIcon.faUserAltSlash]: faUserAltSlash,
    [EnumIcon.faSignalStrong]: faSignalStrong,
    [EnumIcon.faSignal4]: faSignal4,
    [EnumIcon.faLollipop]: faLollipop,
    [EnumIcon.faLollypop]: faLollypop,
    [EnumIcon.faListTree]: faListTree,
    [EnumIcon.faEnvelopeOpen]: faEnvelopeOpen,
    [EnumIcon.faDrawCircle]: faDrawCircle,
    [EnumIcon.faCatSpace]: faCatSpace,
    [EnumIcon.faHandshakeSimpleSlash]: faHandshakeSimpleSlash,
    [EnumIcon.faHandshakeAltSlash]: faHandshakeAltSlash,
    [EnumIcon.faRabbitRunning]: faRabbitRunning,
    [EnumIcon.faRabbitFast]: faRabbitFast,
    [EnumIcon.faMemoPad]: faMemoPad,
    [EnumIcon.faMattressPillow]: faMattressPillow,
    [EnumIcon.faAlarmPlus]: faAlarmPlus,
    [EnumIcon.faAlicorn]: faAlicorn,
    [EnumIcon.faCommentQuestion]: faCommentQuestion,
    [EnumIcon.faGingerbreadMan]: faGingerbreadMan,
    [EnumIcon.faGuaraniSign]: faGuaraniSign,
    [EnumIcon.faBurgerFries]: faBurgerFries,
    [EnumIcon.faMugTea]: faMugTea,
    [EnumIcon.faBorderTop]: faBorderTop,
    [EnumIcon.faArrowsRotate]: faArrowsRotate,
    [EnumIcon.faRefresh]: faRefresh,
    [EnumIcon.faSync]: faSync,
    [EnumIcon.faCircleBookOpen]: faCircleBookOpen,
    [EnumIcon.faBookCircle]: faBookCircle,
    [EnumIcon.faArrowsToDottedLine]: faArrowsToDottedLine,
    [EnumIcon.faFireExtinguisher]: faFireExtinguisher,
    [EnumIcon.faGarageOpen]: faGarageOpen,
    [EnumIcon.faShelvesEmpty]: faShelvesEmpty,
    [EnumIcon.faCruzeiroSign]: faCruzeiroSign,
    [EnumIcon.faWatchApple]: faWatchApple,
    [EnumIcon.faWatchCalculator]: faWatchCalculator,
    [EnumIcon.faListDropdown]: faListDropdown,
    [EnumIcon.faCabinetFiling]: faCabinetFiling,
    [EnumIcon.faBurgerSoda]: faBurgerSoda,
    [EnumIcon.faSquareArrowUp]: faSquareArrowUp,
    [EnumIcon.faArrowSquareUp]: faArrowSquareUp,
    [EnumIcon.faGreaterThanEqual]: faGreaterThanEqual,
    [EnumIcon.faPalletBox]: faPalletBox,
    [EnumIcon.faFaceConfounded]: faFaceConfounded,
    [EnumIcon.faShieldHalved]: faShieldHalved,
    [EnumIcon.faShieldAlt]: faShieldAlt,
    [EnumIcon.faTruckPlow]: faTruckPlow,
    [EnumIcon.faBookAtlas]: faBookAtlas,
    [EnumIcon.faAtlas]: faAtlas,
    [EnumIcon.faVirus]: faVirus,
    [EnumIcon.faCommentMiddleTop]: faCommentMiddleTop,
    [EnumIcon.faEnvelopeCircleCheck]: faEnvelopeCircleCheck,
    [EnumIcon.faLayerGroup]: faLayerGroup,
    [EnumIcon.faRestroomSimple]: faRestroomSimple,
    [EnumIcon.faArrowsToDot]: faArrowsToDot,
    [EnumIcon.faBorderOuter]: faBorderOuter,
    [EnumIcon.faHashtagLock]: faHashtagLock,
    [EnumIcon.faClockTwoThirty]: faClockTwoThirty,
    [EnumIcon.faArchway]: faArchway,
    [EnumIcon.faHeartCircleCheck]: faHeartCircleCheck,
    [EnumIcon.faHouseChimneyCrack]: faHouseChimneyCrack,
    [EnumIcon.faHouseDamage]: faHouseDamage,
    [EnumIcon.faFileZipper]: faFileZipper,
    [EnumIcon.faFileArchive]: faFileArchive,
    [EnumIcon.faHeartHalf]: faHeartHalf,
    [EnumIcon.faCommentCheck]: faCommentCheck,
    [EnumIcon.faSquare]: faSquare,
    [EnumIcon.faMemo]: faMemo,
    [EnumIcon.faMartiniGlassEmpty]: faMartiniGlassEmpty,
    [EnumIcon.faGlassMartini]: faGlassMartini,
    [EnumIcon.faCouch]: faCouch,
    [EnumIcon.faCediSign]: faCediSign,
    [EnumIcon.faItalic]: faItalic,
    [EnumIcon.faGlassCitrus]: faGlassCitrus,
    [EnumIcon.faCalendarLinesPen]: faCalendarLinesPen,
    [EnumIcon.faChurch]: faChurch,
    [EnumIcon.faPersonSnowmobiling]: faPersonSnowmobiling,
    [EnumIcon.faSnowmobile]: faSnowmobile,
    [EnumIcon.faFaceHushed]: faFaceHushed,
    [EnumIcon.faCommentsDollar]: faCommentsDollar,
    [EnumIcon.faPickaxe]: faPickaxe,
    [EnumIcon.faLinkSimpleSlash]: faLinkSimpleSlash,
    [EnumIcon.faDemocrat]: faDemocrat,
    [EnumIcon.faFaceConfused]: faFaceConfused,
    [EnumIcon.faPinball]: faPinball,
    [EnumIcon.faZ]: faZ,
    [EnumIcon.faPersonSkiing]: faPersonSkiing,
    [EnumIcon.faSkiing]: faSkiing,
    [EnumIcon.faDeer]: faDeer,
    [EnumIcon.faInputPipe]: faInputPipe,
    [EnumIcon.faRoadLock]: faRoadLock,
    [EnumIcon.faA]: faA,
    [EnumIcon.faBookmarkSlash]: faBookmarkSlash,
    [EnumIcon.faTemperatureArrowDown]: faTemperatureArrowDown,
    [EnumIcon.faTemperatureDown]: faTemperatureDown,
    [EnumIcon.faMace]: faMace,
    [EnumIcon.faFeatherPointed]: faFeatherPointed,
    [EnumIcon.faFeatherAlt]: faFeatherAlt,
    [EnumIcon.faSausage]: faSausage,
    [EnumIcon.faTrashCanClock]: faTrashCanClock,
    [EnumIcon.faP]: faP,
    [EnumIcon.faSnowflake]: faSnowflake,
    [EnumIcon.faStomach]: faStomach,
    [EnumIcon.faNewspaper]: faNewspaper,
    [EnumIcon.faRectangleAd]: faRectangleAd,
    [EnumIcon.faAd]: faAd,
    [EnumIcon.faGuitarElectric]: faGuitarElectric,
    [EnumIcon.faArrowTurnDownRight]: faArrowTurnDownRight,
    [EnumIcon.faMoonCloud]: faMoonCloud,
    [EnumIcon.faBreadSliceButter]: faBreadSliceButter,
    [EnumIcon.faCircleArrowRight]: faCircleArrowRight,
    [EnumIcon.faArrowCircleRight]: faArrowCircleRight,
    [EnumIcon.faUserGroupCrown]: faUserGroupCrown,
    [EnumIcon.faUsersCrown]: faUsersCrown,
    [EnumIcon.faCircleI]: faCircleI,
    [EnumIcon.faToiletPaperCheck]: faToiletPaperCheck,
    [EnumIcon.faFilterCircleXmark]: faFilterCircleXmark,
    [EnumIcon.faLocust]: faLocust,
    [EnumIcon.faSort]: faSort,
    [EnumIcon.faUnsorted]: faUnsorted,
    [EnumIcon.faListOl]: faListOl,
    [EnumIcon.faList12]: faList12,
    [EnumIcon.faListNumeric]: faListNumeric,
    [EnumIcon.faChartWaterfall]: faChartWaterfall,
    [EnumIcon.faFaceParty]: faFaceParty,
    [EnumIcon.faKidneys]: faKidneys,
    [EnumIcon.faWifiExclamation]: faWifiExclamation,
    [EnumIcon.faChartNetwork]: faChartNetwork,
    [EnumIcon.faPersonDressBurst]: faPersonDressBurst,
    [EnumIcon.faDiceD4]: faDiceD4,
    [EnumIcon.faMoneyCheckDollar]: faMoneyCheckDollar,
    [EnumIcon.faMoneyCheckAlt]: faMoneyCheckAlt,
    [EnumIcon.faVectorSquare]: faVectorSquare,
    [EnumIcon.faBreadSlice]: faBreadSlice,
    [EnumIcon.faLanguage]: faLanguage,
    [EnumIcon.faWheatAwnSlash]: faWheatAwnSlash,
    [EnumIcon.faFaceKissWinkHeart]: faFaceKissWinkHeart,
    [EnumIcon.faKissWinkHeart]: faKissWinkHeart,
    [EnumIcon.faDagger]: faDagger,
    [EnumIcon.faPodium]: faPodium,
    [EnumIcon.faMemoCircleCheck]: faMemoCircleCheck,
    [EnumIcon.faRouteHighway]: faRouteHighway,
    [EnumIcon.faDownToLine]: faDownToLine,
    [EnumIcon.faArrowAltToBottom]: faArrowAltToBottom,
    [EnumIcon.faFilter]: faFilter,
    [EnumIcon.faSquareG]: faSquareG,
    [EnumIcon.faCirclePhone]: faCirclePhone,
    [EnumIcon.faPhoneCircle]: faPhoneCircle,
    [EnumIcon.faClipboardPrescription]: faClipboardPrescription,
    [EnumIcon.faUserNurseHair]: faUserNurseHair,
    [EnumIcon.faQuestion]: faQuestion,
    [EnumIcon.faFileSignature]: faFileSignature,
    [EnumIcon.faToggleLargeOn]: faToggleLargeOn,
    [EnumIcon.faUpDownLeftRight]: faUpDownLeftRight,
    [EnumIcon.faArrowsAlt]: faArrowsAlt,
    [EnumIcon.faDryerHeat]: faDryerHeat,
    [EnumIcon.faDryerAlt]: faDryerAlt,
    [EnumIcon.faHouseChimneyUser]: faHouseChimneyUser,
    [EnumIcon.faHandHoldingHeart]: faHandHoldingHeart,
    [EnumIcon.faArrowUpSmallBig]: faArrowUpSmallBig,
    [EnumIcon.faSortSizeUpAlt]: faSortSizeUpAlt,
    [EnumIcon.faTrainTrack]: faTrainTrack,
    [EnumIcon.faPuzzlePiece]: faPuzzlePiece,
    [EnumIcon.faMoneyCheck]: faMoneyCheck,
    [EnumIcon.faStarHalfStroke]: faStarHalfStroke,
    [EnumIcon.faStarHalfAlt]: faStarHalfAlt,
    [EnumIcon.faFileExclamation]: faFileExclamation,
    [EnumIcon.faCode]: faCode,
    [EnumIcon.faWhiskeyGlass]: faWhiskeyGlass,
    [EnumIcon.faGlassWhiskey]: faGlassWhiskey,
    [EnumIcon.faMoonStars]: faMoonStars,
    [EnumIcon.faBuildingCircleExclamation]: faBuildingCircleExclamation,
    [EnumIcon.faClothesHanger]: faClothesHanger,
    [EnumIcon.faMobileNotch]: faMobileNotch,
    [EnumIcon.faMobileIphone]: faMobileIphone,
    [EnumIcon.faMagnifyingGlassChart]: faMagnifyingGlassChart,
    [EnumIcon.faArrowUpRightFromSquare]: faArrowUpRightFromSquare,
    [EnumIcon.faExternalLink]: faExternalLink,
    [EnumIcon.faCubesStacked]: faCubesStacked,
    [EnumIcon.faImagesUser]: faImagesUser,
    [EnumIcon.faWonSign]: faWonSign,
    [EnumIcon.faKrw]: faKrw,
    [EnumIcon.faWon]: faWon,
    [EnumIcon.faImagePolaroidUser]: faImagePolaroidUser,
    [EnumIcon.faVirusCovid]: faVirusCovid,
    [EnumIcon.faSquareEllipsis]: faSquareEllipsis,
    [EnumIcon.faPie]: faPie,
    [EnumIcon.faChessKnightPiece]: faChessKnightPiece,
    [EnumIcon.faChessKnightAlt]: faChessKnightAlt,
    [EnumIcon.faAustralSign]: faAustralSign,
    [EnumIcon.faCloudPlus]: faCloudPlus,
    [EnumIcon.faF]: faF,
    [EnumIcon.faLeaf]: faLeaf,
    [EnumIcon.faBedBunk]: faBedBunk,
    [EnumIcon.faRoad]: faRoad,
    [EnumIcon.faTaxi]: faTaxi,
    [EnumIcon.faCab]: faCab,
    [EnumIcon.faPersonCirclePlus]: faPersonCirclePlus,
    [EnumIcon.faChartPie]: faChartPie,
    [EnumIcon.faPieChart]: faPieChart,
    [EnumIcon.faBoltLightning]: faBoltLightning,
    [EnumIcon.faClockEight]: faClockEight,
    [EnumIcon.faSackXmark]: faSackXmark,
    [EnumIcon.faFileExcel]: faFileExcel,
    [EnumIcon.faFileContract]: faFileContract,
    [EnumIcon.faFishFins]: faFishFins,
    [EnumIcon.faCircleQ]: faCircleQ,
    [EnumIcon.faBuildingFlag]: faBuildingFlag,
    [EnumIcon.faFaceGrinBeam]: faFaceGrinBeam,
    [EnumIcon.faGrinBeam]: faGrinBeam,
    [EnumIcon.faObjectUngroup]: faObjectUngroup,
    [EnumIcon.faFaceDisguise]: faFaceDisguise,
    [EnumIcon.faCircleArrowDownRight]: faCircleArrowDownRight,
    [EnumIcon.faAlien8bit]: faAlien8bit,
    [EnumIcon.faAlienMonster]: faAlienMonster,
    [EnumIcon.faHandPointRibbon]: faHandPointRibbon,
    [EnumIcon.faPoop]: faPoop,
    [EnumIcon.faObjectExclude]: faObjectExclude,
    [EnumIcon.faTelescope]: faTelescope,
    [EnumIcon.faLocationPin]: faLocationPin,
    [EnumIcon.faMapMarker]: faMapMarker,
    [EnumIcon.faSquareList]: faSquareList,
    [EnumIcon.faKaaba]: faKaaba,
    [EnumIcon.faToiletPaper]: faToiletPaper,
    [EnumIcon.faHelmetSafety]: faHelmetSafety,
    [EnumIcon.faHardHat]: faHardHat,
    [EnumIcon.faHatHard]: faHatHard,
    [EnumIcon.faCommentCode]: faCommentCode,
    [EnumIcon.faSimCards]: faSimCards,
    [EnumIcon.faStarship]: faStarship,
    [EnumIcon.faEject]: faEject,
    [EnumIcon.faCircleRight]: faCircleRight,
    [EnumIcon.faArrowAltCircleRight]: faArrowAltCircleRight,
    [EnumIcon.faPlaneCircleCheck]: faPlaneCircleCheck,
    [EnumIcon.faSeal]: faSeal,
    [EnumIcon.faUserCowboy]: faUserCowboy,
    [EnumIcon.faHexagonVerticalNft]: faHexagonVerticalNft,
    [EnumIcon.faFaceRollingEyes]: faFaceRollingEyes,
    [EnumIcon.faMehRollingEyes]: faMehRollingEyes,
    [EnumIcon.faBreadLoaf]: faBreadLoaf,
    [EnumIcon.faRingsWedding]: faRingsWedding,
    [EnumIcon.faObjectGroup]: faObjectGroup,
    [EnumIcon.faFrenchFries]: faFrenchFries,
    [EnumIcon.faChartLine]: faChartLine,
    [EnumIcon.faLineChart]: faLineChart,
    [EnumIcon.faCalendarArrowDown]: faCalendarArrowDown,
    [EnumIcon.faCalendarDownload]: faCalendarDownload,
    [EnumIcon.faSendBack]: faSendBack,
    [EnumIcon.faMaskVentilator]: faMaskVentilator,
    [EnumIcon.faSignatureLock]: faSignatureLock,
    [EnumIcon.faArrowRight]: faArrowRight,
    [EnumIcon.faSignsPost]: faSignsPost,
    [EnumIcon.faMapSigns]: faMapSigns,
    [EnumIcon.faOctagonPlus]: faOctagonPlus,
    [EnumIcon.faPlusOctagon]: faPlusOctagon,
    [EnumIcon.faCashRegister]: faCashRegister,
    [EnumIcon.faPersonCircleQuestion]: faPersonCircleQuestion,
    [EnumIcon.faMelonSlice]: faMelonSlice,
    [EnumIcon.faSpaceStationMoon]: faSpaceStationMoon,
    [EnumIcon.faMessageSmile]: faMessageSmile,
    [EnumIcon.faCommentAltSmile]: faCommentAltSmile,
    [EnumIcon.faCupStraw]: faCupStraw,
    [EnumIcon.faLeftFromLine]: faLeftFromLine,
    [EnumIcon.faArrowAltFromRight]: faArrowAltFromRight,
    [EnumIcon.faH]: faH,
    [EnumIcon.faBasketShoppingSimple]: faBasketShoppingSimple,
    [EnumIcon.faShoppingBasketAlt]: faShoppingBasketAlt,
    [EnumIcon.faHandsHoldingHeart]: faHandsHoldingHeart,
    [EnumIcon.faHandsHeart]: faHandsHeart,
    [EnumIcon.faClockNine]: faClockNine,
    [EnumIcon.faTarp]: faTarp,
    [EnumIcon.faFaceSleepy]: faFaceSleepy,
    [EnumIcon.faHandHorns]: faHandHorns,
    [EnumIcon.faScrewdriverWrench]: faScrewdriverWrench,
    [EnumIcon.faTools]: faTools,
    [EnumIcon.faArrowsToEye]: faArrowsToEye,
    [EnumIcon.faCircleThreeQuarters]: faCircleThreeQuarters,
    [EnumIcon.faTrophyStar]: faTrophyStar,
    [EnumIcon.faTrophyAlt]: faTrophyAlt,
    [EnumIcon.faPlugCircleBolt]: faPlugCircleBolt,
    [EnumIcon.faFaceThermometer]: faFaceThermometer,
    [EnumIcon.faShirtRunning]: faShirtRunning,
    [EnumIcon.faBookCircleArrowUp]: faBookCircleArrowUp,
    [EnumIcon.faFaceNauseated]: faFaceNauseated,
    [EnumIcon.faHeart]: faHeart,
    [EnumIcon.faFileChartPie]: faFileChartPie,
    [EnumIcon.faMarsAndVenus]: faMarsAndVenus,
    [EnumIcon.faHouseUser]: faHouseUser,
    [EnumIcon.faHomeUser]: faHomeUser,
    [EnumIcon.faCircleArrowDownLeft]: faCircleArrowDownLeft,
    [EnumIcon.faDumpsterFire]: faDumpsterFire,
    [EnumIcon.faHexagonMinus]: faHexagonMinus,
    [EnumIcon.faMinusHexagon]: faMinusHexagon,
    [EnumIcon.faLeftToLine]: faLeftToLine,
    [EnumIcon.faArrowAltToLeft]: faArrowAltToLeft,
    [EnumIcon.faHouseCrack]: faHouseCrack,
    [EnumIcon.faPawSimple]: faPawSimple,
    [EnumIcon.faPawAlt]: faPawAlt,
    [EnumIcon.faArrowLeftLongToLine]: faArrowLeftLongToLine,
    [EnumIcon.faBracketsRound]: faBracketsRound,
    [EnumIcon.faParentheses]: faParentheses,
    [EnumIcon.faMartiniGlassCitrus]: faMartiniGlassCitrus,
    [EnumIcon.faCocktail]: faCocktail,
    [EnumIcon.faUserShakespeare]: faUserShakespeare,
    [EnumIcon.faArrowRightToArc]: faArrowRightToArc,
    [EnumIcon.faFaceSurprise]: faFaceSurprise,
    [EnumIcon.faSurprise]: faSurprise,
    [EnumIcon.faBottleWater]: faBottleWater,
    [EnumIcon.faCirclePause]: faCirclePause,
    [EnumIcon.faPauseCircle]: faPauseCircle,
    [EnumIcon.faGaugeCirclePlus]: faGaugeCirclePlus,
    [EnumIcon.faFolders]: faFolders,
    [EnumIcon.faAngel]: faAngel,
    [EnumIcon.faValueAbsolute]: faValueAbsolute,
    [EnumIcon.faRabbit]: faRabbit,
    [EnumIcon.faToiletPaperSlash]: faToiletPaperSlash,
    [EnumIcon.faAppleWhole]: faAppleWhole,
    [EnumIcon.faAppleAlt]: faAppleAlt,
    [EnumIcon.faKitchenSet]: faKitchenSet,
    [EnumIcon.faDiamondHalf]: faDiamondHalf,
    [EnumIcon.faLockKeyhole]: faLockKeyhole,
    [EnumIcon.faLockAlt]: faLockAlt,
    [EnumIcon.faR]: faR,
    [EnumIcon.faTemperatureQuarter]: faTemperatureQuarter,
    [EnumIcon.faTemperature1]: faTemperature1,
    [EnumIcon.faThermometer1]: faThermometer1,
    [EnumIcon.faThermometerQuarter]: faThermometerQuarter,
    [EnumIcon.faSquareInfo]: faSquareInfo,
    [EnumIcon.faInfoSquare]: faInfoSquare,
    [EnumIcon.faWifiSlash]: faWifiSlash,
    [EnumIcon.faToiletPaperXmark]: faToiletPaperXmark,
    [EnumIcon.faHandsHoldingDollar]: faHandsHoldingDollar,
    [EnumIcon.faHandsUsd]: faHandsUsd,
    [EnumIcon.faCube]: faCube,
    [EnumIcon.faArrowDownTriangleSquare]: faArrowDownTriangleSquare,
    [EnumIcon.faSortShapesDown]: faSortShapesDown,
    [EnumIcon.faBitcoinSign]: faBitcoinSign,
    [EnumIcon.faShutters]: faShutters,
    [EnumIcon.faShieldDog]: faShieldDog,
    [EnumIcon.faSolarPanel]: faSolarPanel,
    [EnumIcon.faLockOpen]: faLockOpen,
    [EnumIcon.faTableTree]: faTableTree,
    [EnumIcon.faHouseChimneyHeart]: faHouseChimneyHeart,
    [EnumIcon.faTally3]: faTally3,
    [EnumIcon.faElevator]: faElevator,
    [EnumIcon.faMoneyBillTransfer]: faMoneyBillTransfer,
    [EnumIcon.faMoneyBillTrendUp]: faMoneyBillTrendUp,
    [EnumIcon.faHouseFloodWaterCircleArrowRight]: faHouseFloodWaterCircleArrowRight,
    [EnumIcon.faSquarePollHorizontal]: faSquarePollHorizontal,
    [EnumIcon.faPollH]: faPollH,
    [EnumIcon.faCircle]: faCircle,
    [EnumIcon.faCartCircleExclamation]: faCartCircleExclamation,
    [EnumIcon.faSword]: faSword,
    [EnumIcon.faBackwardFast]: faBackwardFast,
    [EnumIcon.faFastBackward]: faFastBackward,
    [EnumIcon.faRecycle]: faRecycle,
    [EnumIcon.faUserAstronaut]: faUserAstronaut,
    [EnumIcon.faInterrobang]: faInterrobang,
    [EnumIcon.faPlaneSlash]: faPlaneSlash,
    [EnumIcon.faCircleDashed]: faCircleDashed,
    [EnumIcon.faTrademark]: faTrademark,
    [EnumIcon.faBasketball]: faBasketball,
    [EnumIcon.faBasketballBall]: faBasketballBall,
    [EnumIcon.faForkKnife]: faForkKnife,
    [EnumIcon.faUtensilsAlt]: faUtensilsAlt,
    [EnumIcon.faSatelliteDish]: faSatelliteDish,
    [EnumIcon.faBadgeCheck]: faBadgeCheck,
    [EnumIcon.faCircleUp]: faCircleUp,
    [EnumIcon.faArrowAltCircleUp]: faArrowAltCircleUp,
    [EnumIcon.faSlider]: faSlider,
    [EnumIcon.faMobileScreenButton]: faMobileScreenButton,
    [EnumIcon.faMobileAlt]: faMobileAlt,
    [EnumIcon.faClockOneThirty]: faClockOneThirty,
    [EnumIcon.faInboxOut]: faInboxOut,
    [EnumIcon.faInboxArrowUp]: faInboxArrowUp,
    [EnumIcon.faCloudSlash]: faCloudSlash,
    [EnumIcon.faVolumeHigh]: faVolumeHigh,
    [EnumIcon.faVolumeUp]: faVolumeUp,
    [EnumIcon.faUsersRays]: faUsersRays,
    [EnumIcon.faWallet]: faWallet,
    [EnumIcon.faOctagonCheck]: faOctagonCheck,
    [EnumIcon.faFlatbreadStuffed]: faFlatbreadStuffed,
    [EnumIcon.faClipboardCheck]: faClipboardCheck,
    [EnumIcon.faCartCirclePlus]: faCartCirclePlus,
    [EnumIcon.faTruckClock]: faTruckClock,
    [EnumIcon.faShippingTimed]: faShippingTimed,
    [EnumIcon.faPool8Ball]: faPool8Ball,
    [EnumIcon.faFileAudio]: faFileAudio,
    [EnumIcon.faTurnDownLeft]: faTurnDownLeft,
    [EnumIcon.faLockHashtag]: faLockHashtag,
    [EnumIcon.faChartRadar]: faChartRadar,
    [EnumIcon.faStaff]: faStaff,
    [EnumIcon.faBurger]: faBurger,
    [EnumIcon.faHamburger]: faHamburger,
    [EnumIcon.faUtilityPole]: faUtilityPole,
    [EnumIcon.faTransporter6]: faTransporter6,
    [EnumIcon.faWrench]: faWrench,
    [EnumIcon.faBugs]: faBugs,
    [EnumIcon.faVectorPolygon]: faVectorPolygon,
    [EnumIcon.faDiagramNested]: faDiagramNested,
    [EnumIcon.faRupeeSign]: faRupeeSign,
    [EnumIcon.faRupee]: faRupee,
    [EnumIcon.faFileImage]: faFileImage,
    [EnumIcon.faCircleQuestion]: faCircleQuestion,
    [EnumIcon.faQuestionCircle]: faQuestionCircle,
    [EnumIcon.faImageUser]: faImageUser,
    [EnumIcon.faBuoy]: faBuoy,
    [EnumIcon.faPlaneDeparture]: faPlaneDeparture,
    [EnumIcon.faHandshakeSlash]: faHandshakeSlash,
    [EnumIcon.faBookBookmark]: faBookBookmark,
    [EnumIcon.faBorderCenterH]: faBorderCenterH,
    [EnumIcon.faCanFood]: faCanFood,
    [EnumIcon.faTypewriter]: faTypewriter,
    [EnumIcon.faArrowRightFromArc]: faArrowRightFromArc,
    [EnumIcon.faCircleK]: faCircleK,
    [EnumIcon.faFaceHandOverMouth]: faFaceHandOverMouth,
    [EnumIcon.faPopcorn]: faPopcorn,
    [EnumIcon.faHouseWater]: faHouseWater,
    [EnumIcon.faHouseFlood]: faHouseFlood,
    [EnumIcon.faObjectSubtract]: faObjectSubtract,
    [EnumIcon.faCodeBranch]: faCodeBranch,
    [EnumIcon.faWarehouseFull]: faWarehouseFull,
    [EnumIcon.faWarehouseAlt]: faWarehouseAlt,
    [EnumIcon.faHatCowboy]: faHatCowboy,
    [EnumIcon.faBridge]: faBridge,
    [EnumIcon.faPhoneFlip]: faPhoneFlip,
    [EnumIcon.faPhoneAlt]: faPhoneAlt,
    [EnumIcon.faArrowDownFromDottedLine]: faArrowDownFromDottedLine,
    [EnumIcon.faSquareQuarters]: faSquareQuarters,
    [EnumIcon.faTruckFront]: faTruckFront,
    [EnumIcon.faCat]: faCat,
    [EnumIcon.faTrashXmark]: faTrashXmark,
    [EnumIcon.faCircleCaretLeft]: faCircleCaretLeft,
    [EnumIcon.faCaretCircleLeft]: faCaretCircleLeft,
    [EnumIcon.faFiles]: faFiles,
    [EnumIcon.faAnchorCircleExclamation]: faAnchorCircleExclamation,
    [EnumIcon.faFaceClouds]: faFaceClouds,
    [EnumIcon.faUserCrown]: faUserCrown,
    [EnumIcon.faTruckField]: faTruckField,
    [EnumIcon.faRoute]: faRoute,
    [EnumIcon.faCartCircleCheck]: faCartCircleCheck,
    [EnumIcon.faClipboardQuestion]: faClipboardQuestion,
    [EnumIcon.faPanorama]: faPanorama,
    [EnumIcon.faCommentMedical]: faCommentMedical,
    [EnumIcon.faTeethOpen]: faTeethOpen,
    [EnumIcon.faUserTieHairLong]: faUserTieHairLong,
    [EnumIcon.faFileCircleMinus]: faFileCircleMinus,
    [EnumIcon.faHeadSideMedical]: faHeadSideMedical,
    [EnumIcon.faTags]: faTags,
    [EnumIcon.faWineGlass]: faWineGlass,
    [EnumIcon.faForwardFast]: faForwardFast,
    [EnumIcon.faFastForward]: faFastForward,
    [EnumIcon.faFaceMehBlank]: faFaceMehBlank,
    [EnumIcon.faMehBlank]: faMehBlank,
    [EnumIcon.faUserRobot]: faUserRobot,
    [EnumIcon.faSquareParking]: faSquareParking,
    [EnumIcon.faParking]: faParking,
    [EnumIcon.faCardDiamond]: faCardDiamond,
    [EnumIcon.faFaceZipper]: faFaceZipper,
    [EnumIcon.faFaceRaisedEyebrow]: faFaceRaisedEyebrow,
    [EnumIcon.faHouseSignal]: faHouseSignal,
    [EnumIcon.faSquareChevronUp]: faSquareChevronUp,
    [EnumIcon.faChevronSquareUp]: faChevronSquareUp,
    [EnumIcon.faNfcSymbol]: faNfcSymbol,
    [EnumIcon.faBarsProgress]: faBarsProgress,
    [EnumIcon.faTasksAlt]: faTasksAlt,
    [EnumIcon.faFaucetDrip]: faFaucetDrip,
    [EnumIcon.faArrowsToLine]: faArrowsToLine,
    [EnumIcon.faDolphin]: faDolphin,
    [EnumIcon.faArrowUpRight]: faArrowUpRight,
    [EnumIcon.faCircleR]: faCircleR,
    [EnumIcon.faCartFlatbed]: faCartFlatbed,
    [EnumIcon.faDollyFlatbed]: faDollyFlatbed,
    [EnumIcon.faBanSmoking]: faBanSmoking,
    [EnumIcon.faSmokingBan]: faSmokingBan,
    [EnumIcon.faCircleSortUp]: faCircleSortUp,
    [EnumIcon.faSortCircleUp]: faSortCircleUp,
    [EnumIcon.faTerminal]: faTerminal,
    [EnumIcon.faMobileButton]: faMobileButton,
    [EnumIcon.faHouseMedicalFlag]: faHouseMedicalFlag,
    [EnumIcon.faBasketShopping]: faBasketShopping,
    [EnumIcon.faShoppingBasket]: faShoppingBasket,
    [EnumIcon.faTape]: faTape,
    [EnumIcon.faChestnut]: faChestnut,
    [EnumIcon.faBusSimple]: faBusSimple,
    [EnumIcon.faBusAlt]: faBusAlt,
    [EnumIcon.faEye]: faEye,
    [EnumIcon.faFaceSadCry]: faFaceSadCry,
    [EnumIcon.faSadCry]: faSadCry,
    [EnumIcon.faHeat]: faHeat,
    [EnumIcon.faTicketAirline]: faTicketAirline,
    [EnumIcon.faBootHeeled]: faBootHeeled,
    [EnumIcon.faArrowsMinimize]: faArrowsMinimize,
    [EnumIcon.faCompressArrows]: faCompressArrows,
    [EnumIcon.faAudioDescription]: faAudioDescription,
    [EnumIcon.faPersonMilitaryToPerson]: faPersonMilitaryToPerson,
    [EnumIcon.faFileShield]: faFileShield,
    [EnumIcon.faHexagon]: faHexagon,
    [EnumIcon.faManhole]: faManhole,
    [EnumIcon.faUserSlash]: faUserSlash,
    [EnumIcon.faPen]: faPen,
    [EnumIcon.faTowerObservation]: faTowerObservation,
    [EnumIcon.faFloppyDisks]: faFloppyDisks,
    [EnumIcon.faToiletPaperBlankUnder]: faToiletPaperBlankUnder,
    [EnumIcon.faToiletPaperReverseAlt]: faToiletPaperReverseAlt,
    [EnumIcon.faFileCode]: faFileCode,
    [EnumIcon.faSignal]: faSignal,
    [EnumIcon.faSignal5]: faSignal5,
    [EnumIcon.faSignalPerfect]: faSignalPerfect,
    [EnumIcon.faPump]: faPump,
    [EnumIcon.faBus]: faBus,
    [EnumIcon.faHeartCircleXmark]: faHeartCircleXmark,
    [EnumIcon.faArrowUpLeftFromCircle]: faArrowUpLeftFromCircle,
    [EnumIcon.faHouseChimney]: faHouseChimney,
    [EnumIcon.faHomeLg]: faHomeLg,
    [EnumIcon.faWindowMaximize]: faWindowMaximize,
    [EnumIcon.faDryer]: faDryer,
    [EnumIcon.faFaceFrown]: faFaceFrown,
    [EnumIcon.faFrown]: faFrown,
    [EnumIcon.faChessBishopPiece]: faChessBishopPiece,
    [EnumIcon.faChessBishopAlt]: faChessBishopAlt,
    [EnumIcon.faShirtTankTop]: faShirtTankTop,
    [EnumIcon.faDiploma]: faDiploma,
    [EnumIcon.faScrollRibbon]: faScrollRibbon,
    [EnumIcon.faScreencast]: faScreencast,
    [EnumIcon.faWalker]: faWalker,
    [EnumIcon.faPrescription]: faPrescription,
    [EnumIcon.faShop]: faShop,
    [EnumIcon.faStoreAlt]: faStoreAlt,
    [EnumIcon.faFloppyDisk]: faFloppyDisk,
    [EnumIcon.faSave]: faSave,
    [EnumIcon.faVihara]: faVihara,
    [EnumIcon.faFaceKissClosedEyes]: faFaceKissClosedEyes,
    [EnumIcon.faScaleUnbalanced]: faScaleUnbalanced,
    [EnumIcon.faBalanceScaleLeft]: faBalanceScaleLeft,
    [EnumIcon.faFileUser]: faFileUser,
    [EnumIcon.faUserPoliceTie]: faUserPoliceTie,
    [EnumIcon.faFaceTongueMoney]: faFaceTongueMoney,
    [EnumIcon.faTennisBall]: faTennisBall,
    [EnumIcon.faSquareL]: faSquareL,
    [EnumIcon.faSortUp]: faSortUp,
    [EnumIcon.faSortAsc]: faSortAsc,
    [EnumIcon.faCalendarArrowUp]: faCalendarArrowUp,
    [EnumIcon.faCalendarUpload]: faCalendarUpload,
    [EnumIcon.faCommentDots]: faCommentDots,
    [EnumIcon.faCommenting]: faCommenting,
    [EnumIcon.faPlantWilt]: faPlantWilt,
    [EnumIcon.faScarf]: faScarf,
    [EnumIcon.faAlbumCirclePlus]: faAlbumCirclePlus,
    [EnumIcon.faUserNurseHairLong]: faUserNurseHairLong,
    [EnumIcon.faDiamond]: faDiamond,
    [EnumIcon.faSquareLeft]: faSquareLeft,
    [EnumIcon.faArrowAltSquareLeft]: faArrowAltSquareLeft,
    [EnumIcon.faFaceGrinSquint]: faFaceGrinSquint,
    [EnumIcon.faGrinSquint]: faGrinSquint,
    [EnumIcon.faCircleEllipsisVertical]: faCircleEllipsisVertical,
    [EnumIcon.faHandHoldingDollar]: faHandHoldingDollar,
    [EnumIcon.faHandHoldingUsd]: faHandHoldingUsd,
    [EnumIcon.faGridDividers]: faGridDividers,
    [EnumIcon.faBacterium]: faBacterium,
    [EnumIcon.faHandPointer]: faHandPointer,
    [EnumIcon.faDrumSteelpan]: faDrumSteelpan,
    [EnumIcon.faHandScissors]: faHandScissors,
    [EnumIcon.faHandsPraying]: faHandsPraying,
    [EnumIcon.faPrayingHands]: faPrayingHands,
    [EnumIcon.faFacePensive]: faFacePensive,
    [EnumIcon.faUserMusic]: faUserMusic,
    [EnumIcon.faArrowRotateRight]: faArrowRotateRight,
    [EnumIcon.faArrowRightRotate]: faArrowRightRotate,
    [EnumIcon.faArrowRotateForward]: faArrowRotateForward,
    [EnumIcon.faRedo]: faRedo,
    [EnumIcon.faMessagesDollar]: faMessagesDollar,
    [EnumIcon.faCommentsAltDollar]: faCommentsAltDollar,
    [EnumIcon.faSensorOn]: faSensorOn,
    [EnumIcon.faBalloon]: faBalloon,
    [EnumIcon.faBiohazard]: faBiohazard,
    [EnumIcon.faChessQueenPiece]: faChessQueenPiece,
    [EnumIcon.faChessQueenAlt]: faChessQueenAlt,
    [EnumIcon.faLocationCrosshairs]: faLocationCrosshairs,
    [EnumIcon.faLocation]: faLocation,
    [EnumIcon.faMarsDouble]: faMarsDouble,
    [EnumIcon.faHousePersonLeave]: faHousePersonLeave,
    [EnumIcon.faHouseLeave]: faHouseLeave,
    [EnumIcon.faHousePersonDepart]: faHousePersonDepart,
    [EnumIcon.faRulerTriangle]: faRulerTriangle,
    [EnumIcon.faCardClub]: faCardClub,
    [EnumIcon.faChildDress]: faChildDress,
    [EnumIcon.faUsersBetweenLines]: faUsersBetweenLines,
    [EnumIcon.faLungsVirus]: faLungsVirus,
    [EnumIcon.faSpinnerThird]: faSpinnerThird,
    [EnumIcon.faFaceGrinTears]: faFaceGrinTears,
    [EnumIcon.faGrinTears]: faGrinTears,
    [EnumIcon.faPhone]: faPhone,
    [EnumIcon.faComputerMouseScrollwheel]: faComputerMouseScrollwheel,
    [EnumIcon.faMouseAlt]: faMouseAlt,
    [EnumIcon.faCalendarXmark]: faCalendarXmark,
    [EnumIcon.faCalendarTimes]: faCalendarTimes,
    [EnumIcon.faChildReaching]: faChildReaching,
    [EnumIcon.faTableLayout]: faTableLayout,
    [EnumIcon.faNarwhal]: faNarwhal,
    [EnumIcon.faRampLoading]: faRampLoading,
    [EnumIcon.faCalendarCirclePlus]: faCalendarCirclePlus,
    [EnumIcon.faToothbrush]: faToothbrush,
    [EnumIcon.faBorderInner]: faBorderInner,
    [EnumIcon.faPawClaws]: faPawClaws,
    [EnumIcon.faKiwiFruit]: faKiwiFruit,
    [EnumIcon.faTrafficLightSlow]: faTrafficLightSlow,
    [EnumIcon.faRectangleCode]: faRectangleCode,
    [EnumIcon.faHeadSideVirus]: faHeadSideVirus,
    [EnumIcon.faKeyboardBrightness]: faKeyboardBrightness,
    [EnumIcon.faBooksMedical]: faBooksMedical,
    [EnumIcon.faLightbulbSlash]: faLightbulbSlash,
    [EnumIcon.faHouseBlank]: faHouseBlank,
    [EnumIcon.faHomeBlank]: faHomeBlank,
    [EnumIcon.faSquare5]: faSquare5,
    [EnumIcon.faSquareHeart]: faSquareHeart,
    [EnumIcon.faHeartSquare]: faHeartSquare,
    [EnumIcon.faPuzzle]: faPuzzle,
    [EnumIcon.faUserGear]: faUserGear,
    [EnumIcon.faUserCog]: faUserCog,
    [EnumIcon.faPipeCircleCheck]: faPipeCircleCheck,
    [EnumIcon.faArrowUp19]: faArrowUp19,
    [EnumIcon.faSortNumericUp]: faSortNumericUp,
    [EnumIcon.faOctagonExclamation]: faOctagonExclamation,
    [EnumIcon.faDialLow]: faDialLow,
    [EnumIcon.faDoorClosed]: faDoorClosed,
    [EnumIcon.faLaptopMobile]: faLaptopMobile,
    [EnumIcon.faPhoneLaptop]: faPhoneLaptop,
    [EnumIcon.faConveyorBeltBoxes]: faConveyorBeltBoxes,
    [EnumIcon.faConveyorBeltAlt]: faConveyorBeltAlt,
    [EnumIcon.faShieldVirus]: faShieldVirus,
    [EnumIcon.faStarfighterTwinIonEngineAdvanced]: faStarfighterTwinIonEngineAdvanced,
    [EnumIcon.faStarfighterAltAdvanced]: faStarfighterAltAdvanced,
    [EnumIcon.faDiceSix]: faDiceSix,
    [EnumIcon.faStarfighterTwinIonEngine]: faStarfighterTwinIonEngine,
    [EnumIcon.faStarfighterAlt]: faStarfighterAlt,
    [EnumIcon.faRocketLaunch]: faRocketLaunch,
    [EnumIcon.faMosquitoNet]: faMosquitoNet,
    [EnumIcon.faVentDamper]: faVentDamper,
    [EnumIcon.faBridgeWater]: faBridgeWater,
    [EnumIcon.faBanBug]: faBanBug,
    [EnumIcon.faDebug]: faDebug,
    [EnumIcon.faPersonBooth]: faPersonBooth,
    [EnumIcon.faTextWidth]: faTextWidth,
    [EnumIcon.faGarageCar]: faGarageCar,
    [EnumIcon.faSquareKanban]: faSquareKanban,
    [EnumIcon.faHatWizard]: faHatWizard,
    [EnumIcon.faPenFancy]: faPenFancy,
    [EnumIcon.faCoffeePot]: faCoffeePot,
    [EnumIcon.faMouseField]: faMouseField,
    [EnumIcon.faPersonDigging]: faPersonDigging,
    [EnumIcon.faDigging]: faDigging,
    [EnumIcon.faShowerDown]: faShowerDown,
    [EnumIcon.faShowerAlt]: faShowerAlt,
    [EnumIcon.faBoxCircleCheck]: faBoxCircleCheck,
    [EnumIcon.faBrightness]: faBrightness,
    [EnumIcon.faCarSideBolt]: faCarSideBolt,
    [EnumIcon.faOrnament]: faOrnament,
    [EnumIcon.faPhoneArrowDownLeft]: faPhoneArrowDownLeft,
    [EnumIcon.faPhoneArrowDown]: faPhoneArrowDown,
    [EnumIcon.faPhoneIncoming]: faPhoneIncoming,
    [EnumIcon.faCloudWord]: faCloudWord,
    [EnumIcon.faHandFingersCrossed]: faHandFingersCrossed,
    [EnumIcon.faTrash]: faTrash,
    [EnumIcon.faGaugeSimple]: faGaugeSimple,
    [EnumIcon.faGaugeSimpleMed]: faGaugeSimpleMed,
    [EnumIcon.faTachometerAverage]: faTachometerAverage,
    [EnumIcon.faArrowDownSmallBig]: faArrowDownSmallBig,
    [EnumIcon.faSortSizeDownAlt]: faSortSizeDownAlt,
    [EnumIcon.faBookMedical]: faBookMedical,
    [EnumIcon.faFaceMelting]: faFaceMelting,
    [EnumIcon.faPoo]: faPoo,
    [EnumIcon.faPenClipSlash]: faPenClipSlash,
    [EnumIcon.faPenAltSlash]: faPenAltSlash,
    [EnumIcon.faQuoteRight]: faQuoteRight,
    [EnumIcon.faQuoteRightAlt]: faQuoteRightAlt,
    [EnumIcon.faScrollOld]: faScrollOld,
    [EnumIcon.faGuitars]: faGuitars,
    [EnumIcon.faPhoneXmark]: faPhoneXmark,
    [EnumIcon.faHose]: faHose,
    [EnumIcon.faClockSix]: faClockSix,
    [EnumIcon.faShirt]: faShirt,
    [EnumIcon.faTShirt]: faTShirt,
    [EnumIcon.faTshirt]: faTshirt,
    [EnumIcon.faSquareR]: faSquareR,
    [EnumIcon.faCubes]: faCubes,
    [EnumIcon.faEnvelopeOpenDollar]: faEnvelopeOpenDollar,
    [EnumIcon.faDivide]: faDivide,
    [EnumIcon.faSunCloud]: faSunCloud,
    [EnumIcon.faLampFloor]: faLampFloor,
    [EnumIcon.faSquare7]: faSquare7,
    [EnumIcon.faTengeSign]: faTengeSign,
    [EnumIcon.faTenge]: faTenge,
    [EnumIcon.faHeadphones]: faHeadphones,
    [EnumIcon.faHandsHolding]: faHandsHolding,
    [EnumIcon.faCampfire]: faCampfire,
    [EnumIcon.faCircleAmpersand]: faCircleAmpersand,
    [EnumIcon.faSnowflakes]: faSnowflakes,
    [EnumIcon.faHandsClapping]: faHandsClapping,
    [EnumIcon.faRepublican]: faRepublican,
    [EnumIcon.faLeafMaple]: faLeafMaple,
    [EnumIcon.faArrowLeft]: faArrowLeft,
    [EnumIcon.faPersonCircleXmark]: faPersonCircleXmark,
    [EnumIcon.faRuler]: faRuler,
    [EnumIcon.faCupStrawSwoosh]: faCupStrawSwoosh,
    [EnumIcon.faTemperatureSun]: faTemperatureSun,
    [EnumIcon.faTemperatureHot]: faTemperatureHot,
    [EnumIcon.faAlignLeft]: faAlignLeft,
    [EnumIcon.faDiceD6]: faDiceD6,
    [EnumIcon.faRestroom]: faRestroom,
    [EnumIcon.faHighDefinition]: faHighDefinition,
    [EnumIcon.faRectangleHd]: faRectangleHd,
    [EnumIcon.faJ]: faJ,
    [EnumIcon.faGalaxy]: faGalaxy,
    [EnumIcon.faUsersViewfinder]: faUsersViewfinder,
    [EnumIcon.faFileVideo]: faFileVideo,
    [EnumIcon.faCherries]: faCherries,
    [EnumIcon.faUpRightFromSquare]: faUpRightFromSquare,
    [EnumIcon.faExternalLinkAlt]: faExternalLinkAlt,
    [EnumIcon.faCircleSort]: faCircleSort,
    [EnumIcon.faSortCircle]: faSortCircle,
    [EnumIcon.faTableCells]: faTableCells,
    [EnumIcon.faTh]: faTh,
    [EnumIcon.faFilePdf]: faFilePdf,
    [EnumIcon.faSiren]: faSiren,
    [EnumIcon.faArrowUpToDottedLine]: faArrowUpToDottedLine,
    [EnumIcon.faImageLandscape]: faImageLandscape,
    [EnumIcon.faLandscape]: faLandscape,
    [EnumIcon.faTankWater]: faTankWater,
    [EnumIcon.faCurlingStone]: faCurlingStone,
    [EnumIcon.faCurling]: faCurling,
    [EnumIcon.faGamepadModern]: faGamepadModern,
    [EnumIcon.faGamepadAlt]: faGamepadAlt,
    [EnumIcon.faMessagesQuestion]: faMessagesQuestion,
    [EnumIcon.faBookBible]: faBookBible,
    [EnumIcon.faBible]: faBible,
    [EnumIcon.faO]: faO,
    [EnumIcon.faSuitcaseMedical]: faSuitcaseMedical,
    [EnumIcon.faMedkit]: faMedkit,
    [EnumIcon.faBriefcaseArrowRight]: faBriefcaseArrowRight,
    [EnumIcon.faExpandWide]: faExpandWide,
    [EnumIcon.faClockElevenThirty]: faClockElevenThirty,
    [EnumIcon.faRv]: faRv,
    [EnumIcon.faUserSecret]: faUserSecret,
    [EnumIcon.faOtter]: faOtter,
    [EnumIcon.faDreidel]: faDreidel,
    [EnumIcon.faPersonDress]: faPersonDress,
    [EnumIcon.faFemale]: faFemale,
    [EnumIcon.faCommentDollar]: faCommentDollar,
    [EnumIcon.faBusinessTime]: faBusinessTime,
    [EnumIcon.faBriefcaseClock]: faBriefcaseClock,
    [EnumIcon.faFlowerTulip]: faFlowerTulip,
    [EnumIcon.faPeoplePantsSimple]: faPeoplePantsSimple,
    [EnumIcon.faCloudDrizzle]: faCloudDrizzle,
    [EnumIcon.faTableCellsLarge]: faTableCellsLarge,
    [EnumIcon.faThLarge]: faThLarge,
    [EnumIcon.faBookTanakh]: faBookTanakh,
    [EnumIcon.faTanakh]: faTanakh,
    [EnumIcon.faSolarSystem]: faSolarSystem,
    [EnumIcon.faSealQuestion]: faSealQuestion,
    [EnumIcon.faPhoneVolume]: faPhoneVolume,
    [EnumIcon.faVolumeControlPhone]: faVolumeControlPhone,
    [EnumIcon.faDiscDrive]: faDiscDrive,
    [EnumIcon.faHatCowboySide]: faHatCowboySide,
    [EnumIcon.faTableRows]: faTableRows,
    [EnumIcon.faRows]: faRows,
    [EnumIcon.faLocationExclamation]: faLocationExclamation,
    [EnumIcon.faMapMarkerExclamation]: faMapMarkerExclamation,
    [EnumIcon.faFaceFearful]: faFaceFearful,
    [EnumIcon.faClipboardUser]: faClipboardUser,
    [EnumIcon.faBusSchool]: faBusSchool,
    [EnumIcon.faFilmSlash]: faFilmSlash,
    [EnumIcon.faSquareArrowDownRight]: faSquareArrowDownRight,
    [EnumIcon.faBookSparkles]: faBookSparkles,
    [EnumIcon.faBookSpells]: faBookSpells,
    [EnumIcon.faWashingMachine]: faWashingMachine,
    [EnumIcon.faWasher]: faWasher,
    [EnumIcon.faChild]: faChild,
    [EnumIcon.faLiraSign]: faLiraSign,
    [EnumIcon.faUserVisor]: faUserVisor,
    [EnumIcon.faFilePlusMinus]: faFilePlusMinus,
    [EnumIcon.faChessClockFlip]: faChessClockFlip,
    [EnumIcon.faChessClockAlt]: faChessClockAlt,
    [EnumIcon.faSatellite]: faSatellite,
    [EnumIcon.faPlaneLock]: faPlaneLock,
    [EnumIcon.faSteeringWheel]: faSteeringWheel,
    [EnumIcon.faTag]: faTag,
    [EnumIcon.faStretcher]: faStretcher,
    [EnumIcon.faBookSection]: faBookSection,
    [EnumIcon.faBookLaw]: faBookLaw,
    [EnumIcon.faInboxes]: faInboxes,
    [EnumIcon.faCoffeeBean]: faCoffeeBean,
    [EnumIcon.faBracketsCurly]: faBracketsCurly,
    [EnumIcon.faEllipsisStrokeVertical]: faEllipsisStrokeVertical,
    [EnumIcon.faEllipsisVAlt]: faEllipsisVAlt,
    [EnumIcon.faComment]: faComment,
    [EnumIcon.faSquare1]: faSquare1,
    [EnumIcon.faCakeCandles]: faCakeCandles,
    [EnumIcon.faBirthdayCake]: faBirthdayCake,
    [EnumIcon.faCake]: faCake,
    [EnumIcon.faHeadSide]: faHeadSide,
    [EnumIcon.faEnvelope]: faEnvelope,
    [EnumIcon.faDollyEmpty]: faDollyEmpty,
    [EnumIcon.faFaceTissue]: faFaceTissue,
    [EnumIcon.faAnglesUp]: faAnglesUp,
    [EnumIcon.faAngleDoubleUp]: faAngleDoubleUp,
    [EnumIcon.faPaperclip]: faPaperclip,
    [EnumIcon.faChartLineDown]: faChartLineDown,
    [EnumIcon.faArrowRightToCity]: faArrowRightToCity,
    [EnumIcon.faLockA]: faLockA,
    [EnumIcon.faRibbon]: faRibbon,
    [EnumIcon.faLungs]: faLungs,
    [EnumIcon.faPersonPinball]: faPersonPinball,
    [EnumIcon.faArrowUp91]: faArrowUp91,
    [EnumIcon.faSortNumericUpAlt]: faSortNumericUpAlt,
    [EnumIcon.faAppleCore]: faAppleCore,
    [EnumIcon.faCircleY]: faCircleY,
    [EnumIcon.faH6]: faH6,
    [EnumIcon.faLitecoinSign]: faLitecoinSign,
    [EnumIcon.faCircleSmall]: faCircleSmall,
    [EnumIcon.faBorderNone]: faBorderNone,
    [EnumIcon.faArrowTurnDownLeft]: faArrowTurnDownLeft,
    [EnumIcon.faCircleNodes]: faCircleNodes,
    [EnumIcon.faParachuteBox]: faParachuteBox,
    [EnumIcon.faMessageMedical]: faMessageMedical,
    [EnumIcon.faCommentAltMedical]: faCommentAltMedical,
    [EnumIcon.faRugbyBall]: faRugbyBall,
    [EnumIcon.faCommentMusic]: faCommentMusic,
    [EnumIcon.faIndent]: faIndent,
    [EnumIcon.faTreeDeciduous]: faTreeDeciduous,
    [EnumIcon.faTreeAlt]: faTreeAlt,
    [EnumIcon.faPuzzlePieceSimple]: faPuzzlePieceSimple,
    [EnumIcon.faPuzzlePieceAlt]: faPuzzlePieceAlt,
    [EnumIcon.faTruckFieldUn]: faTruckFieldUn,
    [EnumIcon.faNfcTrash]: faNfcTrash,
    [EnumIcon.faHourglass]: faHourglass,
    [EnumIcon.faHourglassEmpty]: faHourglassEmpty,
    [EnumIcon.faMountain]: faMountain,
    [EnumIcon.faFileXmark]: faFileXmark,
    [EnumIcon.faFileTimes]: faFileTimes,
    [EnumIcon.faHouseHeart]: faHouseHeart,
    [EnumIcon.faHomeHeart]: faHomeHeart,
    [EnumIcon.faHouseChimneyBlank]: faHouseChimneyBlank,
    [EnumIcon.faMeterBolt]: faMeterBolt,
    [EnumIcon.faUserDoctor]: faUserDoctor,
    [EnumIcon.faUserMd]: faUserMd,
    [EnumIcon.faSlashBack]: faSlashBack,
    [EnumIcon.faCircleInfo]: faCircleInfo,
    [EnumIcon.faInfoCircle]: faInfoCircle,
    [EnumIcon.faFishingRod]: faFishingRod,
    [EnumIcon.faHammerCrash]: faHammerCrash,
    [EnumIcon.faMessageHeart]: faMessageHeart,
    [EnumIcon.faCloudMeatball]: faCloudMeatball,
    [EnumIcon.faCameraPolaroid]: faCameraPolaroid,
    [EnumIcon.faCamera]: faCamera,
    [EnumIcon.faCameraAlt]: faCameraAlt,
    [EnumIcon.faSquareVirus]: faSquareVirus,
    [EnumIcon.faCartArrowUp]: faCartArrowUp,
    [EnumIcon.faMeteor]: faMeteor,
    [EnumIcon.faCarOn]: faCarOn,
    [EnumIcon.faSleigh]: faSleigh,
    [EnumIcon.faArrowDown19]: faArrowDown19,
    [EnumIcon.faSortNumericAsc]: faSortNumericAsc,
    [EnumIcon.faSortNumericDown]: faSortNumericDown,
    [EnumIcon.faBuoyMooring]: faBuoyMooring,
    [EnumIcon.faSquare4]: faSquare4,
    [EnumIcon.faHandHoldingDroplet]: faHandHoldingDroplet,
    [EnumIcon.faHandHoldingWater]: faHandHoldingWater,
    [EnumIcon.faTricycleAdult]: faTricycleAdult,
    [EnumIcon.faWaveform]: faWaveform,
    [EnumIcon.faWater]: faWater,
    [EnumIcon.faStarSharpHalfStroke]: faStarSharpHalfStroke,
    [EnumIcon.faStarSharpHalfAlt]: faStarSharpHalfAlt,
    [EnumIcon.faNfcSignal]: faNfcSignal,
    [EnumIcon.faPlaneProp]: faPlaneProp,
    [EnumIcon.faCalendarCheck]: faCalendarCheck,
    [EnumIcon.faClockDesk]: faClockDesk,
    [EnumIcon.faCalendarClock]: faCalendarClock,
    [EnumIcon.faCalendarTime]: faCalendarTime,
    [EnumIcon.faBraille]: faBraille,
    [EnumIcon.faPrescriptionBottleMedical]: faPrescriptionBottleMedical,
    [EnumIcon.faPrescriptionBottleAlt]: faPrescriptionBottleAlt,
    [EnumIcon.faPlateUtensils]: faPlateUtensils,
    [EnumIcon.faFamilyPants]: faFamilyPants,
    [EnumIcon.faHoseReel]: faHoseReel,
    [EnumIcon.faHouseWindow]: faHouseWindow,
    [EnumIcon.faLandmark]: faLandmark,
    [EnumIcon.faTruck]: faTruck,
    [EnumIcon.faCrosshairs]: faCrosshairs,
    [EnumIcon.faCloudRainbow]: faCloudRainbow,
    [EnumIcon.faPersonCane]: faPersonCane,
    [EnumIcon.faAlien]: faAlien,
    [EnumIcon.faTent]: faTent,
    [EnumIcon.faVestPatches]: faVestPatches,
    [EnumIcon.faPeopleDressSimple]: faPeopleDressSimple,
    [EnumIcon.faCheckDouble]: faCheckDouble,
    [EnumIcon.faArrowDownAZ]: faArrowDownAZ,
    [EnumIcon.faSortAlphaAsc]: faSortAlphaAsc,
    [EnumIcon.faSortAlphaDown]: faSortAlphaDown,
    [EnumIcon.faBowlingBallPin]: faBowlingBallPin,
    [EnumIcon.faBellSchoolSlash]: faBellSchoolSlash,
    [EnumIcon.faPlusLarge]: faPlusLarge,
    [EnumIcon.faMoneyBillWheat]: faMoneyBillWheat,
    [EnumIcon.faCameraViewfinder]: faCameraViewfinder,
    [EnumIcon.faScreenshot]: faScreenshot,
    [EnumIcon.faMessageMusic]: faMessageMusic,
    [EnumIcon.faCommentAltMusic]: faCommentAltMusic,
    [EnumIcon.faCarBuilding]: faCarBuilding,
    [EnumIcon.faBorderBottomRight]: faBorderBottomRight,
    [EnumIcon.faBorderStyleAlt]: faBorderStyleAlt,
    [EnumIcon.faOctagon]: faOctagon,
    [EnumIcon.faCommentArrowUpRight]: faCommentArrowUpRight,
    [EnumIcon.faOctagonDivide]: faOctagonDivide,
    [EnumIcon.faCookie]: faCookie,
    [EnumIcon.faArrowRotateLeft]: faArrowRotateLeft,
    [EnumIcon.faArrowLeftRotate]: faArrowLeftRotate,
    [EnumIcon.faArrowRotateBack]: faArrowRotateBack,
    [EnumIcon.faArrowRotateBackward]: faArrowRotateBackward,
    [EnumIcon.faUndo]: faUndo,
    [EnumIcon.faTvMusic]: faTvMusic,
    [EnumIcon.faHardDrive]: faHardDrive,
    [EnumIcon.faHdd]: faHdd,
    [EnumIcon.faReel]: faReel,
    [EnumIcon.faFaceGrinSquintTears]: faFaceGrinSquintTears,
    [EnumIcon.faGrinSquintTears]: faGrinSquintTears,
    [EnumIcon.faDumbbell]: faDumbbell,
    [EnumIcon.faRectangleList]: faRectangleList,
    [EnumIcon.faListAlt]: faListAlt,
    [EnumIcon.faTarpDroplet]: faTarpDroplet,
    [EnumIcon.faAlarmExclamation]: faAlarmExclamation,
    [EnumIcon.faHouseMedicalCircleCheck]: faHouseMedicalCircleCheck,
    [EnumIcon.faTrafficCone]: faTrafficCone,
    [EnumIcon.faGrate]: faGrate,
    [EnumIcon.faArrowDownRight]: faArrowDownRight,
    [EnumIcon.faPersonSkiingNordic]: faPersonSkiingNordic,
    [EnumIcon.faSkiingNordic]: faSkiingNordic,
    [EnumIcon.faCalendarPlus]: faCalendarPlus,
    [EnumIcon.faPersonFromPortal]: faPersonFromPortal,
    [EnumIcon.faPortalExit]: faPortalExit,
    [EnumIcon.faPlaneArrival]: faPlaneArrival,
    [EnumIcon.faCowbellCirclePlus]: faCowbellCirclePlus,
    [EnumIcon.faCowbellMore]: faCowbellMore,
    [EnumIcon.faCircleLeft]: faCircleLeft,
    [EnumIcon.faArrowAltCircleLeft]: faArrowAltCircleLeft,
    [EnumIcon.faDistributeSpacingVertical]: faDistributeSpacingVertical,
    [EnumIcon.faSignalBarsFair]: faSignalBarsFair,
    [EnumIcon.faSignalAlt2]: faSignalAlt2,
    [EnumIcon.faSportsball]: faSportsball,
    [EnumIcon.faGameConsoleHandheldCrank]: faGameConsoleHandheldCrank,
    [EnumIcon.faTrainSubway]: faTrainSubway,
    [EnumIcon.faSubway]: faSubway,
    [EnumIcon.faChartGantt]: faChartGantt,
    [EnumIcon.faFaceSmileUpsideDown]: faFaceSmileUpsideDown,
    [EnumIcon.faBallPile]: faBallPile,
    [EnumIcon.faBadgeDollar]: faBadgeDollar,
    [EnumIcon.faMoneyBillsSimple]: faMoneyBillsSimple,
    [EnumIcon.faMoneyBillsAlt]: faMoneyBillsAlt,
    [EnumIcon.faListTimeline]: faListTimeline,
    [EnumIcon.faIndianRupeeSign]: faIndianRupeeSign,
    [EnumIcon.faIndianRupee]: faIndianRupee,
    [EnumIcon.faInr]: faInr,
    [EnumIcon.faCropSimple]: faCropSimple,
    [EnumIcon.faCropAlt]: faCropAlt,
    [EnumIcon.faMoneyBill1]: faMoneyBill1,
    [EnumIcon.faMoneyBillAlt]: faMoneyBillAlt,
    [EnumIcon.faLeftLong]: faLeftLong,
    [EnumIcon.faLongArrowAltLeft]: faLongArrowAltLeft,
    [EnumIcon.faKeyboardDown]: faKeyboardDown,
    [EnumIcon.faCircleUpRight]: faCircleUpRight,
    [EnumIcon.faCloudBoltMoon]: faCloudBoltMoon,
    [EnumIcon.faThunderstormMoon]: faThunderstormMoon,
    [EnumIcon.faDna]: faDna,
    [EnumIcon.faVirusSlash]: faVirusSlash,
    [EnumIcon.faBracketRoundRight]: faBracketRoundRight,
    [EnumIcon.faCircle5]: faCircle5,
    [EnumIcon.faMinus]: faMinus,
    [EnumIcon.faSubtract]: faSubtract,
    [EnumIcon.faFireFlame]: faFireFlame,
    [EnumIcon.faFlame]: faFlame,
    [EnumIcon.faRightToLine]: faRightToLine,
    [EnumIcon.faArrowAltToRight]: faArrowAltToRight,
    [EnumIcon.faGif]: faGif,
    [EnumIcon.faChess]: faChess,
    [EnumIcon.faTrashSlash]: faTrashSlash,
    [EnumIcon.faArrowLeftLong]: faArrowLeftLong,
    [EnumIcon.faLongArrowLeft]: faLongArrowLeft,
    [EnumIcon.faPlugCircleCheck]: faPlugCircleCheck,
    [EnumIcon.faFontCase]: faFontCase,
    [EnumIcon.faStreetView]: faStreetView,
    [EnumIcon.faArrowDownLeft]: faArrowDownLeft,
    [EnumIcon.faFrancSign]: faFrancSign,
    [EnumIcon.faFlaskRoundPoison]: faFlaskRoundPoison,
    [EnumIcon.faFlaskPoison]: faFlaskPoison,
    [EnumIcon.faVolumeOff]: faVolumeOff,
    [EnumIcon.faBookCircleArrowRight]: faBookCircleArrowRight,
    [EnumIcon.faChartUser]: faChartUser,
    [EnumIcon.faUserChart]: faUserChart,
    [EnumIcon.faHandsAslInterpreting]: faHandsAslInterpreting,
    [EnumIcon.faAmericanSignLanguageInterpreting]: faAmericanSignLanguageInterpreting,
    [EnumIcon.faAslInterpreting]: faAslInterpreting,
    [EnumIcon.faHandsAmericanSignLanguageInterpreting]: faHandsAmericanSignLanguageInterpreting,
    [EnumIcon.faPresentationScreen]: faPresentationScreen,
    [EnumIcon.faPresentation]: faPresentation,
    [EnumIcon.faCircleBolt]: faCircleBolt,
    [EnumIcon.faFaceSmileHalo]: faFaceSmileHalo,
    [EnumIcon.faCartCircleArrowDown]: faCartCircleArrowDown,
    [EnumIcon.faHousePersonReturn]: faHousePersonReturn,
    [EnumIcon.faHousePersonArrive]: faHousePersonArrive,
    [EnumIcon.faHouseReturn]: faHouseReturn,
    [EnumIcon.faMessageXmark]: faMessageXmark,
    [EnumIcon.faCommentAltTimes]: faCommentAltTimes,
    [EnumIcon.faMessageTimes]: faMessageTimes,
    [EnumIcon.faFileCertificate]: faFileCertificate,
    [EnumIcon.faFileAward]: faFileAward,
    [EnumIcon.faUserDoctorHairLong]: faUserDoctorHairLong,
    [EnumIcon.faCameraSecurity]: faCameraSecurity,
    [EnumIcon.faCameraHome]: faCameraHome,
    [EnumIcon.faGear]: faGear,
    [EnumIcon.faCog]: faCog,
    [EnumIcon.faDropletSlash]: faDropletSlash,
    [EnumIcon.faTintSlash]: faTintSlash,
    [EnumIcon.faBookHeart]: faBookHeart,
    [EnumIcon.faMosque]: faMosque,
    [EnumIcon.faDuck]: faDuck,
    [EnumIcon.faMosquito]: faMosquito,
    [EnumIcon.faStarOfDavid]: faStarOfDavid,
    [EnumIcon.faFlagSwallowtail]: faFlagSwallowtail,
    [EnumIcon.faFlagAlt]: faFlagAlt,
    [EnumIcon.faPersonMilitaryRifle]: faPersonMilitaryRifle,
    [EnumIcon.faCarGarage]: faCarGarage,
    [EnumIcon.faCartShopping]: faCartShopping,
    [EnumIcon.faShoppingCart]: faShoppingCart,
    [EnumIcon.faBookFont]: faBookFont,
    [EnumIcon.faShieldPlus]: faShieldPlus,
    [EnumIcon.faVials]: faVials,
    [EnumIcon.faEyeDropperFull]: faEyeDropperFull,
    [EnumIcon.faDistributeSpacingHorizontal]: faDistributeSpacingHorizontal,
    [EnumIcon.faTabletRugged]: faTabletRugged,
    [EnumIcon.faTemperatureSnow]: faTemperatureSnow,
    [EnumIcon.faTemperatureFrigid]: faTemperatureFrigid,
    [EnumIcon.faMoped]: faMoped,
    [EnumIcon.faFaceSmilePlus]: faFaceSmilePlus,
    [EnumIcon.faSmilePlus]: faSmilePlus,
    [EnumIcon.faRadioTuner]: faRadioTuner,
    [EnumIcon.faRadioAlt]: faRadioAlt,
    [EnumIcon.faFaceSwear]: faFaceSwear,
    [EnumIcon.faWaterArrowDown]: faWaterArrowDown,
    [EnumIcon.faWaterLower]: faWaterLower,
    [EnumIcon.faScannerTouchscreen]: faScannerTouchscreen,
    [EnumIcon.faCircle7]: faCircle7,
    [EnumIcon.faPlugCirclePlus]: faPlugCirclePlus,
    [EnumIcon.faPersonSkiJumping]: faPersonSkiJumping,
    [EnumIcon.faSkiJump]: faSkiJump,
    [EnumIcon.faPlaceOfWorship]: faPlaceOfWorship,
    [EnumIcon.faWaterArrowUp]: faWaterArrowUp,
    [EnumIcon.faWaterRise]: faWaterRise,
    [EnumIcon.faWaveformLines]: faWaveformLines,
    [EnumIcon.faWaveformPath]: faWaveformPath,
    [EnumIcon.faSplit]: faSplit,
    [EnumIcon.faFilmCanister]: faFilmCanister,
    [EnumIcon.faFilmCannister]: faFilmCannister,
    [EnumIcon.faFolderXmark]: faFolderXmark,
    [EnumIcon.faFolderTimes]: faFolderTimes,
    [EnumIcon.faToiletPaperBlank]: faToiletPaperBlank,
    [EnumIcon.faToiletPaperAlt]: faToiletPaperAlt,
    [EnumIcon.faTabletScreen]: faTabletScreen,
    [EnumIcon.faTabletAndroidAlt]: faTabletAndroidAlt,
    [EnumIcon.faHexagonVerticalNftSlanted]: faHexagonVerticalNftSlanted,
    [EnumIcon.faFolderMusic]: faFolderMusic,
    [EnumIcon.faDisplayMedical]: faDisplayMedical,
    [EnumIcon.faDesktopMedical]: faDesktopMedical,
    [EnumIcon.faShareAll]: faShareAll,
    [EnumIcon.faPeapod]: faPeapod,
    [EnumIcon.faChessClock]: faChessClock,
    [EnumIcon.faAxe]: faAxe,
    [EnumIcon.faSquareD]: faSquareD,
    [EnumIcon.faGripVertical]: faGripVertical,
    [EnumIcon.faMobileSignalOut]: faMobileSignalOut,
    [EnumIcon.faArrowTurnUp]: faArrowTurnUp,
    [EnumIcon.faLevelUp]: faLevelUp,
    [EnumIcon.faU]: faU,
    [EnumIcon.faArrowUpFromDottedLine]: faArrowUpFromDottedLine,
    [EnumIcon.faSquareRootVariable]: faSquareRootVariable,
    [EnumIcon.faSquareRootAlt]: faSquareRootAlt,
    [EnumIcon.faLightSwitchOn]: faLightSwitchOn,
    [EnumIcon.faArrowDownArrowUp]: faArrowDownArrowUp,
    [EnumIcon.faSortAlt]: faSortAlt,
    [EnumIcon.faRaindrops]: faRaindrops,
    [EnumIcon.faDash]: faDash,
    [EnumIcon.faMinusLarge]: faMinusLarge,
    [EnumIcon.faClock]: faClock,
    [EnumIcon.faClockFour]: faClockFour,
    [EnumIcon.faInputNumeric]: faInputNumeric,
    [EnumIcon.faTruckTow]: faTruckTow,
    [EnumIcon.faBackwardStep]: faBackwardStep,
    [EnumIcon.faStepBackward]: faStepBackward,
    [EnumIcon.faPallet]: faPallet,
    [EnumIcon.faCarBolt]: faCarBolt,
    [EnumIcon.faArrowsMaximize]: faArrowsMaximize,
    [EnumIcon.faExpandArrows]: faExpandArrows,
    [EnumIcon.faFaucet]: faFaucet,
    [EnumIcon.faCloudSleet]: faCloudSleet,
    [EnumIcon.faLampStreet]: faLampStreet,
    [EnumIcon.faListRadio]: faListRadio,
    [EnumIcon.faPenNibSlash]: faPenNibSlash,
    [EnumIcon.faBaseballBatBall]: faBaseballBatBall,
    [EnumIcon.faSquareUpLeft]: faSquareUpLeft,
    [EnumIcon.faOverline]: faOverline,
    [EnumIcon.faS]: faS,
    [EnumIcon.faTimeline]: faTimeline,
    [EnumIcon.faKeyboard]: faKeyboard,
    [EnumIcon.faArrowsFromDottedLine]: faArrowsFromDottedLine,
    [EnumIcon.faUsbDrive]: faUsbDrive,
    [EnumIcon.faBallot]: faBallot,
    [EnumIcon.faCaretDown]: faCaretDown,
    [EnumIcon.faLocationDotSlash]: faLocationDotSlash,
    [EnumIcon.faMapMarkerAltSlash]: faMapMarkerAltSlash,
    [EnumIcon.faCards]: faCards,
    [EnumIcon.faHouseChimneyMedical]: faHouseChimneyMedical,
    [EnumIcon.faClinicMedical]: faClinicMedical,
    [EnumIcon.faBoxingGlove]: faBoxingGlove,
    [EnumIcon.faGloveBoxing]: faGloveBoxing,
    [EnumIcon.faTemperatureThreeQuarters]: faTemperatureThreeQuarters,
    [EnumIcon.faTemperature3]: faTemperature3,
    [EnumIcon.faThermometer3]: faThermometer3,
    [EnumIcon.faThermometerThreeQuarters]: faThermometerThreeQuarters,
    [EnumIcon.faBellSchool]: faBellSchool,
    [EnumIcon.faMobileScreen]: faMobileScreen,
    [EnumIcon.faMobileAndroidAlt]: faMobileAndroidAlt,
    [EnumIcon.faPlaneUp]: faPlaneUp,
    [EnumIcon.faFolderHeart]: faFolderHeart,
    [EnumIcon.faCircleLocationArrow]: faCircleLocationArrow,
    [EnumIcon.faLocationCircle]: faLocationCircle,
    [EnumIcon.faFaceHeadBandage]: faFaceHeadBandage,
    [EnumIcon.faSushiRoll]: faSushiRoll,
    [EnumIcon.faMakiRoll]: faMakiRoll,
    [EnumIcon.faMakizushi]: faMakizushi,
    [EnumIcon.faCarBump]: faCarBump,
    [EnumIcon.faPiggyBank]: faPiggyBank,
    [EnumIcon.faRacquet]: faRacquet,
    [EnumIcon.faCarMirrors]: faCarMirrors,
    [EnumIcon.faIndustryWindows]: faIndustryWindows,
    [EnumIcon.faIndustryAlt]: faIndustryAlt,
    [EnumIcon.faBoltAuto]: faBoltAuto,
    [EnumIcon.faBatteryHalf]: faBatteryHalf,
    [EnumIcon.faBattery3]: faBattery3,
    [EnumIcon.faFluxCapacitor]: faFluxCapacitor,
    [EnumIcon.faMountainCity]: faMountainCity,
    [EnumIcon.faCoins]: faCoins,
    [EnumIcon.faHoneyPot]: faHoneyPot,
    [EnumIcon.faOlive]: faOlive,
    [EnumIcon.faKhanda]: faKhanda,
    [EnumIcon.faFilterList]: faFilterList,
    [EnumIcon.faOutlet]: faOutlet,
    [EnumIcon.faSliders]: faSliders,
    [EnumIcon.faSlidersH]: faSlidersH,
    [EnumIcon.faCauldron]: faCauldron,
    [EnumIcon.faPeople]: faPeople,
    [EnumIcon.faFolderTree]: faFolderTree,
    [EnumIcon.faNetworkWired]: faNetworkWired,
    [EnumIcon.faCroissant]: faCroissant,
    [EnumIcon.faMapPin]: faMapPin,
    [EnumIcon.faHamsa]: faHamsa,
    [EnumIcon.faCentSign]: faCentSign,
    [EnumIcon.faSwordsLaser]: faSwordsLaser,
    [EnumIcon.faFlask]: faFlask,
    [EnumIcon.faPersonPregnant]: faPersonPregnant,
    [EnumIcon.faSquareU]: faSquareU,
    [EnumIcon.faWandSparkles]: faWandSparkles,
    [EnumIcon.faRouter]: faRouter,
    [EnumIcon.faEllipsisVertical]: faEllipsisVertical,
    [EnumIcon.faEllipsisV]: faEllipsisV,
    [EnumIcon.faSwordLaserAlt]: faSwordLaserAlt,
    [EnumIcon.faTicket]: faTicket,
    [EnumIcon.faPowerOff]: faPowerOff,
    [EnumIcon.faCoin]: faCoin,
    [EnumIcon.faLaptopSlash]: faLaptopSlash,
    [EnumIcon.faRightLong]: faRightLong,
    [EnumIcon.faLongArrowAltRight]: faLongArrowAltRight,
    [EnumIcon.faCircleB]: faCircleB,
    [EnumIcon.faPersonDressSimple]: faPersonDressSimple,
    [EnumIcon.faPipeCollar]: faPipeCollar,
    [EnumIcon.faLightsHoliday]: faLightsHoliday,
    [EnumIcon.faCitrus]: faCitrus,
    [EnumIcon.faFlagUsa]: faFlagUsa,
    [EnumIcon.faLaptopFile]: faLaptopFile,
    [EnumIcon.faTty]: faTty,
    [EnumIcon.faTeletype]: faTeletype,
    [EnumIcon.faChartTreeMap]: faChartTreeMap,
    [EnumIcon.faDiagramNext]: faDiagramNext,
    [EnumIcon.faPersonRifle]: faPersonRifle,
    [EnumIcon.faClockFiveThirty]: faClockFiveThirty,
    [EnumIcon.faPipeValve]: faPipeValve,
    [EnumIcon.faArrowUpFromArc]: faArrowUpFromArc,
    [EnumIcon.faFaceSpiralEyes]: faFaceSpiralEyes,
    [EnumIcon.faCompressWide]: faCompressWide,
    [EnumIcon.faCirclePhoneHangup]: faCirclePhoneHangup,
    [EnumIcon.faPhoneCircleDown]: faPhoneCircleDown,
    [EnumIcon.faHouseMedicalCircleExclamation]: faHouseMedicalCircleExclamation,
    [EnumIcon.faBadminton]: faBadminton,
    [EnumIcon.faClosedCaptioning]: faClosedCaptioning,
    [EnumIcon.faPersonHiking]: faPersonHiking,
    [EnumIcon.faHiking]: faHiking,
    [EnumIcon.faRightFromLine]: faRightFromLine,
    [EnumIcon.faArrowAltFromLeft]: faArrowAltFromLeft,
    [EnumIcon.faVenusDouble]: faVenusDouble,
    [EnumIcon.faImages]: faImages,
    [EnumIcon.faCalculator]: faCalculator,
    [EnumIcon.faShuttlecock]: faShuttlecock,
    [EnumIcon.faUserHair]: faUserHair,
    [EnumIcon.faEyeEvil]: faEyeEvil,
    [EnumIcon.faPeoplePulling]: faPeoplePulling,
    [EnumIcon.faN]: faN,
    [EnumIcon.faGarage]: faGarage,
    [EnumIcon.faCableCar]: faCableCar,
    [EnumIcon.faTram]: faTram,
    [EnumIcon.faShovelSnow]: faShovelSnow,
    [EnumIcon.faCloudRain]: faCloudRain,
    [EnumIcon.faFaceLying]: faFaceLying,
    [EnumIcon.faSprinkler]: faSprinkler,
    [EnumIcon.faBuildingCircleXmark]: faBuildingCircleXmark,
    [EnumIcon.faPersonSledding]: faPersonSledding,
    [EnumIcon.faSledding]: faSledding,
    [EnumIcon.faGameConsoleHandheld]: faGameConsoleHandheld,
    [EnumIcon.faShip]: faShip,
    [EnumIcon.faClockSixThirty]: faClockSixThirty,
    [EnumIcon.faBatterySlash]: faBatterySlash,
    [EnumIcon.faTugrikSign]: faTugrikSign,
    [EnumIcon.faArrowsDownToLine]: faArrowsDownToLine,
    [EnumIcon.faDownload]: faDownload,
    [EnumIcon.faShelves]: faShelves,
    [EnumIcon.faInventory]: faInventory,
    [EnumIcon.faCloudSnow]: faCloudSnow,
    [EnumIcon.faFaceGrin]: faFaceGrin,
    [EnumIcon.faGrin]: faGrin,
    [EnumIcon.faDeleteLeft]: faDeleteLeft,
    [EnumIcon.faBackspace]: faBackspace,
    [EnumIcon.faOven]: faOven,
    [EnumIcon.faEyeDropper]: faEyeDropper,
    [EnumIcon.faEyeDropperEmpty]: faEyeDropperEmpty,
    [EnumIcon.faEyedropper]: faEyedropper,
    [EnumIcon.faCommentCaptions]: faCommentCaptions,
    [EnumIcon.faCommentsQuestion]: faCommentsQuestion,
    [EnumIcon.faScribble]: faScribble,
    [EnumIcon.faRotateExclamation]: faRotateExclamation,
    [EnumIcon.faFileCircleCheck]: faFileCircleCheck,
    [EnumIcon.faGlass]: faGlass,
    [EnumIcon.faLoader]: faLoader,
    [EnumIcon.faForward]: faForward,
    [EnumIcon.faUserPilot]: faUserPilot,
    [EnumIcon.faMobile]: faMobile,
    [EnumIcon.faMobileAndroid]: faMobileAndroid,
    [EnumIcon.faMobilePhone]: faMobilePhone,
    [EnumIcon.faCodePullRequestClosed]: faCodePullRequestClosed,
    [EnumIcon.faFaceMeh]: faFaceMeh,
    [EnumIcon.faMeh]: faMeh,
    [EnumIcon.faAlignCenter]: faAlignCenter,
    [EnumIcon.faBookSkull]: faBookSkull,
    [EnumIcon.faBookDead]: faBookDead,
    [EnumIcon.faIdCard]: faIdCard,
    [EnumIcon.faDriversLicense]: faDriversLicense,
    [EnumIcon.faFaceDotted]: faFaceDotted,
    [EnumIcon.faFaceWorried]: faFaceWorried,
    [EnumIcon.faOutdent]: faOutdent,
    [EnumIcon.faDedent]: faDedent,
    [EnumIcon.faHeartCircleExclamation]: faHeartCircleExclamation,
    [EnumIcon.faHouse]: faHouse,
    [EnumIcon.faHome]: faHome,
    [EnumIcon.faHomeAlt]: faHomeAlt,
    [EnumIcon.faHomeLgAlt]: faHomeLgAlt,
    [EnumIcon.faVectorCircle]: faVectorCircle,
    [EnumIcon.faCarCircleBolt]: faCarCircleBolt,
    [EnumIcon.faCalendarWeek]: faCalendarWeek,
    [EnumIcon.faFlyingDisc]: faFlyingDisc,
    [EnumIcon.faLaptopMedical]: faLaptopMedical,
    [EnumIcon.faSquareDownRight]: faSquareDownRight,
    [EnumIcon.faB]: faB,
    [EnumIcon.faSeatAirline]: faSeatAirline,
    [EnumIcon.faMoonOverSun]: faMoonOverSun,
    [EnumIcon.faEclipseAlt]: faEclipseAlt,
    [EnumIcon.faPipe]: faPipe,
    [EnumIcon.faFileMedical]: faFileMedical,
    [EnumIcon.faPotato]: faPotato,
    [EnumIcon.faDiceOne]: faDiceOne,
    [EnumIcon.faCircleA]: faCircleA,
    [EnumIcon.faHelmetBattle]: faHelmetBattle,
    [EnumIcon.faButter]: faButter,
    [EnumIcon.faBlanketFire]: faBlanketFire,
    [EnumIcon.faKiwiBird]: faKiwiBird,
    [EnumIcon.faCastle]: faCastle,
    [EnumIcon.faGolfClub]: faGolfClub,
    [EnumIcon.faArrowRightArrowLeft]: faArrowRightArrowLeft,
    [EnumIcon.faExchange]: faExchange,
    [EnumIcon.faRotateRight]: faRotateRight,
    [EnumIcon.faRedoAlt]: faRedoAlt,
    [EnumIcon.faRotateForward]: faRotateForward,
    [EnumIcon.faUtensils]: faUtensils,
    [EnumIcon.faCutlery]: faCutlery,
    [EnumIcon.faArrowUpWideShort]: faArrowUpWideShort,
    [EnumIcon.faSortAmountUp]: faSortAmountUp,
    [EnumIcon.faBalloons]: faBalloons,
    [EnumIcon.faMillSign]: faMillSign,
    [EnumIcon.faBowlRice]: faBowlRice,
    [EnumIcon.faTimelineArrow]: faTimelineArrow,
    [EnumIcon.faSkull]: faSkull,
    [EnumIcon.faGameBoardSimple]: faGameBoardSimple,
    [EnumIcon.faGameBoardAlt]: faGameBoardAlt,
    [EnumIcon.faCircleVideo]: faCircleVideo,
    [EnumIcon.faVideoCircle]: faVideoCircle,
    [EnumIcon.faChartScatterBubble]: faChartScatterBubble,
    [EnumIcon.faHouseTurret]: faHouseTurret,
    [EnumIcon.faBanana]: faBanana,
    [EnumIcon.faHandHoldingSkull]: faHandHoldingSkull,
    [EnumIcon.faPeopleDress]: faPeopleDress,
    [EnumIcon.faLoveseat]: faLoveseat,
    [EnumIcon.faCouchSmall]: faCouchSmall,
    [EnumIcon.faTowerBroadcast]: faTowerBroadcast,
    [EnumIcon.faBroadcastTower]: faBroadcastTower,
    [EnumIcon.faTruckPickup]: faTruckPickup,
    [EnumIcon.faBlockQuote]: faBlockQuote,
    [EnumIcon.faUpLong]: faUpLong,
    [EnumIcon.faLongArrowAltUp]: faLongArrowAltUp,
    [EnumIcon.faStop]: faStop,
    [EnumIcon.faCodeMerge]: faCodeMerge,
    [EnumIcon.faMoneyCheckDollarPen]: faMoneyCheckDollarPen,
    [EnumIcon.faMoneyCheckEditAlt]: faMoneyCheckEditAlt,
    [EnumIcon.faUpFromLine]: faUpFromLine,
    [EnumIcon.faArrowAltFromBottom]: faArrowAltFromBottom,
    [EnumIcon.faUpload]: faUpload,
    [EnumIcon.faHurricane]: faHurricane,
    [EnumIcon.faPeoplePants]: faPeoplePants,
    [EnumIcon.faMound]: faMound,
    [EnumIcon.faWindsock]: faWindsock,
    [EnumIcon.faCircleHalf]: faCircleHalf,
    [EnumIcon.faBrakeWarning]: faBrakeWarning,
    [EnumIcon.faToiletPortable]: faToiletPortable,
    [EnumIcon.faCompactDisc]: faCompactDisc,
    [EnumIcon.faFileArrowDown]: faFileArrowDown,
    [EnumIcon.faFileDownload]: faFileDownload,
    [EnumIcon.faSaxophoneFire]: faSaxophoneFire,
    [EnumIcon.faSaxHot]: faSaxHot,
    [EnumIcon.faCameraWebSlash]: faCameraWebSlash,
    [EnumIcon.faWebcamSlash]: faWebcamSlash,
    [EnumIcon.faFolderMedical]: faFolderMedical,
    [EnumIcon.faFolderGear]: faFolderGear,
    [EnumIcon.faFolderCog]: faFolderCog,
    [EnumIcon.faHandWave]: faHandWave,
    [EnumIcon.faArrowUpArrowDown]: faArrowUpArrowDown,
    [EnumIcon.faSortUpDown]: faSortUpDown,
    [EnumIcon.faCaravan]: faCaravan,
    [EnumIcon.faShieldCat]: faShieldCat,
    [EnumIcon.faMessageSlash]: faMessageSlash,
    [EnumIcon.faCommentAltSlash]: faCommentAltSlash,
    [EnumIcon.faBolt]: faBolt,
    [EnumIcon.faZap]: faZap,
    [EnumIcon.faTrashCanCheck]: faTrashCanCheck,
    [EnumIcon.faGlassWater]: faGlassWater,
    [EnumIcon.faOilWell]: faOilWell,
    [EnumIcon.faPersonSimple]: faPersonSimple,
    [EnumIcon.faVault]: faVault,
    [EnumIcon.faMars]: faMars,
    [EnumIcon.faToilet]: faToilet,
    [EnumIcon.faPlaneCircleXmark]: faPlaneCircleXmark,
    [EnumIcon.faYenSign]: faYenSign,
    [EnumIcon.faCny]: faCny,
    [EnumIcon.faJpy]: faJpy,
    [EnumIcon.faRmb]: faRmb,
    [EnumIcon.faYen]: faYen,
    [EnumIcon.faNotes]: faNotes,
    [EnumIcon.faRubleSign]: faRubleSign,
    [EnumIcon.faRouble]: faRouble,
    [EnumIcon.faRub]: faRub,
    [EnumIcon.faRuble]: faRuble,
    [EnumIcon.faTrashUndo]: faTrashUndo,
    [EnumIcon.faTrashArrowTurnLeft]: faTrashArrowTurnLeft,
    [EnumIcon.faChampagneGlass]: faChampagneGlass,
    [EnumIcon.faGlassChampagne]: faGlassChampagne,
    [EnumIcon.faObjectsAlignCenterHorizontal]: faObjectsAlignCenterHorizontal,
    [EnumIcon.faSun]: faSun,
    [EnumIcon.faTrashCanSlash]: faTrashCanSlash,
    [EnumIcon.faTrashAltSlash]: faTrashAltSlash,
    [EnumIcon.faScreenUsers]: faScreenUsers,
    [EnumIcon.faUsersClass]: faUsersClass,
    [EnumIcon.faGuitar]: faGuitar,
    [EnumIcon.faSquareArrowLeft]: faSquareArrowLeft,
    [EnumIcon.faArrowSquareLeft]: faArrowSquareLeft,
    [EnumIcon.faSquare8]: faSquare8,
    [EnumIcon.faFaceSmileHearts]: faFaceSmileHearts,
    [EnumIcon.faBracketsSquare]: faBracketsSquare,
    [EnumIcon.faBrackets]: faBrackets,
    [EnumIcon.faLaptopArrowDown]: faLaptopArrowDown,
    [EnumIcon.faHockeyStickPuck]: faHockeyStickPuck,
    [EnumIcon.faHouseTree]: faHouseTree,
    [EnumIcon.faSignalFair]: faSignalFair,
    [EnumIcon.faSignal2]: faSignal2,
    [EnumIcon.faFaceLaughWink]: faFaceLaughWink,
    [EnumIcon.faLaughWink]: faLaughWink,
    [EnumIcon.faCircleDollar]: faCircleDollar,
    [EnumIcon.faDollarCircle]: faDollarCircle,
    [EnumIcon.faUsdCircle]: faUsdCircle,
    [EnumIcon.faHorseHead]: faHorseHead,
    [EnumIcon.faArrowsRepeat]: faArrowsRepeat,
    [EnumIcon.faRepeatAlt]: faRepeatAlt,
    [EnumIcon.faBoreHole]: faBoreHole,
    [EnumIcon.faIndustry]: faIndustry,
    [EnumIcon.faImagePolaroid]: faImagePolaroid,
    [EnumIcon.faWaveTriangle]: faWaveTriangle,
    [EnumIcon.faCircleDown]: faCircleDown,
    [EnumIcon.faArrowAltCircleDown]: faArrowAltCircleDown,
    [EnumIcon.faGrill]: faGrill,
    [EnumIcon.faArrowsTurnToDots]: faArrowsTurnToDots,
    [EnumIcon.faChartMixed]: faChartMixed,
    [EnumIcon.faAnalytics]: faAnalytics,
    [EnumIcon.faFlorinSign]: faFlorinSign,
    [EnumIcon.faArrowDownShortWide]: faArrowDownShortWide,
    [EnumIcon.faSortAmountDesc]: faSortAmountDesc,
    [EnumIcon.faSortAmountDownAlt]: faSortAmountDownAlt,
    [EnumIcon.faLessThan]: faLessThan,
    [EnumIcon.faDisplayCode]: faDisplayCode,
    [EnumIcon.faDesktopCode]: faDesktopCode,
    [EnumIcon.faFaceDrooling]: faFaceDrooling,
    [EnumIcon.faOilTemperature]: faOilTemperature,
    [EnumIcon.faOilTemp]: faOilTemp,
    [EnumIcon.faSquareQuestion]: faSquareQuestion,
    [EnumIcon.faQuestionSquare]: faQuestionSquare,
    [EnumIcon.faAirConditioner]: faAirConditioner,
    [EnumIcon.faAngleDown]: faAngleDown,
    [EnumIcon.faMountains]: faMountains,
    [EnumIcon.faOmega]: faOmega,
    [EnumIcon.faCarTunnel]: faCarTunnel,
    [EnumIcon.faPersonDollyEmpty]: faPersonDollyEmpty,
    [EnumIcon.faPanFood]: faPanFood,
    [EnumIcon.faHeadSideCough]: faHeadSideCough,
    [EnumIcon.faGripLines]: faGripLines,
    [EnumIcon.faThumbsDown]: faThumbsDown,
    [EnumIcon.faUserLock]: faUserLock,
    [EnumIcon.faArrowRightLong]: faArrowRightLong,
    [EnumIcon.faLongArrowRight]: faLongArrowRight,
    [EnumIcon.faTicketsAirline]: faTicketsAirline,
    [EnumIcon.faAnchorCircleXmark]: faAnchorCircleXmark,
    [EnumIcon.faEllipsis]: faEllipsis,
    [EnumIcon.faEllipsisH]: faEllipsisH,
    [EnumIcon.faNfcSlash]: faNfcSlash,
    [EnumIcon.faChessPawn]: faChessPawn,
    [EnumIcon.faKitMedical]: faKitMedical,
    [EnumIcon.faFirstAid]: faFirstAid,
    [EnumIcon.faGrid2Plus]: faGrid2Plus,
    [EnumIcon.faBells]: faBells,
    [EnumIcon.faPersonThroughWindow]: faPersonThroughWindow,
    [EnumIcon.faToolbox]: faToolbox,
    [EnumIcon.faEnvelopeDot]: faEnvelopeDot,
    [EnumIcon.faEnvelopeBadge]: faEnvelopeBadge,
    [EnumIcon.faHandsHoldingCircle]: faHandsHoldingCircle,
    [EnumIcon.faBug]: faBug,
    [EnumIcon.faBowlChopsticks]: faBowlChopsticks,
    [EnumIcon.faCreditCard]: faCreditCard,
    [EnumIcon.faCreditCardAlt]: faCreditCardAlt,
    [EnumIcon.faCircleS]: faCircleS,
    [EnumIcon.faBoxBallot]: faBoxBallot,
    [EnumIcon.faCar]: faCar,
    [EnumIcon.faAutomobile]: faAutomobile,
    [EnumIcon.faHandHoldingHand]: faHandHoldingHand,
    [EnumIcon.faUserTieHair]: faUserTieHair,
    [EnumIcon.faPodiumStar]: faPodiumStar,
    [EnumIcon.faUserHairMullet]: faUserHairMullet,
    [EnumIcon.faBusinessFront]: faBusinessFront,
    [EnumIcon.faPartyBack]: faPartyBack,
    [EnumIcon.faTrianBalbot]: faTrianBalbot,
    [EnumIcon.faMicrophoneStand]: faMicrophoneStand,
    [EnumIcon.faBookOpenReader]: faBookOpenReader,
    [EnumIcon.faBookReader]: faBookReader,
    [EnumIcon.faFamilyDress]: faFamilyDress,
    [EnumIcon.faCircleX]: faCircleX,
    [EnumIcon.faCabin]: faCabin,
    [EnumIcon.faMountainSun]: faMountainSun,
    [EnumIcon.faChartSimpleHorizontal]: faChartSimpleHorizontal,
    [EnumIcon.faBluetooth]: faBluetooth,
    [EnumIcon.faArrowsLeftRightToLine]: faArrowsLeftRightToLine,
    [EnumIcon.faHandBackPointLeft]: faHandBackPointLeft,
    [EnumIcon.faMessageDots]: faMessageDots,
    [EnumIcon.faCommentAltDots]: faCommentAltDots,
    [EnumIcon.faMessaging]: faMessaging,
    [EnumIcon.faFileHeart]: faFileHeart,
    [EnumIcon.faBeerMug]: faBeerMug,
    [EnumIcon.faBeerFoam]: faBeerFoam,
    [EnumIcon.faDiceD20]: faDiceD20,
    [EnumIcon.faDrone]: faDrone,
    [EnumIcon.faTruckDroplet]: faTruckDroplet,
    [EnumIcon.faFileCircleXmark]: faFileCircleXmark,
    [EnumIcon.faTemperatureArrowUp]: faTemperatureArrowUp,
    [EnumIcon.faTemperatureUp]: faTemperatureUp,
    [EnumIcon.faMedal]: faMedal,
    [EnumIcon.faBed]: faBed,
    [EnumIcon.faBookCopy]: faBookCopy,
    [EnumIcon.faSquareH]: faSquareH,
    [EnumIcon.faHSquare]: faHSquare,
    [EnumIcon.faSquareC]: faSquareC,
    [EnumIcon.faClockTwo]: faClockTwo,
    [EnumIcon.faSquareEllipsisVertical]: faSquareEllipsisVertical,
    [EnumIcon.faPodcast]: faPodcast,
    [EnumIcon.faBee]: faBee,
    [EnumIcon.faTemperatureFull]: faTemperatureFull,
    [EnumIcon.faTemperature4]: faTemperature4,
    [EnumIcon.faThermometer4]: faThermometer4,
    [EnumIcon.faThermometerFull]: faThermometerFull,
    [EnumIcon.faBell]: faBell,
    [EnumIcon.faCandyBar]: faCandyBar,
    [EnumIcon.faChocolateBar]: faChocolateBar,
    [EnumIcon.faXmarkLarge]: faXmarkLarge,
    [EnumIcon.faPinata]: faPinata,
    [EnumIcon.faArrowsFromLine]: faArrowsFromLine,
    [EnumIcon.faSuperscript]: faSuperscript,
    [EnumIcon.faBowlSpoon]: faBowlSpoon,
    [EnumIcon.faHexagonCheck]: faHexagonCheck,
    [EnumIcon.faPlugCircleXmark]: faPlugCircleXmark,
    [EnumIcon.faStarOfLife]: faStarOfLife,
    [EnumIcon.faPhoneSlash]: faPhoneSlash,
    [EnumIcon.faTrafficLightStop]: faTrafficLightStop,
    [EnumIcon.faPaintRoller]: faPaintRoller,
    [EnumIcon.faAccentGrave]: faAccentGrave,
    [EnumIcon.faHandshakeAngle]: faHandshakeAngle,
    [EnumIcon.faHandsHelping]: faHandsHelping,
    [EnumIcon.faCircle0]: faCircle0,
    [EnumIcon.faDialMedLow]: faDialMedLow,
    [EnumIcon.faLocationDot]: faLocationDot,
    [EnumIcon.faMapMarkerAlt]: faMapMarkerAlt,
    [EnumIcon.faCrab]: faCrab,
    [EnumIcon.faBoxOpenFull]: faBoxOpenFull,
    [EnumIcon.faBoxFull]: faBoxFull,
    [EnumIcon.faFile]: faFile,
    [EnumIcon.faGreaterThan]: faGreaterThan,
    [EnumIcon.faQuotes]: faQuotes,
    [EnumIcon.faPretzel]: faPretzel,
    [EnumIcon.faPersonSwimming]: faPersonSwimming,
    [EnumIcon.faSwimmer]: faSwimmer,
    [EnumIcon.faArrowDown]: faArrowDown,
    [EnumIcon.faUserRobotXmarks]: faUserRobotXmarks,
    [EnumIcon.faMessageQuote]: faMessageQuote,
    [EnumIcon.faCommentAltQuote]: faCommentAltQuote,
    [EnumIcon.faCandyCorn]: faCandyCorn,
    [EnumIcon.faFolderMagnifyingGlass]: faFolderMagnifyingGlass,
    [EnumIcon.faFolderSearch]: faFolderSearch,
    [EnumIcon.faNotebook]: faNotebook,
    [EnumIcon.faDroplet]: faDroplet,
    [EnumIcon.faTint]: faTint,
    [EnumIcon.faBullseyePointer]: faBullseyePointer,
    [EnumIcon.faEraser]: faEraser,
    [EnumIcon.faHexagonImage]: faHexagonImage,
    [EnumIcon.faEarthAmericas]: faEarthAmericas,
    [EnumIcon.faEarth]: faEarth,
    [EnumIcon.faEarthAmerica]: faEarthAmerica,
    [EnumIcon.faGlobeAmericas]: faGlobeAmericas,
    [EnumIcon.faCrateApple]: faCrateApple,
    [EnumIcon.faAppleCrate]: faAppleCrate,
    [EnumIcon.faPersonBurst]: faPersonBurst,
    [EnumIcon.faGameBoard]: faGameBoard,
    [EnumIcon.faHatChef]: faHatChef,
    [EnumIcon.faHandBackPointRight]: faHandBackPointRight,
    [EnumIcon.faDove]: faDove,
    [EnumIcon.faSnowflakeDroplets]: faSnowflakeDroplets,
    [EnumIcon.faBatteryEmpty]: faBatteryEmpty,
    [EnumIcon.faBattery0]: faBattery0,
    [EnumIcon.faGrid4]: faGrid4,
    [EnumIcon.faSocks]: faSocks,
    [EnumIcon.faFaceSunglasses]: faFaceSunglasses,
    [EnumIcon.faInbox]: faInbox,
    [EnumIcon.faSquare0]: faSquare0,
    [EnumIcon.faSection]: faSection,
    [EnumIcon.faSquareThisWayUp]: faSquareThisWayUp,
    [EnumIcon.faBoxUp]: faBoxUp,
    [EnumIcon.faGaugeHigh]: faGaugeHigh,
    [EnumIcon.faTachometerAlt]: faTachometerAlt,
    [EnumIcon.faTachometerAltFast]: faTachometerAltFast,
    [EnumIcon.faSquareAmpersand]: faSquareAmpersand,
    [EnumIcon.faEnvelopeOpenText]: faEnvelopeOpenText,
    [EnumIcon.faLampDesk]: faLampDesk,
    [EnumIcon.faHospital]: faHospital,
    [EnumIcon.faHospitalAlt]: faHospitalAlt,
    [EnumIcon.faHospitalWide]: faHospitalWide,
    [EnumIcon.faPollPeople]: faPollPeople,
    [EnumIcon.faWhiskeyGlassIce]: faWhiskeyGlassIce,
    [EnumIcon.faGlassWhiskeyRocks]: faGlassWhiskeyRocks,
    [EnumIcon.faWineBottle]: faWineBottle,
    [EnumIcon.faChessRook]: faChessRook,
    [EnumIcon.faUserBountyHunter]: faUserBountyHunter,
    [EnumIcon.faBarsStaggered]: faBarsStaggered,
    [EnumIcon.faReorder]: faReorder,
    [EnumIcon.faStream]: faStream,
    [EnumIcon.faDiagramSankey]: faDiagramSankey,
    [EnumIcon.faCloudHailMixed]: faCloudHailMixed,
    [EnumIcon.faCircleUpLeft]: faCircleUpLeft,
    [EnumIcon.faDharmachakra]: faDharmachakra,
    [EnumIcon.faObjectsAlignLeft]: faObjectsAlignLeft,
    [EnumIcon.faOilCanDrip]: faOilCanDrip,
    [EnumIcon.faFaceSmilingHands]: faFaceSmilingHands,
    [EnumIcon.faBroccoli]: faBroccoli,
    [EnumIcon.faRouteInterstate]: faRouteInterstate,
    [EnumIcon.faEarMuffs]: faEarMuffs,
    [EnumIcon.faHotdog]: faHotdog,
    [EnumIcon.faTransporterEmpty]: faTransporterEmpty,
    [EnumIcon.faPersonWalkingWithCane]: faPersonWalkingWithCane,
    [EnumIcon.faBlind]: faBlind,
    [EnumIcon.faAngle90]: faAngle90,
    [EnumIcon.faRectangleTerminal]: faRectangleTerminal,
    [EnumIcon.faKite]: faKite,
    [EnumIcon.faDrum]: faDrum,
    [EnumIcon.faScrubber]: faScrubber,
    [EnumIcon.faIceCream]: faIceCream,
    [EnumIcon.faHeartCircleBolt]: faHeartCircleBolt,
    [EnumIcon.faFishBones]: faFishBones,
    [EnumIcon.faDeerRudolph]: faDeerRudolph,
    [EnumIcon.faFax]: faFax,
    [EnumIcon.faParagraph]: faParagraph,
    [EnumIcon.faHeadSideHeart]: faHeadSideHeart,
    [EnumIcon.faSquareE]: faSquareE,
    [EnumIcon.faMeterFire]: faMeterFire,
    [EnumIcon.faCloudHail]: faCloudHail,
    [EnumIcon.faCheckToSlot]: faCheckToSlot,
    [EnumIcon.faVoteYea]: faVoteYea,
    [EnumIcon.faMoneyFromBracket]: faMoneyFromBracket,
    [EnumIcon.faStarHalf]: faStarHalf,
    [EnumIcon.faCarBus]: faCarBus,
    [EnumIcon.faSpeaker]: faSpeaker,
    [EnumIcon.faTimer]: faTimer,
    [EnumIcon.faBoxesStacked]: faBoxesStacked,
    [EnumIcon.faBoxes]: faBoxes,
    [EnumIcon.faBoxesAlt]: faBoxesAlt,
    [EnumIcon.faGrillHot]: faGrillHot,
    [EnumIcon.faBallotCheck]: faBallotCheck,
    [EnumIcon.faLink]: faLink,
    [EnumIcon.faChain]: faChain,
    [EnumIcon.faEarListen]: faEarListen,
    [EnumIcon.faAssistiveListeningSystems]: faAssistiveListeningSystems,
    [EnumIcon.faFileMinus]: faFileMinus,
    [EnumIcon.faTreeCity]: faTreeCity,
    [EnumIcon.faPlay]: faPlay,
    [EnumIcon.faFont]: faFont,
    [EnumIcon.faCupTogo]: faCupTogo,
    [EnumIcon.faCoffeeTogo]: faCoffeeTogo,
    [EnumIcon.faSquareDownLeft]: faSquareDownLeft,
    [EnumIcon.faBurgerLettuce]: faBurgerLettuce,
    [EnumIcon.faRupiahSign]: faRupiahSign,
    [EnumIcon.faMagnifyingGlass]: faMagnifyingGlass,
    [EnumIcon.faSearch]: faSearch,
    [EnumIcon.faTableTennisPaddleBall]: faTableTennisPaddleBall,
    [EnumIcon.faPingPongPaddleBall]: faPingPongPaddleBall,
    [EnumIcon.faTableTennis]: faTableTennis,
    [EnumIcon.faPersonDotsFromLine]: faPersonDotsFromLine,
    [EnumIcon.faDiagnoses]: faDiagnoses,
    [EnumIcon.faChevronsDown]: faChevronsDown,
    [EnumIcon.faChevronDoubleDown]: faChevronDoubleDown,
    [EnumIcon.faTrashCanArrowUp]: faTrashCanArrowUp,
    [EnumIcon.faTrashRestoreAlt]: faTrashRestoreAlt,
    [EnumIcon.faSignalGood]: faSignalGood,
    [EnumIcon.faSignal3]: faSignal3,
    [EnumIcon.faLocationQuestion]: faLocationQuestion,
    [EnumIcon.faMapMarkerQuestion]: faMapMarkerQuestion,
    [EnumIcon.faFloppyDiskCircleXmark]: faFloppyDiskCircleXmark,
    [EnumIcon.faFloppyDiskTimes]: faFloppyDiskTimes,
    [EnumIcon.faSaveCircleXmark]: faSaveCircleXmark,
    [EnumIcon.faSaveTimes]: faSaveTimes,
    [EnumIcon.faNairaSign]: faNairaSign,
    [EnumIcon.faPeach]: faPeach,
    [EnumIcon.faTaxiBus]: faTaxiBus,
    [EnumIcon.faBracketCurly]: faBracketCurly,
    [EnumIcon.faBracketCurlyLeft]: faBracketCurlyLeft,
    [EnumIcon.faLobster]: faLobster,
    [EnumIcon.faCartFlatbedEmpty]: faCartFlatbedEmpty,
    [EnumIcon.faDollyFlatbedEmpty]: faDollyFlatbedEmpty,
    [EnumIcon.faColon]: faColon,
    [EnumIcon.faCartArrowDown]: faCartArrowDown,
    [EnumIcon.faWand]: faWand,
    [EnumIcon.faWalkieTalkie]: faWalkieTalkie,
    [EnumIcon.faFilePen]: faFilePen,
    [EnumIcon.faFileEdit]: faFileEdit,
    [EnumIcon.faReceipt]: faReceipt,
    [EnumIcon.faTablePicnic]: faTablePicnic,
    [EnumIcon.faSquarePen]: faSquarePen,
    [EnumIcon.faPenSquare]: faPenSquare,
    [EnumIcon.faPencilSquare]: faPencilSquare,
    [EnumIcon.faCircleMicrophoneLines]: faCircleMicrophoneLines,
    [EnumIcon.faMicrophoneCircleAlt]: faMicrophoneCircleAlt,
    [EnumIcon.faDisplaySlash]: faDisplaySlash,
    [EnumIcon.faDesktopSlash]: faDesktopSlash,
    [EnumIcon.faSuitcaseRolling]: faSuitcaseRolling,
    [EnumIcon.faPersonCircleExclamation]: faPersonCircleExclamation,
    [EnumIcon.faTransporter2]: faTransporter2,
    [EnumIcon.faHandsHoldingDiamond]: faHandsHoldingDiamond,
    [EnumIcon.faHandReceiving]: faHandReceiving,
    [EnumIcon.faMoneyBillSimpleWave]: faMoneyBillSimpleWave,
    [EnumIcon.faChevronDown]: faChevronDown,
    [EnumIcon.faBatteryFull]: faBatteryFull,
    [EnumIcon.faBattery]: faBattery,
    [EnumIcon.faBattery5]: faBattery5,
    [EnumIcon.faBellPlus]: faBellPlus,
    [EnumIcon.faBookArrowRight]: faBookArrowRight,
    [EnumIcon.faHospitals]: faHospitals,
    [EnumIcon.faClub]: faClub,
    [EnumIcon.faSkullCrossbones]: faSkullCrossbones,
    [EnumIcon.faDropletDegree]: faDropletDegree,
    [EnumIcon.faDewpoint]: faDewpoint,
    [EnumIcon.faCodeCompare]: faCodeCompare,
    [EnumIcon.faListUl]: faListUl,
    [EnumIcon.faListDots]: faListDots,
    [EnumIcon.faHandHoldingMagic]: faHandHoldingMagic,
    [EnumIcon.faWatermelonSlice]: faWatermelonSlice,
    [EnumIcon.faCircleEllipsis]: faCircleEllipsis,
    [EnumIcon.faSchoolLock]: faSchoolLock,
    [EnumIcon.faTowerCell]: faTowerCell,
    [EnumIcon.faSdCards]: faSdCards,
    [EnumIcon.faDownLong]: faDownLong,
    [EnumIcon.faLongArrowAltDown]: faLongArrowAltDown,
    [EnumIcon.faEnvelopes]: faEnvelopes,
    [EnumIcon.faPhoneOffice]: faPhoneOffice,
    [EnumIcon.faRankingStar]: faRankingStar,
    [EnumIcon.faChessKing]: faChessKing,
    [EnumIcon.faNfcPen]: faNfcPen,
    [EnumIcon.faPersonHarassing]: faPersonHarassing,
    [EnumIcon.faHatWinter]: faHatWinter,
    [EnumIcon.faBrazilianRealSign]: faBrazilianRealSign,
    [EnumIcon.faLandmarkDome]: faLandmarkDome,
    [EnumIcon.faLandmarkAlt]: faLandmarkAlt,
    [EnumIcon.faBoneBreak]: faBoneBreak,
    [EnumIcon.faArrowUp]: faArrowUp,
    [EnumIcon.faDownFromDottedLine]: faDownFromDottedLine,
    [EnumIcon.faTv]: faTv,
    [EnumIcon.faTelevision]: faTelevision,
    [EnumIcon.faTvAlt]: faTvAlt,
    [EnumIcon.faBorderLeft]: faBorderLeft,
    [EnumIcon.faCircleDivide]: faCircleDivide,
    [EnumIcon.faShrimp]: faShrimp,
    [EnumIcon.faListCheck]: faListCheck,
    [EnumIcon.faTasks]: faTasks,
    [EnumIcon.faDiagramSubtask]: faDiagramSubtask,
    [EnumIcon.faJugDetergent]: faJugDetergent,
    [EnumIcon.faCircleUser]: faCircleUser,
    [EnumIcon.faUserCircle]: faUserCircle,
    [EnumIcon.faSquareY]: faSquareY,
    [EnumIcon.faUserDoctorHair]: faUserDoctorHair,
    [EnumIcon.faPlanetRinged]: faPlanetRinged,
    [EnumIcon.faMushroom]: faMushroom,
    [EnumIcon.faUserShield]: faUserShield,
    [EnumIcon.faMegaphone]: faMegaphone,
    [EnumIcon.faCircleExclamationCheck]: faCircleExclamationCheck,
    [EnumIcon.faWind]: faWind,
    [EnumIcon.faBoxDollar]: faBoxDollar,
    [EnumIcon.faBoxUsd]: faBoxUsd,
    [EnumIcon.faCarBurst]: faCarBurst,
    [EnumIcon.faCarCrash]: faCarCrash,
    [EnumIcon.faY]: faY,
    [EnumIcon.faUserHeadset]: faUserHeadset,
    [EnumIcon.faArrowsRetweet]: faArrowsRetweet,
    [EnumIcon.faRetweetAlt]: faRetweetAlt,
    [EnumIcon.faPersonSnowboarding]: faPersonSnowboarding,
    [EnumIcon.faSnowboarding]: faSnowboarding,
    [EnumIcon.faSquareChevronRight]: faSquareChevronRight,
    [EnumIcon.faChevronSquareRight]: faChevronSquareRight,
    [EnumIcon.faLacrosseStickBall]: faLacrosseStickBall,
    [EnumIcon.faTruckFast]: faTruckFast,
    [EnumIcon.faShippingFast]: faShippingFast,
    [EnumIcon.faUserMagnifyingGlass]: faUserMagnifyingGlass,
    [EnumIcon.faStarSharp]: faStarSharp,
    [EnumIcon.faCommentHeart]: faCommentHeart,
    [EnumIcon.faCircle1]: faCircle1,
    [EnumIcon.faCircleStar]: faCircleStar,
    [EnumIcon.faStarCircle]: faStarCircle,
    [EnumIcon.faFish]: faFish,
    [EnumIcon.faCloudFog]: faCloudFog,
    [EnumIcon.faFog]: faFog,
    [EnumIcon.faWaffle]: faWaffle,
    [EnumIcon.faMusicNote]: faMusicNote,
    [EnumIcon.faMusicAlt]: faMusicAlt,
    [EnumIcon.faHexagonExclamation]: faHexagonExclamation,
    [EnumIcon.faCartShoppingFast]: faCartShoppingFast,
    [EnumIcon.faObjectUnion]: faObjectUnion,
    [EnumIcon.faUserGraduate]: faUserGraduate,
    [EnumIcon.faStarfighter]: faStarfighter,
    [EnumIcon.faCircleHalfStroke]: faCircleHalfStroke,
    [EnumIcon.faAdjust]: faAdjust,
    [EnumIcon.faArrowRightLongToLine]: faArrowRightLongToLine,
    [EnumIcon.faSquareArrowDown]: faSquareArrowDown,
    [EnumIcon.faArrowSquareDown]: faArrowSquareDown,
    [EnumIcon.faDiamondHalfStroke]: faDiamondHalfStroke,
    [EnumIcon.faClapperboard]: faClapperboard,
    [EnumIcon.faSquareChevronLeft]: faSquareChevronLeft,
    [EnumIcon.faChevronSquareLeft]: faChevronSquareLeft,
    [EnumIcon.faPhoneIntercom]: faPhoneIntercom,
    [EnumIcon.faLinkHorizontal]: faLinkHorizontal,
    [EnumIcon.faChainHorizontal]: faChainHorizontal,
    [EnumIcon.faMango]: faMango,
    [EnumIcon.faMusicNoteSlash]: faMusicNoteSlash,
    [EnumIcon.faMusicAltSlash]: faMusicAltSlash,
    [EnumIcon.faCircleRadiation]: faCircleRadiation,
    [EnumIcon.faRadiationAlt]: faRadiationAlt,
    [EnumIcon.faFaceTongueSweat]: faFaceTongueSweat,
    [EnumIcon.faGlobeStand]: faGlobeStand,
    [EnumIcon.faBaseball]: faBaseball,
    [EnumIcon.faBaseballBall]: faBaseballBall,
    [EnumIcon.faCircleP]: faCircleP,
    [EnumIcon.faAwardSimple]: faAwardSimple,
    [EnumIcon.faJetFighterUp]: faJetFighterUp,
    [EnumIcon.faDiagramProject]: faDiagramProject,
    [EnumIcon.faProjectDiagram]: faProjectDiagram,
    [EnumIcon.faPedestal]: faPedestal,
    [EnumIcon.faChartPyramid]: faChartPyramid,
    [EnumIcon.faSidebar]: faSidebar,
    [EnumIcon.faSnowmanHead]: faSnowmanHead,
    [EnumIcon.faFrostyHead]: faFrostyHead,
    [EnumIcon.faCopy]: faCopy,
    [EnumIcon.faBurgerGlass]: faBurgerGlass,
    [EnumIcon.faVolumeXmark]: faVolumeXmark,
    [EnumIcon.faVolumeMute]: faVolumeMute,
    [EnumIcon.faVolumeTimes]: faVolumeTimes,
    [EnumIcon.faHandSparkles]: faHandSparkles,
    [EnumIcon.faBarsFilter]: faBarsFilter,
    [EnumIcon.faPaintbrushPencil]: faPaintbrushPencil,
    [EnumIcon.faPartyBell]: faPartyBell,
    [EnumIcon.faUserVneckHair]: faUserVneckHair,
    [EnumIcon.faJackOLantern]: faJackOLantern,
    [EnumIcon.faGrip]: faGrip,
    [EnumIcon.faGripHorizontal]: faGripHorizontal,
    [EnumIcon.faShareFromSquare]: faShareFromSquare,
    [EnumIcon.faShareSquare]: faShareSquare,
    [EnumIcon.faKeynote]: faKeynote,
    [EnumIcon.faChildCombatant]: faChildCombatant,
    [EnumIcon.faChildRifle]: faChildRifle,
    [EnumIcon.faGun]: faGun,
    [EnumIcon.faSquarePhone]: faSquarePhone,
    [EnumIcon.faPhoneSquare]: faPhoneSquare,
    [EnumIcon.faPlus]: faPlus,
    [EnumIcon.faAdd]: faAdd,
    [EnumIcon.faExpand]: faExpand,
    [EnumIcon.faComputer]: faComputer,
    [EnumIcon.faFort]: faFort,
    [EnumIcon.faCloudCheck]: faCloudCheck,
    [EnumIcon.faXmark]: faXmark,
    [EnumIcon.faClose]: faClose,
    [EnumIcon.faMultiply]: faMultiply,
    [EnumIcon.faRemove]: faRemove,
    [EnumIcon.faTimes]: faTimes,
    [EnumIcon.faFaceSmirking]: faFaceSmirking,
    [EnumIcon.faArrowsUpDownLeftRight]: faArrowsUpDownLeftRight,
    [EnumIcon.faArrows]: faArrows,
    [EnumIcon.faChalkboardUser]: faChalkboardUser,
    [EnumIcon.faChalkboardTeacher]: faChalkboardTeacher,
    [EnumIcon.faRhombus]: faRhombus,
    [EnumIcon.faClawMarks]: faClawMarks,
    [EnumIcon.faPesoSign]: faPesoSign,
    [EnumIcon.faFaceSmileTongue]: faFaceSmileTongue,
    [EnumIcon.faCartCircleXmark]: faCartCircleXmark,
    [EnumIcon.faBuildingShield]: faBuildingShield,
    [EnumIcon.faCirclePhoneFlip]: faCirclePhoneFlip,
    [EnumIcon.faPhoneCircleAlt]: faPhoneCircleAlt,
    [EnumIcon.faBaby]: faBaby,
    [EnumIcon.faUsersLine]: faUsersLine,
    [EnumIcon.faQuoteLeft]: faQuoteLeft,
    [EnumIcon.faQuoteLeftAlt]: faQuoteLeftAlt,
    [EnumIcon.faTractor]: faTractor,
    [EnumIcon.faKeySkeleton]: faKeySkeleton,
    [EnumIcon.faTrashArrowUp]: faTrashArrowUp,
    [EnumIcon.faTrashRestore]: faTrashRestore,
    [EnumIcon.faArrowDownUpLock]: faArrowDownUpLock,
    [EnumIcon.faArrowDownToBracket]: faArrowDownToBracket,
    [EnumIcon.faLinesLeaning]: faLinesLeaning,
    [EnumIcon.faSquareQ]: faSquareQ,
    [EnumIcon.faRulerCombined]: faRulerCombined,
    [EnumIcon.faSymbols]: faSymbols,
    [EnumIcon.faIconsAlt]: faIconsAlt,
    [EnumIcon.faCopyright]: faCopyright,
    [EnumIcon.faHighlighterLine]: faHighlighterLine,
    [EnumIcon.faBracketSquare]: faBracketSquare,
    [EnumIcon.faBracket]: faBracket,
    [EnumIcon.faBracketLeft]: faBracketLeft,
    [EnumIcon.faIslandTropical]: faIslandTropical,
    [EnumIcon.faIslandTreePalm]: faIslandTreePalm,
    [EnumIcon.faArrowRightFromLine]: faArrowRightFromLine,
    [EnumIcon.faArrowFromLeft]: faArrowFromLeft,
    [EnumIcon.faH2]: faH2,
    [EnumIcon.faEquals]: faEquals,
    [EnumIcon.faCakeSlice]: faCakeSlice,
    [EnumIcon.faShortcake]: faShortcake,
    [EnumIcon.faPeanut]: faPeanut,
    [EnumIcon.faWrenchSimple]: faWrenchSimple,
    [EnumIcon.faBlender]: faBlender,
    [EnumIcon.faTeeth]: faTeeth,
    [EnumIcon.faTally2]: faTally2,
    [EnumIcon.faShekelSign]: faShekelSign,
    [EnumIcon.faIls]: faIls,
    [EnumIcon.faShekel]: faShekel,
    [EnumIcon.faSheqel]: faSheqel,
    [EnumIcon.faSheqelSign]: faSheqelSign,
    [EnumIcon.faCars]: faCars,
    [EnumIcon.faAxeBattle]: faAxeBattle,
    [EnumIcon.faUserHairLong]: faUserHairLong,
    [EnumIcon.faMap]: faMap,
    [EnumIcon.faFileCircleInfo]: faFileCircleInfo,
    [EnumIcon.faFaceDisappointed]: faFaceDisappointed,
    [EnumIcon.faLassoSparkles]: faLassoSparkles,
    [EnumIcon.faClockEleven]: faClockEleven,
    [EnumIcon.faRocket]: faRocket,
    [EnumIcon.faSirenOn]: faSirenOn,
    [EnumIcon.faClockTen]: faClockTen,
    [EnumIcon.faCandleHolder]: faCandleHolder,
    [EnumIcon.faVideoArrowDownLeft]: faVideoArrowDownLeft,
    [EnumIcon.faPhotoFilm]: faPhotoFilm,
    [EnumIcon.faPhotoVideo]: faPhotoVideo,
    [EnumIcon.faFloppyDiskCircleArrowRight]: faFloppyDiskCircleArrowRight,
    [EnumIcon.faSaveCircleArrowRight]: faSaveCircleArrowRight,
    [EnumIcon.faFolderMinus]: faFolderMinus,
    [EnumIcon.faPlanetMoon]: faPlanetMoon,
    [EnumIcon.faFaceEyesXmarks]: faFaceEyesXmarks,
    [EnumIcon.faChartScatter]: faChartScatter,
    [EnumIcon.faDisplayArrowDown]: faDisplayArrowDown,
    [EnumIcon.faStore]: faStore,
    [EnumIcon.faArrowTrendUp]: faArrowTrendUp,
    [EnumIcon.faPlugCircleMinus]: faPlugCircleMinus,
    [EnumIcon.faOliveBranch]: faOliveBranch,
    [EnumIcon.faAngle]: faAngle,
    [EnumIcon.faVacuumRobot]: faVacuumRobot,
    [EnumIcon.faSignHanging]: faSignHanging,
    [EnumIcon.faSign]: faSign,
    [EnumIcon.faSquareDivide]: faSquareDivide,
    [EnumIcon.faSignalStreamSlash]: faSignalStreamSlash,
    [EnumIcon.faBezierCurve]: faBezierCurve,
    [EnumIcon.faEyeDropperHalf]: faEyeDropperHalf,
    [EnumIcon.faStoreLock]: faStoreLock,
    [EnumIcon.faBellSlash]: faBellSlash,
    [EnumIcon.faCloudBoltSun]: faCloudBoltSun,
    [EnumIcon.faThunderstormSun]: faThunderstormSun,
    [EnumIcon.faCameraSlash]: faCameraSlash,
    [EnumIcon.faCommentQuote]: faCommentQuote,
    [EnumIcon.faTablet]: faTablet,
    [EnumIcon.faTabletAndroid]: faTabletAndroid,
    [EnumIcon.faSchoolFlag]: faSchoolFlag,
    [EnumIcon.faMessageCode]: faMessageCode,
    [EnumIcon.faGlassHalf]: faGlassHalf,
    [EnumIcon.faGlassHalfEmpty]: faGlassHalfEmpty,
    [EnumIcon.faGlassHalfFull]: faGlassHalfFull,
    [EnumIcon.faFill]: faFill,
    [EnumIcon.faMessageMinus]: faMessageMinus,
    [EnumIcon.faCommentAltMinus]: faCommentAltMinus,
    [EnumIcon.faAngleUp]: faAngleUp,
    [EnumIcon.faDrumstickBite]: faDrumstickBite,
    [EnumIcon.faLinkHorizontalSlash]: faLinkHorizontalSlash,
    [EnumIcon.faChainHorizontalSlash]: faChainHorizontalSlash,
    [EnumIcon.faHollyBerry]: faHollyBerry,
    [EnumIcon.faNose]: faNose,
    [EnumIcon.faChevronLeft]: faChevronLeft,
    [EnumIcon.faBacteria]: faBacteria,
    [EnumIcon.faClouds]: faClouds,
    [EnumIcon.faMoneyBillSimple]: faMoneyBillSimple,
    [EnumIcon.faHandLizard]: faHandLizard,
    [EnumIcon.faTablePivot]: faTablePivot,
    [EnumIcon.faFilterSlash]: faFilterSlash,
    [EnumIcon.faTrashCanUndo]: faTrashCanUndo,
    [EnumIcon.faTrashCanArrowTurnLeft]: faTrashCanArrowTurnLeft,
    [EnumIcon.faTrashUndoAlt]: faTrashUndoAlt,
    [EnumIcon.faNotdef]: faNotdef,
    [EnumIcon.faDisease]: faDisease,
    [EnumIcon.faPersonToDoor]: faPersonToDoor,
    [EnumIcon.faTurntable]: faTurntable,
    [EnumIcon.faBriefcaseMedical]: faBriefcaseMedical,
    [EnumIcon.faGenderless]: faGenderless,
    [EnumIcon.faChevronRight]: faChevronRight,
    [EnumIcon.faSignalWeak]: faSignalWeak,
    [EnumIcon.faSignal1]: faSignal1,
    [EnumIcon.faClockFive]: faClockFive,
    [EnumIcon.faRetweet]: faRetweet,
    [EnumIcon.faCarRear]: faCarRear,
    [EnumIcon.faCarAlt]: faCarAlt,
    [EnumIcon.faPumpSoap]: faPumpSoap,
    [EnumIcon.faComputerClassic]: faComputerClassic,
    [EnumIcon.faFrame]: faFrame,
    [EnumIcon.faVideoSlash]: faVideoSlash,
    [EnumIcon.faBatteryQuarter]: faBatteryQuarter,
    [EnumIcon.faBattery2]: faBattery2,
    [EnumIcon.faEllipsisStroke]: faEllipsisStroke,
    [EnumIcon.faEllipsisHAlt]: faEllipsisHAlt,
    [EnumIcon.faRadio]: faRadio,
    [EnumIcon.faBabyCarriage]: faBabyCarriage,
    [EnumIcon.faCarriageBaby]: faCarriageBaby,
    [EnumIcon.faFaceExpressionless]: faFaceExpressionless,
    [EnumIcon.faDownToDottedLine]: faDownToDottedLine,
    [EnumIcon.faCloudMusic]: faCloudMusic,
    [EnumIcon.faTrafficLight]: faTrafficLight,
    [EnumIcon.faCloudMinus]: faCloudMinus,
    [EnumIcon.faThermometer]: faThermometer,
    [EnumIcon.faShieldMinus]: faShieldMinus,
    [EnumIcon.faVrCardboard]: faVrCardboard,
    [EnumIcon.faCarTilt]: faCarTilt,
    [EnumIcon.faGaugeCircleMinus]: faGaugeCircleMinus,
    [EnumIcon.faBrightnessLow]: faBrightnessLow,
    [EnumIcon.faHandMiddleFinger]: faHandMiddleFinger,
    [EnumIcon.faPercent]: faPercent,
    [EnumIcon.faPercentage]: faPercentage,
    [EnumIcon.faTruckMoving]: faTruckMoving,
    [EnumIcon.faGlassWaterDroplet]: faGlassWaterDroplet,
    [EnumIcon.faConveyorBelt]: faConveyorBelt,
    [EnumIcon.faLocationCheck]: faLocationCheck,
    [EnumIcon.faMapMarkerCheck]: faMapMarkerCheck,
    [EnumIcon.faCoinVertical]: faCoinVertical,
    [EnumIcon.faDisplay]: faDisplay,
    [EnumIcon.faPersonSign]: faPersonSign,
    [EnumIcon.faFaceSmile]: faFaceSmile,
    [EnumIcon.faSmile]: faSmile,
    [EnumIcon.faPhoneHangup]: faPhoneHangup,
    [EnumIcon.faSignatureSlash]: faSignatureSlash,
    [EnumIcon.faThumbtack]: faThumbtack,
    [EnumIcon.faThumbTack]: faThumbTack,
    [EnumIcon.faWheatSlash]: faWheatSlash,
    [EnumIcon.faTrophy]: faTrophy,
    [EnumIcon.faCloudsSun]: faCloudsSun,
    [EnumIcon.faPersonPraying]: faPersonPraying,
    [EnumIcon.faPray]: faPray,
    [EnumIcon.faHammer]: faHammer,
    [EnumIcon.faFaceVomit]: faFaceVomit,
    [EnumIcon.faSpeakers]: faSpeakers,
    [EnumIcon.faTtyAnswer]: faTtyAnswer,
    [EnumIcon.faTeletypeAnswer]: faTeletypeAnswer,
    [EnumIcon.faMugTeaSaucer]: faMugTeaSaucer,
    [EnumIcon.faDiagramLeanCanvas]: faDiagramLeanCanvas,
    [EnumIcon.faAlt]: faAlt,
    [EnumIcon.faDial]: faDial,
    [EnumIcon.faDialMedHigh]: faDialMedHigh,
    [EnumIcon.faHandPeace]: faHandPeace,
    [EnumIcon.faCircleTrash]: faCircleTrash,
    [EnumIcon.faTrashCircle]: faTrashCircle,
    [EnumIcon.faRotate]: faRotate,
    [EnumIcon.faSyncAlt]: faSyncAlt,
    [EnumIcon.faCircleQuarters]: faCircleQuarters,
    [EnumIcon.faSpinner]: faSpinner,
    [EnumIcon.faTowerControl]: faTowerControl,
    [EnumIcon.faArrowUpTriangleSquare]: faArrowUpTriangleSquare,
    [EnumIcon.faSortShapesUp]: faSortShapesUp,
    [EnumIcon.faWhale]: faWhale,
    [EnumIcon.faRobot]: faRobot,
    [EnumIcon.faPeace]: faPeace,
    [EnumIcon.faPartyHorn]: faPartyHorn,
    [EnumIcon.faGears]: faGears,
    [EnumIcon.faCogs]: faCogs,
    [EnumIcon.faSunBright]: faSunBright,
    [EnumIcon.faSunAlt]: faSunAlt,
    [EnumIcon.faWarehouse]: faWarehouse,
    [EnumIcon.faLockKeyholeOpen]: faLockKeyholeOpen,
    [EnumIcon.faLockOpenAlt]: faLockOpenAlt,
    [EnumIcon.faSquareFragile]: faSquareFragile,
    [EnumIcon.faBoxFragile]: faBoxFragile,
    [EnumIcon.faSquareWineGlassCrack]: faSquareWineGlassCrack,
    [EnumIcon.faArrowUpRightDots]: faArrowUpRightDots,
    [EnumIcon.faSquareN]: faSquareN,
    [EnumIcon.faSplotch]: faSplotch,
    [EnumIcon.faFaceGrinHearts]: faFaceGrinHearts,
    [EnumIcon.faGrinHearts]: faGrinHearts,
    [EnumIcon.faMeter]: faMeter,
    [EnumIcon.faMandolin]: faMandolin,
    [EnumIcon.faDiceFour]: faDiceFour,
    [EnumIcon.faSimCard]: faSimCard,
    [EnumIcon.faTransgender]: faTransgender,
    [EnumIcon.faTransgenderAlt]: faTransgenderAlt,
    [EnumIcon.faMercury]: faMercury,
    [EnumIcon.faUpFromBracket]: faUpFromBracket,
    [EnumIcon.faKnifeKitchen]: faKnifeKitchen,
    [EnumIcon.faBorderRight]: faBorderRight,
    [EnumIcon.faArrowTurnDown]: faArrowTurnDown,
    [EnumIcon.faLevelDown]: faLevelDown,
    [EnumIcon.faSpade]: faSpade,
    [EnumIcon.faCardSpade]: faCardSpade,
    [EnumIcon.faLineColumns]: faLineColumns,
    [EnumIcon.faArrowRightToLine]: faArrowRightToLine,
    [EnumIcon.faArrowToRight]: faArrowToRight,
    [EnumIcon.faPersonFallingBurst]: faPersonFallingBurst,
    [EnumIcon.faFlagPennant]: faFlagPennant,
    [EnumIcon.faPennant]: faPennant,
    [EnumIcon.faConveyorBeltEmpty]: faConveyorBeltEmpty,
    [EnumIcon.faAward]: faAward,
    [EnumIcon.faTicketSimple]: faTicketSimple,
    [EnumIcon.faTicketAlt]: faTicketAlt,
    [EnumIcon.faBuilding]: faBuilding,
    [EnumIcon.faAnglesLeft]: faAnglesLeft,
    [EnumIcon.faAngleDoubleLeft]: faAngleDoubleLeft,
    [EnumIcon.faCamcorder]: faCamcorder,
    [EnumIcon.faVideoHandheld]: faVideoHandheld,
    [EnumIcon.faPancakes]: faPancakes,
    [EnumIcon.faAlbumCircleUser]: faAlbumCircleUser,
    [EnumIcon.faQrcode]: faQrcode,
    [EnumIcon.faDiceD10]: faDiceD10,
    [EnumIcon.faFireplace]: faFireplace,
    [EnumIcon.faBrowser]: faBrowser,
    [EnumIcon.faPenPaintbrush]: faPenPaintbrush,
    [EnumIcon.faPencilPaintbrush]: faPencilPaintbrush,
    [EnumIcon.faFishCooked]: faFishCooked,
    [EnumIcon.faChairOffice]: faChairOffice,
    [EnumIcon.faNestingDolls]: faNestingDolls,
    [EnumIcon.faClockRotateLeft]: faClockRotateLeft,
    [EnumIcon.faHistory]: faHistory,
    [EnumIcon.faTrumpet]: faTrumpet,
    [EnumIcon.faFaceGrinBeamSweat]: faFaceGrinBeamSweat,
    [EnumIcon.faGrinBeamSweat]: faGrinBeamSweat,
    [EnumIcon.faFireSmoke]: faFireSmoke,
    [EnumIcon.faPhoneMissed]: faPhoneMissed,
    [EnumIcon.faFileExport]: faFileExport,
    [EnumIcon.faArrowRightFromFile]: faArrowRightFromFile,
    [EnumIcon.faShield]: faShield,
    [EnumIcon.faShieldBlank]: faShieldBlank,
    [EnumIcon.faArrowUpShortWide]: faArrowUpShortWide,
    [EnumIcon.faSortAmountUpAlt]: faSortAmountUpAlt,
    [EnumIcon.faArrowsRepeat1]: faArrowsRepeat1,
    [EnumIcon.faRepeat1Alt]: faRepeat1Alt,
    [EnumIcon.faGunSlash]: faGunSlash,
    [EnumIcon.faAvocado]: faAvocado,
    [EnumIcon.faBinary]: faBinary,
    [EnumIcon.faGlassesRound]: faGlassesRound,
    [EnumIcon.faGlassesAlt]: faGlassesAlt,
    [EnumIcon.faPhonePlus]: faPhonePlus,
    [EnumIcon.faDitto]: faDitto,
    [EnumIcon.faPersonSeat]: faPersonSeat,
    [EnumIcon.faHouseMedical]: faHouseMedical,
    [EnumIcon.faGolfBallTee]: faGolfBallTee,
    [EnumIcon.faGolfBall]: faGolfBall,
    [EnumIcon.faCircleChevronLeft]: faCircleChevronLeft,
    [EnumIcon.faChevronCircleLeft]: faChevronCircleLeft,
    [EnumIcon.faHouseChimneyWindow]: faHouseChimneyWindow,
    [EnumIcon.faScythe]: faScythe,
    [EnumIcon.faPenNib]: faPenNib,
    [EnumIcon.faBanParking]: faBanParking,
    [EnumIcon.faParkingCircleSlash]: faParkingCircleSlash,
    [EnumIcon.faTentArrowTurnLeft]: faTentArrowTurnLeft,
    [EnumIcon.faFaceDiagonalMouth]: faFaceDiagonalMouth,
    [EnumIcon.faDiagramCells]: faDiagramCells,
    [EnumIcon.faCricketBatBall]: faCricketBatBall,
    [EnumIcon.faCricket]: faCricket,
    [EnumIcon.faTents]: faTents,
    [EnumIcon.faWandMagic]: faWandMagic,
    [EnumIcon.faMagic]: faMagic,
    [EnumIcon.faDog]: faDog,
    [EnumIcon.faPenLine]: faPenLine,
    [EnumIcon.faAtomSimple]: faAtomSimple,
    [EnumIcon.faAtomAlt]: faAtomAlt,
    [EnumIcon.faAmpersand]: faAmpersand,
    [EnumIcon.faCarrot]: faCarrot,
    [EnumIcon.faArrowUpFromLine]: faArrowUpFromLine,
    [EnumIcon.faArrowFromBottom]: faArrowFromBottom,
    [EnumIcon.faMoon]: faMoon,
    [EnumIcon.faPenSlash]: faPenSlash,
    [EnumIcon.faWineGlassEmpty]: faWineGlassEmpty,
    [EnumIcon.faWineGlassAlt]: faWineGlassAlt,
    [EnumIcon.faSquareStar]: faSquareStar,
    [EnumIcon.faCheese]: faCheese,
    [EnumIcon.faSendBackward]: faSendBackward,
    [EnumIcon.faYinYang]: faYinYang,
    [EnumIcon.faMusic]: faMusic,
    [EnumIcon.faCompassSlash]: faCompassSlash,
    [EnumIcon.faClockOne]: faClockOne,
    [EnumIcon.faFileMusic]: faFileMusic,
    [EnumIcon.faCodeCommit]: faCodeCommit,
    [EnumIcon.faTemperatureLow]: faTemperatureLow,
    [EnumIcon.faPersonBiking]: faPersonBiking,
    [EnumIcon.faBiking]: faBiking,
    [EnumIcon.faSkeleton]: faSkeleton,
    [EnumIcon.faCircleG]: faCircleG,
    [EnumIcon.faCircleArrowUpLeft]: faCircleArrowUpLeft,
    [EnumIcon.faCoinBlank]: faCoinBlank,
    [EnumIcon.faBroom]: faBroom,
    [EnumIcon.faVacuum]: faVacuum,
    [EnumIcon.faShieldHeart]: faShieldHeart,
    [EnumIcon.faCardHeart]: faCardHeart,
    [EnumIcon.faLightbulbCflOn]: faLightbulbCflOn,
    [EnumIcon.faMelon]: faMelon,
    [EnumIcon.faGopuram]: faGopuram,
    [EnumIcon.faEarthOceania]: faEarthOceania,
    [EnumIcon.faGlobeOceania]: faGlobeOceania,
    [EnumIcon.faContainerStorage]: faContainerStorage,
    [EnumIcon.faFacePouting]: faFacePouting,
    [EnumIcon.faSquareXmark]: faSquareXmark,
    [EnumIcon.faTimesSquare]: faTimesSquare,
    [EnumIcon.faXmarkSquare]: faXmarkSquare,
    [EnumIcon.faFaceExplode]: faFaceExplode,
    [EnumIcon.faExplodingHead]: faExplodingHead,
    [EnumIcon.faHashtag]: faHashtag,
    [EnumIcon.faUpRightAndDownLeftFromCenter]: faUpRightAndDownLeftFromCenter,
    [EnumIcon.faExpandAlt]: faExpandAlt,
    [EnumIcon.faOilCan]: faOilCan,
    [EnumIcon.faT]: faT,
    [EnumIcon.faTransformerBolt]: faTransformerBolt,
    [EnumIcon.faHippo]: faHippo,
    [EnumIcon.faChartColumn]: faChartColumn,
    [EnumIcon.faCassetteVhs]: faCassetteVhs,
    [EnumIcon.faVhs]: faVhs,
    [EnumIcon.faInfinity]: faInfinity,
    [EnumIcon.faVialCircleCheck]: faVialCircleCheck,
    [EnumIcon.faChimney]: faChimney,
    [EnumIcon.faObjectIntersect]: faObjectIntersect,
    [EnumIcon.faPersonArrowDownToLine]: faPersonArrowDownToLine,
    [EnumIcon.faVoicemail]: faVoicemail,
    [EnumIcon.faBlockBrick]: faBlockBrick,
    [EnumIcon.faWallBrick]: faWallBrick,
    [EnumIcon.faFan]: faFan,
    [EnumIcon.faBagsShopping]: faBagsShopping,
    [EnumIcon.faParagraphLeft]: faParagraphLeft,
    [EnumIcon.faParagraphRtl]: faParagraphRtl,
    [EnumIcon.faPersonWalkingLuggage]: faPersonWalkingLuggage,
    [EnumIcon.faCaravanSimple]: faCaravanSimple,
    [EnumIcon.faCaravanAlt]: faCaravanAlt,
    [EnumIcon.faTurtle]: faTurtle,
    [EnumIcon.faUpDown]: faUpDown,
    [EnumIcon.faArrowsAltV]: faArrowsAltV,
    [EnumIcon.faCloudMoonRain]: faCloudMoonRain,
    [EnumIcon.faBoothCurtain]: faBoothCurtain,
    [EnumIcon.faCalendar]: faCalendar,
    [EnumIcon.faBoxHeart]: faBoxHeart,
    [EnumIcon.faTrailer]: faTrailer,
    [EnumIcon.faUserDoctorMessage]: faUserDoctorMessage,
    [EnumIcon.faUserMdChat]: faUserMdChat,
    [EnumIcon.faBahai]: faBahai,
    [EnumIcon.faHaykal]: faHaykal,
    [EnumIcon.faAmpGuitar]: faAmpGuitar,
    [EnumIcon.faSdCard]: faSdCard,
    [EnumIcon.faVolumeSlash]: faVolumeSlash,
    [EnumIcon.faBorderBottom]: faBorderBottom,
    [EnumIcon.faWifiWeak]: faWifiWeak,
    [EnumIcon.faWifi1]: faWifi1,
    [EnumIcon.faDragon]: faDragon,
    [EnumIcon.faShoePrints]: faShoePrints,
    [EnumIcon.faCirclePlus]: faCirclePlus,
    [EnumIcon.faPlusCircle]: faPlusCircle,
    [EnumIcon.faFaceGrinTongueWink]: faFaceGrinTongueWink,
    [EnumIcon.faGrinTongueWink]: faGrinTongueWink,
    [EnumIcon.faHandHolding]: faHandHolding,
    [EnumIcon.faPlugCircleExclamation]: faPlugCircleExclamation,
    [EnumIcon.faLinkSlash]: faLinkSlash,
    [EnumIcon.faChainBroken]: faChainBroken,
    [EnumIcon.faChainSlash]: faChainSlash,
    [EnumIcon.faUnlink]: faUnlink,
    [EnumIcon.faClone]: faClone,
    [EnumIcon.faPersonWalkingArrowLoopLeft]: faPersonWalkingArrowLoopLeft,
    [EnumIcon.faArrowUpZA]: faArrowUpZA,
    [EnumIcon.faSortAlphaUpAlt]: faSortAlphaUpAlt,
    [EnumIcon.faFireFlameCurved]: faFireFlameCurved,
    [EnumIcon.faFireAlt]: faFireAlt,
    [EnumIcon.faTornado]: faTornado,
    [EnumIcon.faFileCirclePlus]: faFileCirclePlus,
    [EnumIcon.faDeleteRight]: faDeleteRight,
    [EnumIcon.faBookQuran]: faBookQuran,
    [EnumIcon.faQuran]: faQuran,
    [EnumIcon.faCircleQuarter]: faCircleQuarter,
    [EnumIcon.faAnchor]: faAnchor,
    [EnumIcon.faBorderAll]: faBorderAll,
    [EnumIcon.faFunction]: faFunction,
    [EnumIcon.faFaceAngry]: faFaceAngry,
    [EnumIcon.faAngry]: faAngry,
    [EnumIcon.faPeopleSimple]: faPeopleSimple,
    [EnumIcon.faCookieBite]: faCookieBite,
    [EnumIcon.faArrowTrendDown]: faArrowTrendDown,
    [EnumIcon.faRss]: faRss,
    [EnumIcon.faFeed]: faFeed,
    [EnumIcon.faFaceMonocle]: faFaceMonocle,
    [EnumIcon.faDrawPolygon]: faDrawPolygon,
    [EnumIcon.faScaleBalanced]: faScaleBalanced,
    [EnumIcon.faBalanceScale]: faBalanceScale,
    [EnumIcon.faCalendarLines]: faCalendarLines,
    [EnumIcon.faCalendarNote]: faCalendarNote,
    [EnumIcon.faArrowDownBigSmall]: faArrowDownBigSmall,
    [EnumIcon.faSortSizeDown]: faSortSizeDown,
    [EnumIcon.faGaugeSimpleHigh]: faGaugeSimpleHigh,
    [EnumIcon.faTachometer]: faTachometer,
    [EnumIcon.faTachometerFast]: faTachometerFast,
    [EnumIcon.faDoNotEnter]: faDoNotEnter,
    [EnumIcon.faShower]: faShower,
    [EnumIcon.faDiceD8]: faDiceD8,
    [EnumIcon.faDesktop]: faDesktop,
    [EnumIcon.faDesktopAlt]: faDesktopAlt,
    [EnumIcon.faM]: faM,
    [EnumIcon.faGripDotsVertical]: faGripDotsVertical,
    [EnumIcon.faFaceViewfinder]: faFaceViewfinder,
    [EnumIcon.faSoftServe]: faSoftServe,
    [EnumIcon.faCreemee]: faCreemee,
    [EnumIcon.faH5]: faH5,
    [EnumIcon.faHandBackPointDown]: faHandBackPointDown,
    [EnumIcon.faTableList]: faTableList,
    [EnumIcon.faThList]: faThList,
    [EnumIcon.faCommentSms]: faCommentSms,
    [EnumIcon.faSms]: faSms,
    [EnumIcon.faRectangle]: faRectangle,
    [EnumIcon.faRectangleLandscape]: faRectangleLandscape,
    [EnumIcon.faClipboardListCheck]: faClipboardListCheck,
    [EnumIcon.faTurkey]: faTurkey,
    [EnumIcon.faBook]: faBook,
    [EnumIcon.faUserPlus]: faUserPlus,
    [EnumIcon.faIceSkate]: faIceSkate,
    [EnumIcon.faCheck]: faCheck,
    [EnumIcon.faBatteryThreeQuarters]: faBatteryThreeQuarters,
    [EnumIcon.faBattery4]: faBattery4,
    [EnumIcon.faTomato]: faTomato,
    [EnumIcon.faSwordLaser]: faSwordLaser,
    [EnumIcon.faHouseCircleCheck]: faHouseCircleCheck,
    [EnumIcon.faBuildings]: faBuildings,
    [EnumIcon.faAngleLeft]: faAngleLeft,
    [EnumIcon.faCartFlatbedBoxes]: faCartFlatbedBoxes,
    [EnumIcon.faDollyFlatbedAlt]: faDollyFlatbedAlt,
    [EnumIcon.faDiagramSuccessor]: faDiagramSuccessor,
    [EnumIcon.faTruckArrowRight]: faTruckArrowRight,
    [EnumIcon.faSquareW]: faSquareW,
    [EnumIcon.faArrowsSplitUpAndLeft]: faArrowsSplitUpAndLeft,
    [EnumIcon.faLamp]: faLamp,
    [EnumIcon.faAirplay]: faAirplay,
    [EnumIcon.faHandFist]: faHandFist,
    [EnumIcon.faFistRaised]: faFistRaised,
    [EnumIcon.faShieldQuartered]: faShieldQuartered,
    [EnumIcon.faSlashForward]: faSlashForward,
    [EnumIcon.faLocationPen]: faLocationPen,
    [EnumIcon.faMapMarkerEdit]: faMapMarkerEdit,
    [EnumIcon.faCloudMoon]: faCloudMoon,
    [EnumIcon.faPotFood]: faPotFood,
    [EnumIcon.faBriefcase]: faBriefcase,
    [EnumIcon.faPersonFalling]: faPersonFalling,
    [EnumIcon.faImagePortrait]: faImagePortrait,
    [EnumIcon.faPortrait]: faPortrait,
    [EnumIcon.faUserTag]: faUserTag,
    [EnumIcon.faRug]: faRug,
    [EnumIcon.faPrintSlash]: faPrintSlash,
    [EnumIcon.faEarthEurope]: faEarthEurope,
    [EnumIcon.faGlobeEurope]: faGlobeEurope,
    [EnumIcon.faCartFlatbedSuitcase]: faCartFlatbedSuitcase,
    [EnumIcon.faLuggageCart]: faLuggageCart,
    [EnumIcon.faHandBackPointRibbon]: faHandBackPointRibbon,
    [EnumIcon.faRectangleXmark]: faRectangleXmark,
    [EnumIcon.faRectangleTimes]: faRectangleTimes,
    [EnumIcon.faTimesRectangle]: faTimesRectangle,
    [EnumIcon.faWindowClose]: faWindowClose,
    [EnumIcon.faTireRugged]: faTireRugged,
    [EnumIcon.faLightbulbDollar]: faLightbulbDollar,
    [EnumIcon.faCowbell]: faCowbell,
    [EnumIcon.faBahtSign]: faBahtSign,
    [EnumIcon.faCorner]: faCorner,
    [EnumIcon.faChevronsRight]: faChevronsRight,
    [EnumIcon.faChevronDoubleRight]: faChevronDoubleRight,
    [EnumIcon.faBookOpen]: faBookOpen,
    [EnumIcon.faBookJournalWhills]: faBookJournalWhills,
    [EnumIcon.faJournalWhills]: faJournalWhills,
    [EnumIcon.faInhaler]: faInhaler,
    [EnumIcon.faHandcuffs]: faHandcuffs,
    [EnumIcon.faSnake]: faSnake,
    [EnumIcon.faTriangleExclamation]: faTriangleExclamation,
    [EnumIcon.faExclamationTriangle]: faExclamationTriangle,
    [EnumIcon.faWarning]: faWarning,
    [EnumIcon.faNoteMedical]: faNoteMedical,
    [EnumIcon.faDatabase]: faDatabase,
    [EnumIcon.faDownLeft]: faDownLeft,
    [EnumIcon.faShare]: faShare,
    [EnumIcon.faArrowTurnRight]: faArrowTurnRight,
    [EnumIcon.faMailForward]: faMailForward,
    [EnumIcon.faFaceThinking]: faFaceThinking,
    [EnumIcon.faTurnDownRight]: faTurnDownRight,
    [EnumIcon.faBottleDroplet]: faBottleDroplet,
    [EnumIcon.faMaskFace]: faMaskFace,
    [EnumIcon.faHillRockslide]: faHillRockslide,
    [EnumIcon.faScannerKeyboard]: faScannerKeyboard,
    [EnumIcon.faCircleO]: faCircleO,
    [EnumIcon.faGridHorizontal]: faGridHorizontal,
    [EnumIcon.faMessageDollar]: faMessageDollar,
    [EnumIcon.faCommentAltDollar]: faCommentAltDollar,
    [EnumIcon.faRightLeft]: faRightLeft,
    [EnumIcon.faExchangeAlt]: faExchangeAlt,
    [EnumIcon.faColumns3]: faColumns3,
    [EnumIcon.faPaperPlane]: faPaperPlane,
    [EnumIcon.faRoadCircleExclamation]: faRoadCircleExclamation,
    [EnumIcon.faDungeon]: faDungeon,
    [EnumIcon.faHandHoldingBox]: faHandHoldingBox,
    [EnumIcon.faInputText]: faInputText,
    [EnumIcon.faWindowFlip]: faWindowFlip,
    [EnumIcon.faWindowAlt]: faWindowAlt,
    [EnumIcon.faAlignRight]: faAlignRight,
    [EnumIcon.faScannerGun]: faScannerGun,
    [EnumIcon.faScanner]: faScanner,
    [EnumIcon.faTire]: faTire,
    [EnumIcon.faEngine]: faEngine,
    [EnumIcon.faMoneyBill1Wave]: faMoneyBill1Wave,
    [EnumIcon.faMoneyBillWaveAlt]: faMoneyBillWaveAlt,
    [EnumIcon.faLifeRing]: faLifeRing,
    [EnumIcon.faHands]: faHands,
    [EnumIcon.faSignLanguage]: faSignLanguage,
    [EnumIcon.faSigning]: faSigning,
    [EnumIcon.faCircleCaretRight]: faCircleCaretRight,
    [EnumIcon.faCaretCircleRight]: faCaretCircleRight,
    [EnumIcon.faWheat]: faWheat,
    [EnumIcon.faFileSpreadsheet]: faFileSpreadsheet,
    [EnumIcon.faAudioDescriptionSlash]: faAudioDescriptionSlash,
    [EnumIcon.faCalendarDay]: faCalendarDay,
    [EnumIcon.faWaterLadder]: faWaterLadder,
    [EnumIcon.faLadderWater]: faLadderWater,
    [EnumIcon.faSwimmingPool]: faSwimmingPool,
    [EnumIcon.faArrowsUpDown]: faArrowsUpDown,
    [EnumIcon.faArrowsV]: faArrowsV,
    [EnumIcon.faChessPawnPiece]: faChessPawnPiece,
    [EnumIcon.faChessPawnAlt]: faChessPawnAlt,
    [EnumIcon.faFaceGrimace]: faFaceGrimace,
    [EnumIcon.faGrimace]: faGrimace,
    [EnumIcon.faWheelchairMove]: faWheelchairMove,
    [EnumIcon.faWheelchairAlt]: faWheelchairAlt,
    [EnumIcon.faTurnDown]: faTurnDown,
    [EnumIcon.faLevelDownAlt]: faLevelDownAlt,
    [EnumIcon.faSquareS]: faSquareS,
    [EnumIcon.faRectangleBarcode]: faRectangleBarcode,
    [EnumIcon.faBarcodeAlt]: faBarcodeAlt,
    [EnumIcon.faPersonWalkingArrowRight]: faPersonWalkingArrowRight,
    [EnumIcon.faSquareEnvelope]: faSquareEnvelope,
    [EnumIcon.faEnvelopeSquare]: faEnvelopeSquare,
    [EnumIcon.faDice]: faDice,
    [EnumIcon.faUnicorn]: faUnicorn,
    [EnumIcon.faBowlingBall]: faBowlingBall,
    [EnumIcon.faPompebled]: faPompebled,
    [EnumIcon.faBrain]: faBrain,
    [EnumIcon.faWatchSmart]: faWatchSmart,
    [EnumIcon.faBookUser]: faBookUser,
    [EnumIcon.faSensorCloud]: faSensorCloud,
    [EnumIcon.faSensorSmoke]: faSensorSmoke,
    [EnumIcon.faClapperboardPlay]: faClapperboardPlay,
    [EnumIcon.faBandage]: faBandage,
    [EnumIcon.faBandAid]: faBandAid,
    [EnumIcon.faCalendarMinus]: faCalendarMinus,
    [EnumIcon.faCircleXmark]: faCircleXmark,
    [EnumIcon.faTimesCircle]: faTimesCircle,
    [EnumIcon.faXmarkCircle]: faXmarkCircle,
    [EnumIcon.faCircle4]: faCircle4,
    [EnumIcon.faGifts]: faGifts,
    [EnumIcon.faAlbumCollection]: faAlbumCollection,
    [EnumIcon.faHotel]: faHotel,
    [EnumIcon.faEarthAsia]: faEarthAsia,
    [EnumIcon.faGlobeAsia]: faGlobeAsia,
    [EnumIcon.faIdCardClip]: faIdCardClip,
    [EnumIcon.faIdCardAlt]: faIdCardAlt,
    [EnumIcon.faMagnifyingGlassPlus]: faMagnifyingGlassPlus,
    [EnumIcon.faSearchPlus]: faSearchPlus,
    [EnumIcon.faThumbsUp]: faThumbsUp,
    [EnumIcon.faCloudShowers]: faCloudShowers,
    [EnumIcon.faUserClock]: faUserClock,
    [EnumIcon.faOnion]: faOnion,
    [EnumIcon.faClockTwelveThirty]: faClockTwelveThirty,
    [EnumIcon.faArrowDownToDottedLine]: faArrowDownToDottedLine,
    [EnumIcon.faHandDots]: faHandDots,
    [EnumIcon.faAllergies]: faAllergies,
    [EnumIcon.faFileInvoice]: faFileInvoice,
    [EnumIcon.faWindowMinimize]: faWindowMinimize,
    [EnumIcon.faRectangleWide]: faRectangleWide,
    [EnumIcon.faCommentArrowUp]: faCommentArrowUp,
    [EnumIcon.faGarlic]: faGarlic,
    [EnumIcon.faMugSaucer]: faMugSaucer,
    [EnumIcon.faCoffee]: faCoffee,
    [EnumIcon.faBrush]: faBrush,
    [EnumIcon.faTreeDecorated]: faTreeDecorated,
    [EnumIcon.faMask]: faMask,
    [EnumIcon.faCalendarHeart]: faCalendarHeart,
    [EnumIcon.faMagnifyingGlassMinus]: faMagnifyingGlassMinus,
    [EnumIcon.faSearchMinus]: faSearchMinus,
    [EnumIcon.faFlower]: faFlower,
    [EnumIcon.faRulerVertical]: faRulerVertical,
    [EnumIcon.faUserLarge]: faUserLarge,
    [EnumIcon.faUserAlt]: faUserAlt,
    [EnumIcon.faStarshipFreighter]: faStarshipFreighter,
    [EnumIcon.faTrainTram]: faTrainTram,
    [EnumIcon.faBridgeSuspension]: faBridgeSuspension,
    [EnumIcon.faTrashCheck]: faTrashCheck,
    [EnumIcon.faUserNurse]: faUserNurse,
    [EnumIcon.faBoombox]: faBoombox,
    [EnumIcon.faSyringe]: faSyringe,
    [EnumIcon.faCloudSun]: faCloudSun,
    [EnumIcon.faShieldExclamation]: faShieldExclamation,
    [EnumIcon.faStopwatch20]: faStopwatch20,
    [EnumIcon.faSquareFull]: faSquareFull,
    [EnumIcon.faGripDots]: faGripDots,
    [EnumIcon.faCommentExclamation]: faCommentExclamation,
    [EnumIcon.faPenSwirl]: faPenSwirl,
    [EnumIcon.faFalafel]: faFalafel,
    [EnumIcon.faCircle2]: faCircle2,
    [EnumIcon.faMagnet]: faMagnet,
    [EnumIcon.faJar]: faJar,
    [EnumIcon.faGramophone]: faGramophone,
    [EnumIcon.faDiceD12]: faDiceD12,
    [EnumIcon.faNoteSticky]: faNoteSticky,
    [EnumIcon.faStickyNote]: faStickyNote,
    [EnumIcon.faDown]: faDown,
    [EnumIcon.faArrowAltDown]: faArrowAltDown,
    [EnumIcon.faHundredPoints]: faHundredPoints,
    [EnumIcon.fa100]: fa100,
    [EnumIcon.faPaperclipVertical]: faPaperclipVertical,
    [EnumIcon.faWindWarning]: faWindWarning,
    [EnumIcon.faWindCircleExclamation]: faWindCircleExclamation,
    [EnumIcon.faLocationPinSlash]: faLocationPinSlash,
    [EnumIcon.faMapMarkerSlash]: faMapMarkerSlash,
    [EnumIcon.faFaceSadSweat]: faFaceSadSweat,
    [EnumIcon.faBugSlash]: faBugSlash,
    [EnumIcon.faCupcake]: faCupcake,
    [EnumIcon.faLightSwitchOff]: faLightSwitchOff,
    [EnumIcon.faToggleLargeOff]: faToggleLargeOff,
    [EnumIcon.faPenFancySlash]: faPenFancySlash,
    [EnumIcon.faTruckContainer]: faTruckContainer,
    [EnumIcon.faBoot]: faBoot,
    [EnumIcon.faArrowUpFromWaterPump]: faArrowUpFromWaterPump,
    [EnumIcon.faFileCheck]: faFileCheck,
    [EnumIcon.faBone]: faBone,
    [EnumIcon.faCardsBlank]: faCardsBlank,
    [EnumIcon.faCircle3]: faCircle3,
    [EnumIcon.faBenchTree]: faBenchTree,
    [EnumIcon.faKeyboardBrightnessLow]: faKeyboardBrightnessLow,
    [EnumIcon.faSkiBootSki]: faSkiBootSki,
    [EnumIcon.faBrainCircuit]: faBrainCircuit,
    [EnumIcon.faUserInjured]: faUserInjured,
    [EnumIcon.faBlockBrickFire]: faBlockBrickFire,
    [EnumIcon.faFirewall]: faFirewall,
    [EnumIcon.faFaceSadTear]: faFaceSadTear,
    [EnumIcon.faSadTear]: faSadTear,
    [EnumIcon.faPlane]: faPlane,
    [EnumIcon.faTentArrowsDown]: faTentArrowsDown,
    [EnumIcon.faExclamation]: faExclamation,
    [EnumIcon.faArrowsSpin]: faArrowsSpin,
    [EnumIcon.faFaceSmileRelaxed]: faFaceSmileRelaxed,
    [EnumIcon.faCommentXmark]: faCommentXmark,
    [EnumIcon.faCommentTimes]: faCommentTimes,
    [EnumIcon.faPrint]: faPrint,
    [EnumIcon.faTurkishLiraSign]: faTurkishLiraSign,
    [EnumIcon.faTry]: faTry,
    [EnumIcon.faTurkishLira]: faTurkishLira,
    [EnumIcon.faFaceNoseSteam]: faFaceNoseSteam,
    [EnumIcon.faCircleWaveformLines]: faCircleWaveformLines,
    [EnumIcon.faWaveformCircle]: faWaveformCircle,
    [EnumIcon.faDollarSign]: faDollarSign,
    [EnumIcon.faDollar]: faDollar,
    [EnumIcon.faUsd]: faUsd,
    [EnumIcon.faFerrisWheel]: faFerrisWheel,
    [EnumIcon.faComputerSpeaker]: faComputerSpeaker,
    [EnumIcon.faSkullCow]: faSkullCow,
    [EnumIcon.faX]: faX,
    [EnumIcon.faMagnifyingGlassDollar]: faMagnifyingGlassDollar,
    [EnumIcon.faSearchDollar]: faSearchDollar,
    [EnumIcon.faUsersGear]: faUsersGear,
    [EnumIcon.faUsersCog]: faUsersCog,
    [EnumIcon.faPersonMilitaryPointing]: faPersonMilitaryPointing,
    [EnumIcon.faBuildingColumns]: faBuildingColumns,
    [EnumIcon.faBank]: faBank,
    [EnumIcon.faInstitution]: faInstitution,
    [EnumIcon.faMuseum]: faMuseum,
    [EnumIcon.faUniversity]: faUniversity,
    [EnumIcon.faCircleT]: faCircleT,
    [EnumIcon.faSack]: faSack,
    [EnumIcon.faGrid2]: faGrid2,
    [EnumIcon.faCameraCctv]: faCameraCctv,
    [EnumIcon.faCctv]: faCctv,
    [EnumIcon.faUmbrella]: faUmbrella,
    [EnumIcon.faTrowel]: faTrowel,
    [EnumIcon.faHorizontalRule]: faHorizontalRule,
    [EnumIcon.faBedFront]: faBedFront,
    [EnumIcon.faBedAlt]: faBedAlt,
    [EnumIcon.faD]: faD,
    [EnumIcon.faStapler]: faStapler,
    [EnumIcon.faMasksTheater]: faMasksTheater,
    [EnumIcon.faTheaterMasks]: faTheaterMasks,
    [EnumIcon.faKipSign]: faKipSign,
    [EnumIcon.faFaceWoozy]: faFaceWoozy,
    [EnumIcon.faCloudQuestion]: faCloudQuestion,
    [EnumIcon.faPineapple]: faPineapple,
    [EnumIcon.faHandPointLeft]: faHandPointLeft,
    [EnumIcon.faGalleryThumbnails]: faGalleryThumbnails,
    [EnumIcon.faCircleJ]: faCircleJ,
    [EnumIcon.faEyes]: faEyes,
    [EnumIcon.faHandshakeSimple]: faHandshakeSimple,
    [EnumIcon.faHandshakeAlt]: faHandshakeAlt,
    [EnumIcon.faPageCaretUp]: faPageCaretUp,
    [EnumIcon.faFileCaretUp]: faFileCaretUp,
    [EnumIcon.faJetFighter]: faJetFighter,
    [EnumIcon.faFighterJet]: faFighterJet,
    [EnumIcon.faComet]: faComet,
    [EnumIcon.faSquareShareNodes]: faSquareShareNodes,
    [EnumIcon.faShareAltSquare]: faShareAltSquare,
    [EnumIcon.faShieldKeyhole]: faShieldKeyhole,
    [EnumIcon.faBarcode]: faBarcode,
    [EnumIcon.faPlusMinus]: faPlusMinus,
    [EnumIcon.faSquareSlidersVertical]: faSquareSlidersVertical,
    [EnumIcon.faSlidersVSquare]: faSlidersVSquare,
    [EnumIcon.faVideo]: faVideo,
    [EnumIcon.faVideoCamera]: faVideoCamera,
    [EnumIcon.faMessageMiddle]: faMessageMiddle,
    [EnumIcon.faCommentMiddleAlt]: faCommentMiddleAlt,
    [EnumIcon.faGraduationCap]: faGraduationCap,
    [EnumIcon.faMortarBoard]: faMortarBoard,
    [EnumIcon.faHandHoldingMedical]: faHandHoldingMedical,
    [EnumIcon.faPersonCircleCheck]: faPersonCircleCheck,
    [EnumIcon.faSquareZ]: faSquareZ,
    [EnumIcon.faMessageText]: faMessageText,
    [EnumIcon.faCommentAltText]: faCommentAltText,
    [EnumIcon.faTurnUp]: faTurnUp,
    [EnumIcon.faLevelUpAlt]: faLevelUpAlt,
};
